webpackJsonp([42],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(341)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(343),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(416),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(382)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(384),
  /* scopeId */
  "data-v-29b7c940",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(318),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(344)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(346),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(339)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(368),
  /* scopeId */
  "data-v-4b943062",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(356)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(367),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(417)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(419),
  /* scopeId */
  "data-v-1883b718",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(472)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(474),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(379)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(381),
  /* scopeId */
  "data-v-7eab4f47",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(370),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(487)
__webpack_require__(488)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(490),
  /* scopeId */
  "data-v-4b0cd678",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(395),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(426)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(454),
  /* scopeId */
  "data-v-8757686c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TOGGLE_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TOGGLE_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EXPAND_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SWITCH_EFFECT; });
var TOGGLE_DEVICE = 'TOGGLE_DEVICE';

var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

var EXPAND_MENU = 'EXPAND_MENU';

var SWITCH_EFFECT = 'SWITCH_EFFECT';

/***/ }),
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(428)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(430),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(514)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(516),
  /* scopeId */
  "data-v-e2f1d502",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export jsPlumbToolkitVue2 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseNodeComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsplumb__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsplumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jsplumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translations_i18n__ = __webpack_require__(83);




/**
 * jsPlumb Toolkit Vue 2 integration.
 */

var connectProperties = {
  // detachable: false,
  connectorStyle: { stroke: '#5c96bc', strokeWidth: 3, outlineStroke: 'transparent', outlineWidth: 5 },
  endpointStyle: { fillStyle: 'blue', outlineColor: 'black', outlineWidth: 1 },
  paintStyle: { stroke: '#5c96bc', strokeWidth: 3, outlineStroke: 'transparent', outlineWidth: 5 },

  connector: getUrlParam('connector', '') || 'Straight',
  // // connector: [ 'Flowchart', { stub: [40, 60], gap: 10, cornerRadius: 5, alwaysRespectStubs: true } ],
  // Connector: [ 'Bezier', { curviness: 50 } ],

  anchors: [['Perimeter', { shape: 'Rectangle' }], ['Perimeter', { shape: 'Rectangle' }]]
  // anchor: ['AutoDefault', 'AutoDefault']
};
connectProperties.ConnectorStyle = connectProperties.connectorStyle;
connectProperties.PaintStyle = connectProperties.paintStyle;
connectProperties.Connector = connectProperties.connector;
connectProperties.Anchors = connectProperties.anchors;

var jsPlumbToolkitVue2 = {
  addToolkit: function addToolkit(view) {
    var params = {};
    params.DragOptions = { cursor: 'pointer', zIndex: 2000 };
    params.container = 'canvas';
    params.ConnectionOverlays = [['Arrow', {
      location: 1,
      id: 'arrow',
      length: 14,
      foldback: 0.8
    }]];
    var toolkit = __WEBPACK_IMPORTED_MODULE_1_jsplumb__["jsPlumb"].getInstance(params);
    toolkit.allNodes = {};

    function generateId() {
      var id = 'jsPlumb_3_' + Math.floor(Math.random() * 1000);
      if (document.getElementById(id)) {
        return generateId();
      } else {
        return id;
      }
    }

    toolkit.addNode = function (data, scenarioId, availableSmsGateways) {
      var Cls = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(view.nodeComponent);
      data.scenarioId = scenarioId;
      data.data.id = data.data.id || generateId();
      data.availableSmsGateways = availableSmsGateways;
      // data.client = client
      var component = new Cls({
        data: { obj: data }
      });
      return toolkit.addComponent(component, true, false);
    };
    toolkit.addRedirectNode = function (data) {
      var Cls = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(view.nodeRedirectComponent);
      data.view.id = data.view.id || generateId();
      var component = new Cls({
        data: { obj: data }
      });
      return toolkit.addComponent(component, false, true);
    };
    toolkit.addSmsNode = function (data) {
      var Cls = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(view.nodeSmsComponent);
      data.view.id = data.view.id || generateId();
      var component = new Cls({
        data: { obj: data }
      });
      component.isSms = true;
      return toolkit.addComponent(component, false, false);
    };
    toolkit.addHttpRequestNode = function (data) {
      var Cls = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(view.nodeHttpRequestComponent);
      data.view.id = data.view.id || generateId();
      var component = new Cls({
        data: { obj: data }
      });
      component.isHttpRequest = true;
      return toolkit.addComponent(component, false, false);
    };
    toolkit.addComponent = function (component, isAnswer, isRedirect) {
      component.$mount(); // could pass some toolkit stuff here
      component.toolkit = toolkit;

      document.getElementById('canvas').appendChild(component.$el);
      toolkit.draggable(component.$el, { scroll: false });

      connectProperties.filter = '.add i.connect';
      toolkit.makeSource(component.$el, connectProperties);
      toolkit.makeTarget(component.$el, {
        anchor: ['Perimeter', { shape: 'Rectangle' }]
      });

      component.isAnswer = isAnswer;
      component.isRedirect = isRedirect;
      toolkit.allNodes[component.$el.id] = component;
      return component;
    };

    toolkit.addCustomConnection = function (sourceComponent, targetComponent) {
      var sourceEl = void 0;
      var targetEl = void 0;
      if (typeof sourceComponent === 'string' || sourceComponent instanceof String) {
        sourceEl = document.getElementById(sourceComponent);
      } else {
        sourceEl = sourceComponent.$el;
      }
      if (typeof targetComponent === 'string' || targetComponent instanceof String) {
        targetEl = document.getElementById(targetComponent);
      } else {
        targetEl = targetComponent.$el;
      }

      var sourceConnections = toolkit.getConnections({ source: sourceEl.id });
      if (sourceConnections && sourceConnections.length) {
        for (var i = 0; i < sourceConnections.length; i++) {
          if (sourceConnections[i].targetId === targetEl.id) {
            return;
          }
        }
      }

      toolkit.connect({ source: sourceEl, target: targetEl }, connectProperties);
    };

    toolkit.customRemoveNode = function (nodeId) {
      this.remove(nodeId);
      this.allNodes[nodeId] = null;
    };

    toolkit.getFirstTarget = function (node) {
      var connections = this.getConnections({ source: node.$el.id });
      if (!connections || !connections.length) {
        return null;
      } else {
        return this.allNodes[connections[0].targetId];
      }
    };

    toolkit.getAllTargets = function (node) {
      var connections = this.getConnections({ source: node.$el.id });
      if (!connections || !connections.length) {
        return null;
      } else {
        var targets = [];
        for (var i = 0; i < connections.length; i++) {
          targets.push(this.allNodes[connections[i].targetId]);
        }
        return targets;
      }
    };

    toolkit.getRedirectData = function (nodeId) {
      var node = this.allNodes[nodeId];
      if (node) {
        var target = this.getFirstTarget(node);
        if (target && target.isRedirect) {
          return {
            sip: target.$el.querySelector('.sipNumber').value,
            w: target.$el.offsetWidth,
            h: target.$el.offsetHeight,
            top: target.$el.offsetTop,
            left: target.$el.offsetLeft,
            id: target.$el.id
          };
        }
      }
      return null;
    };

    toolkit.getRedirectUrl = function (nodeId) {
      var data = this.getRedirectData(nodeId);
      if (data) {
        return data.sip;
      }
    };

    toolkit.getSmsData = function (nodeId) {
      var node = this.allNodes[nodeId];
      if (node) {
        var targets = this.getAllTargets(node);
        if (targets) {
          for (var i = 0; i < targets.length; i++) {
            var target = targets[i];
            if (target.isSms && target.$el.querySelector('.smsGateway') && target.$el.querySelector('.smsText')) {
              return {
                data: {
                  gateway: target.$el.querySelector('.smsGateway').value,
                  sender: target.$el.querySelector('.sender').value,
                  text: target.$el.querySelector('.smsText').value
                },
                view: {
                  w: target.$el.offsetWidth,
                  h: target.$el.offsetHeight,
                  top: target.$el.offsetTop,
                  left: target.$el.offsetLeft,
                  id: target.$el.id
                }
              };
            }
          }
        }
      }
      return null;
    };

    toolkit.getHttpRequestData = function (nodeId) {
      function getKeValList(target, type) {
        var result = {};
        var objects = target.$el.querySelectorAll('.' + type);
        for (var i = 0; i < objects.length; i++) {
          var key = objects[i].querySelector('.key').value;
          var value = objects[i].querySelector('.value').value;
          if (key) {
            result[key] = value;
          }
        }
        return result;
      }

      var node = this.allNodes[nodeId];
      if (node) {
        var targets = this.getAllTargets(node);
        if (targets) {
          for (var i = 0; i < targets.length; i++) {
            var target = targets[i];
            if (target.isHttpRequest) {
              return {
                data: {
                  method: target.$el.querySelector('.method').value,
                  url: target.$el.querySelector('.url').value,
                  body: target.$el.querySelector('.body').value,
                  headers: getKeValList(target, 'header'),
                  params: getKeValList(target, 'param')
                },
                view: {
                  w: target.$el.offsetWidth,
                  h: target.$el.offsetHeight,
                  top: target.$el.offsetTop,
                  left: target.$el.offsetLeft,
                  id: target.$el.id
                }
              };
            }
          }
        }
      }
    };
    return toolkit;
  }
};

var BaseNodeComponent = {
  methods: {
    getToolkit: function getToolkit() {
      return this.toolkit;
    },
    deleteNode: function deleteNode() {
      var toolkit = this.getToolkit();
      toolkit.remove(this.$el.id);
    }
  },
  i18n: __WEBPACK_IMPORTED_MODULE_2__translations_i18n__["a" /* default */]
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('jsplumb-toolkit', {
  props: ['view', 'scenarioId', 'client', 'availableSmsGateways'],
  template: '<div style="width:100%;height:100%"></div>',
  mounted: function mounted() {
    this.toolkit = jsPlumbToolkitVue2.addToolkit(this._props.view);
    if (this.startCallBacks) {
      for (var i = 0; i < this.startCallBacks.length; i++) {
        this.startCallBacks[i]();
      }
      this.startCallBacks = [];
    }
  },
  data: function data() {
    return {
      toolkit: null,
      startCallBacks: []
    };
  },

  methods: {
    // getToolkit: function () {
    //   return this.toolkit
    // },
    drawScenario: function drawScenario(scenarioData) {
      var scenarioVisual = scenarioData.visual;
      if (scenarioVisual && scenarioVisual.hideArrows) {
        document.getElementById('canvas').classList.add('hidden_arrows');
      }
      if (scenarioVisual && scenarioVisual.compactWindows) {
        document.getElementById('canvas').classList.add('compact_windows');
      }
      var that = this;
      function draw() {
        console.log('draw scenario');
        var nodes = document.querySelectorAll('#Konstruktor .flowchart-object');
        for (var i = nodes.length - 1; i >= 0; i--) {
          that.toolkit.customRemoveNode(nodes[i].id);
        }

        for (var _i = 0; _i < scenarioData.states.length; _i++) {
          var state = scenarioData.states[_i];
          var node = that.toolkit.addNode(state, that.scenarioId, that._props.availableSmsGateways);

          if (state.redirectSipNumber) {
            node.addRedirect(state.redirectSipNumber, state.redirectView);
          }
          if (state.smsData) {
            node.addSMS(state.smsData.data, state.smsData.view, that._props.availableSmsGateways);
          }
          if (state.httpRequestData) {
            node.addHttpRequest(state.httpRequestData.data, state.httpRequestData.view);
          }
        }

        if (scenarioData.connections && scenarioData.connections.length) {
          for (var _i2 = 0; _i2 < scenarioData.connections.length; _i2++) {
            var connection = scenarioData.connections[_i2];
            that.toolkit.addCustomConnection(connection.sourceId, connection.targetId);
          }
        }
      }

      if (this.toolkit) {
        draw();
      } else {
        this.startCallBacks.push(draw);
      }
    },
    getAllConnections: function getAllConnections() {
      return this.toolkit.getAllConnections();
    },
    getRedirectData: function getRedirectData(nodeId) {
      return this.toolkit.getRedirectData(nodeId);
    },
    getSmsData: function getSmsData(nodeId) {
      return this.toolkit.getSmsData(nodeId);
    },
    getHttpRequestData: function getHttpRequestData(nodeId) {
      return this.toolkit.getHttpRequestData(nodeId);
    }
  }
});

function getUrlVars() {
  var vars = {};
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    vars[key] = value;
  });
  return vars;
}

function getUrlParam(parameter, defaultvalue) {
  var urlparameter = defaultvalue;
  if (window.location.href.indexOf(parameter) > -1) {
    urlparameter = getUrlVars()[parameter];
  }
  return urlparameter;
}

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(443)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(445),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(337)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(369),
  /* scopeId */
  "data-v-3780f868",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(448)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(453),
  /* scopeId */
  "data-v-d9881e96",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(462)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(464),
  /* scopeId */
  "data-v-19f3bb38",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(475)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(477),
  /* scopeId */
  "data-v-e5d0768c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export messages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enAutoGenerate__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ru__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pl__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(158);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function isObject(item) {
  return item && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && !Array.isArray(item);
}

function mergeDeep(target) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  if (!sources.length) return target;
  var source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (var key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, _defineProperty({}, key, {}));
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, _defineProperty({}, key, source[key]));
      }
    }
  }
  return mergeDeep.apply(undefined, [target].concat(sources));
}

var messages = {
  // en: en,
  enAutoGenerate: mergeDeep(Object(__WEBPACK_IMPORTED_MODULE_3__enAutoGenerate__["a" /* generateEnByRu */])(), __WEBPACK_IMPORTED_MODULE_2__en__["a" /* en */]),
  ru: __WEBPACK_IMPORTED_MODULE_4__ru__["a" /* ru */],
  pl: __WEBPACK_IMPORTED_MODULE_5__pl__["a" /* pl */]
};

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* getCookie */])('voicebotLanguage') || 'ru', // set locale
  fallbackLocale: 'enAutoGenerate', // set fallback locale
  messages: messages // set locale messages
});

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(651),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */,
/* 86 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(581)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(582),
  /* template */
  __webpack_require__(636),
  /* scopeId */
  "data-v-5961122c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(661)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(662),
  /* template */
  __webpack_require__(663),
  /* scopeId */
  "data-v-6753cc00",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(469)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(471),
  /* scopeId */
  "data-v-515fb758",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCookie;
/* harmony export (immutable) */ __webpack_exports__["b"] = setCookie;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function getCookie(name) {
  var matches = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));

  return matches ? decodeURIComponent(matches[2]) : undefined;
}

function setCookie(name, value) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  options = _extends({
    path: '/'
  }, options);

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  var updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

  for (var optionKey in options) {
    updatedCookie += '; ' + optionKey;
    var optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += '=' + optionValue;
    }
  }

  document.cookie = updatedCookie;
}

/***/ }),
/* 159 */,
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lazyLoading__ = __webpack_require__(316);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// import charts from './charts'
// import uifeatures from './uifeatures'
// import components from './components'
// import tables from './tables'

// show: meta.label -> name
// name: component name
// meta.label: display label

var state = {
  items: [{
    name: 'Сценарии',
    path: '/scenarios',
    meta: {
      label: 'Сценарии',
      labelTrans: 'scenarios.scenarios',
      icon: 'fa-comments',
      link: 'scenarios/Scenarios.vue'
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('scenario/Scenarios')
  }, {
    name: 'Рассылки',
    path: '/campaigns',
    meta: {
      label: 'Рассылки',
      // label: this.$t('campaigns.daily'),
      labelTrans: 'campaigns.campaigns',
      icon: 'fa-phone-square',
      link: 'campaigns/Campaigns.vue'
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('campaigns/Campaigns')
  }, {
    name: 'Ежедневные Рассылки',
    path: '/campaigns/daily',
    meta: {
      // label: '└─Ежедневные',
      labelTrans: 'campaigns.dailyLabel',
      // icon: 'fa-phone-square',
      link: 'campaigns/daily/DailyCampaigns.vue'
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('campaigns/daily/DailyCampaigns.vue')
  }, {
    name: 'Лицевой счёт',
    path: '/billing',
    meta: {
      label: 'Лицевой счёт',
      labelTrans: 'billing.billing',
      link: 'billing/Balance.vue',
      icon: 'fa-wallet'
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('billing/Balance.vue')
  }, {
    name: 'Аналитика затрат',
    path: '/billing/summary',
    meta: {
      labelTrans: 'billing.summaryLabel',
      // icon: 'fa-phone-square',
      link: 'billing/BillingSummaryDashboard.vue'
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('billing/BillingSummaryDashboard.vue')
  }, {
    name: 'Детализации',
    path: '/billing/details',
    meta: {
      labelTrans: 'billing.detailsLabel',
      // icon: 'fa-phone-square',
      link: 'billing/BillingDetails.vue'
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('billing/BillingDetails.vue')
  }, {
    name: 'Уведомления',
    path: '/billing/notifications',
    meta: {
      labelTrans: 'billing.notificationsLabel',
      // icon: 'fa-phone-square',
      link: 'billing/BillingNotifications.vue'
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('billing/BillingNotifications.vue')
  },
  // {
  //   name: 'Архив рассылок',
  //   path: '/archive',
  //   meta: {
  //     label: 'Архив рассылок',
  //     icon: 'fas fa-archive',
  //     link: 'campaigns/Archive.vue'
  //   },
  //   component: lazyLoading('campaigns/Archive')
  // },
  {
    name: 'Пользователи',
    path: '/users',
    meta: {
      label: 'Пользователи',
      labelTrans: 'users.users',
      icon: 'fa-user',
      link: 'users/Users.vue'
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('users/Users')
  }, {
    name: 'Настройка прав',
    path: '/permissions',
    meta: {
      label: 'Настройка прав',
      labelTrans: 'permissions.permissions',
      icon: 'fa-tasks',
      link: 'settings/Permissions.vue'
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('settings/Permissions')
  }, {
    name: 'Настройка приложения',
    path: '/appconfig',
    meta: {
      label: 'Настройка приложения',
      labelTrans: 'appConfig.appConfig',
      icon: 'fa-cogs',
      link: 'settings/AppConfig.vue'
    },
    component: Object(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('settings/AppConfig')
  }]
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* EXPAND_MENU */], function (state, menuItem) {
  if (menuItem.index > -1) {
    if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
      state.items[menuItem.index].meta.expanded = menuItem.expanded;
    }
  } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
    menuItem.item.meta.expanded = menuItem.expanded;
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(329)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(336),
  /* scopeId */
  "data-v-71adb06e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(331)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(333),
  /* scopeId */
  "data-v-24d5b040",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(371)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(373),
  /* scopeId */
  "data-v-5075c840",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(374)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(376),
  /* scopeId */
  "data-v-369d3951",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(377)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(385),
  /* scopeId */
  "data-v-058a52ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(386)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(388),
  /* scopeId */
  "data-v-47c1fb2e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(389)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(391),
  /* scopeId */
  "data-v-5a710a62",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(392)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(394),
  /* scopeId */
  "data-v-7b9a7b77",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(405),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */,
/* 171 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(406)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(420),
  /* scopeId */
  "data-v-1ce8085e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(422),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(423)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(425),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(435),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(440)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(447),
  /* scopeId */
  "data-v-a995ceb2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(450)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(452),
  /* scopeId */
  "data-v-0c2c9cf8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(455)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(457),
  /* scopeId */
  "data-v-07411758",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(459),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(460)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(465),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(466)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(468),
  /* scopeId */
  "data-v-225085ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(478)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(480),
  /* scopeId */
  "data-v-5e5698a5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(481)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(483),
  /* scopeId */
  "data-v-bc7776ec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(484)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(486),
  /* scopeId */
  "data-v-4a58c152",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(491)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(497),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ru; });
var ru = {
  shell: {
    menu: 'Меню',
    exit: 'Выход',
    profile: 'Профиль пользователя',
    personalAccount: 'Личный кабинет',
    developedBy: 'Разработано'
  },
  authentication: {
    authentication: 'Авторизация',
    registration: 'Регистрация'
  },
  campaigns: {
    campaigns: 'Рассылки',
    dailyCampaigns: 'Ежедневные рассылки',
    daily: 'Ежедневные',
    dailyLabel: '└─Ежедневные',
    campaign: 'Рассылка',
    newCampaign: 'Новая рассылка',
    campaignsArchive: 'Архив рассылкок',
    createCampaign: 'Создать рассылку',
    putCampaignsName: 'Введите название рассылки',
    ringing: 'Прозвон',
    report: 'Отчёт',
    unprocessed: 'Необработанные',
    monitoring: 'Мониторинг',
    cost: 'Стоимость',
    toArchive: 'В архив',
    loadBase: 'Загрузка базы',
    putBaseFromClipboard: 'Вставьте базу из буфера обмена',
    deleteFailedCalls: 'Удалить несостоявшиеся звонки',
    reportTexts: {
      createReport: 'Создать отчёт',
      reportIsBeingGeneratedNow: 'Отчёт генерируется',
      createReportError: 'Ошибка создания отчёта'
    },
    states: {
      started: 'Запущена',
      readyToRun: 'Готова к запуску',
      preparing: 'В разработке',
      ready: 'Подготовлена',
      // started: 'Прозвон идёт',
      finished: 'Завершена',
      paused: 'Остановлена',
      canceled: 'Отменена'
    },
    campaignParams: {
      campaignsParameters: 'Параметры рассылки',
      callDate: 'Дата прозвона',
      putCallDate: 'Введите дату',
      timezone: 'Часовой пояс',
      callTime: 'Время прозвона',

      numberOfAttemptsToGetThrough: 'Количество попыток дозвониться',
      intervalBetweenRepeatedCalls: 'Интервал между повторными звонками',
      openScenario: 'Открыть сценарий',
      scenarioIsReady: 'Сценарий подготовлен',
      scenarioIsNotReady: 'Сценарий неподготовлен',

      base: 'База',
      viewBase: 'Просмотреть базу',
      removeBase: 'Удалить базу',
      numbers: 'номера',
      uploadedNumbers: 'Загружено номеров',
      reportByTestCalls: 'Отчёт по тестовым звонкам',

      callResult: 'Результат обзвона',
      callsMonitoring: 'Мониторинг рассылки'
    },
    additionalParameters: {
      additionalParameters: 'Дополнительные параметры'
    },
    quotas: {
      quotas: 'Квоты',
      noLimit: 'Без ограничений',
      addQuota: 'Добавить квоту'
    }
  },
  testCall: {
    testCall: 'Тестовый звонок',
    callToNumber: 'Позвонить на номер',
    call: 'Позвонить',
    putNumber: 'Введите номер',
    viewTestResults: 'Просмотреть результаты тестов',
    testCallParameters: 'Параметры тестового звонка',
    callToPhone: 'на телефон',
    calInBrowser: 'в браузере',
    toPhoneNote: 'для звонка на телефон должна быть создана рассылка с настройками для исходящих вызовов',
    inBrowserNote: 'для звонка в браузере необходимо разрешить использование микрофона и перезагрузить страницу'
  },
  scenarios: {
    scenarios: 'Сценарии',
    scenario: 'Сценарий',
    createScenario: 'Создать сценарий',
    newScenario: 'Новый сценарий',
    scenarioName: 'Название сценария',
    putScenarioName: 'Введите название сценария',
    prepared: 'Подготовлен',
    notPrepared: 'Не подготовлен',
    scenarioTemplate: 'Шаблон сценария',
    chooseScenarioTemplate: 'Выберите шаблон сценария',
    konstruktor: {
      // toolButtons: {
      //   testCall: 'Тестовый звонок',
      //   callToNumber: 'Позвонить на номер'
      // },
      commonParams: {
        hideArrows: 'Скрыть стрелки'
      },
      canvas: {
        add: {
          robotAnswer: 'ответ робота',
          recognition: 'распознование',
          redirectToOperator: 'перевод на оператора',
          sendSMS: 'Отправить смс',
          sendHttpRequest: 'Отправить http запрос'
        },
        answer: {
          answer: 'Ответ',
          startOfTalk: 'Начало разговора',
          stateQuestion: 'Вопрос состояния',
          silence: 'Молчание',
          illegibly: 'Неразборчиво',
          approve: 'Одобрение',
          deny: 'Отрицание',
          custom: 'Индивидуальное',
          anotherAnswer: 'Другой ответ',
          foStatusValueUse: 'Для значения состояния использовать',
          transcription: 'Транскрибация',
          indicate: 'Указать',
          stateValue: 'Значение состояние',
          windowSizes: {
            smallSize: 'Маленький размер',
            mediumSize: 'Средний размер',
            maxSize: 'Максимальный размер'
          },
          synonyms: {
            addForAllWithSameTitle: 'Добавить для всех с таким же названием',
            addWord: 'Добавьте слово'
          },
          initAudio: {
            fromText: 'Из текста',
            toPutUrl: 'Ввести урл',
            putUrl: 'Введите урл',
            toAddUrl: 'Добавить урл',
            toRemoveUrl: 'Удалить урл',

            toUploadFromFile: 'загрузить из файла',
            toRemoveAll: 'Удалить всё',

            toAddParameter: 'Добавить параметр',
            putParameterName: 'Добавьте название параметра',
            addParameter: 'Добавьте параметр',
            toRemoveParameter: 'Удалить параметр',
            speed: 'Скорость',
            generateAudio: 'Сгенерировать',

            text: 'Текст',

            Your_browser_does_not_support_html5_audio_Try_chrome: 'Ваш браузер не поддерживает html5 audio. Попробуйте chrome.'
          },
          audioConfig: 'Настройки аудио',
          sipSubUrl: 'Сип адрес',
          sms: {
            gateway: 'Шлюз',
            sender: 'Отправитель',
            messageText: 'Текст сообщения'
          },
          httpRequest: {
            params: 'Параметры',
            headers: 'Заголовки',
            body: 'Тело'
          }
        },
        recognition: {
          recognitionDriver: 'Драйвер распознавания',
          driver: 'Драйвер'
        }
      }
    },
    removeScenario: 'Удалить сценарий'
  },
  billing: {
    billing: 'Лицевой счёт',
    summaryLabel: '└─Аналитика затрат',
    detailsLabel: '└─Детализации',
    notificationsLabel: '└─Уведомления'

  },
  users: {
    users: 'Пользователи',
    user: 'Пользователь',
    newUser: 'Новый пользователь',
    userData: 'Данные пользователя'
  },
  callTasks: {
    testCallsByCampaign: 'Тестовые звонки по рассылке',
    phone: 'Телефон',
    state: 'Состояние',
    phoneNumber: 'Номер телефона',
    byCampaign: 'по рассылке',
    states: {
      failed: 'Недозвон',
      dialing: 'Вызов',
      ongoing: 'Идет разговор',
      performed: 'Выполнена',
      postponed: 'Отложена',
      ready: 'В очереди',
      telephony_error_suspend: 'Отложена',
      canceled: 'Отменена'
    }
  },
  permissions: {
    permissions: 'Настройки прав'
  },
  appConfig: {
    appConfig: 'Настройки приложения'
  },
  common: {
    default: 'По умолчанию',
    yes: 'Да',
    no: 'Нет',
    timeInterval: {
      from: 'С',
      to: 'До'
    },
    search: 'Поиск',
    title: 'Название',
    client: 'Клиент',
    template: 'Шаблон',
    readiness: 'Готовность',
    state: 'Статус',
    creationDate: 'Дата создания',
    up: 'наверх',
    settings: 'Настройки',
    action: 'Действие',
    actions: {
      add: 'Добавить',
      delete: 'Удалить',
      save: 'Сохранить',
      cancel: 'Отмена',
      close: 'Закрыть',
      connect: 'Соединить',
      run: 'Запустить',
      stop: 'Остановить',
      copy: 'Копировать',
      load: 'Загрузить',
      loadFromFile: 'Загрузить из файла',
      create: 'Создать',
      reCreate: 'Пересоздать',
      export: 'Экспортировать',
      import: 'Импортировать'
    },
    key: 'Ключ',
    parameter: 'Параметр',
    value: 'Значение',
    language: 'Язык',
    voice: 'Голос',
    time: {
      minutes: 'минуты',
      seconds: 'секунды'
    },
    date: {
      days: {
        longhand: {
          sunday: 'Воскресенье',
          monday: 'Понедельник',
          tuesday: 'Вторник',
          wednesday: 'Среда',
          thursday: 'Четверг',
          friday: 'Пятница',
          saturday: 'Суббота'
        },
        shorthand: {
          sunday: 'Вс',
          monday: 'Пн',
          tuesday: 'Вт',
          wednesday: 'Ср',
          thursday: 'Чт',
          friday: 'Пт',
          saturday: 'Сб'
        }
      },
      months: {
        January: 'Январь',
        February: 'Февраль',
        March: 'Март',
        April: 'Апрель',
        May: 'Май',
        June: 'Июнь',
        July: 'Июль',
        August: 'Август',
        September: 'Сентябрь',
        October: 'Октябрь',
        November: 'Ноябрь',
        December: 'Декабрь'
      }
    },
    results: 'Результаты',
    recognitionLogs: 'Логи распознавания',
    information: 'Информация'
  },
  paging: {
    first: 'Первая',
    previous: 'Предыдущая',
    next: 'Следующая',
    last: 'Последняя'
  },
  errors: {
    downloadError: 'Ошибка скачивания'
  },
  notifications: {
    notification: 'Уведомление',
    toAddRobotAnswerPleaseRemoveRedirectToOperator: 'Чтобы добавить ответ, удалите перевод на оператора',
    toAddRedirectToOperatorPleaseRemoveAllRobotAnswers: 'Чтобы добавить перевод на оператора, удалите все последующие ответы',
    thereIsAlreadyHasARedirectToOperator: 'Уже есть перевод на оператора',
    errorLoadApplicationConfig: 'Ошибка загрузки параметров приложения',
    errorLoadAudio: 'Ошибка загрузки аудио',
    beforeGenerateAudioYouShouldSaveScenario: 'Перед генерацией аудио необходимо сохранить сценарий',
    beforeUploadFileYouShouldSaveScenario: 'Перед загрузкой файла необходимо сохранить сценарий',
    beforeLoadAudioYouShouldSaveScenario: 'Перед загрузкой аудио необходимо сохранить сценарий',
    campaign: {
      campaignIsReady: 'Рассылка подготовлена',
      errorStartCampaign: 'Ошибка запуска рассылки',
      campaignStopped: 'Рассылка остановлена',
      errorStopCampaign: 'Ошибка остановки рассылки',
      report: {
        errorLoadReport: 'Ошибка загрузки отчета'
      },
      errorDeletePhoneBase: 'Ошибка удаления телефонной базы',
      baseRemoved: 'База удалена'
    },
    scenario: {
      scenarioHasBeenRemoved: 'Сценарий удален',
      errorRemoveScenario: 'Ошибка удаления сценария',
      errorToGetUserStatus: 'Ошибка получения статуса пользователя',
      errorLoadScenarioList: 'Ошибка загрузки списка сценариев',
      errorLoadScenario: 'Ошибка загрузки сценария',

      scenarioSaved: 'Сценарий сохранён',
      errorSaveScenario: 'Ошибка сохранения сценария'
    },
    testCall: {
      testCallActivated: 'Тестовый звонок активирован',
      errorCreatingTestCall: 'Ошибка создания тестового звонка',
      testCallNumberSaved: 'Номер тестового звонка сохранен',
      saveCampaignBeforeTestCall: 'Перед тестом необходимо сохранить рассылку'
    },
    callTasks: {
      errorLoadTestCallsPhoneNumbers: 'Ошибка загрузки тестовых телефонных номеров'
    }
  }
};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(499)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(501),
  /* scopeId */
  "data-v-317de15b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(502)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(504),
  /* scopeId */
  "data-v-45762da8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(505)
__webpack_require__(506)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(517),
  /* scopeId */
  "data-v-2409dfff",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(508)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(510),
  /* scopeId */
  "data-v-54c2f26b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(511)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(513),
  /* scopeId */
  "data-v-0454a37f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(518)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(523),
  /* scopeId */
  "data-v-5d04d4ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(520)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(522),
  /* scopeId */
  "data-v-3c8ac640",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(524)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(526),
  /* scopeId */
  "data-v-7fd87125",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(527)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(529),
  /* scopeId */
  "data-v-3502c9ca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(530)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(532),
  /* scopeId */
  "data-v-f4629e44",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(533)
__webpack_require__(534)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(536),
  /* scopeId */
  "data-v-ea0433e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(537)
__webpack_require__(538)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(540),
  /* scopeId */
  "data-v-4f99736a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(541)
__webpack_require__(542)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(643),
  /* scopeId */
  "data-v-b061a42a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(544)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(568),
  /* scopeId */
  "data-v-706346a6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(547)
__webpack_require__(548)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(555),
  /* scopeId */
  "data-v-879764ec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return googleVoicesMapList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return googleLanguages; });
var googleVoices = ['Arabic    Standard    ar-XA    ar-XA-Standard-A    FEMALE', 'Arabic    Standard    ar-XA    ar-XA-Standard-B    MALE', 'Arabic    Standard    ar-XA    ar-XA-Standard-C    MALE', 'Arabic    Standard    ar-XA    ar-XA-Standard-D    FEMALE', 'Arabic    WaveNet    ar-XA    ar-XA-Wavenet-A    FEMALE', 'Arabic    WaveNet    ar-XA    ar-XA-Wavenet-B    MALE', 'Arabic    WaveNet    ar-XA    ar-XA-Wavenet-C    MALE', 'Bengali (India)    Standard    bn-IN    bn-IN-Standard-A    FEMALE', 'Bengali (India)    Standard    bn-IN    bn-IN-Standard-B    MALE', 'Czech (Czech Republic)    Standard    cs-CZ    cs-CZ-Standard-A    FEMALE', 'Czech (Czech Republic)    WaveNet    cs-CZ    cs-CZ-Wavenet-A    FEMALE', 'Danish (Denmark)    Standard    da-DK    da-DK-Standard-A    FEMALE', 'Danish (Denmark)    WaveNet    da-DK    da-DK-Wavenet-A    FEMALE', 'Dutch (Netherlands)    Standard    nl-NL    nl-NL-Standard-A    FEMALE', 'Dutch (Netherlands)    Standard    nl-NL    nl-NL-Standard-B    MALE', 'Dutch (Netherlands)    Standard    nl-NL    nl-NL-Standard-C    MALE', 'Dutch (Netherlands)    Standard    nl-NL    nl-NL-Standard-D    FEMALE', 'Dutch (Netherlands)    Standard    nl-NL    nl-NL-Standard-E    FEMALE', 'Dutch (Netherlands)    WaveNet    nl-NL    nl-NL-Wavenet-A    FEMALE', 'Dutch (Netherlands)    WaveNet    nl-NL    nl-NL-Wavenet-B    MALE', 'Dutch (Netherlands)    WaveNet    nl-NL    nl-NL-Wavenet-C    MALE', 'Dutch (Netherlands)    WaveNet    nl-NL    nl-NL-Wavenet-D    FEMALE', 'Dutch (Netherlands)    WaveNet    nl-NL    nl-NL-Wavenet-E    FEMALE', 'English (Australia)    Standard    en-AU    en-AU-Standard-A    FEMALE', 'English (Australia)    Standard    en-AU    en-AU-Standard-B    MALE', 'English (Australia)    Standard    en-AU    en-AU-Standard-C    FEMALE', 'English (Australia)    Standard    en-AU    en-AU-Standard-D    MALE', 'English (Australia)    WaveNet    en-AU    en-AU-Wavenet-A    FEMALE', 'English (Australia)    WaveNet    en-AU    en-AU-Wavenet-B    MALE', 'English (Australia)    WaveNet    en-AU    en-AU-Wavenet-C    FEMALE', 'English (Australia)    WaveNet    en-AU    en-AU-Wavenet-D    MALE', 'English (India)    Standard    en-IN    en-IN-Standard-A    FEMALE', 'English (India)    Standard    en-IN    en-IN-Standard-B    MALE', 'English (India)    Standard    en-IN    en-IN-Standard-C    MALE', 'English (India)    Standard    en-IN    en-IN-Standard-D    FEMALE', 'English (India)    WaveNet    en-IN    en-IN-Wavenet-A    FEMALE', 'English (India)    WaveNet    en-IN    en-IN-Wavenet-B    MALE', 'English (India)    WaveNet    en-IN    en-IN-Wavenet-C    MALE', 'English (India)    WaveNet    en-IN    en-IN-Wavenet-D    FEMALE', 'English (UK)    Standard    en-GB    en-GB-Standard-A    FEMALE', 'English (UK)    Standard    en-GB    en-GB-Standard-B    MALE', 'English (UK)    Standard    en-GB    en-GB-Standard-C    FEMALE', 'English (UK)    Standard    en-GB    en-GB-Standard-D    MALE', 'English (UK)    WaveNet    en-GB    en-GB-Wavenet-A    FEMALE', 'English (UK)    WaveNet    en-GB    en-GB-Wavenet-B    MALE', 'English (UK)    WaveNet    en-GB    en-GB-Wavenet-C    FEMALE', 'English (UK)    WaveNet    en-GB    en-GB-Wavenet-D    MALE', 'English (US)    Standard    en-US    en-US-Standard-B    MALE', 'English (US)    Standard    en-US    en-US-Standard-C    FEMALE', 'English (US)    Standard    en-US    en-US-Standard-D    MALE', 'English (US)    Standard    en-US    en-US-Standard-E    FEMALE', 'English (US)    WaveNet    en-US    en-US-Wavenet-A    MALE', 'English (US)    WaveNet    en-US    en-US-Wavenet-B    MALE', 'English (US)    WaveNet    en-US    en-US-Wavenet-C    FEMALE', 'English (US)    WaveNet    en-US    en-US-Wavenet-D    MALE', 'English (US)    WaveNet    en-US    en-US-Wavenet-E    FEMALE', 'English (US)    WaveNet    en-US    en-US-Wavenet-F    FEMALE', 'Filipino (Philippines)    Standard    fil-PH    fil-PH-Standard-A    FEMALE', 'Filipino (Philippines)    WaveNet    fil-PH    fil-PH-Wavenet-A    FEMALE', 'Finnish (Finland)    Standard    fi-FI    fi-FI-Standard-A    FEMALE', 'Finnish (Finland)    WaveNet    fi-FI    fi-FI-Wavenet-A    FEMALE', 'French (Canada)    Standard    fr-CA    fr-CA-Standard-A    FEMALE', 'French (Canada)    Standard    fr-CA    fr-CA-Standard-B    MALE', 'French (Canada)    Standard    fr-CA    fr-CA-Standard-C    FEMALE', 'French (Canada)    Standard    fr-CA    fr-CA-Standard-D    MALE', 'French (Canada)    WaveNet    fr-CA    fr-CA-Wavenet-A    FEMALE', 'French (Canada)    WaveNet    fr-CA    fr-CA-Wavenet-B    MALE', 'French (Canada)    WaveNet    fr-CA    fr-CA-Wavenet-C    FEMALE', 'French (Canada)    WaveNet    fr-CA    fr-CA-Wavenet-D    MALE', 'French (France)    Standard    fr-FR    fr-FR-Standard-A    FEMALE', 'French (France)    Standard    fr-FR    fr-FR-Standard-B    MALE', 'French (France)    Standard    fr-FR    fr-FR-Standard-C    FEMALE', 'French (France)    Standard    fr-FR    fr-FR-Standard-D    MALE', 'French (France)    Standard    fr-FR    fr-FR-Standard-E    FEMALE', 'French (France)    WaveNet    fr-FR    fr-FR-Wavenet-A    FEMALE', 'French (France)    WaveNet    fr-FR    fr-FR-Wavenet-B    MALE', 'French (France)    WaveNet    fr-FR    fr-FR-Wavenet-C    FEMALE', 'French (France)    WaveNet    fr-FR    fr-FR-Wavenet-D    MALE', 'French (France)    WaveNet    fr-FR    fr-FR-Wavenet-E    FEMALE', 'German (Germany)    Standard    de-DE    de-DE-Standard-A    FEMALE', 'German (Germany)    Standard    de-DE    de-DE-Standard-B    MALE', 'German (Germany)    Standard    de-DE    de-DE-Standard-E    MALE', 'German (Germany)    Standard    de-DE    de-DE-Standard-F    FEMALE', 'German (Germany)    WaveNet    de-DE    de-DE-Wavenet-A    FEMALE', 'German (Germany)    WaveNet    de-DE    de-DE-Wavenet-B    MALE', 'German (Germany)    WaveNet    de-DE    de-DE-Wavenet-C    FEMALE', 'German (Germany)    WaveNet    de-DE    de-DE-Wavenet-D    MALE', 'German (Germany)    WaveNet    de-DE    de-DE-Wavenet-E    MALE', 'German (Germany)    WaveNet    de-DE    de-DE-Wavenet-F    FEMALE', 'Greek (Greece)    Standard    el-GR    el-GR-Standard-A    FEMALE', 'Greek (Greece)    WaveNet    el-GR    el-GR-Wavenet-A    FEMALE', 'Gujarati (India)    Standard    gu-IN    gu-IN-Standard-A    FEMALE', 'Gujarati (India)    Standard    gu-IN    gu-IN-Standard-B    MALE', 'Hindi (India)    Standard    hi-IN    hi-IN-Standard-A    FEMALE', 'Hindi (India)    Standard    hi-IN    hi-IN-Standard-B    MALE', 'Hindi (India)    Standard    hi-IN    hi-IN-Standard-C    MALE', 'Hindi (India)    Standard    hi-IN    hi-IN-Standard-D    FEMALE', 'Hindi (India)    WaveNet    hi-IN    hi-IN-Wavenet-A    FEMALE', 'Hindi (India)    WaveNet    hi-IN    hi-IN-Wavenet-B    MALE', 'Hindi (India)    WaveNet    hi-IN    hi-IN-Wavenet-C    MALE', 'Hindi (India)    WaveNet    hi-IN    hi-IN-Wavenet-D    FEMALE', 'Hungarian (Hungary)    Standard    hu-HU    hu-HU-Standard-A    FEMALE', 'Hungarian (Hungary)    WaveNet    hu-HU    hu-HU-Wavenet-A    FEMALE', 'Indonesian (Indonesia)    Standard    id-ID    id-ID-Standard-A    FEMALE', 'Indonesian (Indonesia)    Standard    id-ID    id-ID-Standard-B    MALE', 'Indonesian (Indonesia)    Standard    id-ID    id-ID-Standard-C    MALE', 'Indonesian (Indonesia)    Standard    id-ID    id-ID-Standard-D    FEMALE', 'Indonesian (Indonesia)    WaveNet    id-ID    id-ID-Wavenet-A    FEMALE', 'Indonesian (Indonesia)    WaveNet    id-ID    id-ID-Wavenet-B    MALE', 'Indonesian (Indonesia)    WaveNet    id-ID    id-ID-Wavenet-C    MALE', 'Indonesian (Indonesia)    WaveNet    id-ID    id-ID-Wavenet-D    FEMALE', 'Italian (Italy)    Standard    it-IT    it-IT-Standard-A    FEMALE', 'Italian (Italy)    Standard    it-IT    it-IT-Standard-B    FEMALE', 'Italian (Italy)    Standard    it-IT    it-IT-Standard-C    MALE', 'Italian (Italy)    Standard    it-IT    it-IT-Standard-D    MALE', 'Italian (Italy)    WaveNet    it-IT    it-IT-Wavenet-A    FEMALE', 'Italian (Italy)    WaveNet    it-IT    it-IT-Wavenet-B    FEMALE', 'Italian (Italy)    WaveNet    it-IT    it-IT-Wavenet-C    MALE', 'Italian (Italy)    WaveNet    it-IT    it-IT-Wavenet-D    MALE', 'Japanese (Japan)    Standard    ja-JP    ja-JP-Standard-A    FEMALE', 'Japanese (Japan)    Standard    ja-JP    ja-JP-Standard-B    FEMALE', 'Japanese (Japan)    Standard    ja-JP    ja-JP-Standard-C    MALE', 'Japanese (Japan)    Standard    ja-JP    ja-JP-Standard-D    MALE', 'Japanese (Japan)    WaveNet    ja-JP    ja-JP-Wavenet-A    FEMALE', 'Japanese (Japan)    WaveNet    ja-JP    ja-JP-Wavenet-B    FEMALE', 'Japanese (Japan)    WaveNet    ja-JP    ja-JP-Wavenet-C    MALE', 'Japanese (Japan)    WaveNet    ja-JP    ja-JP-Wavenet-D    MALE', 'Kannada (India)    Standard    kn-IN    kn-IN-Standard-A    FEMALE', 'Kannada (India)    Standard    kn-IN    kn-IN-Standard-B    MALE', 'Korean (South Korea)    Standard    ko-KR    ko-KR-Standard-A    FEMALE', 'Korean (South Korea)    Standard    ko-KR    ko-KR-Standard-B    FEMALE', 'Korean (South Korea)    Standard    ko-KR    ko-KR-Standard-C    MALE', 'Korean (South Korea)    Standard    ko-KR    ko-KR-Standard-D    MALE', 'Korean (South Korea)    WaveNet    ko-KR    ko-KR-Wavenet-A    FEMALE', 'Korean (South Korea)    WaveNet    ko-KR    ko-KR-Wavenet-B    FEMALE', 'Korean (South Korea)    WaveNet    ko-KR    ko-KR-Wavenet-C    MALE', 'Korean (South Korea)    WaveNet    ko-KR    ko-KR-Wavenet-D    MALE', 'Malayalam (India)    Standard    ml-IN    ml-IN-Standard-A    FEMALE', 'Malayalam (India)    Standard    ml-IN    ml-IN-Standard-B    MALE', 'Mandarin Chinese    Standard    cmn-CN    cmn-CN-Standard-A    FEMALE', 'Mandarin Chinese    Standard    cmn-CN    cmn-CN-Standard-B    MALE', 'Mandarin Chinese    Standard    cmn-CN    cmn-CN-Standard-C    MALE', 'Mandarin Chinese    Standard    cmn-CN    cmn-CN-Standard-D    FEMALE', 'Mandarin Chinese    WaveNet    cmn-CN    cmn-CN-Wavenet-A    FEMALE', 'Mandarin Chinese    WaveNet    cmn-CN    cmn-CN-Wavenet-B    MALE', 'Mandarin Chinese    WaveNet    cmn-CN    cmn-CN-Wavenet-C    MALE', 'Mandarin Chinese    WaveNet    cmn-CN    cmn-CN-Wavenet-D    FEMALE', 'Mandarin Chinese    Standard    cmn-TW    cmn-TW-Standard-A-Alpha    FEMALE', 'Mandarin Chinese    Standard    cmn-TW    cmn-TW-Standard-B-Alpha    MALE', 'Mandarin Chinese    Standard    cmn-TW    cmn-TW-Standard-C-Alpha    MALE', 'Mandarin Chinese    WaveNet    cmn-TW    cmn-TW-Wavenet-A-Alpha    FEMALE', 'Mandarin Chinese    WaveNet    cmn-TW    cmn-TW-Wavenet-B-Alpha    MALE', 'Mandarin Chinese    WaveNet    cmn-TW    cmn-TW-Wavenet-C-Alpha    MALE', 'Norwegian (Norway)    Standard    nb-NO    nb-NO-Standard-A    FEMALE', 'Norwegian (Norway)    Standard    nb-NO    nb-NO-Standard-B    MALE', 'Norwegian (Norway)    Standard    nb-NO    nb-NO-Standard-C    FEMALE', 'Norwegian (Norway)    Standard    nb-NO    nb-NO-Standard-D    MALE', 'Norwegian (Norway)    WaveNet    nb-NO    nb-NO-Wavenet-A    FEMALE', 'Norwegian (Norway)    WaveNet    nb-NO    nb-NO-Wavenet-B    MALE', 'Norwegian (Norway)    WaveNet    nb-NO    nb-NO-Wavenet-C    FEMALE', 'Norwegian (Norway)    WaveNet    nb-NO    nb-NO-Wavenet-D    MALE', 'Norwegian (Norway)    Standard    nb-NO    nb-no-Standard-E    FEMALE', 'Norwegian (Norway)    WaveNet    nb-NO    nb-no-Wavenet-E    FEMALE', 'Polish (Poland)    Standard    pl-PL    pl-PL-Standard-A    FEMALE', 'Polish (Poland)    Standard    pl-PL    pl-PL-Standard-B    MALE', 'Polish (Poland)    Standard    pl-PL    pl-PL-Standard-C    MALE', 'Polish (Poland)    Standard    pl-PL    pl-PL-Standard-D    FEMALE', 'Polish (Poland)    Standard    pl-PL    pl-PL-Standard-E    FEMALE', 'Polish (Poland)    WaveNet    pl-PL    pl-PL-Wavenet-A    FEMALE', 'Polish (Poland)    WaveNet    pl-PL    pl-PL-Wavenet-B    MALE', 'Polish (Poland)    WaveNet    pl-PL    pl-PL-Wavenet-C    MALE', 'Polish (Poland)    WaveNet    pl-PL    pl-PL-Wavenet-D    FEMALE', 'Polish (Poland)    WaveNet    pl-PL    pl-PL-Wavenet-E    FEMALE', 'Portuguese (Brazil)    Standard    pt-BR    pt-BR-Standard-A    FEMALE', 'Portuguese (Brazil)    WaveNet    pt-BR    pt-BR-Wavenet-A    FEMALE', 'Portuguese (Portugal)    Standard    pt-PT    pt-PT-Standard-A    FEMALE', 'Portuguese (Portugal)    Standard    pt-PT    pt-PT-Standard-B    MALE', 'Portuguese (Portugal)    Standard    pt-PT    pt-PT-Standard-C    MALE', 'Portuguese (Portugal)    Standard    pt-PT    pt-PT-Standard-D    FEMALE', 'Portuguese (Portugal)    WaveNet    pt-PT    pt-PT-Wavenet-A    FEMALE', 'Portuguese (Portugal)    WaveNet    pt-PT    pt-PT-Wavenet-B    MALE', 'Portuguese (Portugal)    WaveNet    pt-PT    pt-PT-Wavenet-C    MALE', 'Portuguese (Portugal)    WaveNet    pt-PT    pt-PT-Wavenet-D    FEMALE', 'Russian (Russia)    Standard    ru-RU    ru-RU-Standard-A    FEMALE', 'Russian (Russia)    Standard    ru-RU    ru-RU-Standard-B    MALE', 'Russian (Russia)    Standard    ru-RU    ru-RU-Standard-C    FEMALE', 'Russian (Russia)    Standard    ru-RU    ru-RU-Standard-D    MALE', 'Russian (Russia)    Standard    ru-RU    ru-RU-Standard-E    FEMALE', 'Russian (Russia)    WaveNet    ru-RU    ru-RU-Wavenet-A    FEMALE', 'Russian (Russia)    WaveNet    ru-RU    ru-RU-Wavenet-B    MALE', 'Russian (Russia)    WaveNet    ru-RU    ru-RU-Wavenet-C    FEMALE', 'Russian (Russia)    WaveNet    ru-RU    ru-RU-Wavenet-D    MALE', 'Russian (Russia)    WaveNet    ru-RU    ru-RU-Wavenet-E    FEMALE', 'Slovak (Slovakia)    Standard    sk-SK    sk-SK-Standard-A    FEMALE', 'Slovak (Slovakia)    WaveNet    sk-SK    sk-SK-Wavenet-A    FEMALE', 'Spanish (Spain)    Standard    es-ES    es-ES-Standard-A    FEMALE', 'Swedish (Sweden)    Standard    sv-SE    sv-SE-Standard-A    FEMALE', 'Swedish (Sweden)    WaveNet    sv-SE    sv-SE-Wavenet-A    FEMALE', 'Tamil (India)    Standard    ta-IN    ta-IN-Standard-A    FEMALE', 'Tamil (India)    Standard    ta-IN    ta-IN-Standard-B    MALE', 'Telugu (India)    Standard    te-IN    te-IN-Standard-A    FEMALE', 'Telugu (India)    Standard    te-IN    te-IN-Standard-B    MALE', 'Thai (Thailand)    Standard    th-TH    th-TH-Standard-A    FEMALE', 'Turkish (Turkey)    Standard    tr-TR    tr-TR-Standard-A    FEMALE', 'Turkish (Turkey)    Standard    tr-TR    tr-TR-Standard-B    MALE', 'Turkish (Turkey)    Standard    tr-TR    tr-TR-Standard-C    FEMALE', 'Turkish (Turkey)    Standard    tr-TR    tr-TR-Standard-D    FEMALE', 'Turkish (Turkey)    Standard    tr-TR    tr-TR-Standard-E    MALE', 'Turkish (Turkey)    WaveNet    tr-TR    tr-TR-Wavenet-A    FEMALE', 'Turkish (Turkey)    WaveNet    tr-TR    tr-TR-Wavenet-B    MALE', 'Turkish (Turkey)    WaveNet    tr-TR    tr-TR-Wavenet-C    FEMALE', 'Turkish (Turkey)    WaveNet    tr-TR    tr-TR-Wavenet-D    FEMALE', 'Turkish (Turkey)    WaveNet    tr-TR    tr-TR-Wavenet-E    MALE', 'Ukrainian (Ukraine)    Standard    uk-UA    uk-UA-Standard-A    FEMALE', 'Ukrainian (Ukraine)    WaveNet    uk-UA    uk-UA-Wavenet-A    FEMALE', 'Vietnamese (Vietnam)    Standard    vi-VN    vi-VN-Standard-A    FEMALE', 'Vietnamese (Vietnam)    Standard    vi-VN    vi-VN-Standard-B    MALE', 'Vietnamese (Vietnam)    Standard    vi-VN    vi-VN-Standard-C    FEMALE', 'Vietnamese (Vietnam)    Standard    vi-VN    vi-VN-Standard-D    MALE', 'Vietnamese (Vietnam)    WaveNet    vi-VN    vi-VN-Wavenet-A    FEMALE', 'Vietnamese (Vietnam)    WaveNet    vi-VN    vi-VN-Wavenet-B    MALE', 'Vietnamese (Vietnam)    WaveNet    vi-VN    vi-VN-Wavenet-C    FEMALE', 'Vietnamese (Vietnam)    WaveNet    vi-VN    vi-VN-Wavenet-D    MALE', 'Kazakh (Kazakhstan)    WaveNet    kz-KZ    kz-KZ-Standard-A    MALE'];

function getVoicesMapList() {
  console.log('google voices. getVoicesMapList');
  var map = {};
  for (var i = 0; i < googleVoices.length; i++) {
    var split = googleVoices[i].split('    ');
    var lang = split[2];
    var voice = split[3];
    var sex = split[4];
    var label = voice.substr(6) + ' ' + sex;
    if (!map[lang]) {
      map[lang] = [];
    }
    map[lang].push({
      value: voice,
      label: label
    });
  }
  return map;
}
function geLanguagesList() {
  var list = [];
  var map = {};
  for (var i = 0; i < googleVoices.length; i++) {
    var split = googleVoices[i].split('    ');
    if (!map[split[2]] && availableGoogleLanguages.indexOf(split[2]) > -1) {
      map[split[2]] = split[0];
      list.push({
        value: split[2],
        label: split[0]
      });
    }
  }
  return list;
}

var googleVoicesMapList = getVoicesMapList();

var availableGoogleLanguages = ['ar-XA', // 'Arabic'
'en-GB', // 'English (UK)'
'en-US', // 'English (US)'
'fr-FR', // 'French (France)'
'de-DE', // 'German (Germany)'
'pl-PL', // 'Polish'
'ru-RU', // 'Russian'
'es-ES', // 'Spanish'
'uk-UA', // 'Ukrainian'
'cs-CZ', // 'Czech'
'kz-KZ'];
var googleLanguages = geLanguagesList();

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(556)
__webpack_require__(557)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(564),
  /* scopeId */
  "data-v-4b93c4d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(560)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(562),
  /* scopeId */
  "data-v-5f96a77a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(565)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(567),
  /* scopeId */
  "data-v-174d9592",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(569)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(571),
  /* scopeId */
  "data-v-4109630b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(572)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(574),
  /* scopeId */
  "data-v-846ddb0c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(575)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(577),
  /* scopeId */
  "data-v-536189e6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(578)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(580),
  /* scopeId */
  "data-v-38d19f02",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(583)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(635),
  /* scopeId */
  "data-v-28a5cb3f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(585)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(586),
  /* template */
  __webpack_require__(587),
  /* scopeId */
  "data-v-c790dec8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(637)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(638),
  /* template */
  __webpack_require__(639),
  /* scopeId */
  "data-v-ffe66da0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(640)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(641),
  /* template */
  __webpack_require__(642),
  /* scopeId */
  "data-v-7a111e08",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(644)
__webpack_require__(645)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(650),
  /* scopeId */
  "data-v-4493c831",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(647)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(648),
  /* template */
  __webpack_require__(649),
  /* scopeId */
  "data-v-2659cb8f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(652)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(653),
  /* template */
  __webpack_require__(654),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(655)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(656),
  /* template */
  __webpack_require__(657),
  /* scopeId */
  "data-v-38b3bfa5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(658)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(659),
  /* template */
  __webpack_require__(660),
  /* scopeId */
  "data-v-6deb9466",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(664)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(665),
  /* template */
  __webpack_require__(666),
  /* scopeId */
  "data-v-7bce71ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */,
/* 254 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(319)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(328),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(256);


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(257);


__WEBPACK_IMPORTED_MODULE_0__app__["a" /* app */].$mount('#app');

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_buefy__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_buefy_dist_buefy_css__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_buefy_dist_buefy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_buefy_dist_buefy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_nprogress__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_vue__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__filters__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_js_toggle_button__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_js_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_js_toggle_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex_store_mutation_types__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_suggestion__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__translations_i18n__ = __webpack_require__(83);
/* unused harmony reexport router */
/* unused harmony reexport store */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






// import VueAuth from '@websanova/vue-auth'











// const ROUTE_ROLES = {
//   'Administrator': 1,
//   'Client': 2,
//   'Anonymous': 3
// }

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].router = __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_js_toggle_button___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_suggestion__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_buefy__["a" /* default */]);
// Vue.use(VueAuth, {
//   auth: {
//     request: function (req, token) {
//       this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + token})
//     },
//     response: function (res) {
//       // Get Token from response body
//       return res.data.auth.token
//     }
//   },
//   http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
//   router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
//   loginData: { url: 'http://localhost:8093/api/auth/sign-in', fetchUser: false },
//   refreshData: { enabled: false }
// })

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_nprogress___default.a);
// Enable devtools
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.devtools = true;

Object(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */]);

var nprogress = new __WEBPACK_IMPORTED_MODULE_5_vue_nprogress___default.a({ parent: '.nprogress-container' });

var state = __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state;

// Roles (binary)
//  000001 - SuperAdmin  (1)
//  000010 - Admin  (2)
//  000100 - Partner (4)
//  001000 - Referrer (8)
//  010000 - Client (16)
//  100000 - Anonymous (32)

var PAGE_MAPPER = {
  'Ошибка скачивания': 63,
  'Пользователь': 63,
  'Данные пользователя': 63,
  'Пользователи': 15,
  'Новый пользователь': 3,
  'Архив рассылок': 63,
  'Рассылки': 63,
  'Ежедневные Рассылки': 63,
  'Новая рассылка': 63,
  'Копия рассылки': 63,
  'Рассылка': 63,
  'Сценарии': 63,
  'Сценарий': 63,
  'Новый сценарий': 63,
  'Номера на прозвон': 63,
  'Мониторинг рассылки': 63,
  'Аггрегированный отчёт': 63,
  'Тестовые номера': 63,
  'Лицевой счет': 63,
  'Аналитика затрат': 63,
  'Детализации': 63,
  'Уведомления': 63,
  'Результат теста': 63,
  'Авторизация': 127,
  'Регистрация': 127,
  'Настройка прав': 1,
  'Настройка приложения': 1
};

__WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (state.app.device.isMobile && state.app.sidebar.opened) {
    __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_12_vuex_store_mutation_types__["d" /* TOGGLE_SIDEBAR */], false);
  }
  // next()
  var role = __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters.loggedRole;
  var toPathRoleGate = PAGE_MAPPER[to.name];
  console.log(role + '-' + toPathRoleGate);
  if ((role & toPathRoleGate) > 0) {
    next();
  } else if (__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters.isLogged) {
    next('/campaigns');
  } else {
    next('/login');
  }
});

Object.keys(__WEBPACK_IMPORTED_MODULE_10__filters__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter(key, __WEBPACK_IMPORTED_MODULE_10__filters__[key]);
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"](_extends({
  i18n: __WEBPACK_IMPORTED_MODULE_14__translations_i18n__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */],
  nprogress: nprogress
}, __WEBPACK_IMPORTED_MODULE_7__App_vue___default.a));



/***/ }),
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(285)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(314),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_layout___ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["c" /* Navbar */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["d" /* Sidebar */],
    AppMain: __WEBPACK_IMPORTED_MODULE_1_components_layout___["a" /* AppMain */],
    FooterBar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["b" /* FooterBar */],
    NprogressContainer: __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer___default.a
  },

  data: function data() {
    return {
      monitor: false
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    var _document = document,
        body = _document.body;

    var WIDTH = 768;
    var RATIO = 3;

    var handler = function handler() {
      if (!document.hidden) {
        var rect = body.getBoundingClientRect();
        var isMobile = rect.width - RATIO < WIDTH;
        _this.toggleDevice(isMobile ? 'mobile' : 'other');
        _this.toggleSidebar({
          opened: !isMobile
        });
      }
    };

    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
  },


  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    sidebar: 'sidebar',
    isLogged: 'isLogged',
    loggedRole: 'loggedRole'
  }),

  methods: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['toggleDevice', 'toggleSidebar'])
});

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(288)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(290),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nprogress-container'
});

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nprogress-container"
  })
},staticRenderFns: []}

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navbar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Navbar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Sidebar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AppMain__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__AppMain___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterBar__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FooterBar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__FooterBar___default.a; });









/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(293)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(297),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tooltip__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(158);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var APPCONFIG_API = '/api/appConfig';

/* harmony default export */ __webpack_exports__["default"] = ({

  components: {
    Tooltip: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tooltip__["a" /* default */]
  },

  props: {
    show: Boolean
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    pkginfo: 'pkg',
    sidebar: 'sidebar',
    loggedUser: 'loggedUser',
    loggedUserState: 'loggedUserState',
    loggedId: 'loggedId',
    isLogged: 'isLogged',
    authenticationToken: 'authenticationToken'
  }),

  data: function data() {
    return {
      appconfig: {},
      appTitle: '',
      languages: [{
        value: 'ru',
        label: 'Русский',
        ico: 'https://u6.filesonload.ru/aba5c429f806ba82de88b4376ac48a40/3680df95b29f311c5ca38f0f4dcfb9bb.png'
      }, {
        value: 'enAutoGenerate',
        label: 'English',
        ico: 'https://u6.filesonload.ru/aba5c429f806ba82de88b4376ac48a40/5c46b460c9073dcf9c1474b79f5d928d.png'
      }, {
        value: 'pl',
        label: 'Polski'
      }]
    };
  },


  created: function created() {
    this.loadAppConfig();
  },

  methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['toggleSidebar', 'removeToken', 'setLoggedRole', 'setLoggedStatus', 'setLoggedId', 'setLoggedUser', 'setLoggedUserState', 'setPermissionMap', 'setClientId']), {
    logout: function logout() {
      clearInterval(this.$root.monitor);
      this.removeToken();
      this.setLoggedId(null);
      this.setLoggedUser('');
      this.setLoggedUserState('');
      this.setLoggedStatus(false);
      this.setLoggedRole('Anonymous');
      this.setPermissionMap('');
      this.setClientId(null);
      this.$router.push('/login');
    },
    prepareSecurityHeader: function prepareSecurityHeader() {
      return {
        Authorization: 'Bearer ' + this.authenticationToken,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      };
    },
    loadAppConfig: function loadAppConfig() {
      var that = this;
      this.$http.get(APPCONFIG_API, { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.appconfig = response.data;
        that.appTitle = that.appconfig.defaultAppTitle;
        document.title = that.appTitle + ' - Личный Кабинет';
      }).catch(function (error) {
        console.log(error);
      });
    },
    languageChange: function languageChange() {
      Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* setCookie */])('voicebotLanguage', this.$i18n.locale);
      // document.cookie = 'voicebotLanguage=' + this.$i18n.locale
    }
  })
});

/***/ }),
/* 295 */,
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated",
    class: {
      slideInDown: _vm.show,
      slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left is-flex"
  }, [_c('a', {
    staticClass: "nav-item is-hidden-tablet",
    on: {
      "click": function($event) {
        return _vm.toggleSidebar({
          opened: !_vm.sidebar.opened
        })
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sidebar.hidden),
      expression: "!sidebar.hidden"
    }],
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "i18ChooseLanguage control select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$i18n.locale),
      expression: "$i18n.locale"
    }],
    staticClass: "form-control appLanguage",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$i18n, "locale", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.languageChange()
      }]
    }
  }, _vm._l((_vm.languages), function(language) {
    return _c('option', {
      style: ('background-image:url(' + language.ico + ');'),
      domProps: {
        "value": language.value
      }
    }, [_vm._v("\n                " + _vm._s(language.label) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "nav-center"
  }, [_c('a', {
    staticClass: "nav-item hero-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('tooltip', {
    attrs: {
      "label": 'beta',
      "placement": "right",
      "type": "success",
      "size": "small",
      "no-animate": true,
      "always": true,
      "rounded": true
    }
  }, [_c('div', {
    staticClass: "is-hidden-mobile"
  }, [_c('span', {
    staticClass: "vue"
  }, [_vm._v(_vm._s(_vm.appTitle))]), _vm._v(" "), _c('strong', {
    staticClass: "admin"
  }, [_vm._v(" " + _vm._s(_vm.$t('shell.personalAccount')))])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "nav-right is-flex"
  }, [_c('a', {
    staticClass: "nav-item is-hidden-tablet",
    on: {
      "click": function($event) {
        return _vm.toggleSidebar({
          opened: !_vm.sidebar.opened
        })
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sidebar.hidden),
      expression: "!sidebar.hidden"
    }],
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (_vm.loggedUser) ? _c('div', {
    staticClass: "nav-item"
  }, [_c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.loggedUser))])]), _vm._v(" "), (_vm.loggedUserState != 'Активен') ? _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.loggedUserState))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isLogged) ? _c('a', {
    staticClass: "nav-item",
    attrs: {
      "tag": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('button', {
    staticClass: "button is-light",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('shell.exit')))])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  })])
}]}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(299)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(305),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  components: {
    Expanding: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding___default.a
  },

  props: {
    show: Boolean
  },

  data: function data() {
    return {
      isReady: false,
      menuRoles: [{
        name: 'Сценарии',
        role: 63
      }, {
        name: 'Рассылки',
        role: 63
      }, {
        name: 'Ежедневные Рассылки',
        role: 63
      }, {
        name: 'Лицевой счет',
        role: 63
      }, {
        name: 'Аналитика затрат',
        role: 63
      }, {
        name: 'Детализации',
        role: 63
      }, {
        name: 'Уведомления',
        role: 63
      }, {
        name: 'Архив рассылок',
        role: 15
      }, {
        name: 'Пользователи',
        role: 15
      }, {
        name: 'Настройка прав',
        role: 1
      }, {
        name: 'Настройка приложения',
        role: 1
      }]
    };
  },
  mounted: function mounted() {
    var route = this.$route;
    if (route.name) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    }
  },


  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    menu: 'menuitems',
    loggedRole: 'loggedRole'
  }),

  methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['expandMenu']), {
    getLoggedUserRole: function getLoggedUserRole() {
      console.log(this.loggedRole);
      return this.loggedRole;
    },
    isExpanded: function isExpanded(item) {
      return item.meta.expanded;
    },
    toggle: function toggle(index, item) {
      this.expandMenu({
        index: index,
        expanded: !item.meta.expanded
      });
    },
    shouldExpandMatchItem: function shouldExpandMatchItem(route) {
      var matched = route.matched;
      var lastMatched = matched[matched.length - 1];
      var parent = lastMatched.parent || lastMatched;
      var isParent = parent === lastMatched;

      if (isParent) {
        var p = this.findParentFromMenu(route);
        if (p) {
          parent = p;
        }
      }

      if ('expanded' in parent.meta && !isParent) {
        this.expandMenu({
          item: parent,
          expanded: true
        });
      }
    },
    generatePath: function generatePath(item, subItem) {
      return '' + (item.component ? item.path + '/' : '') + subItem.path;
    },
    findParentFromMenu: function findParentFromMenu(route) {
      var menu = this.menu;
      for (var i = 0, l = menu.length; i < l; i++) {
        var item = menu[i];
        var k = item.children && item.children.length;
        if (k) {
          for (var j = 0; j < k; j++) {
            if (item.children[j].name === route.name) {
              return item;
            }
          }
        }
      }
    }
  }),

  watch: {
    $route: function $route(route) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    }
  }

});

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(302)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(304),
  /* scopeId */
  "data-v-66188c51",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.classList.remove('collapse');
      el.style.display = 'block';
      el.classList.add('collapsing');
      el.style.height = el.scrollHeight + 'px';
    },
    afterEnter: function afterEnter(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse', 'in');
    },
    beforeLeave: function beforeLeave(el) {
      el.classList.add('collapsing');
      el.classList.remove('collapse', 'in');
      el.style.height = 0;
    },
    afterLeave: function afterLeave(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse');
      el.style.display = 'none';
    }
  }

});

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterEnter": _vm.afterEnter,
      "beforeLeave": _vm.beforeLeave,
      "afterLeave": _vm.afterLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar animated",
    class: {
      slideInLeft: _vm.show,
      slideOutLeft: !_vm.show
    }
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('shell.menu')) + "\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.menu), function(item, index) {
    return _c('li', [((_vm.menuRoles[index].role & _vm.getLoggedUserRole()) > 0) ? _c('div', [(item.path) ? _c('router-link', {
      attrs: {
        "to": item.path,
        "exact": true,
        "aria-expanded": _vm.isExpanded(item) ? 'true' : 'false'
      },
      nativeOn: {
        "click": function($event) {
          return _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n          " + _vm._s(item.meta && item.meta.labelTrans && _vm.$t(item.meta.labelTrans) || item.meta.label || item.name) + "\n          "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]) : _c('a', {
      attrs: {
        "aria-expanded": _vm.isExpanded(item)
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n          " + _vm._s(item.meta.label || item.name) + "\n          "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]), _vm._v(" "), (item.children && item.children.length) ? _c('expanding', [_c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExpanded(item)),
        expression: "isExpanded(item)"
      }]
    }, _vm._l((item.children), function(subItem) {
      return (subItem.path) ? _c('li', [_c('router-link', {
        attrs: {
          "to": _vm.generatePath(item, subItem)
        }
      }, [_vm._v("\n                " + _vm._s(subItem.meta && subItem.meta.labelTrans && _vm.$t(subItem.meta.labelTrans) || subItem.meta.label || subItem.name) + "\n              ")])], 1) : _vm._e()
    }), 0)]) : _vm._e()], 1) : _vm._e()])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(307)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(309),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Levelbar from './Levelbar'


/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])({
    sidebar: 'sidebar'
  }), {
    hiddenSidebarStyle: function hiddenSidebarStyle() {
      return this.sidebar.hidden ? { 'margin-left': 0 } : null;
    }
  })

  // components: {
  //   Levelbar
  // }
});

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main",
    style: ([_vm.hiddenSidebarStyle])
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless app-content"
  }, [_c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "appear": ""
    }
  }, [_c('router-view', {
    staticClass: "animated"
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(311)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(313),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return this.$store.state.pkg;
  }
});

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('shell.developedBy')) + " "), _c('a', {
    attrs: {
      "href": "http://ivoice.tech",
      "target": "_blank"
    }
  }, [_vm._v("ivoice.tech")])])])])])
},staticRenderFns: []}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'loggedRole-' + _vm.loggedRole,
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), _c('navbar', {
    attrs: {
      "show": true
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "show": _vm.sidebar.opened && !_vm.sidebar.hidden && _vm.isLogged
    }
  }), _vm._v(" "), _c('app-main'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_store_modules_menu__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_scenarios_Scenario__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_scenarios_Scenario___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_scenarios_Scenario__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'is-active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    name: 'Ошибка скачивания',
    meta: {
      labelTrans: 'errors.downloadError'
    },
    path: '/error/downloadError',
    component: __webpack_require__(182)
  }, {
    name: 'Рассылки',
    meta: {
      labelTrans: 'campaigns.campaigns'
    },
    path: '/campaigns',
    component: __webpack_require__(179)
  }, {
    name: 'Ежедневные Рассылки',
    meta: {
      labelTrans: 'campaigns.dailyCampaigns'
    },
    path: '/campaigns/daily',
    component: __webpack_require__(180)
  }, {
    name: 'Архив рассылок',
    meta: {
      labelTrans: 'campaigns.campaignsArchive'
    },
    path: '/archive',
    component: __webpack_require__(173)
  }, {
    name: 'Новая рассылка',
    meta: {
      labelTrans: 'campaigns.newCampaign'
    },
    path: '/campaigns/new',
    component: __webpack_require__(50)
  }, {
    name: 'Копия рассылки',
    path: '/campaigns/copy/:idcopy',
    component: __webpack_require__(50),
    props: true
  }, {
    name: 'Рассылка',
    meta: {
      labelTrans: 'campaigns.campaign'
    },
    path: '/campaigns/:id',
    component: __webpack_require__(50),
    props: true
  }, {
    name: 'Сценарии',
    meta: {
      labelTrans: 'scenarios.scenarios'
    },
    path: '/scenarios',
    component: __webpack_require__(249)
  }, {
    name: 'Лицевой счет',
    meta: {
      labelTrans: 'billing.billing'
    },
    path: '/billing',
    component: __webpack_require__(165)
  }, {
    name: 'Аналитика затрат',
    meta: {
      labelTrans: 'billing.summaryLabel'
    },
    path: '/billing/summary',
    component: __webpack_require__(168)
  }, {
    name: 'Детализации',
    meta: {
      labelTrans: 'billing.detailsLabel'
    },
    path: '/billing/details',
    component: __webpack_require__(166)
  }, {
    name: 'Уведомления',
    meta: {
      labelTrans: 'billing.notificationsLabel'
    },
    path: '/billing/notifications',
    component: __webpack_require__(167)
  }, {
    path: '/scenarios/:campaignid/new',
    component: __WEBPACK_IMPORTED_MODULE_3__views_scenarios_Scenario___default.a,
    name: 'Новый сценарий',
    meta: {
      labelTrans: 'scenarios.newScenario'
    },
    props: true
  }, {
    name: 'Сценарий',
    meta: {
      labelTrans: 'scenarios.scenario'
    },
    path: '/scenarios/:campaignid/:id',
    component: __webpack_require__(84),
    props: true
  }, {
    name: 'Пользователи',
    path: '/users',
    meta: {
      labelTrans: 'users.users'
    },
    component: __webpack_require__(252)
  }, {
    name: 'Пользователь',
    meta: {
      labelTrans: 'users.user'
    },
    path: '/users/:id',
    component: __webpack_require__(105),
    props: true
  }, {
    name: 'Новый пользователь',
    meta: {
      labelTrans: 'users.newUser'
    },
    path: '/users/new',
    component: __webpack_require__(105)
  }, {
    name: 'Данные пользователя',
    meta: {
      labelTrans: 'users.userData'
    },
    path: '/profiles/:id',
    component: __webpack_require__(183),
    props: true
  }, {
    name: 'Номера на прозвон',
    path: '/callTasks/:id',
    component: __webpack_require__(169),
    props: true
  }, {
    name: 'Мониторинг рассылки',
    path: '/monitoring/:id',
    component: __webpack_require__(178),
    props: true
  }, {
    name: 'Аггрегированный отчёт',
    path: '/campaignCallsResult/:id',
    component: __webpack_require__(177),
    props: true
  }, {
    name: 'Тестовые номера',
    path: '/callTasksTest/:id',
    component: __webpack_require__(172),
    props: true
  }, {
    name: 'Результат теста',
    path: '/callTasksTestResult/:campaignid/:id',
    component: __webpack_require__(171),
    props: true
  }, {
    name: 'Авторизация',
    meta: {
      labelTrans: 'authentication.authentication'
    },
    path: '/login',
    component: __webpack_require__(163)
  }, {
    name: 'Регистрация',
    meta: {
      labelTrans: 'authentication.Регистрация'
    },
    path: '/sign-up',
    component: __webpack_require__(164)
  }, {
    name: 'Настройка прав',
    meta: {
      labelTrans: 'permissions.permissions'
    },
    path: '/permissions',
    component: __webpack_require__(251)
  }, {
    name: 'Настройка приложения',
    meta: {
      labelTrans: 'appConfig.appConfig'
    },
    path: '/appconfig',
    component: __webpack_require__(250)
  }].concat(_toConsumableArray(generateRoutesFromMenu(__WEBPACK_IMPORTED_MODULE_2_vuex_store_modules_menu__["a" /* default */].state.items)), [{
    path: '*',
    redirect: '/campaigns'
  }])
}));
// Menu should have 2 levels.
function generateRoutesFromMenu() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var routes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  for (var i = 0, l = menu.length; i < l; i++) {
    var item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes);
    }
  }
  return routes;
}

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// lazy loading Components
// https://github.com/vuejs/vue-router/blob/dev/examples/lazy-loading/app.js#L8
/* harmony default export */ __webpack_exports__["a"] = (function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__(317)("./" + name + (index ? '/index' : '') + '.vue');
  };
});

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Home.vue": [
		682,
		16
	],
	"./applications/Application.vue": [
		683,
		30
	],
	"./applications/Applications.vue": [
		684,
		40
	],
	"./audiorecording/audioRecorder.vue": [
		161
	],
	"./audiorecording/icon-button.vue": [
		162
	],
	"./authentication/AuthCommon.vue": [
		79
	],
	"./authentication/CheckPermission.vue": [
		37
	],
	"./authentication/CheckToken.vue": [
		20
	],
	"./authentication/Login.vue": [
		163
	],
	"./authentication/SignUp.vue": [
		164
	],
	"./axios/index.vue": [
		685,
		3
	],
	"./billing/Balance.vue": [
		165
	],
	"./billing/BillingDetails.vue": [
		166
	],
	"./billing/BillingNotifications.vue": [
		167
	],
	"./billing/BillingSummaryDashboard.vue": [
		168
	],
	"./calltasks/Calltasks.vue": [
		686,
		39
	],
	"./calltasks/CalltasksCampaign.vue": [
		169
	],
	"./calltasks/GetCalltaskState.vue": [
		49
	],
	"./calltasks/Modal.vue": [
		687,
		29
	],
	"./calltasks/TestCallTasksResult.vue": [
		171
	],
	"./calltasks/TestCalltasksCampaign.vue": [
		172
	],
	"./campaigns/Archive.vue": [
		173
	],
	"./campaigns/Campaign.vue": [
		50
	],
	"./campaigns/CampaignCallsResult.vue": [
		177
	],
	"./campaigns/CampaignMonitoring.vue": [
		178
	],
	"./campaigns/Campaigns.vue": [
		179
	],
	"./campaigns/CampaignsCommon.vue": [
		81
	],
	"./campaigns/Modal.vue": [
		64
	],
	"./campaigns/ReportGenerator.vue": [
		80
	],
	"./campaigns/daily/DailyCampaigns.vue": [
		180
	],
	"./campaigns/daily/ReusableCampaign.vue": [
		688,
		28
	],
	"./campaigns/quota/CampaignQuota.vue": [
		175
	],
	"./charts/Chartist.vue": [
		689,
		10
	],
	"./charts/Chartjs.vue": [
		690,
		2
	],
	"./charts/Peity.vue": [
		691,
		33
	],
	"./charts/Plotly.vue": [
		692,
		15
	],
	"./charts/index.vue": [
		693,
		38
	],
	"./clientes/Balance.vue": [
		107
	],
	"./clientes/ClientParameters.vue": [
		694,
		27
	],
	"./clientes/Clientes.vue": [
		695,
		26
	],
	"./components/BackToTop.vue": [
		696,
		37
	],
	"./components/Brace.vue": [
		697,
		0
	],
	"./components/Collapse.vue": [
		698,
		25
	],
	"./components/Datepicker.vue": [
		699,
		24
	],
	"./components/Default.vue": [
		700,
		13
	],
	"./components/Emoji.vue": [
		701,
		9
	],
	"./components/Lory.vue": [
		702,
		4
	],
	"./components/Message.vue": [
		703,
		23
	],
	"./components/Modal.vue": [
		704,
		6
	],
	"./components/Notification.vue": [
		705,
		22
	],
	"./components/Paging.vue": [
		32
	],
	"./components/ProgressBar.vue": [
		706,
		12
	],
	"./components/ProgressTracker.vue": [
		707,
		8
	],
	"./components/Quill.vue": [
		708,
		5
	],
	"./components/Rating.vue": [
		709,
		7
	],
	"./components/Slider.vue": [
		710,
		21
	],
	"./components/Switch.vue": [
		711,
		20
	],
	"./components/Tabs.vue": [
		712,
		19
	],
	"./components/Tooltip.vue": [
		713,
		18
	],
	"./components/VbSwitchWithTwoLabels.vue": [
		82
	],
	"./components/VisCommon.vue": [
		18
	],
	"./components/index.vue": [
		714,
		41
	],
	"./components/loaders/Loader1.vue": [
		176
	],
	"./components/loaders/LoaderRollers1.vue": [
		181
	],
	"./components/modals/CardModal.vue": [
		680,
		32
	],
	"./components/modals/ImageModal.vue": [
		679,
		36
	],
	"./components/modals/Modal.vue": [
		678,
		35
	],
	"./dashboard/index.vue": [
		715,
		1
	],
	"./errors/DownloadError.vue": [
		182
	],
	"./profiles/Profile.vue": [
		183
	],
	"./scenarios/Answer.vue": [
		44
	],
	"./scenarios/BaseComponent.vue": [
		23
	],
	"./scenarios/Modal.vue": [
		184
	],
	"./scenarios/ModalAudio.vue": [
		24
	],
	"./scenarios/Scenario.vue": [
		84
	],
	"./scenarios/Scenarios.vue": [
		249
	],
	"./scenarios/Sms.vue": [
		248
	],
	"./scenarios/audioCustomizer/AudioCustomizer.vue": [
		247
	],
	"./scenarios/commonComponents/LocalVoice.vue": [
		189
	],
	"./scenarios/commonComponents/ScenarioCommon.vue": [
		190
	],
	"./scenarios/depricated/1_questionYesNo_i18.vue": [
		188
	],
	"./scenarios/depricated/GenerateRepeatAudio.vue": [
		192
	],
	"./scenarios/depricated/ScenarioAkvamir.vue": [
		197
	],
	"./scenarios/depricated/ScenarioDentaPromotion.vue": [
		196
	],
	"./scenarios/depricated/ScenarioInterviewAFewQuestions.vue": [
		194
	],
	"./scenarios/depricated/ScenarioNotice.vue": [
		195
	],
	"./scenarios/depricated/ScenarioQuestionInterview.vue": [
		193
	],
	"./scenarios/depricated/ScenarioQuestionRecognition.vue": [
		186
	],
	"./scenarios/depricated/ScenarioQuestionYesNo.vue": [
		187
	],
	"./scenarios/depricated/ScenarioSaver.vue": [
		65
	],
	"./scenarios/depricated/ScenarioTwoLevelYesNo.vue": [
		191
	],
	"./scenarios/konstruktor/BaseEditableNode.vue": [
		199
	],
	"./scenarios/konstruktor/DebugDialog.vue": [
		210
	],
	"./scenarios/konstruktor/HttpRequest.vue": [
		246
	],
	"./scenarios/konstruktor/InOutState.vue": [
		202
	],
	"./scenarios/konstruktor/OutState.vue": [
		204
	],
	"./scenarios/konstruktor/Redirect.vue": [
		205
	],
	"./scenarios/konstruktor/ScenarioCommonParams.vue": [
		245
	],
	"./scenarios/konstruktor/ScenarioInfo.vue": [
		207
	],
	"./scenarios/konstruktor/ScenarioKonstruktor.vue": [
		198
	],
	"./scenarios/konstruktor/Sms.vue": [
		206
	],
	"./scenarios/konstruktor/TestCall.vue": [
		209
	],
	"./scenarios/konstruktor/ToolButtons.vue": [
		86
	],
	"./scenarios/konstruktor/UniversalAnswer.vue": [
		200
	],
	"./scenarios/konstruktor/Zoom.vue": [
		208
	],
	"./scenarios/konstruktor/suggestion-item-template.vue": [
		203
	],
	"./settings/AppConfig.vue": [
		250
	],
	"./settings/Permissions.vue": [
		251
	],
	"./tables/Basic.vue": [
		716,
		31
	],
	"./ui/Buttons.vue": [
		717,
		17
	],
	"./ui/Form.vue": [
		718,
		14
	],
	"./ui/Icons.vue": [
		719,
		11
	],
	"./ui/Typography.vue": [
		720,
		34
	],
	"./users/User.vue": [
		105
	],
	"./users/Users.vue": [
		252
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 317;
module.exports = webpackAsyncContext;

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var AUTH_API = '/api/auth';

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])(['removeToken', 'setLoggedRole', 'setLoggedStatus', 'setLoggedId', 'setLoggedUser', 'setLoggedUserState', 'setPermissionMap', 'setClientId']), {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    checkToken: function checkToken() {
      var _this = this;

      clearInterval(this.$root.monitor);
      var that = this;
      this.$http.get(AUTH_API + '/isTokenValid/' + this.authenticationToken, { headers: this.prepareSecurityHeader() }).then(function (response) {
        if (!response.data) {
          that.logout();
        }
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка проверки токена. ');
      });
    },
    logout: function logout() {
      this.removeToken();
      this.setLoggedId(null);
      this.setLoggedUser('');
      this.setLoggedUserState('');
      this.setLoggedStatus(false);
      this.setLoggedRole('Anonymous');
      this.setPermissionMap('');
      this.setClientId(null);
      this.$router.push('/login');
    }
  })
});

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BasicInput__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SingleInput__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SingleInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SingleInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WrapperInput__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WrapperInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__WrapperInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flatpickr__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flatpickr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_flatpickr__);
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BasicInput__["a" /* default */]],

  props: {
    alignment: String,
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  components: {
    SingleInput: __WEBPACK_IMPORTED_MODULE_1__SingleInput___default.a,
    WrapperInput: __WEBPACK_IMPORTED_MODULE_2__WrapperInput___default.a
  },

  data: function data() {
    return {
      datepicker: null,
      selectedDates: null
    };
  },
  mounted: function mounted() {
    if (!this.datepicker) {
      this.config.onValueUpdate = this.dateUpdated;
      this.datepicker = new __WEBPACK_IMPORTED_MODULE_3_flatpickr___default.a(this.$el, this.config);
      this.setDate(this.value);
    }
    this.$watch('config', this.redraw);
    this.$watch('value', this.setDate);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.datepicker && !this.static) {
      this.datepicker.destroy();
      this.datepicker = null;
    }
  },


  methods: {
    redraw: function redraw(newConfig) {
      this.datepicker.config = Object.assign(this.datepicker.config, newConfig);
      this.datepicker.redraw();
      this.datepicker.jumpToDate();
    },
    setDate: function setDate(newDate, oldDate) {
      newDate && this.datepicker.setDate(newDate);
    },
    dateUpdated: function dateUpdated(selectedDates, dateStr) {
      this.date = dateStr;
    }
  },

  computed: {
    wrap: function wrap() {
      return !!this.config.wrap;
    },
    static: function _static() {
      return !!this.config.static;
    },
    name: function name() {
      return this.wrap ? 'wrapperInput' : 'singleInput';
    },

    date: {
      get: function get() {
        return this.selectedDates || this.value;
      },
      set: function set(newValue) {
        if (this.selectedDates !== newValue) {
          this.selectedDates = newValue;
          this.$emit('input', newValue);
        }
      }
    }
  }
});

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(323),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BasicInput__ = __webpack_require__(78);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BasicInput__["a" /* default */]]
});

/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    staticClass: "input",
    class: _vm.inputClass,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(326),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BasicInput__ = __webpack_require__(78);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BasicInput__["a" /* default */]],

  props: {
    alignment: String
  }
});

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports={render:function (){
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control has-addons flatpickr",
    class: ( _obj = {}, _obj[("has-addons-" + _vm.alignment)] = _vm.alignment, _obj ),
    attrs: {
      "data-wrap": "true",
      "data-clickOpens": "false"
    }
  }, [_c('input', {
    staticClass: "input",
    class: _vm.inputClass,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "data-input": ""
    },
    domProps: {
      "value": _vm.value
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 327 */,
/* 328 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.wrap ? 'WrapperInput' : 'SingleInput', {
    tag: "component",
    attrs: {
      "value": _vm.date,
      "placeholder": _vm.placeholder,
      "inputClass": _vm.inputClass,
      "alignment": _vm.alignment
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icon_button__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icon_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__icon_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__recorder__ = __webpack_require__(334);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'audioRecorder',
  props: {
    attempts: { type: Number },
    compact: { type: Boolean, default: false },
    time: { type: Number },
    attemptsLimit: { type: Function },
    micFailed: { type: Function },
    startRecord: { type: Function },
    stopRecord: { type: Function },
    failedUpload: { type: Function },
    headers: { type: Object },
    startUpload: { type: Function },
    successfulUpload: { type: Function },
    uploadUrl: { type: String },
    successfulUploadMsg: { type: String, default: 'Upload successful' },
    failedUploadMsg: { type: String, default: 'Upload fail' }
  },
  data: function data() {
    var _this = this;

    return {
      isUploading: false,
      recorder: new __WEBPACK_IMPORTED_MODULE_1__recorder__["a" /* default */]({
        afterStop: function afterStop() {
          _this.recordList = _this.recorder.recordList();
          if (_this.stopRecord) {
            _this.stopRecord('stop record');
          }
        },
        attempts: this.attempts,
        time: this.time
      }),
      recordList: [],
      selected: {},
      uploadStatus: null,
      uploaderOptions: {},
      audioSource: {}
    };
  },

  components: {
    IconButton: __WEBPACK_IMPORTED_MODULE_0__icon_button___default.a
  },
  created: function created() {
    this.uploaderOptions = {
      failedUpload: this.failedUpload,
      headers: this.headers,
      startUpload: this.startUpload,
      successfulUpload: this.successfulUpload,
      uploadUrl: this.uploadUrl
    };
    this.$watch('audioSource', function () {
      this.$refs.questionPlayer.load();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.stopRecorder();
  },

  methods: {
    close: function close() {
      this.$emit('close');
    },
    toggleRecorder: function toggleRecorder() {
      if (this.attempts && this.recorder.records.length >= this.attempts) {
        return;
      }
      if (!this.isRecording || this.isRecording && this.isPause) {
        this.recorder.start();
        if (this.startRecord) {
          this.startRecord('start record');
        }
      } else {
        this.recorder.pause();
        if (this.startRecord) {
          this.startRecord('pause record');
        }
      }
    },
    stopRecorder: function stopRecorder() {
      if (!this.isRecording) {
        return;
      }
      this.recorder.stop();
      this.audioSource = this.recordList[0];
    },
    retry: function retry() {
      this.recordList.splice(0, 1);
      this.audioSource.url = null;
    }
  },
  computed: {
    iconButtonType: function iconButtonType() {
      return this.isRecording && this.isPause ? 'mic' : this.isRecording ? 'pause' : 'mic';
    },
    isPause: function isPause() {
      return this.recorder.isPause;
    },
    isRecording: function isRecording() {
      return this.recorder.isRecording;
    },
    message: function message() {
      return this.uploadStatus === 'success' ? this.successfulUploadMsg : this.failedUploadMsg;
    },
    recordedTime: function recordedTime() {
      if (this.time && this.recorder.duration >= this.time * 60) {
        this.stopRecorder();
      }
      return new Date(this.recorder.duration * 1000).toISOString().substr(14, 5);
    },
    uploadStatusClasses: function uploadStatusClasses() {
      var classes = ['ar__upload-status'];
      classes.push(this.uploadStatus === 'success' ? 'ar__upload-status--success' : 'ar__upload-status--fail');
      return classes.join(' ');
    },
    volume: function volume() {
      return parseFloat(this.recorder.volume);
    }
  }
});

/***/ }),
/* 331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'icon-button',
    props: {
        name: { type: String }
    },
    data: function data() {
        return {
            icons: {
                download: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"/><path fill="none" d="M0 0h24v24H0z"/></svg>',
                mic: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
                pause: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
                play: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
                save: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"/></svg>',
                stop: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M6 6h12v12H6z"/></svg>',
                volume: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/><path d="M0 0h24v24H0z" fill="none"/></svg>'
            }
        };
    }
});

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.icons[_vm.name])
    }
  })
},staticRenderFns: []}

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wav_encoder__ = __webpack_require__(335);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var _class = function () {
  function _class() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, _class);

    this.afterStop = options.afterStop;
    this.micFailed = options.micFailed;

    this.bufferSize = 4096;
    this.records = [];
    this.samples = [];

    this.isPause = false;
    this.isRecording = false;

    this.duration = 0;
    this.volume = 0;

    this._duration = 0;
  }

  _createClass(_class, [{
    key: 'start',
    value: function start() {
      navigator.mediaDevices.getUserMedia({ audio: true }).then(this._micCaptured.bind(this)).catch(this._micError.bind(this));
      this.isPause = false;
      this.isRecording = true;
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.stream.getTracks().forEach(function (track) {
        return track.stop();
      });
      this.input.disconnect();
      this.processor.disconnect();
      this.context.close();

      var encoder = new __WEBPACK_IMPORTED_MODULE_0__wav_encoder__["a" /* default */]({
        bufferSize: this.bufferSize,
        sampleRate: this.context.sampleRate,
        samples: this.samples
      });

      var audioBlob = encoder.getData();
      var audioUrl = URL.createObjectURL(audioBlob);

      this.samples = [];

      this.records.push({
        id: Date.now(),
        blob: audioBlob,
        duration: this.convertTimeMMSS(this.duration),
        url: audioUrl
      });

      this._duration = 0;
      this.duration = 0;

      this.isPause = false;
      this.isRecording = false;

      if (this.afterStop) {
        this.afterStop();
      }
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.stream.getTracks().forEach(function (track) {
        return track.stop();
      });
      this.input.disconnect();
      this.processor.disconnect();
      this.context.close();

      this._duration = this.duration;
      this.isPause = true;
    }
  }, {
    key: 'recordList',
    value: function recordList() {
      return this.records;
    }
  }, {
    key: 'lastRecord',
    value: function lastRecord() {
      return this.records.slice(-1);
    }
  }, {
    key: '_micCaptured',
    value: function _micCaptured(stream) {
      var _this = this;

      this.context = new (window.AudioContext || window.webkitAudioContext)();
      this.duration = this._duration;
      this.input = this.context.createMediaStreamSource(stream);
      this.processor = this.context.createScriptProcessor(this.bufferSize, 1, 1);
      this.stream = stream;

      this.processor.onaudioprocess = function (ev) {
        var sample = ev.inputBuffer.getChannelData(0);
        var sum = 0.0;

        for (var i = 0; i < sample.length; ++i) {
          sum += sample[i] * sample[i];
        }

        _this.duration = parseFloat(_this._duration) + parseFloat(_this.context.currentTime.toFixed(2));
        _this.volume = Math.sqrt(sum / sample.length).toFixed(2);
        _this.samples.push(new Float32Array(sample));
      };

      this.input.connect(this.processor);
      this.processor.connect(this.context.destination);
    }
  }, {
    key: '_micError',
    value: function _micError(error) {
      if (this.micFailed) {
        this.micFailed(error);
      }
    }
  }, {
    key: 'convertTimeMMSS',
    value: function convertTimeMMSS(seconds) {
      return new Date(seconds * 1000).toISOString().substr(14, 5);
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class(options) {
    _classCallCheck(this, _class);

    this.bufferSize = options.bufferSize || 4096;
    this.sampleRate = options.sampleRate;
    this.samples = options.samples;
  }

  _createClass(_class, [{
    key: 'getData',
    value: function getData() {
      this._joinSamples();

      var buffer = new ArrayBuffer(44 + this.samples.length * 2);
      var view = new DataView(buffer);

      this._writeString(view, 0, 'RIFF'); // RIFF identifier
      view.setUint32(4, 36 + this.samples.length * 2, true); // RIFF chunk length
      this._writeString(view, 8, 'WAVE'); // RIFF type
      this._writeString(view, 12, 'fmt '); // format chunk identifier
      view.setUint32(16, 16, true); // format chunk length
      view.setUint16(20, 1, true); // sample format (raw)
      view.setUint16(22, 1, true); // channel count
      view.setUint32(24, this.sampleRate, true); // sample rate
      view.setUint32(28, this.sampleRate * 4, true); // byte rate (sample rate * block align)
      view.setUint16(32, 4, true); // block align (channel count * bytes per sample)
      view.setUint16(34, 16, true); // bits per sample
      this._writeString(view, 36, 'data'); // data chunk identifier
      view.setUint32(40, this.samples.length * 2, true); // data chunk length

      this._floatTo16BitPCM(view, 44, this.samples);

      return new Blob([view], { type: 'audio/wav' });
    }
  }, {
    key: '_floatTo16BitPCM',
    value: function _floatTo16BitPCM(output, offset, input) {
      for (var i = 0; i < input.length; i++, offset += 2) {
        var s = Math.max(-1, Math.min(1, input[i]));
        output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
      }
    }
  }, {
    key: '_joinSamples',
    value: function _joinSamples() {
      var recordLength = this.samples.length * this.bufferSize;
      var joinedSamples = new Float64Array(recordLength);
      var offset = 0;

      for (var i = 0; i < this.samples.length; i++) {
        var sample = this.samples[i];
        joinedSamples.set(sample, offset);
        offset += sample.length;
      }

      this.samples = joinedSamples;
    }
  }, {
    key: '_writeString',
    value: function _writeString(view, offset, string) {
      for (var i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
      }
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ar"
  }, [(_vm.isUploading) ? _c('div', {
    staticClass: "ar__overlay"
  }) : _vm._e(), _vm._v(" "), (_vm.isUploading) ? _c('div', {
    staticClass: "ar-spinner"
  }, [_c('div', {
    staticClass: "ar-spinner__dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "ar-spinner__dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "ar-spinner__dot"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ar-content",
    class: {
      'ar__blur': _vm.isUploading
    }
  }, [_c('div', {
    staticClass: "ar-recorder"
  }, [_c('icon-button', {
    staticClass: "ar-icon ar-icon__lg",
    class: {
      'ar-icon--rec': _vm.isRecording,
      'ar-icon--pulse': _vm.isRecording && _vm.volume > 0.02
    },
    attrs: {
      "name": _vm.iconButtonType
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleRecorder.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('icon-button', {
    staticClass: "ar-icon ar-icon__sm ar-recorder__stop",
    attrs: {
      "name": "stop"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.stopRecorder.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ar-recorder__duration"
  }, [_vm._v(_vm._s(_vm.recordedTime))]), _vm._v(" "), (_vm.time) ? _c('div', {
    staticClass: "ar-recorder__time-limit"
  }, [_vm._v("Длительность записи ограничена: " + _vm._s(_vm.time) + " мин")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ar-records"
  }, [(_vm.audioSource.url) ? _c('audio', {
    ref: "questionPlayer",
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.audioSource.url
    }
  }), _vm._v("\n        Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ar__upload-status"
  }, [(_vm.audioSource.url) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.retry
    }
  }, [_vm._v("Перезаписать")]) : _vm._e(), _vm._v(" "), (_vm.audioSource.url) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.$emit('confirm', _vm.audioSource)
      }
    }
  }, [_vm._v("Сохранить")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-link",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Закрыть")])]), _vm._v(" "), (_vm.uploadStatus) ? _c('div', {
    class: _vm.uploadStatusClasses
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scenarios_BaseComponent__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scenarios_BaseComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__scenarios_BaseComponent__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//





var AUTH_API = '/api/auth';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AuthCommon',

  extends: __WEBPACK_IMPORTED_MODULE_1__scenarios_BaseComponent___default.a,
  methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])(['setAuthenticationToken', 'setLoggedRole', 'setLoggedStatus', 'setLoggedId', 'setLoggedUser', 'setLoggedUserState', 'setPermissionMap', 'setClientId']), {
    loginCallback: function loginCallback(response) {
      this.setAuthenticationToken(response.data.auth.token);
      this.setLoggedRole(response.data.role);
      this.setLoggedId(response.data.id);
      this.setLoggedUser(response.data.username);
      this.setLoggedUserState(response.data.state);
      this.setLoggedStatus(true);
      this.setPermission(response.data.role);
      this.setClientId(response.data.clientid);
    },
    setPermission: function setPermission(role) {
      var _this = this;

      this.$http.get(AUTH_API + '/getPermissions/' + role, { headers: this.prepareSecurityHeader() }).then(function (response) {
        var pMap = JSON.stringify(Object.entries(response.data));
        _this.setPermissionMap(pMap);
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка установки разрешений. ');
      });
    }
  })
});

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_message__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalAudio__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ModalAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//








var NotificationComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

// const MessageComponent = Vue.extend(Message)
// const openMessage = (propsData = {
//   title: '',
//   message: '',
//   type: '',
//   direction: '',
//   duration: 10000,
//   container: '.messages'
// }) => {
//   return new MessageComponent({
//     el: document.createElement('div'),
//     propsData
//   })
// }

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BaseComponent',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_4__ModalAudio___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_message___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a,
    Collapse: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__["Item"]
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapGetters"])(['loadedScenario', 'loggedId', 'loggedUser', 'authenticationToken'])),
  methods: {
    securityHeaders: function securityHeaders() {
      return {
        'testH': 'testHV',
        'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ'
      };
    },
    prepareUploadHeaders: function prepareUploadHeaders() {
      return {
        'headers': {
          'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
          'Content-Type': 'multipart/form-data',
          'testH': 'testHV'
        }
      };
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.currentAudio = null;
    },
    openModal: function openModal(audioId, audioValue, generationType, audioName) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед записью аудио необходимо сохранить сценарий');
      } else {
        this.showModal = true;
        this.currentAudio = new FormData();
        this.currentAudio.append('audioId', audioId);
        this.currentAudio.append('audioValue', audioValue);
        this.currentAudio.append('generationType', generationType);
        this.currentAudio.append('audioName', audioName);
      }
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: this.$i18n.messages[this.$i18n.locale].notifications.notification,
        message: message,
        type: type
      });
    }
  },
  data: function data() {
    return {
      showModal: null,
      currentAudio: null
    };
  }
});

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    type: String,
    title: String,
    message: String,
    direction: {
      type: String,
      default: 'Right'
    },
    duration: {
      type: Number,
      default: 4500
    },
    container: {
      type: String,
      default: '.notifications'
    }
  },

  data: function data() {
    return {
      $_parent_: null,
      show: true
    };
  },
  created: function created() {
    var $parent = this.$parent;
    if (!$parent) {
      var parent = document.querySelector(this.container);
      if (!parent) {
        // Lazy creating `div.notifications` container.
        var className = this.container.replace('.', '');
        var Notifications = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
          name: 'Notifications',
          render: function render(h) {
            return h('div', {
              'class': _defineProperty({}, '' + className, true)
            });
          }
        });
        $parent = new Notifications().$mount();
        document.body.appendChild($parent.$el);
      } else {
        $parent = parent.__vue__;
      }
      // Hacked.
      this.$_parent_ = $parent;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$_parent_) {
      this.$_parent_.$el.appendChild(this.$el);
      this.$parent = this.$_parent_;
      delete this.$_parent_;
    }
    if (this.duration > 0) {
      this.timer = setTimeout(function () {
        return _this.close();
      }, this.duration);
    }
  },
  destroyed: function destroyed() {
    this.$el.remove();
  },


  computed: {
    transition: function transition() {
      return 'bounce-' + this.direction;
    },
    enterClass: function enterClass() {
      return 'bounceIn' + this.direction;
    },
    leaveClass: function leaveClass() {
      return 'bounceOut' + this.direction;
    }
  },

  methods: {
    closedByUser: function closedByUser() {
      this.$emit('closed-by-user');
      clearTimeout(this.timer);
      this.show = false;
    },
    close: function close() {
      this.$emit('closed-automatically');
      clearTimeout(this.timer);
      this.show = false;
    },
    afterLeave: function afterLeave() {
      this.$destroy();
    }
  }
});

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: ['notification', 'animated', _vm.type ? ("is-" + _vm.type) : '']
  }, [_c('button', {
    staticClass: "delete touchable",
    on: {
      "click": function($event) {
        return _vm.closedByUser()
      }
    }
  }), _vm._v(" "), (_vm.title) ? _c('div', {
    staticClass: "title is-5"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.message) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    type: String,
    title: String,
    message: String,
    direction: {
      type: String,
      default: 'Down'
    },
    duration: {
      type: Number,
      default: 1500
    },
    container: {
      type: String,
      default: '.messages'
    },
    showCloseButton: Boolean
  },

  data: function data() {
    return {
      $_parent_: null,
      icons: {
        normal: '',
        primary: 'arrow-circle-right',
        info: 'info-circle',
        success: 'check-circle',
        warning: 'exclamation-circle',
        danger: 'times-circle'
      },
      show: true
    };
  },
  created: function created() {
    var $parent = this.$parent;
    if (!$parent) {
      var parent = document.querySelector(this.container);
      if (!parent) {
        // Lazy creating `div.notifications` container.
        var className = this.container.replace('.', '');
        var Messages = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
          name: 'Messages',
          render: function render(h) {
            return h('div', {
              'class': _defineProperty({}, '' + className, true)
            });
          }
        });
        $parent = new Messages().$mount();
        document.body.appendChild($parent.$el);
      } else {
        $parent = parent.__vue__;
      }
      // Hacked.
      this.$_parent_ = $parent;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$_parent_) {
      this.$_parent_.$el.appendChild(this.$el);
      this.$parent = this.$_parent_;
      delete this.$_parent_;
    }
    if (this.duration > 0) {
      this.timer = setTimeout(function () {
        return _this.close();
      }, this.duration);
    }
  },
  destroyed: function destroyed() {
    this.$el.remove();
  },


  computed: {
    transition: function transition() {
      return 'bounce-' + this.direction;
    },
    enterClass: function enterClass() {
      return 'bounceIn' + this.direction;
    },
    leaveClass: function leaveClass() {
      return 'bounceOut' + (this.direction === 'Up' ? 'Down' : 'Up');
    },
    icon: function icon() {
      return this.icons[this.type];
    }
  },

  methods: {
    close: function close() {
      clearTimeout(this.timer);
      this.show = false;
    },
    afterLeave: function afterLeave() {
      this.$destroy();
    }
  }
});

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "message-box animated"
  }, [_c('article', {
    class: ['message', _vm.type ? ("is-" + _vm.type) : '']
  }, [_c('div', {
    staticClass: "message-header"
  }, [(_vm.showCloseButton) ? _c('button', {
    staticClass: "delete touchable",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon) ? _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    class: ['fa', ("fa-" + _vm.icon)]
  })]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "message-body"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(348)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(350),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isFullwidth: Boolean,
    accordion: Boolean
  },

  computed: {
    $collapseItems: function $collapseItems() {
      return this.$children.filter(function (child) {
        return child._isCollapseItem;
      });
    }
  },

  methods: {
    openByIndex: function openByIndex(index) {
      if (this.accordion) {
        this.$collapseItems.forEach(function (item, i) {
          if (i !== index) {
            item.isActived = false;
          }
        });
      }
    }
  }

});

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapse is-fullwidth"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(352)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(355),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animejs__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animejs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    selected: Boolean,
    title: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      isActived: this.selected
    };
  },
  created: function created() {
    this._isCollapseItem = true;
  },
  mounted: function mounted() {
    this.$on('open', this.$parent.openByIndex);
    if (this.isActived) {
      this.$emit('open', this.index);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.anime && this.targets) {
      __WEBPACK_IMPORTED_MODULE_0_animejs___default.a.remove(this.targets);
    }
    this.$off('open', this.$parent.openByIndex);
  },


  computed: {
    index: function index() {
      return this.$parent.$collapseItems.indexOf(this);
    }
  },

  methods: {
    toggle: function toggle() {
      if (this.isActived = !this.isActived) {
        this.$emit('open', this.index);
      }
    },
    getAnime: function getAnime(targets) {
      if (this.anime) return this.anime;
      return this.anime = __WEBPACK_IMPORTED_MODULE_0_animejs___default()({ targets: targets });
    },
    cancel: function cancel() {
      this.anime.pause();
    },
    before: function before(targets) {
      if (!this.targets) this.targets = targets;
      targets.removeAttribute('style');
    },
    enter: function enter(targets, done) {
      var height = targets.scrollHeight;
      targets.style.height = 0;
      targets.style.opacity = 0;
      this.getAnime(targets).play({
        targets: targets,
        duration: 377,
        easing: 'easeOutExpo',
        opacity: [0, 1],
        height: height,
        complete: function complete() {
          targets.removeAttribute('style');
          done();
        }
      });
    },
    leave: function leave(targets, complete) {
      this.getAnime(targets).play({
        targets: targets,
        duration: 377,
        easing: 'easeOutExpo',
        opacity: [1, 0],
        height: 0,
        complete: complete
      });
    }
  }
});

/***/ }),
/* 354 */,
/* 355 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card collapse-item",
    class: {
      'is-fullwidth': _vm.$parent.isFullwidth,
      'is-active': _vm.isActived
    }
  }, [_c('header', {
    staticClass: "card-header touchable",
    attrs: {
      "role": "tab",
      "aria-expanded": _vm.selected ? 'true' : 'fase'
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('h3', {
    staticClass: "card-header-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "collapsed-fade",
      "css": false,
      "appear": ""
    },
    on: {
      "before-appear": _vm.before,
      "appear": _vm.enter,
      "appear-cancel": _vm.cancel,
      "before-enter": _vm.before,
      "enter": _vm.enter,
      "enter-cancel": _vm.cancel,
      "leave": _vm.leave,
      "leave-cancel": _vm.cancel
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActived),
      expression: "isActived"
    }],
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-content-box"
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-header-icon"
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])
}]}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_modal__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audiorecording_audioRecorder__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audiorecording_audioRecorder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__audiorecording_audioRecorder__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_modal__["c" /* Modal */],
    audioRecorder: __WEBPACK_IMPORTED_MODULE_1__audiorecording_audioRecorder___default.a
  },

  props: {
    visible: Boolean,
    title: String,
    audioUrl: ''
  },

  methods: {
    close: function close() {
      this.$emit('close');
    },
    confirmAction: function confirmAction(value) {
      this.$emit('confirm', value);
    }
  }
});

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(360),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModal__ = __webpack_require__(63);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BaseModal__["a" /* default */]],

  props: {
    closable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return ['modal', 'animated', 'is-active'];
    }
  }
});

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterLeave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.deactive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._t("default")], 2)]), _vm._v(" "), (_vm.closable) ? _c('button', {
    staticClass: "modal-close",
    on: {
      "click": _vm.deactive
    }
  }) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(363),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModal__ = __webpack_require__(63);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BaseModal__["a" /* default */]],

  props: {
    title: {
      type: String
    },
    okText: {
      type: String,
      default: 'Ok'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    }
  },

  computed: {
    classes: function classes() {
      return ['modal', 'animated', 'is-active'];
    }
  },

  methods: {
    ok: function ok() {
      this.$emit('ok');
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
});

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterLeave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.deactive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.deactive
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.ok
    }
  }, [_vm._v(_vm._s(_vm.okText))]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(366),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModal__ = __webpack_require__(63);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BaseModal__["a" /* default */]],

  props: {
    closable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return ['modal', 'animated', 'is-active'];
    }
  }
});

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterLeave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.deactive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.closable) ? _c('button', {
    staticClass: "modal-close",
    on: {
      "click": _vm.deactive
    }
  }) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "visible": _vm.visible
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', [_c('article', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h4', [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")])]), _vm._v(" "), _c('audio-recorder', {
    attrs: {
      "attempts": 1,
      "time": 2
    },
    on: {
      "close": _vm.close,
      "confirm": _vm.confirmAction
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 368 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['permissionMap'])),
  methods: {
    // general
    canCreate: function canCreate(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 1) === 1;
    },
    canRead: function canRead(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 2) === 2;
    },
    canUpdate: function canUpdate(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 4) === 4;
    },
    canDelete: function canDelete(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 8) === 8;
    },

    // key = 'campaign' only
    canModerate: function canModerate(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 16) === 16;
    },
    canUpdateAfterModerating: function canUpdateAfterModerating(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 32) === 32;
    },
    canAccessAdditionalParameters: function canAccessAdditionalParameters(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 64) === 64;
    },

    // key = 'user' only
    canSelectUser: function canSelectUser(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 16) === 16;
    },
    canUpdateUserTypeAndState: function canUpdateUserTypeAndState(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 32) === 32;
    },
    canUpdateUserPayment: function canUpdateUserPayment(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 64) === 64;
    }
  }
});

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_notification__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthCommon__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthCommon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AuthCommon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var AUTH_API = '/api/auth';
var APPCONFIG_API = '/api/appConfig';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_notification___default.a
  },
  extends: __WEBPACK_IMPORTED_MODULE_1__AuthCommon___default.a,
  data: function data() {
    return {
      data: {
        body: {
          username: null,
          password: null
        },
        rememberMe: false
      },
      canSignUp: true
    };
  },

  created: function created() {
    this.loadAppConfig();
  },
  mounted: function mounted() {
    // if (this.$auth.redirect()) {
    //   console.log('Redirect from: ' + this.$auth.redirect().from.name)
    // }
    // Can set query parameter here for auth redirect or just do it silently in login redirect.
  },

  methods: {
    login: function login() {
      var _this = this;

      this.$http.post(AUTH_API + '/sign-in', this.data.body).then(function (response) {
        _this.openNotificationWithType('success', 'Осуществлен вход ' + _this.data.body.username);
        _this.loginCallback(response);
        _this.$router.push('/scenarios');
      }).catch(function (error) {
        _this.openNotificationWithType('danger', 'Ошибка авторизации');
        console.log(error);
      });
    },
    loadAppConfig: function loadAppConfig() {
      var _this2 = this;

      this.$http.get(APPCONFIG_API, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.appconfig = response.data;
        _this2.canSignUp = _this2.appconfig.userCanSignUp;
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ');
      });
    }
  }
});

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.username),
      expression: "data.body.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "email@example.org"
    },
    domProps: {
      "value": (_vm.data.body.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.password),
      expression: "data.body.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.data.body.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Войти")]), _vm._v(" "), (_vm.canSignUp) ? _c('a', {
    staticClass: "button is-success",
    attrs: {
      "href": "#/sign-up"
    }
  }, [_c('span', [_vm._v("Зарегистрироваться")])]) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthCommon__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthCommon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AuthCommon__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var APPCONFIG_API = '/api/appConfig';
var AUTH_API = '/api/auth';

/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_1__AuthCommon___default.a,
  data: function data() {
    return {
      data: {
        body: {
          username: null,
          password: null,
          role: 16,
          // mainUserId: null,
          recaptchaResponse: null
        },
        matchPassword: null,
        rememberMe: false
      },
      rcapt_sig_key: "6Lc41nsUAAAAAHnkjZWH9mSV44CSugUJ58jN_zSq",
      rcapt_disable: Object({"NODE_ENV":"production","GOOGLE_RECAPTCHA_KEY":"6Lc41nsUAAAAAHnkjZWH9mSV44CSugUJ58jN_zSq"}).CAPTCHA_DISABLED,
      rcapt_id: 0,
      canSignUp: true,
      reg: /^([a-zA-Z0-9_-]+\.)*[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*\.[a-zA-Z]{2,6}$/
    };
  },
  mounted: function mounted() {
    if (window.grecaptcha && !this.rcapt_disable) {
      this.rcapt_id = grecaptcha.render(document.getElementById('g-recaptcha'), { sitekey: this.rcapt_sig_key });
    }
  },

  created: function created() {
    this.loadAppConfig();
  },
  methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])(['setAuthenticationToken', 'setLoggedRole', 'setLoggedStatus', 'setLoggedId']), {
    register: function register() {
      var _this = this;

      if (this.validateFields()) {
        this.$http.post(AUTH_API + '/sign-up', this.data.body).then(function (response) {
          _this.openNotificationWithType('success', 'Успешная регистрация пользователя ' + _this.data.body.username);
          _this.loginCallback(response);
          _this.$router.push('/scenarios');
        }).catch(function (error) {
          _this.openNotificationWithType('danger', 'Ошибка регистрации' + '\n' + error.response.data);
          console.log(error.response.data);
        });
      }
    },
    validateFields: function validateFields() {
      if (this.data.body.username) {
        if (this.reg.test(this.data.body.username)) {
          if (this.data.matchPassword === this.data.body.password) {
            if (!this.rcapt_disable && grecaptcha) {
              this.data.body.recaptchaResponse = grecaptcha.getResponse(this.rcapt_id);
              if (this.data.body.recaptchaResponse) {
                return true;
              } else {
                this.openNotificationWithType('danger', 'Необходимо пройти капчу!');
              }
            } else {
              return true;
            }
          } else {
            this.openNotificationWithType('danger', 'Пароли не совпадают');
          }
        } else {
          this.openNotificationWithType('danger', 'Необходимо ввести корректный адрес электронной почты');
        }
      } else {
        this.openNotificationWithType('danger', 'Необходимо ввести адрес электронной почты');
      }
      return false;
    },
    loadAppConfig: function loadAppConfig() {
      var _this2 = this;

      this.$http.get(APPCONFIG_API, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.appconfig = response.data;
        _this2.canSignUp = _this2.appconfig.userCanSignUp;
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ');
      });
    }
  })
});

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.register.apply(null, arguments)
      }
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.username),
      expression: "data.body.username"
    }],
    staticClass: "input",
    attrs: {
      "id": "email",
      "type": "email",
      "placeholder": "email@example.org"
    },
    domProps: {
      "value": (_vm.data.body.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.password),
      expression: "data.body.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.data.body.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Match password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.matchPassword),
      expression: "data.matchPassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "match password"
    },
    domProps: {
      "value": (_vm.data.matchPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "matchPassword", $event.target.value)
      }
    }
  })]), _vm._v(" "), (!_vm.rcapt_disable) ? _c('div', {
    staticClass: "g-recaptcha",
    attrs: {
      "data-sitekey": _vm.rcapt_sig_key,
      "id": "g-recaptcha"
    }
  }) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [(_vm.canSignUp) ? _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Зарегистрироваться")]) : _vm._e(), _vm._v(" "), _vm._m(0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button is-success",
    attrs: {
      "href": "#/login"
    }
  }, [_c('span', [_vm._v("Войти")])])
}]}

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Paging__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Paging___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Paging__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VisCommon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VisCommon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_VisCommon__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BILLING_API = 'billing/clientBalance';
var CLIENTS_API = '/api/clients';





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Balance',
  extends: __WEBPACK_IMPORTED_MODULE_2__components_VisCommon___default.a,
  components: {
    Paging: __WEBPACK_IMPORTED_MODULE_1__components_Paging___default.a
  },
  data: function data() {
    return {
      replenishmentResourcesPage: { content: [] },
      replenishItemsPerPage: 8,
      title: '',
      clientBalance: {},
      loading: false,
      currentSort: 'timestampUtcMillis',
      currentSortDir: 'desc'
    };
  },

  created: function created() {
    this.loadReplenishmentResourcesPage();
    this.loadClientBalance();
  },

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'clientId'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    loadReplenishmentResourcesPage: function loadReplenishmentResourcesPage(page) {
      var that = this;
      this.loading = true;
      page = page ? page - 1 : 0;
      var url = BILLING_API + '/getAddResourcesList/' + this.clientId + '?page=' + page + '&pageSize=' + this.replenishItemsPerPage + '&sortDir=' + 'desc' + '&sort=' + 'timestampUtcMillis';
      this.$http.get(url, { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.loading = false;
        that.replenishmentResourcesPage = response.data;
      }).catch(function (error) {
        that.loading = false;
        console.log(error);
        that.openNotificationWithType('danger', 'Ошибка загрузки списка пополнений. ');
      });
    },


    loadClientBalance: function loadClientBalance() {
      var _this = this;

      var that = this;
      this.loading = true;
      this.$http.get(CLIENTS_API + '/getClient/' + this.clientId, { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.loading = false;
        that.clientBalance = response.data.clientBalance;
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка загрузки данных клиента. ');
      });
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Paging',
    props: ['refresh', 'perPage', 'data', 'pagingClass'],
    data: function data() {
        return {
            maxVisibleButtons: 10
        };
    },

    computed: {
        totalPages: function totalPages() {
            return this._props.data.totalPages;
        },
        startPage: function startPage() {
            if (this.currentPage() === 1) {
                return 1;
            }

            if (this.currentPage() === this.totalPages) {
                return Math.max(this.totalPages - this.maxVisibleButtons + 1, 1);
            }

            return this.currentPage() - 1;
        },
        endPage: function endPage() {
            return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
        },
        pages: function pages() {
            var range = [];
            for (var i = this.startPage; i <= this.endPage; i += 1) {
                range.push({
                    name: i,
                    isDisabled: i === this.currentPage()
                });
            }
            return range;
        },
        isInFirstPage: function isInFirstPage() {
            return this._props.data.first;
        },
        isInLastPage: function isInLastPage() {
            return this._props.data.last;
        }
    },
    methods: {
        onClickFirstPage: function onClickFirstPage() {
            this.onPageChange(1);
        },
        onClickPreviousPage: function onClickPreviousPage() {
            this.onPageChange(this.currentPage() - 1);
        },
        onClickPage: function onClickPage(page) {
            this.onPageChange(page);
        },
        onClickNextPage: function onClickNextPage() {
            this.onPageChange(this.currentPage() + 1);
        },
        onClickLastPage: function onClickLastPage() {
            this.onPageChange(this.totalPages);
        },
        isPageActive: function isPageActive(page) {
            return this.currentPage() === page;
        },
        onPageChange: function onPageChange(page) {
            this._props.refresh(page);
        },
        currentPage: function currentPage() {
            return this._props.data.number + 1;
        }
    }
});

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.totalPages > 1),
      expression: "data.totalPages>1"
    }],
    staticClass: "pagination",
    class: _vm.pagingClass,
    attrs: {
      "role": "navigation",
      "aria-label": "pagination"
    }
  }, [_c('ul', {
    staticClass: "pagination-list"
  }, [_c('li', [_c('a', {
    staticClass: "pagination-link pagination-first",
    attrs: {
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to first page"
    },
    on: {
      "click": _vm.onClickFirstPage
    }
  }, [_vm._v("\n        Первая\n      ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "pagination-previous",
    attrs: {
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to previous page"
    },
    on: {
      "click": _vm.onClickPreviousPage
    }
  }, [_vm._v("\n        Предыдущая\n      ")])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', [_c('a', {
      staticClass: "pagination-link",
      class: {
        activepage: _vm.isPageActive(page.name)
      },
      attrs: {
        "disabled": page.isDisabled,
        "aria-label": ("Go to page number " + (page.name))
      },
      on: {
        "click": function($event) {
          return _vm.onClickPage(page.name)
        }
      }
    }, [_vm._v("\n        " + _vm._s(page.name) + "\n      ")])])
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "pagination-next",
    attrs: {
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to next page"
    },
    on: {
      "click": _vm.onClickNextPage
    }
  }, [_vm._v("\n        Следующая\n      ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "pagination-link pagination-last",
    attrs: {
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to last page"
    },
    on: {
      "click": _vm.onClickLastPage
    }
  }, [_vm._v("\n        Последняя\n      ")])])], 2)])
},staticRenderFns: []}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scenarios_BaseComponent__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scenarios_BaseComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__scenarios_BaseComponent__);
//
//
//
//

var PROFILES_API = '/api/profiles';
var APPCONFIG_API = '/api/appConfig';


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'VisCommon',
    extends: __WEBPACK_IMPORTED_MODULE_0__scenarios_BaseComponent___default.a,
    created: function created() {
        this.checkToken();
        this.loadState();
        this.loadAppConfig();
    },
    data: function data() {
        return {
            confirmation: true,
            appconfig: {},
            isActive: false
        };
    },

    methods: {
        loadAppConfig: function loadAppConfig() {
            var that = this;
            this.$http.get(APPCONFIG_API, { headers: this.prepareSecurityHeader() }).then(function (response) {
                that.appconfig = response.data;
            }).catch(function (error) {
                console.log(error);
                that.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ');
            });
        },
        loadState: function loadState() {
            var _this = this;

            var that = this;
            this.$http({
                url: PROFILES_API + '/activeState/' + this.loggedId,
                headers: this.prepareSecurityHeader()
            }).then(function (response) {
                that.isActive = response.data;
                if (!that.isActive) {
                    openMessage({
                        message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
                        type: 'danger',
                        showCloseButton: true
                    });
                }
            }).catch(function (error) {
                console.log(error);
                that.openNotificationWithType('danger', _this.$i18n.messages[_this.$i18n.locale].scenarios.errorToGetUserStatus);
            });
        },
        getDateFormat: function getDateFormat(datetime) {
            var now = new Date(datetime);
            var dd = now.getDate();
            var mm = now.getMonth() + 1; // January is 0!
            var hh = now.getHours();
            var min = now.getMinutes();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            if (hh < 10) {
                hh = '0' + hh;
            }
            if (min < 10) {
                min = '0' + min;
            }
            return dd + '.' + mm + '.' + now.getFullYear() + ' ' + hh + ':' + min;
        }
    }
});

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-custom"
  }, [(_vm.clientBalance.balance) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('h2', [_vm._v("Текущий баланс")]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.clientBalance.balance), function(value, name) {
    return _c('tr', {
      key: name
    }, [_c('td', {
      staticClass: "td-resource"
    }, [_vm._v(_vm._s(name))]), _vm._v(" "), _c('td', {
      staticClass: "td-value"
    }, [_vm._v(_vm._s(value))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.clientBalance.creditLimit) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('h2', [_vm._v(" Кредитный лимит ")]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.clientBalance.creditLimit), function(value, name) {
    return _c('tr', {
      key: name
    }, [_c('td', {
      staticClass: "td-resource"
    }, [_vm._v(_vm._s(name))]), _vm._v(" "), _c('td', {
      staticClass: "td-value"
    }, [_vm._v(_vm._s(value))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.replenishmentResourcesPage && _vm.replenishmentResourcesPage.content) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('h2', [_vm._v("Пополнения")]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.replenishmentResourcesPage.content), function(addResource) {
    return _c('tr', {
      key: addResource.id
    }, [_c('td', {
      staticClass: "date"
    }, [_vm._v("\n          " + _vm._s(_vm.getDateFormat((addResource.timestampUtcMillis / 1000) < 1000000000000 ? addResource.timestampUtcMillis : addResource.timestamp / 1000)) + "\n        ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "table-responsive"
    }, [_c('table', {
      staticClass: "table is-bordered"
    }, [_vm._m(3, true), _vm._v(" "), _c('tbody', _vm._l((addResource.resources), function(value, name) {
      return _c('tr', {
        key: name
      }, [(value) ? _c('td', {
        staticClass: "td-resource"
      }, [_vm._v(_vm._s(name) + "\n                ")]) : _vm._e(), _vm._v(" "), (value) ? _c('td', {
        staticClass: "td-value"
      }, [_vm._v(_vm._s(value) + "\n                ")]) : _vm._e()])
    }), 0)])])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "paging-bottom"
  }, [_c('Paging', {
    attrs: {
      "refresh": _vm.loadReplenishmentResourcesPage,
      "per-page": _vm.replenishItemsPerPage,
      "data": _vm.replenishmentResourcesPage,
      "pagingClass": 'bottom'
    },
    on: {
      "update:data": function($event) {
        _vm.replenishmentResourcesPage = $event
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ресурс")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ресурс")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n          Дата пополнения\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Пополняемые ресурсы\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ресурс")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])])
}]}

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VisCommon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VisCommon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_VisCommon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Paging__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Paging___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Paging__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var _MS_PER_DAY = 1000 * 60 * 60 * 24;
var CAMPAIGN_API = '/api/campaigns';
var BILLING_API = 'billing/details';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BillingDetails',
  extends: __WEBPACK_IMPORTED_MODULE_1__components_VisCommon___default.a,
  components: {
    Paging: __WEBPACK_IMPORTED_MODULE_2__components_Paging___default.a
  },

  data: function data() {
    return {
      loading: false,
      startPeriodDate: [],
      endPeriodDate: [],
      campaignsList: [],
      selectedCampaign: '',
      detailsReportsPage: { content: [] },
      currentSort: 'createdTimestamp',
      currentSortDir: 'desc',
      perPage: 8
    };
  },


  created: function created() {
    this.loadCampaignsList();
    this.loadDetailsReportsPage();
  },

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'clientId'])),

  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    loadCampaignsList: function loadCampaignsList() {
      var that = this;
      that.loading = true;
      this.$http.get(CAMPAIGN_API + '/listByClient', { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.loading = false;
        that.campaignsList = response.data.response;
      }).catch(function (error) {
        that.loading = false;
        console.log(error);
        that.openNotificationWithType('danger', 'Ошибка загрузки кампаний клиента.');
      });
    },
    sendGenerateDetailsReportRequest: function sendGenerateDetailsReportRequest() {
      if (!this.validateInputs()) {
        return;
      }
      var that = this;
      that.loading = true;
      this.$http.post(BILLING_API + '/create' + '?campaignId=' + this.selectedCampaign + '&startDatePeriod=' + this.formatDateToStr(this.startPeriodDate) + '&endDatePeriod=' + this.formatDateToStr(this.endPeriodDate), {}, { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.loading = false;

        if (response.data.response) {
          that.openNotificationWithType('info', 'Запрос на детализацию успешно создан.');
        }
        that.loadDetailsReportsPage();
      }).catch(function (error) {
        that.loading = false;
        console.log(error);
        that.openNotificationWithType('danger', 'Ошибка создания запроса детализации.');
      });
    },
    loadDetailsReportsPage: function loadDetailsReportsPage(page) {
      var that = this;
      this.loading = true;
      page = page ? page - 1 : 0;
      var url = BILLING_API + '/getReports' + '?page=' + page + '&pageSize=' + this.perPage + '&sortDir=' + this.currentSortDir + '&sort=' + this.currentSort;
      this.$http.get(url, { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.loading = false;
        that.detailsReportsPage = response.data.response;
      }).catch(function (error) {
        that.loading = false;
        console.log(error);
        that.openNotificationWithType('danger', 'Ошибка загрузки списка детализаций. ');
      });
    },
    validateInputs: function validateInputs() {
      if (!Date.parse(this.startPeriodDate) || !Date.parse(this.endPeriodDate) || this.selectedCampaign === '') {
        this.openNotificationWithType('danger', 'Не выбраны периоды дат или кампания.');
        return false;
      }

      var difference = this.dateDiffInDays(this.startPeriodDate, this.endPeriodDate);

      if (difference < 1) {
        this.openNotificationWithType('danger', 'Ошибка: конечная дата должна быть больше, чем стартовая и разница между ними должна быть равна хотя бы одному дню');
        return false;
      }

      if (difference > 30) {
        this.openNotificationWithType('danger', 'Ошибка: Разница между датами не должна первышать 30 дней');
        return false;
      }

      return true;
    },
    dateDiffInDays: function dateDiffInDays(a, b) {
      // Discard the time and time-zone information.
      var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
      var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

      return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    },


    getCurrentDate: function getCurrentDate() {
      var date = new Date();
      return date;
    },

    // dd.mm.yyyy
    formatDateToStr: function formatDateToStr(date) {
      var d = date.getDate();
      var m = date.getMonth() + 1;
      var y = date.getFullYear();

      var dateString = (d <= 9 ? '0' + d : d) + '.' + (m <= 9 ? '0' + m : m) + '.' + y;

      return dateString;
    },
    isEmpty: function isEmpty(obj) {
      return Object.keys(obj).length === 0;
    },
    getProgressType: function getProgressType(progress) {
      if (progress == 0) {
        return 'is-warning';
      }
      if (progress == 100) {
        return 'is-success';
      }

      return 'is-info';
    },


    getStatusClass: function getStatusClass(status) {
      if (status === 'SUCCESS') {
        return 'status-success';
      } else if (status === 'PENDING') {
        return 'status-pending';
      } else if (status === 'READY') {
        return 'status-ready';
      }
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-message', {
    attrs: {
      "title": "Info",
      "type": "is-info",
      "aria-close-label": "Close message"
    }
  }, [_vm._v("\n    Для того, чтобы выгрузить детализированный отчёт по кампании необходимо выбрать стартовую и конечную даты,\n    кампанию и нажать \"Отправить запрос\".\n    По готовности отчёта будет отправлено письмо. Так же результат можно будет посмотреть в релевантной карточке\n    детализации на данной странице.\n  ")]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Select start period date"
    }
  }, [_c('b-datepicker', {
    attrs: {
      "rounded": "",
      "size": "is-medium",
      "placeholder": "Click to select...",
      "max-date": _vm.getCurrentDate()
    },
    model: {
      value: (_vm.startPeriodDate),
      callback: function($$v) {
        _vm.startPeriodDate = $$v
      },
      expression: "startPeriodDate"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Select end period date"
    }
  }, [_c('b-datepicker', {
    attrs: {
      "rounded": "",
      "size": "is-medium",
      "placeholder": "Click to select...",
      "max-date": _vm.getCurrentDate()
    },
    model: {
      value: (_vm.endPeriodDate),
      callback: function($$v) {
        _vm.endPeriodDate = $$v
      },
      expression: "endPeriodDate"
    }
  })], 1), _vm._v(" "), (_vm.campaignsList) ? _c('b-field', {
    attrs: {
      "label": "Campaign"
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select a campaign",
      "rounded": "",
      "required": "",
      "expanded": "",
      "size": "is-medium"
    },
    model: {
      value: (_vm.selectedCampaign),
      callback: function($$v) {
        _vm.selectedCampaign = $$v
      },
      expression: "selectedCampaign"
    }
  }, _vm._l((_vm.campaignsList), function(campaign) {
    return _c('option', {
      key: campaign.id,
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n        " + _vm._s(campaign.name) + "\n      ")])
  }), 0)], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !!_vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.sendGenerateDetailsReportRequest()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Отправить запрос")])])]), _vm._v(" "), (_vm.detailsReportsPage && _vm.detailsReportsPage.content) ? _c('div', {
    staticClass: "reports-container"
  }, [_vm._l((_vm.detailsReportsPage.content), function(detailsReport) {
    return _c('div', {
      key: detailsReport.id,
      staticClass: "report-card"
    }, [_c('div', {
      staticClass: "report-card-title"
    }, [_c('h2', [_vm._v(" №" + _vm._s(detailsReport.id) + " ")]), _vm._v(" "), _c('span', {
      staticClass: "report-card-status",
      class: _vm.getStatusClass(detailsReport.status)
    }, [_vm._v(_vm._s(detailsReport.status))])]), _vm._v(" "), _c('div', {
      staticClass: "report-card-details"
    }, [_c('div', {
      staticClass: "report-card-details-item"
    }, [_vm._v("\n          Кампания : " + _vm._s(detailsReport.campaignName) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "report-card-details-item"
    }, [_vm._v("\n          Начало периода выгрузки : " + _vm._s(detailsReport.startDatePeriod) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "report-card-details-item"
    }, [_vm._v("\n          Конец периода выгрузки : " + _vm._s(detailsReport.endDatePeriod) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "report-card-details-item"
    }, [_vm._v("\n          Дата создания запроса : " + _vm._s(_vm.getDateFormat((detailsReport.createdTimestamp / 1000) < 1000000000000 ? detailsReport.createdTimestamp : detailsReport.createdTimestamp / 1000)) + "\n        ")]), _vm._v(" "), (detailsReport.finishedTimestamp) ? _c('div', {
      staticClass: "report-card-details-item"
    }, [_vm._v("\n          Запрос обработан : " + _vm._s(_vm.getDateFormat((detailsReport.finishedTimestamp / 1000) < 1000000000000 ? detailsReport.finishedTimestamp : detailsReport.finishedTimestamp / 1000)) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "report-card-details-item"
    }, [_vm._v("\n          Прогресс выполнения отчёта :\n        ")])]), _vm._v(" "), _c('div', {
      staticClass: "report-card-progress"
    }, [_c('b-progress', {
      attrs: {
        "size": "is-large",
        "type": _vm.getProgressType(detailsReport.progress),
        "value": detailsReport.progress,
        "show-value": "",
        "format": "percent"
      }
    })], 1), _vm._v(" "), (detailsReport.status === 'SUCCESS') ? _c('a', {
      staticClass: "report-card-button",
      attrs: {
        "target": "_blank",
        "rel": "noopener noreferrer",
        "href": detailsReport.hostPathToReport
      }
    }, [_vm._v(" Скачать отчёт ")]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "paging-bottom"
  }, [_c('Paging', {
    attrs: {
      "refresh": _vm.loadDetailsReportsPage,
      "per-page": _vm.perPage,
      "data": _vm.detailsReportsPage,
      "pagingClass": 'bottom'
    },
    on: {
      "update:data": function($event) {
        _vm.detailsReportsPage = $event
      }
    }
  })], 1)], 2) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  })])
}]}

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VisCommon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VisCommon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_VisCommon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Paging__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Paging___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Paging__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var BILLING_API = 'billing/notifications';
/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'BillingNotifications',
  extends: __WEBPACK_IMPORTED_MODULE_1__components_VisCommon___default.a,
  components: {
    Paging: __WEBPACK_IMPORTED_MODULE_2__components_Paging___default.a
  },

  data: function data() {
    return {
      loading: false,
      notificationsPage: { content: [] },
      currentSort: 'timestampInEpochMilli',
      currentSortDir: 'desc',
      perPage: 8
    };
  },


  created: function created() {
    this.loadNotificationsPage();
  },

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'clientId'])),

  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    loadNotificationsPage: function loadNotificationsPage(page) {
      var that = this;
      this.loading = true;
      page = page ? page - 1 : 0;
      var url = BILLING_API + '/get' + '?page=' + page + '&pageSize=' + this.perPage + '&sortDir=' + this.currentSortDir + '&sort=' + this.currentSort;
      this.$http.get(url, { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.loading = false;
        console.log(response.data.response);
        that.notificationsPage = response.data.response;
      }).catch(function (error) {
        that.loading = false;
        console.log(error);
        that.openNotificationWithType('danger', 'Ошибка загрузки уведомлений. ');
      });
    },


    getSubjectClass: function getSubjectClass(subject) {
      if (subject === 'REPLENISH_BALANCE') {
        return 'subject-info';
      } else if (subject === 'STOPPED_CAMPAIGN_RESUMED_AFTER_REPLENISH_BALANCE') {
        return 'subject-info';
      } else if (subject === 'CREDIT_LIMIT_UPDATE') {
        return 'subject-info';
      } else if (subject === 'DETAILS_REPORT_SUCCESS') {
        return 'subject-info';
      } else if (subject === 'CAMPAIGN_STOPPED_ON_CREDIT_LIMIT_EXCEED') {
        return 'subject-warn';
      }
    }
  }

});

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.notificationsPage && _vm.notificationsPage.content) ? _c('div', {
    staticClass: "notifications-container"
  }, [_vm._l((_vm.notificationsPage.content), function(notification) {
    return _c('div', {
      key: notification.id,
      staticClass: "notification-card"
    }, [_c('div', {
      staticClass: "notification-card-title"
    }, [_c('h2', [_vm._v(" №" + _vm._s(notification.id) + " ")]), _vm._v(" "), _c('span', {
      staticClass: "notification-card-subject",
      class: _vm.getSubjectClass(notification.subject)
    }, [_vm._v(_vm._s(notification.subject))])]), _vm._v(" "), _c('div', {
      staticClass: "notification-card-details"
    }, [_c('div', {
      staticClass: "notification-card-details-item"
    }, [_vm._v("\n        " + _vm._s(notification.message) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "notification-card-details-item"
    }, [_vm._v("\n        Дата :\n        " + _vm._s(_vm.getDateFormat((notification.timestampInEpochMilli / 1000) < 1000000000000 ? notification.timestampInEpochMilli : notification.timestampInEpochMilli / 1000)) + "\n      ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "paging-bottom"
  }, [_c('Paging', {
    attrs: {
      "refresh": _vm.loadNotificationsPage,
      "per-page": _vm.perPage,
      "data": _vm.notificationsPage,
      "pagingClass": 'bottom'
    },
    on: {
      "update:data": function($event) {
        _vm.notificationsPage = $event
      }
    }
  })], 1)], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VisCommon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VisCommon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_VisCommon__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var BILLING_API = 'billing/';
var _MS_PER_DAY = 1000 * 60 * 60 * 24;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BillingSummaryDashboard',
  extends: __WEBPACK_IMPORTED_MODULE_1__components_VisCommon___default.a,
  data: function data() {
    return {
      loading: false,
      startPeriodDate: [],
      endPeriodDate: [],
      summaryData: {}
    };
  },

  created: function created() {
    this.startPeriodDate = this.getFirstDayOfCurrentMonth();
    this.endPeriodDate = this.getLastDayOfCurrentMonth();
    this.loadAggregateDataForPeriod();
  },

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'clientId'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },


    getFirstDayOfCurrentMonth: function getFirstDayOfCurrentMonth() {
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      return firstDay;
    },

    getLastDayOfCurrentMonth: function getLastDayOfCurrentMonth() {
      var date = new Date();
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      return lastDay;
    },

    dateDiffInDays: function dateDiffInDays(a, b) {
      // Discard the time and time-zone information.
      var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
      var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

      return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    },


    // dd.mm.yyyy
    formatDateToStr: function formatDateToStr(date) {
      var d = date.getDate();
      var m = date.getMonth() + 1;
      var y = date.getFullYear();

      var dateString = (d <= 9 ? '0' + d : d) + '.' + (m <= 9 ? '0' + m : m) + '.' + y;

      return dateString;
    },
    loadAggregateDataForPeriod: function loadAggregateDataForPeriod() {
      var that = this;
      var difference = that.dateDiffInDays(this.startPeriodDate, this.endPeriodDate);
      if (difference < 1) {
        that.openNotificationWithType('danger', 'Ошибка: конечная дата должна быть больше, чем стартовая и разница между ними должна быть равна хотя бы одному дню');
      }
      that.loading = true;
      this.$http.get(BILLING_API + 'getAggregateForPeriod/' + '?startPeriodDate=' + that.formatDateToStr(that.startPeriodDate) + '&endPeriodDate=' + that.formatDateToStr(that.endPeriodDate), { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.loading = false;
        that.summaryData = response.data.response;
      }).catch(function (error) {
        that.loading = false;
        console.log(error);
        that.openNotificationWithType('danger', 'Ошибка загрузки данных клиента. ');
      });
    }
  }
});

/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-message', {
    attrs: {
      "title": "Info",
      "type": "is-info",
      "aria-close-label": "Close message"
    }
  }, [_vm._v("\n    На данный момент можно посмотреть параметры в пределах текущего месяца, ниже можно выбрать период, по умолчанию\n    это начало и конец текущего месяца\n  ")]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Select start period date of current month"
    }
  }, [_c('b-datepicker', {
    attrs: {
      "rounded": "",
      "size": "is-medium",
      "placeholder": "Click to select...",
      "min-date": _vm.getFirstDayOfCurrentMonth(),
      "max-date": _vm.getLastDayOfCurrentMonth()
    },
    model: {
      value: (_vm.startPeriodDate),
      callback: function($$v) {
        _vm.startPeriodDate = $$v
      },
      expression: "startPeriodDate"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Select end period date of current month"
    }
  }, [_c('b-datepicker', {
    attrs: {
      "rounded": "",
      "size": "is-medium",
      "placeholder": "Click to select...",
      "min-date": _vm.getFirstDayOfCurrentMonth(),
      "max-date": _vm.getLastDayOfCurrentMonth()
    },
    model: {
      value: (_vm.endPeriodDate),
      callback: function($$v) {
        _vm.endPeriodDate = $$v
      },
      expression: "endPeriodDate"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !!_vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.loadAggregateDataForPeriod()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Загрузить данные")])])]), _vm._v(" "), (_vm.summaryData) ? _c('div', {
    staticClass: "summary-container"
  }, [_c('div', {
    staticClass: "client-summary"
  }, [_c('h2', {
    staticClass: "client-summary-title"
  }, [_vm._v(" " + _vm._s(_vm.summaryData.clientName))]), _vm._v(" "), (_vm.summaryData.clientSummary) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('h2', [_vm._v("Затрачено за период по всем кампаниям")]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.summaryData.clientSummary), function(value, name) {
    return _c('tr', {
      key: name
    }, [_c('td', {
      staticClass: "td-resource"
    }, [_vm._v(_vm._s(name))]), _vm._v(" "), _c('td', {
      staticClass: "td-value"
    }, [_vm._v(_vm._s(value))])])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "campaigns-summary-container"
  }, _vm._l((_vm.summaryData.campaignSummaryList), function(item) {
    return _c('div', {
      key: item.campaignName,
      staticClass: "campaigns-summary-item"
    }, [_c('div', {
      staticClass: "campaigns-summary-item-title"
    }, [_vm._v(" " + _vm._s(item.campaignName))]), _vm._v(" "), _c('div', {
      staticClass: "campaigns-summary-item-data"
    }, [(item.campaignSummary) ? _c('div', {
      staticClass: "table-responsive"
    }, [_c('h2', [_vm._v("Затрачено за период по кампании")]), _vm._v(" "), _c('table', {
      staticClass: "table is-bordered"
    }, [_vm._m(2, true), _vm._v(" "), _c('tbody', _vm._l((item.campaignSummary), function(value, name) {
      return _c('tr', {
        key: name
      }, [_c('td', {
        staticClass: "td-resource"
      }, [_vm._v(_vm._s(name))]), _vm._v(" "), _c('td', {
        staticClass: "td-value"
      }, [_vm._v(_vm._s(value))])])
    }), 0)])]) : _vm._e()])])
  }), 0)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ресурс")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ресурс")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])])
}]}

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    getCallTaskState: function getCallTaskState(state) {
      if (this.$i18n && this.$i18n.locale && this.$i18n.messages && this.$i18n.messages[this.$i18n.locale]) {
        return this.$i18n.messages[this.$i18n.locale].callTasks.states[state.toLowerCase()];
      } else {
        switch (state) {
          case 'FAILED':
            return 'Недозвон';
          case 'DIALING':
            return 'Вызов';
          case 'ONGOING':
            return 'Идет разговор';
          case 'PERFORMED':
            return 'Выполнена';
          case 'POSTPONED':
            return 'Отложена';
          case 'READY':
            return 'В очереди';
          case 'TELEPHONY_ERROR_SUSPEND':
            return 'Отложена';
          case 'CANCELLED':
            return 'Отменена';
          default:
            return state;
        }
      }
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_jump__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GetCalltaskState__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GetCalltaskState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__GetCalltaskState__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_4__GetCalltaskState___default.a);

var CALLTASKS_API = '/outgoing-cpg-sec';
var CAMPAIGNS_API = '/api/campaigns';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  components: {
    BackToTop: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_jump__["a" /* BackToTop */]
  },
  data: function data() {
    return {
      calltasks: [],
      campaign: ''
    };
  },

  created: function created() {
    this.checkToken();
    this.calltasks = this.loadData();
    this.loadCampaign();
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'loggedId'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    loadApplications: function loadApplications() {
      this.loadData();
    },
    loadData: function loadData() {
      var _this = this;

      this.$http.get(CALLTASKS_API + '/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.calltasks = response.data;
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка загрузки телефонных номеров. ');
      });
    },
    loadCampaign: function loadCampaign() {
      var _this2 = this;

      this.$http.get(CAMPAIGNS_API + '/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.campaign = response.data;
      });
    },
    cancel: function cancel() {
      this.$router.push('/campaigns/' + this.$props.id);
    }
  }
});

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(398)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(401),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jump_js__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(400);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    visibilityHeight: {
      type: Number,
      default: 400
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      visible: false
    };
  },
  mounted: function mounted() {
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },


  methods: {
    handleScroll: function handleScroll() {
      this.visible = Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* getScroll */])(window, true) > this.visibilityHeight;
    },
    scrollToTop: function scrollToTop() {
      Object(__WEBPACK_IMPORTED_MODULE_0_jump_js__["a" /* default */])(document.body, this.options);
    }
  }
});

/***/ }),
/* 400 */,
/* 401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "jump back-to-top",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(404),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jump_js__ = __webpack_require__(170);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    target: String,
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  created: function created() {
    this.$el = this.$el.nextSibling;
  },
  mounted: function mounted() {
    this.$el.addEventListener('click', this.handler);
  },


  methods: {
    handler: function handler() {
      Object(__WEBPACK_IMPORTED_MODULE_0_jump_js__["a" /* default */])(this.target, this.options);
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jump"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("по рассылке " + _vm._s(_vm.campaign.name))]), _vm._v(" "), _c('div', {
    staticClass: "jump-target"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.calltasks), function(calltask) {
    return _c('tr', [_c('td', [(calltask.testing) ? _c('strong', [_vm._v(_vm._s(calltask.phone))]) : _vm._e(), _vm._v(" "), (!calltask.testing) ? _c('div', [_vm._v(_vm._s(calltask.phone))]) : _vm._e()]), _vm._v(" "), _c('td', [(calltask.testing) ? _c('strong', [_vm._v(_vm._s(_vm.getCallTaskState(calltask.state)))]) : _vm._e(), _vm._v(" "), (!calltask.testing) ? _c('div', [_vm._v(_vm._s(_vm.getCallTaskState(calltask.state)))]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('back-to-top', {
    attrs: {
      "target": ".jump-target"
    }
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("Наверх")])])], 1), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Телефон")]), _vm._v(" "), _c('th', [_vm._v("Состояние")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
}]}

/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_collapse__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GetCalltaskState__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GetCalltaskState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__GetCalltaskState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_audio_player_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_audio_player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_audio_player_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_7__GetCalltaskState___default.a);

var NotificationComponent = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var CALLTASKTESTING_API = '/outgoing-cpg-sec/callTasksTesting';
var CAMPAIGNS_API = '/api/campaigns';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['campaignid', 'id'],
  data: function data() {
    return {
      callTask: {},
      callTaskState: '',
      callTaskParameters: '',
      callTaskReportParameters: '',
      campaign: '',
      title: '',
      results: {},
      recognitionLogs: {},
      permissionKey: 'campaign',
      scenarioTestAudio: ''
    };
  },

  components: {
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification___default.a,
    Collapse: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_collapse__["Item"],
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_8__components_audio_player_vue___default.a
  },
  created: function created() {
    this.checkToken();
    this.handlePhone();
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['loggedUser', 'authenticationToken'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      };
    },
    handlePhone: function handlePhone() {
      this.loadCampaign();
      this.loadCallTask();
    },
    loadCallTask: function loadCallTask() {
      var _this = this;

      this.$http({
        url: CALLTASKTESTING_API + '/' + this.$props.id,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('opening testing call task ' + response.data.phone);
        _this.callTask = response.data;
        _this.callTaskState = _this.getCallTaskState(_this.callTask.state);
        _this.callTaskParameters = JSON.stringify(_this.callTask.parameters);
        _this.callTaskReportParameters = JSON.stringify(_this.callTask.reportParameters);
        _this.results = Object.entries(_this.callTask.scenarioResult.items[0]);
        for (var i = 1; i < _this.callTask.scenarioResult.items.length; i++) {
          _this.results = _this.results.concat(['', '']);
          _this.results = _this.results.concat(Object.entries(_this.callTask.scenarioResult.items[i]));
        }
        _this.recognitionLogs = Object.entries(_this.callTask.scenarioResult.log[0]);
        for (var j = 1; j < _this.callTask.scenarioResult.log.length; j++) {
          _this.recognitionLogs = _this.recognitionLogs.concat(['', '']);
          _this.recognitionLogs = _this.recognitionLogs.concat(Object.entries(_this.callTask.scenarioResult.log[j]));
        }
        // this.results = this.callTask.scenarioResult.items
        // this.results = Object.entries(this.callTask.scenarioResult)
        _this.isSaved = true;
        _this.initScenarioTestAudio();
      }).catch(function (error) {
        console.log(error);
        // this.openNotificationWithType('danger', 'Ошибка загрузки информации о тестовом звонке. ')
        _this.callTask.campaign = _this.$props.id;
      });
    },
    loadCampaign: function loadCampaign() {
      var _this2 = this;

      this.$http.get(CAMPAIGNS_API + '/' + this.$props.campaignid, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.campaign = response.data;
        _this2.initScenarioTestAudio();
        // this.callTask.campaign = this.campaign
      });
    },
    initScenarioTestAudio: function initScenarioTestAudio() {
      if (this.campaign && this.campaign.recordHost && this.campaign.clientId && this.callTask && this.callTask.id) {
        this.scenarioTestAudio = this.campaign.recordHost + '/' + this.campaign.clientId + '/' + this.campaign.id + '/' + this.callTask.id + '.wav';
      }
    },
    cancel: function cancel() {
      this.$router.push('/callTasksTest/' + this.$props.campaignid);
    },
    getDateTime: function getDateTime(time) {
      var d = new Date(time);
      var day = d.getUTCDate();
      var month = d.getUTCMonth() + 1;
      var year = d.getUTCFullYear();
      var hour = d.getUTCHours();
      var minute = d.getUTCMinutes();
      if (day < 10) day = '0' + day;
      if (month < 10) month = '0' + month;
      if (hour < 10) hour = '0' + hour;
      if (minute < 10) minute = '0' + minute;
      return day + '.' + month + '.' + year + ' ' + hour + ':' + minute + ' UTC';
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: this.$i18n.messages[this.$i18n.locale].notifications.notification,
        message: message,
        type: type
      });
    }
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cleave_js__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cleave_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cleave_js__);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      cleave: null
    };
  },


  methods: {
    updateValue: function updateValue(value) {
      this.$emit('input', value);
    }
  },

  mounted: function mounted() {
    this.cleave = new __WEBPACK_IMPORTED_MODULE_0_cleave_js___default.a(this.$el, this.options);
  },
  beforeDestroy: function beforeDestroy() {
    this.cleave.destroy();
  }
});

/***/ }),
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    file: {
      type: String,
      default: null
    },
    onLoad: {
      type: Function,
      default: null
    }
  },
  data: function data() {
    return {
      audio: undefined,
      currentSeconds: 0,
      durationSeconds: 0,
      durationSeconds_: 0,
      loaded: false,
      playing: false,
      previousVolume: 35,
      showVolume: false,
      volume: 100
    };
  },
  computed: {
    currentTime: function currentTime() {
      return new Date(this.currentSeconds * 1000).toISOString().substr(14, 5);
    },
    durationTime: function durationTime() {
      return new Date(this.durationSeconds_ * 1000).toISOString().substr(14, 5);
    },
    percentComplete: function percentComplete() {
      return parseInt(this.currentSeconds / this.durationSeconds * 100);
    },
    muted: function muted() {
      return this.volume / 100 === 0;
    }
  },
  watch: {
    playing: function playing(value) {
      if (value) {
        return this.audio.play();
      }
      this.audio.pause();
    },
    volume: function volume(value) {
      this.showVolume = false;
      this.audio.volume = this.volume / 100;
    }
  },
  methods: {
    download: function download() {
      this.stop();
      window.location.href = this.audio.currentSrc;
    },
    load: function load() {
      if (this.audio.readyState >= 2) {
        this.loaded = true;
        this.durationSeconds = parseInt(this.audio.duration);
        this.durationSeconds_ = Math.ceil(this.audio.duration);
        // this.playing = this.autoPlay

        if (this.onLoad) {
          this.onLoad({ duration: this.durationSeconds_, url: this.audio.src });
        }
      } else {
        throw new Error('Failed to load sound file.');
      }
    },
    mute: function mute() {
      if (this.muted) {
        this.volume = this.previousVolume;
      } else {
        this.previousVolume = this.volume;
        this.volume = 0;
      }
    },
    seek: function seek(e) {
      if (!this.playing || e.target.tagName === 'SPAN') {
        return;
      }

      var el = e.target.getBoundingClientRect();
      var seekPos = (e.clientX - el.left) / el.width;

      this.audio.currentTime = parseInt(this.audio.duration * seekPos);
    },
    stop: function stop() {
      this.playing = false;
      this.audio.currentTime = 0;
    },
    update: function update(e) {
      this.currentSeconds = parseInt(this.audio.currentTime);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.audio = null;
    var len = document.querySelectorAll('audio').length;
    for (var i = 0; i < len; i++) {
      if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
        if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src').nodeValue == this.file) {
          this.audio = document.querySelectorAll('audio')[i];
        }
      }
    }
    this.audio.addEventListener('timeupdate', this.update);
    this.audio.addEventListener('loadeddata', this.load);
    this.audio.addEventListener('pause', function () {
      _this.playing = false;
    });
    this.audio.addEventListener('play', function () {
      _this.playing = true;
    });
  }
});

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "player"
  }, [_c('iframe', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "my_iframe"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "player-controls"
  }, [_c('div', [_c('a', {
    attrs: {
      "title": "Стоп",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.stop.apply(null, arguments)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "18px",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M16,4.995v9.808C16,15.464,15.464,16,14.804,16H4.997C4.446,16,4,15.554,4,15.003V5.196C4,4.536,4.536,4,5.196,4h9.808C15.554,4,16,4.446,16,4.995z"
    }
  })])])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "title": "Воспроизведение/Пауза",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.playing = !_vm.playing
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "18px",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20"
    }
  }, [(!_vm.playing) ? _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M15,10.001c0,0.299-0.305,0.514-0.305,0.514l-8.561,5.303C5.51,16.227,5,15.924,5,15.149V4.852c0-0.777,0.51-1.078,1.135-0.67l8.561,5.305C14.695,9.487,15,9.702,15,10.001z"
    }
  }) : _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M15,3h-2c-0.553,0-1,0.048-1,0.6v12.8c0,0.552,0.447,0.6,1,0.6h2c0.553,0,1-0.048,1-0.6V3.6C16,3.048,15.553,3,15,3z M7,3H5C4.447,3,4,3.048,4,3.6v12.8C4,16.952,4.447,17,5,17h2c0.553,0,1-0.048,1-0.6V3.6C8,3.048,7.553,3,7,3z"
    }
  })])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "player-progress",
    attrs: {
      "title": "Воспроизведено : Всего"
    },
    on: {
      "click": _vm.seek
    }
  }, [_c('div', {
    staticClass: "player-seeker",
    style: ({
      width: this.percentComplete + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "player-time"
  }, [_c('div', {
    staticClass: "player-time-current"
  }, [_vm._v(_vm._s(_vm.currentTime))]), _vm._v(" "), _c('div', {
    staticClass: "player-time-total"
  }, [_vm._v(_vm._s(_vm.durationTime))])])]), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('a', {
    attrs: {
      "title": "Загрузка файла",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.download.apply(null, arguments)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "18px",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M15,7h-3V1H8v6H5l5,5L15,7z M19.338,13.532c-0.21-0.224-1.611-1.723-2.011-2.114C17.062,11.159,16.683,11,16.285,11h-1.757l3.064,2.994h-3.544c-0.102,0-0.194,0.052-0.24,0.133L12.992,16H7.008l-0.816-1.873c-0.046-0.081-0.139-0.133-0.24-0.133H2.408L5.471,11H3.715c-0.397,0-0.776,0.159-1.042,0.418c-0.4,0.392-1.801,1.891-2.011,2.114c-0.489,0.521-0.758,0.936-0.63,1.449l0.561,3.074c0.128,0.514,0.691,0.936,1.252,0.936h16.312c0.561,0,1.124-0.422,1.252-0.936l0.561-3.074C20.096,14.468,19.828,14.053,19.338,13.532z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "muting"
  }, [_c('a', {
    attrs: {
      "title": "Приглушение",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.mute.apply(null, arguments)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "18px",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20"
    }
  }, [(!_vm.muted) ? _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M5.312,4.566C4.19,5.685-0.715,12.681,3.523,16.918c4.236,4.238,11.23-0.668,12.354-1.789c1.121-1.119-0.335-4.395-3.252-7.312C9.706,4.898,6.434,3.441,5.312,4.566z M14.576,14.156c-0.332,0.328-2.895-0.457-5.364-2.928C6.745,8.759,5.956,6.195,6.288,5.865c0.328-0.332,2.894,0.457,5.36,2.926C14.119,11.258,14.906,13.824,14.576,14.156zM15.434,5.982l1.904-1.906c0.391-0.391,0.391-1.023,0-1.414c-0.39-0.391-1.023-0.391-1.414,0L14.02,4.568c-0.391,0.391-0.391,1.024,0,1.414C14.41,6.372,15.043,6.372,15.434,5.982z M11.124,3.8c0.483,0.268,1.091,0.095,1.36-0.388l1.087-1.926c0.268-0.483,0.095-1.091-0.388-1.36c-0.482-0.269-1.091-0.095-1.36,0.388L10.736,2.44C10.468,2.924,10.642,3.533,11.124,3.8z M19.872,6.816c-0.267-0.483-0.877-0.657-1.36-0.388l-1.94,1.061c-0.483,0.268-0.657,0.878-0.388,1.36c0.268,0.483,0.877,0.657,1.36,0.388l1.94-1.061C19.967,7.907,20.141,7.299,19.872,6.816z"
    }
  }) : _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M14.201,9.194c1.389,1.883,1.818,3.517,1.559,3.777c-0.26,0.258-1.893-0.17-3.778-1.559l-5.526,5.527c4.186,1.838,9.627-2.018,10.605-2.996c0.925-0.922,0.097-3.309-1.856-5.754L14.201,9.194z M8.667,7.941c-1.099-1.658-1.431-3.023-1.194-3.26c0.233-0.234,1.6,0.096,3.257,1.197l1.023-1.025C9.489,3.179,7.358,2.519,6.496,3.384C5.568,4.31,2.048,9.261,3.265,13.341L8.667,7.941z M18.521,1.478c-0.39-0.391-1.023-0.391-1.414,0L1.478,17.108c-0.391,0.391-0.391,1.024,0,1.414c0.391,0.391,1.023,0.391,1.414,0l15.629-15.63C18.912,2.501,18.912,1.868,18.521,1.478z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "volume"
  }, [_c('a', {
    attrs: {
      "title": "Громкость",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      },
      "mouseenter": function($event) {
        _vm.showVolume = true
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "18px",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M19,13.805C19,14.462,18.462,15,17.805,15H1.533c-0.88,0-0.982-0.371-0.229-0.822l16.323-9.055C18.382,4.67,19,5.019,19,5.9V13.805z"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy.number",
      value: (_vm.volume),
      expression: "volume",
      modifiers: {
        "lazy": true,
        "number": true
      }
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.showVolume),
      expression: "showVolume"
    }],
    attrs: {
      "type": "range",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.volume)
    },
    on: {
      "change": function($event) {
        _vm.volume = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('audio', {
    ref: "audiofile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": _vm.file,
      "preload": "auto"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', [_c('div', {
    staticClass: "is-inline-block"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('callTasks.byCampaign')) + " " + _vm._s(_vm.campaign.name))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('callTasks.phoneNumber')) + " " + _vm._s(_vm.callTask.phone))])]), _vm._v(" "), (_vm.scenarioTestAudio) ? _c('div', {
    staticClass: "is-inline-block resultAudio"
  }, [_c('audio', [(_vm.scenarioTestAudio) ? _c('source', {
    attrs: {
      "src": _vm.scenarioTestAudio
    }
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.Your_browser_does_not_support_html5_audio_Try_chrome')) + "\n          ")]), _vm._v(" "), (_vm.scenarioTestAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenarioTestAudio
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('p', {
    staticClass: "control"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('callTasks.state')) + "  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTaskState),
      expression: "callTaskState"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTaskState)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.callTaskState = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('collapse-item', {
    attrs: {
      "title": _vm.$t('common.results'),
      "selected": ""
    }
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('common.parameter')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.value')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.results), function(res) {
    return _c('tr', [_c('td', [_vm._v("\n                  " + _vm._s(res[0]) + "\n                ")]), _vm._v(" "), (res[0] == 'time') ? _c('td', [_vm._v("\n                  " + _vm._s(_vm.getDateTime(res[1])) + "\n                ")]) : _vm._e(), _vm._v(" "), (res[0] != 'time') ? _c('td', [_vm._v("\n                  " + _vm._s(res[1]) + "\n                ")]) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('collapse-item', {
    attrs: {
      "title": _vm.$t('common.recognitionLogs'),
      "selected": ""
    }
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('common.parameter')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.value')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.recognitionLogs), function(res) {
    return _c('tr', [_c('td', [_vm._v("\n                  " + _vm._s(res[0]) + "\n                ")]), _vm._v(" "), (res[0] == 'time') ? _c('td', [_vm._v("\n                  " + _vm._s(_vm.getDateTime(res[1])) + "\n                ")]) : _vm._e(), _vm._v(" "), (res[0] != 'time') ? _c('td', [_vm._v("\n                  " + _vm._s(res[1]) + "\n                ")]) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('collapse-item', {
    attrs: {
      "title": _vm.$t('common.information')
    }
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("\n              Тег  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTask.tag),
      expression: "callTask.tag"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTask.tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.callTask, "tag", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              failComment  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTask.failComment),
      expression: "callTask.failComment"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTask.failComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.callTask, "failComment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              calledTimestamp  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTask.calledTimestamp),
      expression: "callTask.calledTimestamp"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTask.calledTimestamp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.callTask, "calledTimestamp", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              talkMillis  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTask.talkMillis),
      expression: "callTask.talkMillis"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTask.talkMillis)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.callTask, "talkMillis", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              nextAttemptTimestamp  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTask.nextAttemptTimestamp),
      expression: "callTask.nextAttemptTimestamp"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTask.nextAttemptTimestamp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.callTask, "nextAttemptTimestamp", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              parameters  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTaskParameters),
      expression: "callTaskParameters"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTaskParameters)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.callTaskParameters = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              reportParameters  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTaskReportParameters),
      expression: "callTaskReportParameters"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTaskReportParameters)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.callTaskReportParameters = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              created  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTask.created),
      expression: "callTask.created"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTask.created)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.callTask, "created", $event.target.value)
      }
    }
  })])])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.close')))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
}]}

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_jump__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GetCalltaskState__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GetCalltaskState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__GetCalltaskState__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_4__GetCalltaskState___default.a);

var CALLTASKS_API = '/outgoing-cpg-sec';
var CAMPAIGNS_API = '/api/campaigns';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  components: {
    BackToTop: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_jump__["a" /* BackToTop */]
  },
  data: function data() {
    return {
      calltasks: [],
      campaign: ''
    };
  },

  created: function created() {
    this.checkToken();
    this.calltasks = this.loadData();
    this.loadCampaign();
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'loggedId'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    loadApplications: function loadApplications() {
      this.loadData();
    },
    loadData: function loadData() {
      var _this = this;

      var that = this;
      this.$http.get(CALLTASKS_API + '/test/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.calltasks = response.data;
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', that.$i18n.messages[that.$i18n.locale].notifications.callTasks.errorLoadTestCallsPhoneNumbers);
      });
    },
    loadCampaign: function loadCampaign() {
      var _this2 = this;

      this.$http.get(CAMPAIGNS_API + '/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.campaign = response.data;
      });
    },
    cancel: function cancel() {
      this.$router.push('/campaigns/' + this.$props.id);
    }
  }
});

/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('callTasks.testCallsByCampaign')) + " " + _vm._s(_vm.campaign.name))]), _vm._v(" "), _c('div', {
    staticClass: "jump-target"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('callTasks.phone')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('callTasks.state')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.calltasks), function(calltask) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": '#/callTasksTestResult/' + _vm.$props.id + '/' + calltask.id
      }
    }, [_vm._v(_vm._s(calltask.phone))])]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.getCallTaskState(calltask.state)) + "\n              ")])])
  }), 0)])]), _vm._v(" "), _c('back-to-top', {
    attrs: {
      "target": ".jump-target"
    }
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v(_vm._s(_vm.$t('common.up')))])])], 1), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.close')))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
}]}

/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_message__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authentication_CheckPermission__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authentication_CheckPermission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__authentication_CheckPermission__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_4__authentication_CheckPermission___default.a);

var MessageComponent = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_message___default.a);
var openMessage = function openMessage() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  };

  return new MessageComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var GET_ARCHIVE_LIST_API = '/api/campaigns/archive';
var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      campaigns: [],
      sortedCampaigns: [],
      currentPage: 1,
      perPage: 10,
      maxVisibleButtons: 10,
      currentSort: 'dateCreated',
      currentSortDir: 'asc',
      ascIcon: ' ▲',
      descIcon: ' ▼',
      isActive: false,
      permissionKey: 'campaign'
    };
  },


  created: function created() {
    this.checkToken();
    this.loadState();
    this.loadData();
  },

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['loggedId', 'authenticationToken']), {
    totalPages: function totalPages() {
      return Math.max(Math.ceil(this.campaigns.length / this.perPage), 1);
    },
    startPage: function startPage() {
      if (this.currentPage === 1) {
        return 1;
      }

      if (this.currentPage === this.totalPages) {
        return Math.max(this.totalPages - this.maxVisibleButtons + 1, 1);
      }

      return this.currentPage - 1;
    },
    endPage: function endPage() {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
    },
    pages: function pages() {
      var range = [];
      for (var i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        });
      }
      return range;
    },
    isInFirstPage: function isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage: function isInLastPage() {
      return this.currentPage === this.totalPages;
    }
  }),

  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    loadData: function loadData() {
      var _this = this;

      this.$http.get(GET_ARCHIVE_LIST_API, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.campaigns = response.data;
        _this.sortedCampaigns = _this.sortedCamp();
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка загрузки списка архивных рассылок. ');
      });
    },
    loadState: function loadState() {
      var _this2 = this;

      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this2.isActive = response.data;
        if (!_this2.isActive) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', _this2.$i18n.messages[_this2.$i18n.locale].scenarios.errorToGetUserStatus);
      });
    },
    getReportCSV: function getReportCSV(campaign) {
      var _this3 = this;

      this.$http.get('/report/reportByCampaignId.csv?campaignId=' + campaign.id).then(function (response) {
        var blob = new Blob([response.data], { type: 'text/csv' });
        var a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = 'ReportByCampaign_' + campaign.name + '.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }).catch(function (error) {
        _this3.openNotificationWithType('danger', 'Ошибка загрузки отчета');
        console.log(error);
      });
    },
    getDate: function getDate(date) {
      var d = new Date(Number(date));
      var day = d.getUTCDate();
      var month = d.getUTCMonth() + 1;
      var year = d.getUTCFullYear();
      if (day < 10) day = '0' + day;
      if (month < 10) month = '0' + month;
      return day + '.' + month + '.' + year;
    },
    sortedCamp: function sortedCamp() {
      var _this4 = this;

      return this.campaigns.sort(function (a, b) {
        var modifier = 1;
        if (_this4.currentSortDir === 'desc') modifier = -1;
        if (a[_this4.currentSort] < b[_this4.currentSort]) return -1 * modifier;
        if (a[_this4.currentSort] > b[_this4.currentSort]) return 1 * modifier;
        return 0;
      }).filter(function (row, index) {
        var start = (_this4.currentPage - 1) * _this4.perPage;
        var end = _this4.currentPage * _this4.perPage;
        if (index >= start && index < end) return true;
      });
    },
    sort: function sort(s) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
      this.sortedCampaigns = this.sortedCamp();
    },
    sortIcon: function sortIcon(s) {
      if (s === this.currentSort) {
        if (this.currentSortDir === 'asc') {
          return this.ascIcon;
        } else {
          return this.descIcon;
        }
      } else {
        return '';
      }
    },
    onClickFirstPage: function onClickFirstPage() {
      this.onPageChange(1);
    },
    onClickPreviousPage: function onClickPreviousPage() {
      this.onPageChange(this.currentPage - 1);
    },
    onClickPage: function onClickPage(page) {
      this.onPageChange(page);
    },
    onClickNextPage: function onClickNextPage() {
      this.onPageChange(this.currentPage + 1);
    },
    onClickLastPage: function onClickLastPage() {
      this.onPageChange(this.totalPages);
    },
    isPageActive: function isPageActive(page) {
      return this.currentPage === page;
    },
    onPageChange: function onPageChange(page) {
      this.currentPage = page;
      this.sortedCampaigns = this.sortedCamp();
    },
    toggleDropdown: function toggleDropdown(event) {
      event.currentTarget.classList.toggle('is-active');
    }
  }
});

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('name')
      }
    }
  }, [_vm._v("Название" + _vm._s(_vm.sortIcon('name')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('client')
      }
    }
  }, [_vm._v("Автор" + _vm._s(_vm.sortIcon('client')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('scenario')
      }
    }
  }, [_vm._v("Сценарий" + _vm._s(_vm.sortIcon('scenario')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('date')
      }
    }
  }, [_vm._v("Прозвон" + _vm._s(_vm.sortIcon('date')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('state')
      }
    }
  }, [_vm._v("Статус" + _vm._s(_vm.sortIcon('state')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('dateCreated')
      }
    }
  }, [_vm._v("Дата создания" + _vm._s(_vm.sortIcon('dateCreated')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('sumConsume')
      }
    }
  }, [_vm._v("Сумма" + _vm._s(_vm.sortIcon('sumConsume')))]), _vm._v(" "), _c('th', [_vm._v("Отчет")]), _vm._v(" "), _c('th', [_vm._v("Действие")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedCampaigns), function(campaign) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": '#/campaigns/' + campaign.id
      }
    }, [_vm._v(_vm._s(campaign.name))])]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(campaign.client) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(campaign.scenario) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(campaign.date) + " " + _vm._s(campaign.timeStart) + "-" + _vm._s(campaign.timeEnd) + " " + _vm._s(campaign.zoneOffset) + " UTC\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(campaign.state) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.getDate(campaign.dateCreated)) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(campaign.sumConsume) + "\n            ")]), _vm._v(" "), _c('td', [(campaign.state == 'Завершена') ? _c('div', {
      staticClass: "dropdown"
    }, [_c('div', {
      staticClass: "dropdown__header",
      on: {
        "click": function($event) {
          return _vm.toggleDropdown($event)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('i', {
      staticClass: "fa fa-angle-down",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-angle-up",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "dropdown__content"
    }, [_c('ul', [_c('li', [_c('button', {
      staticClass: "button is-info",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.getReportCSV(campaign)
        }
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('span', [_vm._v("Отчет в CSV")])])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": '/report/reportByCampaignId.xls?campaignId=' + campaign.id,
        "tag": "button"
      }
    }, [_vm._m(2, true)])])])])]) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.canCreate(_vm.permissionKey)) ? _c('a', {
      staticClass: "button is-success",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "href": '#/campaigns/copy/' + campaign.id,
        "disabled": !_vm.isActive
      }
    }, [_vm._m(3, true), _vm._v(" "), _c('span', [_vm._v("Копировать")])]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-navigation"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to first page"
    },
    on: {
      "click": _vm.onClickFirstPage
    }
  }, [_vm._v("\n              Первая\n            ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to previous page"
    },
    on: {
      "click": _vm.onClickPreviousPage
    }
  }, [_vm._v("\n              Предыдущая\n            ")])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      staticClass: "pagination-item"
    }, [_c('button', {
      class: {
        activepage: _vm.isPageActive(page.name)
      },
      attrs: {
        "type": "button",
        "disabled": page.isDisabled,
        "aria-label": ("Go to page number " + (page.name))
      },
      on: {
        "click": function($event) {
          return _vm.onClickPage(page.name)
        }
      }
    }, [_vm._v("\n              " + _vm._s(page.name) + "\n            ")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to next page"
    },
    on: {
      "click": _vm.onClickNextPage
    }
  }, [_vm._v("\n              Следующая\n            ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to last page"
    },
    on: {
      "click": _vm.onClickLastPage
    }
  }, [_vm._v("\n              Последняя\n            ")])])], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-info",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', [_vm._v("Отчеты")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-info",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]), _vm._v(" "), _c('span', [_vm._v("Отчет в XLS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-copy"
  })])
}]}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_datepicker__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cleave__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_notification__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_tabs__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_bulma_collapse__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bulma_message__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__authentication_CheckToken__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__authentication_CheckPermission__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__authentication_CheckPermission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__authentication_CheckPermission__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__quota_CampaignQuota__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__quota_CampaignQuota___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__quota_CampaignQuota__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ReportGenerator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ReportGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ReportGenerator__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















__WEBPACK_IMPORTED_MODULE_4_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_9__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_10__authentication_CheckPermission___default.a);

var NotificationComponent = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var MessageComponent = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_8_vue_bulma_message___default.a);
var openMessage = function openMessage() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  };

  return new MessageComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var CAMPAIGNS_API = '/api/campaigns';
var CAMPAIGNS_CTS_API = '/outgoing-cpg-sec';
var SCENARIOS_API = '/api/scenarios';
var PHONEBASEUPLOADING_API = '/outgoing-cpg-sec';
var CALLTASKS_API = '/outgoing-cpg-sec';
var APPCONFIG_API = '/api/appConfig';
var FSGATEWAY_API = 'api/fsgateways';
var PROFILES_API = '/api/profiles';
var CALLTASKTESTING_API = '/outgoing-cpg-sec/callTasksTesting';
// const REPORTS_API = '/calls'
var TEST_REPORTS_GENERATE_API = '/report/testReport';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id', 'idcopy'],
  components: {
    ReportGenerator: __WEBPACK_IMPORTED_MODULE_12__ReportGenerator___default.a,
    CampaignQuota: __WEBPACK_IMPORTED_MODULE_11__quota_CampaignQuota___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_datepicker___default.a,
    Cleave: __WEBPACK_IMPORTED_MODULE_1_vue_cleave___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_2__Modal___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_notification___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_8_vue_bulma_message___default.a,
    Tabs: __WEBPACK_IMPORTED_MODULE_6_vue_bulma_tabs__["b" /* Tabs */],
    TabPane: __WEBPACK_IMPORTED_MODULE_6_vue_bulma_tabs__["a" /* TabPane */],
    Collapse: __WEBPACK_IMPORTED_MODULE_7_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_7_vue_bulma_collapse__["Item"]
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['loggedUser', 'loggedId', 'loggedRole', 'clientId', 'authenticationToken']), {
    l10n: function l10n() {
      return {
        firstDayOfWeek: 1,
        weekdays: {
          shorthand: Object.values(this.$i18n.messages[this.$i18n.locale].common.date.days.shorthand),
          longhand: Object.values(this.$i18n.messages[this.$i18n.locale].common.date.days.longhand)
        },
        months: {
          shorthand: Object.values(this.$i18n.messages[this.$i18n.locale].common.date.months),
          longhand: Object.values(this.$i18n.messages[this.$i18n.locale].common.date.months)
        }
      };
    }
  }),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      };
    },
    prepareSecurityHeaderYandex: function prepareSecurityHeaderYandex(uuid) {
      return {
        'Content-Type': 'application/json',
        'Idempotence-Key': uuid
      };
    },
    tabSelected: function tabSelected(index) {
      this.activeTab = index;
    },
    transformTimeStart: function transformTimeStart() {
      this.campaign.timeStart = this.transform(this.campaign.timeStart);
    },
    transformTimeEnd: function transformTimeEnd() {
      this.campaign.timeEnd = this.transform(this.campaign.timeEnd);
    },
    transform: function transform(tt) {
      var t = tt;
      if (t != null) {
        if (t.length === 3) {
          var part1 = t.substr(0, 2);
          var part2 = t.substr(2);
          if (part2 !== ':') {
            t = part1 + ':' + part2;
          }
        }
        if (t.length > 5) {
          t = t.substr(0, 5);
        }
      } else {
        t = '12:00';
      }
      return t;
    },
    save: function save(showMessage) {
      if (this.checkTime()) {
        this.campaign.phonePreprocessingParameters = {};
        for (var i = 0; i < this.phonePreprocessingParametersArray.length; i++) {
          var item = this.phonePreprocessingParametersArray[i];
          this.campaign.phonePreprocessingParameters[item[0]] = item[1];
        }
        if (!this.campaign.id) {
          this.saveNew(showMessage);
        } else {
          this.update(showMessage);
        }
      } else {
        this.openNotificationWithType('warning', 'Неверно указано время рассылки.');
      }
    },
    saveNew: function saveNew(showMessage) {
      var that = this;
      console.log('saving new campaign: ' + JSON.stringify(this.campaign));
      this.$http.post(CAMPAIGNS_API, this.campaign, { headers: this.prepareSecurityHeader() }).then(function (response) {
        console.log(response.data);
        that.isSaved = true;
        that.campaign = response.data;
        if (showMessage) {
          that.openNotificationWithType('info', 'Рассылка сохранена.');
        }
        //        that.$router.push('/campaigns/')
      }).catch(function (error) {
        console.log(error);
        that.openNotificationWithType('danger', 'Ошибка сохранения рассылки. ');
      });
    },
    update: function update(showMessage) {
      var that = this;
      console.log('updating campaign: ' + JSON.stringify(this.campaign));
      this.$http.put(CAMPAIGNS_API, this.campaign, { headers: this.prepareSecurityHeader() }).then(function (response) {
        console.log(response.data);
        that.isSaved = true;
        if (showMessage) {
          that.openNotificationWithType('info', 'Рассылка сохранена.');
        }
        //        this.$router.push('/campaigns/')
      }).catch(function (error) {
        console.log(error);
        that.openNotificationWithType('danger', 'Ошибка сохранения рассылки. ');
      });
    },
    uploadFile: function uploadFile(buttonId) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить рассылку');
      } else {
        document.getElementById(buttonId).click();
      }
    },
    loadState: function loadState() {
      var _this = this;

      var that = this;
      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        that.isActive = response.data;
        if (!that.isActive && !that.campaign.archiveStatus) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        that.openNotificationWithType('danger', _this.$i18n.messages[_this.$i18n.locale].scenarios.errorToGetUserStatus);
      });
    },
    loadAppConfig: function loadAppConfig() {
      var that = this;
      this.$http.get(APPCONFIG_API, { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.appconfig = response.data;
        that.campaign.gateway = that.appconfig.defaultGateway;
        that.campaign.scheduleStrategy = that.appconfig.defaultScheduleStrategy;
        that.campaign.postponingStrategy = that.appconfig.defaultPostponingConfig.strategy;
        that.campaign.telErrorStrategy = that.appconfig.defaultTelErrorStrategy.strategy;
        that.campaign.postponingAttempts = that.appconfig.defaultPostponingConfig.parameters.attempts;
        that.campaign.postponingIntervalMin = that.appconfig.defaultPostponingConfig.parameters.waitMinutes;
        that.campaign.dialplanContext = that.appconfig.defaultDialplanContext;
        that.campaign.dialplanExtension = that.appconfig.defaultDialplanExtension;
        that.campaign.targetStrategy = that.appconfig.defaultTargetStrategy;
        that.campaign.phonePreprocessingStrategy = that.appconfig.defaultPhonePreprocessingStrategy.strategy;
        that.campaign.recordHost = that.appconfig.defaultRecordHost;
        that.phonePreprocessingParametersArray = Object.entries(that.appconfig.defaultPhonePreprocessingStrategy.parameters);

        that.initStartCampaign();
      }).catch(function (error) {
        console.log(error);
        that.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ');
      });
    },
    loadCampaign: function loadCampaign() {
      var that = this;
      this.$http({
        url: CAMPAIGNS_API + '/' + this.$props.id,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('opening campaign ' + response.data.id);
        that.campaign = response.data;
        that.phonePreprocessingParametersArray = that.campaign.phonePreprocessingParameters ? Object.entries(that.campaign.phonePreprocessingParameters) : [];
        that.loadTasksCount();
        that.loadTasksCountPerformed();
        that.isSaved = true;
        that.getScenarioReadyState();
        that.loadState();
        that.getScenario();
      }).catch(function (error) {
        console.log(error);
        that.openNotificationWithType('danger', 'Ошибка загрузки рассылки. ');
      });
    },
    deletePhonePreprocessingParameter: function deletePhonePreprocessingParameter(index) {
      this.phonePreprocessingParametersArray.splice(index, 1);
    },
    addPhonePreprocessingParameter: function addPhonePreprocessingParameter() {
      this.phonePreprocessingParametersArray.push({});
    },
    deleteTestPhoneParameter: function deleteTestPhoneParameter(index) {
      this.testPhoneParametersArray.splice(index, 1);
    },
    addTestPhoneParameter: function addTestPhoneParameter() {
      this.testPhoneParametersArray.push({});
    },
    copyCampaign: function copyCampaign() {
      var _this2 = this;

      var that = this;
      this.$http({
        url: CAMPAIGNS_API + '/' + this.$props.idcopy,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('copying campaign ' + response.data.id);
        that.campaign = response.data;
        that.campaign.id = undefined;
        that.notSaved();
        that.loadState();
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка создания копии рассылки. ');
      });
    },
    loadScenarios: function loadScenarios() {
      var that = this;
      this.$http.get(SCENARIOS_API + '/names', { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.scenarios = response.data;
      }).catch(function (error) {
        console.log(error);
        that.openNotificationWithType('danger', 'Ошибка загрузки сценариев. ');
      });
    },
    loadFsGateways: function loadFsGateways() {
      var that = this;
      this.$http.get(FSGATEWAY_API, { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.fsGateways = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    loadTasksCount: function loadTasksCount() {
      var that = this;
      this.$http.get(CALLTASKS_API + '/' + this.campaign.id + '/count', { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.tasksCount = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    loadTasksCountPerformed: function loadTasksCountPerformed() {
      var that = this;
      this.$http.get(CALLTASKS_API + '/' + this.campaign.id + '/countPerformed', { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.tasksCountPerformed = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getScenarioReadyState: function getScenarioReadyState() {
      this.getScenario();
      var that = this;
      this.$http({
        url: SCENARIOS_API + '/isReady/' + this.campaign.scenario,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        that.isReadyScenario = response.data;
      }).catch(function (error) {
        console.log(error);
        that.openNotificationWithType('danger', 'Ошибка получения состояния сценария. ');
      });
    },
    getScenario: function getScenario() {
      if (this.campaign.scenario) {
        var that = this;
        this.$http.get(SCENARIOS_API + '/' + this.campaign.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
          that.loadedScenario = response.data;

          console.log('loadedScenario ' + that.loadedScenario);
        }).catch(function (error) {
          console.log(error);
          that.openNotificationWithType('danger', that.$i18n.messages[that.$i18n.locale].notifications.scenario.errorLoadScenario);
        });
        return that.loadedScenario;
      }
    },
    checkContainsAudio: function checkContainsAudio() {
      var states = this.loadedScenario.parameters.states;
      for (var i = 0; i < states.length; i++) {
        if (!states[i].data.audio && states[i].type !== 'inOutState') {
          return false;
        }
      }
      return true;
    },
    openModalDelete: function openModalDelete() {
      console.log('Нажали удалить базу');
      this.title = 'Удалить базу?';
      this.confirmation = true;
      this.openModal();
    },
    openModalReady: function openModalReady() {
      if (this.checkContainsAudio()) {
        this.title = 'Запустить рассылку?';
        this.confirmation = true;
        this.openModal();
      } else {
        this.openNotificationWithType('danger', 'Нельзя запустить рассылку со сценарием, где нет аудио');
      }
    },
    openModalStop: function openModalStop() {
      this.title = 'Остановить рассылку?';
      this.confirmation = true;
      this.openModal();
    },
    openModalClipboard: function openModalClipboard() {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой базы необходимо сохранить рассылку');
      } else {
        this.title = 'Загрузка базы';
        this.confirmation = false;
        this.openModal();
      }
    },
    closeModal: function closeModal() {
      this.showModal = false;
    },
    openModal: function openModal() {
      this.showModal = true;
    },
    confirmAction: function confirmAction(value) {
      this.closeModal();
      if (this.title == 'Запустить рассылку?') {
        // this.save(false)
        this.setReadyStatus();
      }
      if (this.title == 'Остановить рассылку?') {
        // this.save(false)
        this.setPauseStatus();
      }
      if (this.title == 'Удалить базу?') {
        this.deletePhones();
      }
      if (this.title == 'Загрузка базы') {
        this.clipboard = value;
        this.uploadPhonesFromClipboard();
      }
    },
    uploadPhonesFromClipboard: function uploadPhonesFromClipboard() {
      this.handleUploadPhonesFromClipboardRequest();
    },
    handleUploadPhonesFromClipboardRequest: function handleUploadPhonesFromClipboardRequest() {
      var _this3 = this;

      this.$http.post(PHONEBASEUPLOADING_API + '/' + 'loadForCampaignFromClipboard', this.prepareClipboardMultipartFile(this.clipboard, this.campaign.id), { headers: this.prepareSecurityHeader(), timeout: 180000 }).then(function (response) {
        if (response.status === 200) {
          if (response.data.message === '' || response.data.message === 'Загрузка прошла успешно') {
            _this3.openNotificationWithType('info', 'База загружена.');
            _this3.loadTasksCount();
          } else {
            _this3.openNotificationWithType('danger', response.data.message, 0);
            _this3.loadTasksCount();
          }
        } else {
          _this3.openNotificationWithType('danger', 'Ошибка загрузки файла');
          _this3.loadTasksCount();
        }
      }).catch(function (error) {
        _this3.openNotificationWithType('danger', 'Ошибка загрузки файла');
        _this3.loadTasksCount();
        console.log(error);
      });
      this.loadTasksCountPerformed();
    },
    prepareClipboardMultipartFile: function prepareClipboardMultipartFile(phonesClipboard, phonesCampaign) {
      var phonesFormData = new FormData();
      phonesFormData.append('clipboard', phonesClipboard);
      phonesFormData.append('campaign', phonesCampaign);
      return phonesFormData;
    },
    uploadPhones: function uploadPhones(inputId) {
      var input = document.querySelector('#' + inputId);
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой базы необходимо сохранить рассылку');
        } else {
          //          this.save(false)
          this.handleUploadPhonesRequest(input.files[0]);
        }
      }
    },
    handleUploadPhonesRequest: function handleUploadPhonesRequest(phonesFile) {
      var _this4 = this;

      this.$http.post(PHONEBASEUPLOADING_API + '/' + 'loadForCampaign', this.prepareMultipartFile(phonesFile, this.campaign.id), { headers: this.prepareSecurityHeader(), timeout: 180000 }).then(function (response) {
        if (response.status === 200) {
          var message = '';
          if (typeof response.data === 'string' || response.data instanceof String) {
            message = response.data;
          } else if (response.data && !response.data.message) {
            message = response.data.message;
          }
          if (!message) {
            _this4.openNotificationWithType('info', 'База загружена.');
          } else {
            _this4.openNotificationWithType('danger', message, 0);
          }
          _this4.loadTasksCount();
        } else {
          _this4.openNotificationWithType('danger', 'Ошибка загрузки файла');
          _this4.loadTasksCount();
        }
      }).catch(function (error) {
        _this4.openNotificationWithType('danger', 'Ошибка загрузки файла');
        _this4.loadTasksCount();
        console.log(error);
      });
      this.loadTasksCountPerformed();
    },
    prepareMultipartFile: function prepareMultipartFile(phonesFile, phonesCampaign) {
      var phonesFormData = new FormData();
      phonesFormData.append('file', phonesFile);
      phonesFormData.append('campaign', phonesCampaign);
      return phonesFormData;
    },
    deletePhones: function deletePhones() {
      var _this5 = this;

      var that = this;
      this.$http.delete(PHONEBASEUPLOADING_API + '/' + this.campaign.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this5.openNotificationWithType('info', that.$i18n.messages[_this5.$i18n.locale].notifications.campaign.baseRemoved);
        _this5.tasksCount = 0;
        //          this.save(false)
      }).catch(function (error) {
        console.log(error);
        _this5.openNotificationWithType('danger', that.$i18n.messages[_this5.$i18n.locale].notifications.campaign.errorDeletePhoneBase);
      });
    },
    cancel: function cancel() {
      if (this.campaign.archiveStatus) {
        this.$router.push('/archive/');
      } else {
        this.$router.push('/campaigns/');
      }
    },
    gotoScenario: function gotoScenario() {
      this.$router.push('/scenarios/' + this.campaign.id + '/' + this.campaign.scenario);
    },
    viewCallTasks: function viewCallTasks() {
      this.$router.push('/callTasks/' + this.campaign.id);
    },
    viewMonitor: function viewMonitor() {
      this.$router.push('/monitoring/' + this.campaign.id);
    },
    viewCallsResult: function viewCallsResult() {
      this.$router.push('/campaignCallsResult/' + this.campaign.id);
    },
    viewTestCallTasks: function viewTestCallTasks() {
      this.$router.push('/callTasksTest/' + this.campaign.id);
    },

    // prepareReport () {
    //   this.$http.get('/report/prepareReportByCampaignId?campaignId=' + this.campaign.id)
    //     .then((response) => {
    //       this.openNotificationWithType('info', 'Отчет подготовлен')
    //       this.loadCampaign()
    //       this.loadScenarios()
    //       this.loadFsGateways()
    //     })
    //     .catch((error) => {
    //       this.openNotificationWithType('warning', 'Отчет формируется. Пожалуйста, загрузите его чуть позже.' +
    //         ' Необходимо будет обновить эту страницу, нажав Ctrl+F5')
    //       console.log(error)
    //     })
    // },
    downloadTestReport: function downloadTestReport() {
      var _this6 = this;

      var that = this;
      // this.$http.get('/report/reportByCampaignId.csv?campaignId=' + this.campaign.id)
      this.$http.get(TEST_REPORTS_GENERATE_API + '/' + this.campaign.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        var s = response.headers['content-disposition'];
        var res = s.split('filename="').pop();
        res = res.split('"')[0];
        var blob = new Blob([response.data], { type: 'text/csv' });
        var a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        // a.download = 'ReportByCampaign_' + this.campaign.name + '.csv'
        a.download = res;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }).catch(function (error) {
        _this6.openNotificationWithType('danger', that.$i18n.messages[_this6.$i18n.locale].notifications.campaign.report.errorLoadReport);
        console.log(error);
      });
    },
    getReadyCallTasksCSV: function getReadyCallTasksCSV() {
      var _this7 = this;

      var that = this;
      this.$http.get(CALLTASKS_API + '/readyCallTasksByCampaignId.csv?campaignId=' + this.campaign.id).then(function (response) {
        var blob = new Blob([response.data], { type: 'text/csv' });
        var a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = 'readyCallTasksByCampaign_' + _this7.campaign.name + '.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }).catch(function (error) {
        _this7.openNotificationWithType('danger', that.$i18n.messages[_this7.$i18n.locale].notifications.campaign.report.errorLoadReport);
        console.log(error);
      });
    },
    setReadyStatus: function setReadyStatus() {
      var _this8 = this;

      var that = this;
      this.campaign.state = 'Подготовлена';
      // this.$http.put(CAMPAIGNS_API, this.campaign, {headers: this.prepareSecurityHeader()})
      this.$http.put(CAMPAIGNS_CTS_API + '/' + this.campaign.id + '/updatestate?state=READY', {}, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this8.openNotificationWithType('success', that.$i18n.messages[_this8.$i18n.locale].notifications.campaign.campaignIsReady);
      }).catch(function (error) {
        console.log(error);
        _this8.openNotificationWithType('danger', that.$i18n.messages[_this8.$i18n.locale].notifications.campaign.errorStartCampaign);
      });
    },
    setPauseStatus: function setPauseStatus() {
      var _this9 = this;

      var that = this;
      this.campaign.state = 'Остановлена';
      // this.$http.put(CAMPAIGNS_API, this.campaign, {headers: this.prepareSecurityHeader()})
      this.$http.put(CAMPAIGNS_CTS_API + '/' + this.campaign.id + '/updatestate?state=PAUSED', {}, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this9.openNotificationWithType('success', that.$i18n.messages[_this9.$i18n.locale].notifications.campaign.campaignStopped);
      }).catch(function (error) {
        console.log(error);
        _this9.openNotificationWithType('danger', that.$i18n.messages[_this9.$i18n.locale].notifications.campaign.errorStopCampaign);
      });
    },
    canSetReadyStatus: function canSetReadyStatus() {
      var result = this.campaign.state !== 'Подготовлена' && this.campaign.state !== 'Прозвон идёт' && (this.campaign.state === 'В разработке' || this.campaign.state === 'Остановлена' || this.campaign.scheduleStrategy === 'DAILY_TIME_INTERVAL' || this.canContinue()) && this.canModerate(this.permissionKey) && this.campaign.client != null && this.campaign.date != null && this.campaign.scenario != null && this.campaign.zoneOffset != null && this.campaign.timeStart != null && this.campaign.timeEnd && this.isReadyScenario // &&
      // ((this.campaign.postponingIntervalMin == 0 && this.campaign.postponingAttempts == 0) ||
      //   (this.campaign.postponingIntervalMin != 0 && this.campaign.postponingAttempts != 0))) // ||
      ;
      // this.appconfig.campaignSetReadyButtonVisibleForAll
      return result;
    },
    canPauseStatus: function canPauseStatus() {
      var result = (this.campaign.state === 'Подготовлена' || this.campaign.state === 'Прозвон идёт') && this.canModerate(this.permissionKey);
      return result;
    },
    notSaved: function notSaved() {
      this.isSaved = false;
    },
    canEdit: function canEdit() {
      if (this.campaign.archiveStatus) {
        return false;
      }
      if (!this.isActive) {
        return false;
      } else if (!this.campaign.id) {
        return true;
      } else if (this.campaign.scheduleStrategy === 'DAILY_TIME_INTERVAL') {
        return true;
      } else {
        if (this.loggedRole == 1) {
          return this.campaign.state === 'В разработке' || this.campaign.state === 'Подготовлена' || this.campaign.state === 'Остановлена';
        } else {
          return this.campaign.state === 'В разработке' || this.campaign.state === 'Остановлена';
        }
      }
    },
    canContinue: function canContinue() {
      if (!this.isActive) {
        return false;
      } else {
        return this.campaign.state === 'Завершена' && this.campaign.hasReadyTasks;
      }
    },
    canLoadReport: function canLoadReport(campaign) {
      return campaign.state === 'Завершена' || campaign.scheduleStrategy === 'DAILY_TIME_INTERVAL';
    },
    callTest: function callTest(showMessage) {
      var _this10 = this;

      var that = this;
      if (!this.isSaved) {
        this.openNotificationWithType('danger', that.$i18n.messages[this.$i18n.locale].notifications.testCall.saveCampaignBeforeTestCall);
      } else {
        if (this.testPhone.trim() !== '') {
          console.log('saving new testing call task: ' + JSON.stringify(this.testPhone));
          this.$http.post(CALLTASKTESTING_API, this.prepareTestPhone(this.campaign.id, this.testPhone, this.testPhoneParametersArray), { headers: this.prepareSecurityHeader() }).then(function (response) {
            _this10.testPhone = '';
            _this10.testPhoneParametersArray = [{
              key: '',
              value: ''
            }];
            // this.callTask = response.data
            _this10.loadTasksCount();
            if (showMessage) {
              _this10.openNotificationWithType('info', that.$i18n.messages[_this10.$i18n.locale].notifications.testCall.testCallNumberSaved);
            }
          }).catch(function (error) {
            console.log(error);
            _this10.openNotificationWithType('danger', that.$i18n.messages[_this10.$i18n.locale].notifications.testCall.errorCreatingTestCall);
          });
        }
      }
    },
    prepareTestPhoneForm: function prepareTestPhoneForm(campaignId, testPhone, testPhoneParametersArray) {
      var formData = new FormData();
      formData.append('campaignId', campaignId);
      formData.append('phone', testPhone);
      var testPhoneParameters = {};
      for (var i = 0; i < testPhoneParametersArray.length; i++) {
        var item = testPhoneParametersArray[i];
        testPhoneParameters[item[0]] = item[1];
      }
      formData.append('parameters', JSON.stringify(testPhoneParameters));
      return formData;
    },
    prepareTestPhone: function prepareTestPhone(campaignId, testPhone, testPhoneParametersArray) {
      var testCallTaskDto = {
        phone: '',
        campaign: '',
        parameters: {}
      };
      testCallTaskDto.campaign = campaignId;
      testCallTaskDto.phone = testPhone;
      var testPhoneParameters = {};
      for (var i = 0; i < testPhoneParametersArray.length; i++) {
        var item = testPhoneParametersArray[i];
        testPhoneParameters[item[0]] = item[1];
      }
      testCallTaskDto.parameters = testPhoneParameters;
      return testCallTaskDto;
    },
    checkTime: function checkTime() {
      return this.regTime.test(this.campaign.timeStart) && this.regTime.test(this.campaign.timeEnd) && this.campaign.timeEnd.localeCompare(this.campaign.timeStart) > 0;
    },
    openNotificationWithType: function openNotificationWithType(type, message, duration) {
      openNotification({
        title: this.$i18n.messages[this.$i18n.locale].notifications.notification,
        message: message,
        type: type,
        duration: duration
      });
    },
    initStartCampaign: function initStartCampaign() {
      if (!this.$props.id) {
        if (!this.$props.idcopy) {
          console.log('creating new campaign');
          this.notSaved();
          this.loadState();
        } else {
          console.log('copying campaign: ' + this.name);
          this.copyCampaign();
        }
      } else {
        console.log('loading campaign: ' + this.name);
        this.loadCampaign();
      }
    },
    quotaServiceNotAvailable: function quotaServiceNotAvailable() {
      this.quotaServiceAvailable = false;
    }
  },
  data: function data() {
    return {
      campaign: {
        timeStart: '10:00',
        timeEnd: '18:00',
        state: '',
        scheduleStrategy: '',
        postponingAttempts: '',
        postponingIntervalMin: '',
        id: ''
      },
      loadedScenario: null,
      scenarios: [],
      tasksCount: '',
      tasksCountPerformed: 0,
      sumPayment: 0,
      reg: /^[-]?[0-9]+[.]?[0-9]{0,2}$/,
      regTime: /^(([0,1][0-9])|(2[0-3])):[0-5][0-9]$/,
      showModal: null,
      title: '',
      confirmation: true,
      isSaved: false,
      fsGateways: [],
      appconfig: {},
      isActive: false,
      isReadyScenario: false,
      clipboard: '',
      testPhone: '',
      testPhoneParametersArray: [{
        key: '',
        value: ''
      }],
      permissionKey: 'campaign',
      phonePreprocessingParametersArray: [{
        key: '',
        value: ''
      }],
      activeTab: 0,
      quotaServiceAvailable: true
    };
  },

  created: function created() {
    this.checkToken();
    this.loadAppConfig();
    this.loadFsGateways();

    this.loadScenarios();
  }
});

/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_modal__ = __webpack_require__(72);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_modal__["c" /* Modal */]
  },

  props: {
    visible: Boolean,
    title: String,
    confirmation: Boolean,
    clipboard: Boolean,
    clipboardArea: ''
  },

  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "visible": _vm.visible
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('article', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h4', [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")])]), _vm._v(" "), (_vm.clipboard) ? _c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clipboardArea),
      expression: "clipboardArea"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": _vm.$t('campaigns.putBaseFromClipboard')
    },
    domProps: {
      "value": (_vm.clipboardArea)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clipboardArea = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.confirmation) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.$emit('confirm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]) : _vm._e(), _vm._v(" "), (_vm.confirmation) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))]) : _vm._e(), _vm._v(" "), (_vm.clipboard) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.$emit('confirm', _vm.clipboardArea)
      }
    }
  }, [_vm._v("ОК")]) : _vm._e(), _vm._v(" "), (_vm.clipboard) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.actions.cancel')))]) : _vm._e()])])])])])
},staticRenderFns: []}

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(432)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(436),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TabList__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TabList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TabList__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TabList: __WEBPACK_IMPORTED_MODULE_0__TabList___default.a
  },

  props: {
    isFullwidth: Boolean,
    layout: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'bottom', 'left', 'right'].indexOf(val) > -1;
      }
    },
    type: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    alignment: {
      type: String,
      default: ''
    },
    selectedIndex: {
      type: Number,
      default: -1
    },
    animation: {
      type: String,
      default: 'fade'
    },
    onlyFade: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      realSelectedIndex: this.selectedIndex,
      tabPanes: []
    };
  },
  mounted: function mounted() {
    this.update();
    if (this.realSelectedIndex === -1) {
      this.select(0);
    }
  },


  methods: {
    update: function update() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.tabPanes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var tabPane = _step.value;

          if (!tabPane.disabled && tabPane.realSelected) {
            this.select(tabPane.index);
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    isActived: function isActived(index) {
      return index === this.realSelectedIndex;
    },
    select: function select(index) {
      this.$emit('tab-selected', index);
      this.realSelectedIndex = index;
    }
  },
  watch: {
    selectedIndex: function selectedIndex(newIndex) {
      this.select(newIndex);
    }
  }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    alignment: {
      type: String,
      default: ''
    }
  },

  computed: {
    classObject: function classObject() {
      var alignment = this.alignment;

      return _defineProperty({
        'tab-list': true,
        'is-flex': true
      }, 'is-' + alignment, alignment);
    }
  }
});

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    class: _vm.classObject,
    attrs: {
      "role": "tablist"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports={render:function (){
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ( _obj = {
      'vue-bulma-tabs': true
    }, _obj[("is-layout-" + _vm.layout)] = true, _obj )
  }, [_c('div', {
    class: ( _obj$1 = {
      tabs: true
    }, _obj$1[("is-" + _vm.size)] = _vm.size, _obj$1[("is-" + _vm.alignment)] = _vm.alignment, _obj$1[("is-" + _vm.type)] = _vm.type, _obj$1['is-fullwidth'] =  _vm.isFullwidth, _obj$1 )
  }, [_vm._t("left-tab-list"), _vm._v(" "), _c('tab-list', _vm._l((_vm.tabPanes), function(tab, index) {
    return _c('li', {
      class: {
        'is-active': _vm.isActived(index),
        'is-disabled': tab.disabled,
        'is-flex': true
      },
      attrs: {
        "role": "tab",
        "aria-selected": _vm.isActived(index) ? 'true' : 'false',
        "aria-expanded": _vm.isActived(index) ? 'true' : 'false',
        "aria-disabled": tab.disabled ? 'true' : 'false',
        "selected": _vm.isActived(index),
        "disabled": tab.disabled
      },
      on: {
        "click": function($event) {
          return _vm.select(index)
        }
      }
    }, [_c('a', {
      staticClass: "is-unselectable"
    }, [(tab.icon) ? _c('span', {
      class: ['icon', {
        'is-small': _vm.size !== 'large'
      }]
    }, [_c('i', {
      class: tab.icon
    })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(tab.label))])])])
  }), 0), _vm._v(" "), _vm._t("right-tab-list")], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-content is-flex"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(439),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var TS = {
  'fade': {
    enterClass: 'fadeIn',
    leaveClass: 'fadeOut'
  },
  'fade-horizontal-rtl': {
    enterClass: 'fadeInRight',
    leaveClass: 'fadeOutLeft'
  },
  'fade-horizontal-ltr': {
    enterClass: 'fadeInLeft',
    leaveClass: 'fadeOutRight'
  },
  'slide-horizontal-rtl': {
    enterClass: 'slideInRight',
    leaveClass: 'slideOutLeft'
  },
  'slide-horizontal-ltr': {
    enterClass: 'slideInLeft',
    leaveClass: 'slideOutRight'
  },
  'fade-vertical-dtu': {
    enterClass: 'fadeInUp',
    leaveClass: 'fadeOutUp'
  },
  'fade-vertical-utd': {
    enterClass: 'fadeInDown',
    leaveClass: 'fadeOutDown'
  },
  'slide-vertical-dtu': {
    enterClass: 'slideInUp',
    leaveClass: 'slideOutUp'
  },
  'slide-vertical-utd': {
    enterClass: 'slideInDown',
    leaveClass: 'slideOutDown'
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    icon: String,
    selected: Boolean,
    disabled: Boolean,
    label: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      default: 'out-in'
    }
  },

  data: function data() {
    return {
      realSelected: this.selected,
      transition: TS['fade']
    };
  },
  created: function created() {
    this.$parent.tabPanes.push(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.tabPanes.splice(this.index, 1);
  },


  computed: {
    classObject: function classObject() {
      var realSelected = this.realSelected;

      return {
        'tab-pane': true,
        'animated': true,
        'is-active': realSelected,
        'is-deactive': !realSelected
      };
    },
    layout: function layout() {
      return this.$parent.layout;
    },
    direction: function direction() {
      if (this.layout === 'top' || this.layout === 'bottom') {
        return 'horizontal';
      } else if (this.layout === 'left' || this.layout === 'right') {
        return 'vertical';
      }
      return '';
    },
    animation: function animation() {
      return this.$parent.animation;
    },
    onlyFade: function onlyFade() {
      return this.$parent.onlyFade;
    },
    gte: function gte() {
      if (this.direction === 'vertical') {
        return 'utd';
      } else if (this.direction === 'horizontal') {
        return 'ltr';
      }
      return '';
    },
    lt: function lt() {
      if (this.direction === 'vertical') {
        return 'dtu';
      } else if (this.direction === 'horizontal') {
        return 'rtl';
      }
      return '';
    },
    hidden: function hidden() {
      return this.realSelected ? 'false' : 'true';
    },
    index: function index() {
      return this.$parent.tabPanes.indexOf(this);
    }
  },

  watch: {
    '$parent.realSelectedIndex': function $parentRealSelectedIndex(index, prevIndex) {
      if (!this.onlyFade) {
        var transition = void 0;
        if (prevIndex === -1 || prevIndex > index) {
          transition = '' + this.animation + (this.layout ? '-' + this.direction : '') + (this.gte ? '-' + this.gte : '');
        } else {
          transition = '' + this.animation + (this.layout ? '-' + this.direction : '') + (this.lt ? '-' + this.lt : '');
        }
        this.transition = TS[transition] || TS['fade'];
      }
      this.realSelected = this.index === index;
    }
  }
});

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.animation,
      "mode": "out-in",
      "appear": "",
      "appear-active-class": _vm.transition.enterClass,
      "enter-active-class": _vm.transition.enterClass,
      "leave-active-class": _vm.transition.leaveClass
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realSelected),
      expression: "realSelected"
    }],
    class: _vm.classObject,
    attrs: {
      "role": "tabpanel",
      "aria-labelledby": _vm.label,
      "aria-hidden": _vm.hidden
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VisCommon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VisCommon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_VisCommon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_collapse__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_switch__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component_theme_default_css__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component_theme_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_slider_component_theme_default_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var QUOTAS_API = '/quota';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignQuota',
  extends: __WEBPACK_IMPORTED_MODULE_0__components_VisCommon___default.a,
  components: {
    VueSlider: __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default.a,
    Collapse: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_collapse__["Item"],
    VbSwitch: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_switch___default.a
  },
  props: ['campaignId'],
  data: function data() {
    return {
      quotas: [],
      quotasParam: {
        maxAge: 100,
        marks: function marks(val) {
          return val % 10 === 0;
        }
      }
    };
  },
  created: function created() {
    this.loadQuotas();
  },

  methods: {
    setQuotas: function setQuotas(val) {
      if (val) {
        this.quotas = val;
      } else {
        this.quotas = [];
      }
    },
    saveQuotas: function saveQuotas() {
      var _this = this;

      if (!this.validateQuotas()) {
        return;
      }
      var that = this;
      this.$http.post(QUOTAS_API + '/' + this.$props.campaignId, this.convertFromUiQuotas(this.quotas), { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.openNotificationWithType('info', 'Квоты сохранены.');
        that.setQuotas(_this.convertToUiQuotas(response.data.quotas));
      }).catch(function (error) {
        console.log(error);
        that.openNotificationWithType('danger', 'Ошибка сохранения квот.');
      });
    },
    validateQuotas: function validateQuotas() {
      for (var i = 0; i < this.quotas.length; i++) {
        if (!this.quotas[i].limit && this.quotas[i].limit !== 0) {
          this.openNotificationWithType('warning', 'Заполните лимиты');
          return false;
        }
        for (var j = 0; j < i; j++) {
          if (this.quotas[i].gender === this.quotas[j].gender && this.isQuotaIntersect(this.quotas[i], this.quotas[j])) {
            this.openNotificationWithType('warning', j + 1 + ' и ' + (i + 1) + ' квоты пересекаются');
            return false;
          }
        }
      }
      return true;
    },
    isQuotaIntersect: function isQuotaIntersect(quota1, quota2) {
      var age1 = {
        start: Array.isArray(quota1.age) ? quota1.age[0] : quota1.age,
        finish: this.isRange(quota1.age) ? quota1.age[1] : 100
      };
      var age2 = {
        start: Array.isArray(quota2.age) ? quota2.age[0] : quota2.age,
        finish: this.isRange(quota2.age) ? quota2.age[1] : 100
      };

      return !((age1.start > age2.finish || age1.finish < age2.start) && (age2.start > age1.finish || age2.finish < age1.start));
    },
    loadQuotas: function loadQuotas() {
      var _this2 = this;

      var that = this;
      this.$http({
        url: QUOTAS_API + '/' + this.$props.campaignId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        that.setQuotas(_this2.convertToUiQuotas(response.data.quotas));
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 504 || error.response.status === 404) {
          _this2.$emit('serviceNotAvailable');
        }
      });
    },
    convertToUiQuotas: function convertToUiQuotas(dataQuotas) {
      var quotas = [];
      for (var key in dataQuotas) {
        var quota = {};
        var quotaSplit = key.split('_');
        quota.gender = quotaSplit[0] !== 'M';
        if (parseInt(quotaSplit[1])) {
          quota.age = [parseInt(quotaSplit[1]), parseInt(quotaSplit[2])];
        } else {
          quota.age = [parseInt(quotaSplit[2])];
        }
        quota.limit = dataQuotas[key];
        quotas.push(quota);
      }
      return quotas;
    },
    convertFromUiQuotas: function convertFromUiQuotas(dataQuotas) {
      var quotas = {};
      for (var i = 0; i < dataQuotas.length; i++) {
        var quotaStr = '';
        quotaStr = !dataQuotas[i].gender ? 'M_' : 'F_';
        if (this.isRange(dataQuotas[i].age)) {
          quotaStr += dataQuotas[i].age[0] + '_' + dataQuotas[i].age[1];
        } else {
          var ageStart = Array.isArray(dataQuotas[i].age) ? dataQuotas[i].age[0] : dataQuotas[i].age;
          quotaStr += 'GTE_' + ageStart;
        }
        quotas[quotaStr] = dataQuotas[i].limit;
      }
      return quotas;
    },
    addQuota: function addQuota() {
      var preferQuota = this.preferQuota(this.quotas);
      this.quotas.push(preferQuota);
      this.$emit('set', this.quotas);
    },
    preferQuota: function preferQuota(quotasList) {
      if (quotasList && quotasList.length) {
        var lastQuota = quotasList[quotasList.length - 1];
        if (this.isRange(lastQuota.age) && lastQuota.age[1] < this.quotasParam.maxAge) {
          var firstAge = lastQuota.age[1] + 1;
          var lastAge = firstAge + lastQuota.age[1] - lastQuota.age[0];
          var newQuota = {
            age: [firstAge, lastAge],
            gender: lastQuota.gender
          };
          if (newQuota.age[1] > this.quotasParam.maxAge) {
            newQuota.age = [newQuota.age[0], this.quotasParam.maxAge];
          }
          return newQuota;
        } else {
          return {
            age: [18, 24],
            gender: !lastQuota.gender
          };
        }
      }
      return {
        age: [18, 24],
        gender: false
      };
    },
    getQuotaDivClass: function getQuotaDivClass(quota, index) {
      var divClass = !quota.gender ? 'm' : 'f';
      if (!this.isRange(quota.age)) {
        divClass += ' gte';
      }
      divClass += index % 2 === 1 ? ' uneven' : ' even';
      return divClass;
    },
    getSliderRailStyle: function getSliderRailStyle(quota) {
      if (this.isRange(quota.age)) {
        return null;
      } else {
        return {
          'background-color': !quota.gender ? '#3498db' : '#db6086'
        };
      }
    },
    getSliderTooltipStyle: function getSliderTooltipStyle(quota) {
      if (!quota.gender) {
        return null;
      } else {
        return {
          'background-color': '#db6086',
          'border-color': '#db6086'
        };
      }
    },
    getSliderProcessStyle: function getSliderProcessStyle(quota) {
      if (this.isRange(quota.age)) {
        if (!quota.gender) {
          return null;
        } else {
          return {
            'background-color': '#db6086'
          };
        }
      } else {
        return {
          'background-color': '#ccc'
        };
      }
    },
    toggleHighLimit: function toggleHighLimit(range, quota) {
      if (!range && this.isRange(quota.age)) {
        quota.age = [quota.age[0]];
      } else if (range && !this.isRange(quota.age)) {
        var ageStart = Array.isArray(quota.age) ? quota.age[0] : quota.age;
        quota.age = [ageStart, ageStart + 10];
      }
      console.log(quota.age);
    },
    getQuotaSummary: function getQuotaSummary(quota) {
      var summary = !quota.gender ? 'Мужчины' : 'Женщины';
      if (this.isRange(quota.age)) {
        summary += ' от ' + quota.age[0] + ' до ' + quota.age[1] + ' ' + this.yearFormat(quota.age[1]);
      } else {
        var ageStart = Array.isArray(quota.age) ? quota.age[0] : quota.age;
        summary += ' старше ' + ageStart + ' ' + this.yearFormat(ageStart);
      }
      if (quota.limit || quota.limit === 0) {
        summary += '.  Лимит: ' + quota.limit;
      }
      return summary;
    },
    yearFormat: function yearFormat(year) {
      if (year !== 11 && year % 10 === 1) {
        return 'года';
      } else {
        return 'лет';
      }
    },
    isRange: function isRange(age) {
      return Array.isArray(age) && age.length === 2;
    }
  }
});

/***/ }),
/* 442 */,
/* 443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  model: {
    prop: 'model',
    event: 'change'
  },
  props: {
    id: String,
    name: String,
    disabled: Boolean,
    required: Boolean,
    type: String,
    size: String,
    model: [String, Number, Boolean, Array],
    inputClass: [String, Number, Array, Object],
    trueValue: true,
    falseValue: true,
    value: {
      type: [String, Number, Boolean],
      default: 'on'
    }
  },

  data: function data() {
    var dt = this.getDateType();
    var t = this.getTrue();
    var f = this.getFalse();
    return {
      checked: this.initCheck(this.model, t, dt),
      dt: dt,
      t: t,
      f: f
    };
  },


  computed: {
    classObject: function classObject() {
      var _ref;

      var type = this.type,
          size = this.size,
          checked = this.checked;

      return _ref = {}, _defineProperty(_ref, 'is-' + type, type), _defineProperty(_ref, 'is-' + size, size), _defineProperty(_ref, 'checked', checked), _ref;
    }
  },

  methods: {
    getDateType: function getDateType() {
      return Array.isArray(this.model) ? 2 : typeof this.model === 'boolean' ? 1 : 0;
    },
    getTrue: function getTrue() {
      return this.trueValue === undefined ? this.value : this.trueValue;
    },
    getFalse: function getFalse() {
      return this.falseValue === undefined ? null : this.falseValue;
    },
    initCheck: function initCheck(model, value, dt) {
      if (dt === 2) {
        return model.includes(value);
      }

      if (dt === 1) {
        return model;
      }

      return model === value;
    },
    set: function set(checked, model, t, f, dt) {
      if (dt === 2) {
        var i = model.indexOf(checked);
        var has = i !== -1;
        if (checked && !has) {
          model.push(t);
        } else if (!checked && has) {
          model.splice(i, 1);
        }
        this.$emit('change', model);
      } else if (dt === 1) {
        this.$emit('change', checked);
      } else {
        this.$emit('change', checked ? t : f);
      }
    },
    input: function input() {
      this.set(this.checked, this.model, this.t, this.f, this.dt);
    }
  },

  watch: {
    value: function value(v) {
      var dt = this.getDateType();
      switch (dt) {
        case 2:
          this.checked = this.model.includes(v);
          break;
        case 1:
          this.checked = v;
          break;
        default:
          this.checked = v === this.trueValue;
      }
    }
  }
});

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch",
    class: _vm.classObject
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    ref: "input",
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }, _vm.input]
    }
  }, 'input', {
    id: _vm.id,
    name: _vm.name,
    value: _vm.value,
    disabled: _vm.disabled,
    required: _vm.required,
    class: _vm.inputClass
  }, false))])
},staticRenderFns: []}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "quotas"
  }, [_c('div', {
    staticClass: "rangesList"
  }, [_vm._l((_vm.quotas), function(quota, index) {
    return _c('div', {
      staticClass: "field quota",
      class: _vm.getQuotaDivClass(quota, index)
    }, [_c('div', {
      staticClass: "is-inline-block gender"
    }, [_c('vb-switch', {
      attrs: {
        "type": "danger rounded",
        "size": "medium"
      },
      model: {
        value: (quota.gender),
        callback: function($$v) {
          _vm.$set(quota, "gender", $$v)
        },
        expression: "quota.gender"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "is-inline-block age"
    }, [_c('vue-slider', {
      attrs: {
        "tooltip": 'always',
        "tooltip-placement": ['top', 'top'],
        "contained": true,
        "max": _vm.quotasParam.maxAge,
        "marks": _vm.quotasParam.marks,
        "railStyle": _vm.getSliderRailStyle(quota),
        "tooltipStyle": _vm.getSliderTooltipStyle(quota),
        "processStyle": _vm.getSliderProcessStyle(quota)
      },
      model: {
        value: (quota.age),
        callback: function($$v) {
          _vm.$set(quota, "age", $$v)
        },
        expression: "quota.age"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "field highLimit"
    }, [_c('div', {
      staticClass: "control"
    }, [_c('label', {
      staticClass: "checkbox"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('campaigns.quotas.noLimit')))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": !_vm.isRange(quota.age)
      },
      on: {
        "change": function($event) {
          return _vm.toggleHighLimit(!this.event.target.checked, quota)
        }
      }
    })])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "control is-inline-block limit"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (quota.limit),
        expression: "quota.limit"
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "placeholder": "limit",
        "min": "0"
      },
      domProps: {
        "value": (quota.limit)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(quota, "limit", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "control is-inline-block summary"
    }, [_c('span', [_vm._v(_vm._s(_vm.getQuotaSummary(quota)))])])])
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-rounded",
    on: {
      "click": function($event) {
        return _vm.addQuota()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle"
  }), _vm._v(_vm._s(_vm.$t('campaigns.quotas.addQuotas')))])], 2)]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary save",
    on: {
      "click": function($event) {
        return _vm.saveQuotas()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.save')))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
}]}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_loaders_Loader1__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_loaders_Loader1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_loaders_Loader1__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var REPORTS_GENERATE_API = '/report';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReportGenerator',
  components: { Loader: __WEBPACK_IMPORTED_MODULE_0__components_loaders_Loader1___default.a },
  props: ['campaignId', 'status', 'checkStatusWhenCreated'],
  data: function data() {
    return {
      reportStatus: '',
      reportLink: '',
      checkStatusTimer: null
    };
  },
  created: function created() {
    if (this._props.campaignId && this._props.checkStatusWhenCreated) {
      this.checkStatus();
    }
  },

  methods: {
    checkStatus: function checkStatus() {
      console.log('checkStatus');
      var that = this;
      this.$http({
        url: REPORTS_GENERATE_API + '/checkStatus/' + this._props.campaignId
      }).then(function (response) {
        that.reportStatus = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    generateReport: function generateReport() {
      var that = this;
      that.reportStatus = 'generating';

      that.$http({
        url: REPORTS_GENERATE_API + '/generateAsync/' + that._props.campaignId
      }).then(function () {
        // that.reportStatus = 'exist'
      }).catch(function (error) {
        that.reportStatus = 'fail';
        console.log(error);
      });
    },
    initCheckStatusInterval: function initCheckStatusInterval() {
      this.checkStatusTimer = setInterval(this.checkStatus, 4000);
    },
    clearCheckStatusInterval: function clearCheckStatusInterval() {
      if (this.checkStatusTimer) {
        clearInterval(this.checkStatusTimer);
        this.checkStatusTimer = null;
      }
    }
  },
  watch: {
    reportStatus: function reportStatus(val) {
      console.log('reportStatus ' + val);
      this.clearCheckStatusInterval();
      if (val === 'generating') {
        this.initCheckStatusInterval();
      } else if (val === 'exist') {
        this.reportLink = REPORTS_GENERATE_API + '/generatedReports/' + this._props.campaignId;
      }
    },
    campaignId: function campaignId() {
      this.checkStatus();
    },
    status: function status(val) {
      this.reportStatus = val;
    }
  }
});

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Loader1',
    props: ['color']
});

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "rect1",
    style: ('background-color:' + _vm.color)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect2",
    style: ('background-color:' + _vm.color)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect3",
    style: ('background-color:' + _vm.color)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect4",
    style: ('background-color:' + _vm.color)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect5",
    style: ('background-color:' + _vm.color)
  })])
},staticRenderFns: []}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.reportStatus === 'absent') ? _c('div', [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.generateReport
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('campaigns.reportTexts.createReport')))])])]) : (_vm.reportStatus === 'generating') ? _c('div', {
    staticClass: "waiting button is-primary"
  }, [_c('Loader', {
    attrs: {
      "color": "white"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.reportTexts.reportIsBeingGeneratedNow')))])], 1) : (_vm.reportStatus === 'exist' && _vm.reportLink) ? _c('div', [_c('a', {
    staticClass: "button is-success",
    attrs: {
      "href": _vm.reportLink
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.load')))])]), _vm._v(" "), _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.generateReport
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.actions.reCreate')))])])]) : (_vm.reportStatus === 'fail') ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('campaigns.reportTexts.createReportError')))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])
}]}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box",
    class: 'activeTab_' + _vm.activeTab
  }, [_c('tabs', {
    attrs: {
      "type": "boxed"
    },
    on: {
      "tab-selected": _vm.tabSelected
    }
  }, [_c('tab-pane', {
    attrs: {
      "label": _vm.$t('campaigns.campaignParams.campaignsParameters')
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.title')))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.namePostfix),
      expression: "campaign.namePostfix"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('campaigns.putCampaignsName'),
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.namePostfix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "namePostfix", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.callDate')))]), _vm._v(" "), _c('datepicker', {
    staticClass: "date",
    attrs: {
      "disabled": !_vm.canEdit() && !_vm.canContinue(),
      "placeholder": _vm.$t('campaigns.campaignParams.putCallDate'),
      "config": {
        wrap: true,
        dateFormat: 'd.m.Y',
        locale: _vm.l10n
      }
    },
    model: {
      value: (_vm.campaign.date),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "date", $$v)
      },
      expression: "campaign.date"
    }
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "data-toggle": "",
      "disabled": !_vm.canEdit() && !_vm.canContinue()
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "data-clear": "",
      "disabled": !_vm.canEdit() && !_vm.canContinue()
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.timezone')) + " (UTC)")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.zoneOffset),
      expression: "campaign.zoneOffset"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaign, "zoneOffset", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("0")]), _vm._v(" "), _c('option', [_vm._v("+1")]), _vm._v(" "), _c('option', [_vm._v("+2")]), _vm._v(" "), _c('option', [_vm._v("+3")]), _vm._v(" "), _c('option', [_vm._v("+4")]), _vm._v(" "), _c('option', [_vm._v("+5")]), _vm._v(" "), _c('option', [_vm._v("+6")]), _vm._v(" "), _c('option', [_vm._v("+7")]), _vm._v(" "), _c('option', [_vm._v("+8")]), _vm._v(" "), _c('option', [_vm._v("+9")]), _vm._v(" "), _c('option', [_vm._v("+10")]), _vm._v(" "), _c('option', [_vm._v("+11")]), _vm._v(" "), _c('option', [_vm._v("+12")])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.callTime')))]), _vm._v(" "), _c('p', {
    staticClass: "control has-addons"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('common.timeInterval.from'))), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.timeStart),
      expression: "campaign.timeStart"
    }],
    staticClass: "time",
    attrs: {
      "type": "text",
      "pattern": "(([0,1][0-9])|(2[0-3])):[0-5][0-9]",
      "placeholder": "XX:XX",
      "value": "10:00",
      "readonly": !_vm.canEdit() && !_vm.canContinue(),
      "onblur": _vm.transformTimeStart()
    },
    domProps: {
      "value": (_vm.campaign.timeStart)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "timeStart", $event.target.value)
      }
    }
  }), _vm._v("\n              " + _vm._s(_vm.$t('common.timeInterval.to'))), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.timeEnd),
      expression: "campaign.timeEnd"
    }],
    staticClass: "time",
    attrs: {
      "type": "text",
      "pattern": "(([0,1][0-9])|(2[0-3])):[0-5][0-9]",
      "placeholder": "XX:XX",
      "value": "18:00",
      "readonly": !_vm.canEdit() && !_vm.canContinue(),
      "onblur": _vm.transformTimeEnd()
    },
    domProps: {
      "value": (_vm.campaign.timeEnd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "timeEnd", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.numberOfAttemptsToGetThrough')))]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.postponingAttempts),
      expression: "campaign.postponingAttempts"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaign, "postponingAttempts", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("0")]), _vm._v(" "), _c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("5")])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.intervalBetweenRepeatedCalls')) + " (" + _vm._s(_vm.$t('common.time.minutes')) + ")")]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.postponingIntervalMin),
      expression: "campaign.postponingIntervalMin"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaign, "postponingIntervalMin", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("30")]), _vm._v(" "), _c('option', [_vm._v("60")]), _vm._v(" "), _c('option', [_vm._v("120")]), _vm._v(" "), _c('option', [_vm._v("240")])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('scenarios.scenario')))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.scenario),
      expression: "campaign.scenario"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "click": _vm.getScenarioReadyState,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaign, "scenario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.scenarios), function(scenario) {
    return _c('option', {
      domProps: {
        "value": scenario.id
      }
    }, [_vm._v("\n                " + _vm._s(scenario.name) + "\n              ")])
  }), 0)]), _vm._v(" "), (_vm.campaign.scenario) ? _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.gotoScenario
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.openScenario')))])]) : _vm._e(), _vm._v(" "), (_vm.isReadyScenario) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.scenarioIsReady')))])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.scenarioIsNotReady')))])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.base')))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "disabled": !_vm.canEdit(),
      "type": "button",
      "id": "uploadFile",
      "value": _vm.$t('common.actions.loadFromFile')
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('uploadPhones')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "uploadPhones",
      "name": "load-phones",
      "type": "file",
      "accept": ".txt,.csv,.xls,.xlsx"
    },
    on: {
      "input": function($event) {
        return _vm.uploadPhones('uploadPhones')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-info",
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "click": _vm.openModalClipboard
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.putBaseFromClipboard')))])]), _vm._v(" "), (_vm.tasksCount > 0) ? _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.viewCallTasks
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.viewBase')))])]) : _vm._e(), _vm._v(" "), (_vm.tasksCountPerformed == 0 && _vm.tasksCount > 0 && !_vm.campaign.archiveStatus) ? _c('button', {
    staticClass: "button is-light delete-button",
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "click": _vm.openModalDelete
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.removeBase')))])]) : _vm._e(), _vm._v(" "), (_vm.canContinue()) ? _c('button', {
    staticClass: "button is-warning",
    on: {
      "click": _vm.getReadyCallTasksCSV
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.unprocessed')) + " " + _vm._s(_vm.$t('campaigns.campaignParams.numbers')))])]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.uploadedNumbers')) + ": " + _vm._s(_vm.tasksCount))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('testCall.testCall')))]), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.campaign.archiveStatus
    },
    on: {
      "click": function($event) {
        return _vm.callTest(true)
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-volume-control-phone"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('testCall.callToNumber')))])])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.testPhone),
      expression: "testPhone"
    }],
    staticClass: "input",
    attrs: {
      "disabled": _vm.campaign.archiveStatus,
      "type": "text",
      "placeholder": _vm.$t('testCall.putNumber')
    },
    domProps: {
      "value": (_vm.testPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.testPhone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.viewTestCallTasks
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('testCall.viewTestResults')))])])])]), _vm._v(" "), (!_vm.campaign.archiveStatus) ? _c('div', {
    staticClass: "control"
  }, [_c('collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('collapse-item', {
    attrs: {
      "title": _vm.$t('testCall.testCallParameters')
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('common.key')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.value')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.testPhoneParametersArray), function(param, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[0]),
        expression: "param[0]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (param[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 0, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-light",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.deleteTestPhoneParameter(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-minus-circle"
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.delete')))])])])])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
    staticClass: "button is-light",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.addTestPhoneParameter
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.add')))])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])], 2)])])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('br')], 1), _vm._v(" "), (_vm.canAccessAdditionalParameters(_vm.permissionKey)) ? _c('tab-pane', {
    attrs: {
      "label": _vm.$t('campaigns.additionalParameters.additionalParameters')
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("FS Gateway")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.gateway),
      expression: "campaign.gateway"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaign, "gateway", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.fsGateways), function(fsGateway) {
    return _c('option', {
      domProps: {
        "value": fsGateway.name
      }
    }, [_vm._v("\n                " + _vm._s(fsGateway.name) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Приоритет")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.priority),
      expression: "campaign.priority"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Приоритет рассылки",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.priority)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "priority", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Record Host")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.recordHost),
      expression: "campaign.recordHost"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.recordHost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "recordHost", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Postponing Strategy")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.postponingStrategy),
      expression: "campaign.postponingStrategy"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.postponingStrategy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "postponingStrategy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Schedule Strategy")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.scheduleStrategy),
      expression: "campaign.scheduleStrategy"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.scheduleStrategy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "scheduleStrategy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Tel Error Strategy")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.telErrorStrategy),
      expression: "campaign.telErrorStrategy"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.telErrorStrategy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "telErrorStrategy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Dialplan Context")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.dialplanContext),
      expression: "campaign.dialplanContext"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.dialplanContext)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "dialplanContext", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Dialplan Extension")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.dialplanExtension),
      expression: "campaign.dialplanExtension"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.dialplanExtension)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "dialplanExtension", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Target Strategy")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.targetStrategy),
      expression: "campaign.targetStrategy"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.targetStrategy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "targetStrategy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Phone Preprocessing Strategy")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.phonePreprocessingStrategy),
      expression: "campaign.phonePreprocessingStrategy"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.phonePreprocessingStrategy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "phonePreprocessingStrategy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('common.key')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.value')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.phonePreprocessingParametersArray), function(param, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[0]),
        expression: "param[0]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": !_vm.canEdit()
      },
      domProps: {
        "value": (param[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 0, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": !_vm.canEdit()
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-light",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": !_vm.canEdit()
      },
      on: {
        "click": function($event) {
          return _vm.deletePhonePreprocessingParameter(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-minus-circle"
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.delete')))])])])])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
    staticClass: "button is-light",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "click": _vm.addPhonePreprocessingParameter
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.add')))])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.quotaServiceAvailable && _vm.campaign && _vm.campaign.id) ? _c('tab-pane', {
    attrs: {
      "label": _vm.$t('campaigns.quotas.quotas')
    }
  }, [_c('div', {
    staticClass: "quotasShell"
  }, [_c('CampaignQuota', {
    attrs: {
      "campaign-id": _vm.campaign.id
    },
    on: {
      "serviceNotAvailable": _vm.quotaServiceNotAvailable
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "control toolButtons"
  }, [(_vm.canEdit() || _vm.canContinue()) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.save')))])]) : _vm._e(), _vm._v(" "), (_vm.canSetReadyStatus() && !_vm.campaign.archiveStatus) ? _c('button', {
    staticClass: "button is-info",
    attrs: {
      "disabled": !_vm.canEdit(),
      "disabled": _vm.appconfig.disableCampaignSetReadyState
    },
    on: {
      "click": _vm.openModalReady
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.run')))])]) : _vm._e(), _vm._v(" "), (_vm.canPauseStatus()) ? _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.openModalStop
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.stop')))])]) : _vm._e()]), _c('div', {
    staticClass: "report"
  }, [_c('ReportGenerator', {
    attrs: {
      "campaign-id": _vm.id,
      "check-status-when-created": true
    }
  }), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.downloadTestReport
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.reportByTestCalls')))])])])], 1), _vm._v(" "), (_vm.canLoadReport(_vm.campaign)) ? _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.viewCallsResult
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.callResult')))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.close')))])]), _vm._v(" "), (!_vm.campaign.archiveStatus && _vm.canAccessAdditionalParameters(_vm.permissionKey)) ? _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.viewMonitor
    }
  }, [_vm._m(4), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.callsMonitoring')))])]) : _vm._e(), _vm._v(" "), _c('p')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title,
      "confirmation": _vm.confirmation,
      "clipboard": !_vm.confirmation
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-stop-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-tv"
  })])
}]}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VisCommon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VisCommon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_VisCommon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var CAMPAIGNS_API = '/api/campaigns';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignCallsResult',
  extends: __WEBPACK_IMPORTED_MODULE_0__components_VisCommon___default.a,
  components: {},
  props: ['id'],
  data: function data() {
    return {
      result: {
        fullCount: '',
        predefinedCount: '',
        firstQuestionAnsweredCount: '',
        dialogToEndCount: ''
      }
    };
  },
  created: function created() {
    this.loadResults();
  },

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['authenticationToken', 'loggedId'])),
  methods: {
    loadResults: function loadResults() {
      var _this = this;

      this.$http.get(CAMPAIGNS_API + '/getCallsResult/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.result = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calls-result"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Контактов в базе")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.fullCount))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Дозвонились до")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.predefinedCount))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ответили на первый вопрос")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.firstQuestionAnsweredCount))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Сценарий завершён")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.dialogToEndCount))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__authentication_CheckToken__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__authentication_CheckToken__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_2__authentication_CheckToken___default.a);

var MONITORING_API = '/monitoring';
var CAMPAIGNS_API = '/api/campaigns';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  data: function data() {
    return {
      campaignProgress: {},
      campaign: ''
    };
  },
  created: function created() {
    this.checkToken();
    this.calltasks = this.loadData();
    this.loadCampaign();
    this.monitoringCampaign();
  },

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'loggedId'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    loadData: function loadData() {
      var _this = this;

      this.$http.get(MONITORING_API + '/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.campaignProgress = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    monitoringCampaign: function monitoringCampaign() {
      var _this2 = this;

      this.$root.monitor = setInterval(function () {
        _this2.calltasks = _this2.loadData();
      }, 60000);
    },
    loadCampaign: function loadCampaign() {
      var _this3 = this;

      this.$http.get(CAMPAIGNS_API + '/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this3.campaign = response.data;
      });
    },
    cancel: function cancel() {
      clearInterval(this.$root.monitor);
      this.$router.push('/campaigns/' + this.$props.id);
    }
  }
});

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('label', [_vm._v(_vm._s(_vm.campaign.name))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Статистика задач")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("В очереди")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignProgress.ready))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Вызов")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignProgress.dialing))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Идет разговор")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignProgress.ongoing))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Выполнена")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignProgress.performed))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Недозвон")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignProgress.failed))])])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Метрики прозвона")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Скорость выполнения")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignProgress.performingSpeed))])])])])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Состояние")]), _vm._v(" "), _c('th', [_vm._v("Количество")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Метрика")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
}]}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Paging__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Paging___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Paging__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CampaignsCommon__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CampaignsCommon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CampaignsCommon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ReportGenerator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ReportGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ReportGenerator__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var CAMPAIGN_API = '/api/campaigns';
var CALLTASKS_API = '/outgoing-cpg-sec';
var REPORTS_GENERATE_API = '/report';

/* harmony default export */ __webpack_exports__["default"] = (_defineProperty({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__Modal___default.a,
    Paging: __WEBPACK_IMPORTED_MODULE_1__components_Paging___default.a,
    ReportGenerator: __WEBPACK_IMPORTED_MODULE_3__ReportGenerator___default.a
  },
  extends: __WEBPACK_IMPORTED_MODULE_2__CampaignsCommon___default.a,

  data: function data() {
    return {
      campaignsPage: { content: [] },
      reportStatusMap: {},
      perPage: 10,
      currentSort: 'created',
      currentSortDir: 'desc',
      ascIcon: ' ▲',
      descIcon: ' ▼',
      searchName: '',
      campaignToDelete: null,
      campaignToArchive: null,
      campaignToReady: null,
      campaignToPause: null,
      showModal: null,
      title: '',
      permissionKey: 'campaign'
    };
  },

  watch: {
    searchName: function searchName() {
      this.loadData();
    }
  },
  created: function created() {
    this.loadData();
  },

  methods: {
    loadData: function loadData(page) {
      var _this = this;

      var that = this;
      page = page || that.campaignsPage.number;
      page = page ? page - 1 : 0;
      var url = CAMPAIGN_API + '/filter' + '?page=' + page + '&pageSize=' + this.perPage + '&filter=' + this.searchName + '&sortDir=' + this.currentSortDir + '&sort=' + this.currentSort;
      this.$http.get(url, { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.campaignsPage = response.data;
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка загрузки списка рассылок. ');
      });
    },
    sort: function sort(s) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
      this.loadData();
    },
    searchByName: function searchByName() {
      this.loadData();
    },
    sortIcon: function sortIcon(s) {
      if (s === this.currentSort) {
        if (this.currentSortDir === 'asc') {
          return this.ascIcon;
        } else {
          return this.descIcon;
        }
      } else {
        return '';
      }
    },
    closeModal: function closeModal() {
      this.campaignToDelete = null;
      this.campaignToArchive = null;
      this.campaignToReady = null;
      // this.campaignToStart = null
      // this.campaignToPause = null
      this.showModal = false;
    },
    openModal: function openModal(campaign, type) {
      this.campaignToStart = null;
      this.campaignToPause = null;
      this.closeModal();
      this.confirmation = true;
      if (type == 'archive') {
        this.campaignToArchive = campaign;
        this.title = 'Перенести рассылку в архив?';
      } else if (type == 'delete') {
        this.campaignToDelete = campaign;
        this.title = 'Удалить рассылку?';
      } else if (type === 'readyStatus') {
        this.campaignToReady = campaign;
        this.title = 'Запустить рассылку?';
      } else if (type === 'pauseStatus') {
        this.title = 'Остановить рассылку?';
        this.campaignToPause = campaign;
      }
      this.showModal = true;
    },
    confirmAction: function confirmAction() {
      if (this.campaignToDelete) {
        this.removeCampaign();
        this.campaignToDelete = null;
      }
      if (this.campaignToArchive) {
        this.addToArchive();
        this.campaignToArchive = null;
      }
      if (this.campaignToReady) {
        this.setReadyStatus(this.campaignToReady);
        this.campaignToReady = null;
      }
      if (this.campaignToPause) {
        this.setPauseStatus(this.campaignToPause);
        this.campaignToPause = null;
      }
      this.closeModal();
    },
    addToArchive: function addToArchive() {
      var _this2 = this;

      this.campaignToArchive.archiveStatus = true;
      this.$http.put(CAMPAIGN_API, this.campaignToArchive, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.openNotificationWithType('info', 'Рассылка помещена в архив.');
        _this2.loadData();
        //          this.$router.push('/archive/')
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка переноса в архив. ');
      });
    },
    removeCampaign: function removeCampaign() {
      var _this3 = this;

      this.$http.delete(CAMPAIGN_API + '/' + this.campaignToDelete.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this3.openNotificationWithType('info', 'Рассылка удалена.');
        _this3.loadData();
      }).catch(function (error) {
        console.log(error);
        _this3.openNotificationWithType('danger', 'Ошибка удаления рассылки. ');
      });
    },
    copyCampaign: function copyCampaign(campaign) {
      this.$router.push('/copy/' + campaign.id);
    },
    handleReadyState: function handleReadyState(callTaskList) {
      return callTaskList.filter(function (callTask) {
        return callTask.state === 'READY';
      });
    },
    canDeleteState: function canDeleteState(campaign) {
      return (campaign.state === 'Подготовлена' || campaign.state === 'В разработке') && !campaign.hasPerformedTasks;
    },

    // prepareReport (campaign) {
    //   this.$http.get('/report/prepareReportByCampaignId?campaignId=' + campaign.id)
    //     .then((response) => {
    //       this.openNotificationWithType('info', 'Отчет подготовлен')
    //       this.loadData()
    //     })
    //     .catch((error) => {
    //       this.openNotificationWithType('warning', 'Отчет формируется. Пожалуйста, загрузите его чуть позже.' +
    //         ' Необходимо будет обновить эту страницу, нажав Ctrl+F5')
    //       console.log(error)
    //     })
    // },
    viewMonitor: function viewMonitor(campaign) {
      this.$router.push('/monitoring/' + campaign.id);
    },
    getReadyCallTasksCSV: function getReadyCallTasksCSV(campaign) {
      var _this4 = this;

      this.$http.get(CALLTASKS_API + '/readyCallTasksByCampaignId.csv?campaignId=' + campaign.id).then(function (response) {
        var blob = new Blob([response.data], { type: 'text/csv' });
        var a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = 'readyCallTasksByCampaign_' + campaign.name + '.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }).catch(function (error) {
        _this4.openNotificationWithType('danger', 'Ошибка загрузки отчета');
        console.log(error);
      });
    },
    getSumConsume: function getSumConsume(campaign) {
      var _this5 = this;

      console.log(campaign.id);
      this.$http.get(CAMPAIGN_API + '/sumConsume/' + campaign.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this5.openNotificationWithType('info', 'Сумма расчитана.');
        _this5.loadData();
        //          this.$router.push('/archive/')
      }).catch(function (error) {
        console.log(error);
        _this5.openNotificationWithType('danger', 'Ошибка рассчета суммы. ');
      });
    },
    getDate: function getDate(date) {
      var d = new Date(Number(date));
      var day = d.getUTCDate();
      var month = d.getUTCMonth() + 1;
      var year = d.getUTCFullYear();
      if (day < 10) day = '0' + day;
      if (month < 10) month = '0' + month;
      return day + '.' + month + '.' + year;
    },
    toggleDropdown: function toggleDropdown(event) {
      event.currentTarget.classList.toggle('is-active');
    }
  }
}, 'watch', {
  campaignsPage: function campaignsPage(val) {
    if (val && val.content && val.content.length) {
      var ids = '';
      for (var i = 0; i < val.content.length; i++) {
        if (ids) {
          ids += ',';
        }
        ids += val.content[i].id;
      }
      var that = this;
      this.$http.get(REPORTS_GENERATE_API + '/checkStatus?campaignIds=' + ids).then(function (response) {
        that.reportStatusMap = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
}));

/***/ }),
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VisCommon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VisCommon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_VisCommon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Modal__);
//
//
//
//




var REPORTS_API = '/report/csv/win/campaign';
var PHONEBASEUPLOADING_API = '/outgoing-cpg-sec';
var CAMPAIGNS_CTS_API = '/outgoing-cpg-sec';
var OLD_REPORTS_API = '/calls';

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CampaignsCommon',
    extends: __WEBPACK_IMPORTED_MODULE_0__components_VisCommon___default.a,
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_1__Modal___default.a
    },
    data: function data() {
        return {
            permissionKey: 'campaign'
        };
    },

    methods: {
        getCampaignStateInfo: function getCampaignStateInfo(campaign) {
            if (this.canSetReadyStatus(campaign)) {
                return 'Готова к запуску';
            } else if (this.canPauseStatus(campaign)) {
                return 'Запущена';
            } else {
                return campaign.state;
            }
        },
        getCampaignStateInfoTrans: function getCampaignStateInfoTrans(campaign) {
            var state = this.getCampaignStateInfo(campaign);
            if (state === 'Готова к запуску') {
                return 'campaigns.states.readyToRun';
            } else if (state === 'Запущена') {
                return 'campaigns.states.started';
            } else {
                return campaign.stateCode ? 'campaigns.states.' + campaign.stateCode.toLowerCase() : state;
            }
        },
        canSetReadyStatus: function canSetReadyStatus(campaign) {
            var result = (campaign.state === 'В разработке' || campaign.scheduleStrategy && campaign.scheduleStrategy.startsWith('DAILY_TIME_INTERVAL') && campaign.state !== 'Подготовлена' && campaign.state !== 'Прозвон идёт' || this.canContinue(campaign)) && this.canModerate(this.permissionKey) && campaign.client != null && campaign.date != null && campaign.scenario != null && campaign.zoneOffset != null && campaign.timeStart != null && campaign.timeEnd;
            return result;
        },
        canPauseStatus: function canPauseStatus(campaign) {
            var result = campaign.scheduleStrategy && campaign.scheduleStrategy.startsWith('DAILY_TIME_INTERVAL') && (campaign.state === 'Подготовлена' || campaign.state === 'Прозвон идёт') && this.canModerate(this.permissionKey);
            return result;
        },
        canContinue: function canContinue(campaign) {
            return campaign.state === 'Завершена' && campaign.hasReadyTasks;
        },
        setReadyStatus: function setReadyStatus(campaign) {
            var _this = this;

            campaign.state = 'Подготовлена';
            this.$http.put(CAMPAIGNS_CTS_API + '/' + campaign.id + '/updatestate?state=READY', {}, { headers: this.prepareSecurityHeader() }).then(function () {
                _this.openNotificationWithType('info', 'Рассылка готова к запуску.');
            }).catch(function (error) {
                console.log(error);
                _this.openNotificationWithType('danger', 'Ошибка запуска рассылки. ');
            });
        },
        setPauseStatus: function setPauseStatus(campaign) {
            var _this2 = this;

            campaign.state = 'Остановлена';
            this.$http.put(CAMPAIGNS_CTS_API + '/' + campaign.id + '/updatestate?state=PAUSED_INTENTIONALLY', {}, { headers: this.prepareSecurityHeader() }).then(function () {
                _this2.openNotificationWithType('info', 'Рассылка остановлена');
            }).catch(function (error) {
                console.log(error);
                _this2.openNotificationWithType('danger', 'Ошибка остановки рассылки. ');
            });
        },
        canLoadReport: function canLoadReport(campaign) {
            return campaign.state === 'Завершена' || campaign.scheduleStrategy === 'DAILY_TIME_INTERVAL';
        },
        getReportCSV: function getReportCSV(campaign, periodStart, periodEnd) {
            var _this3 = this;

            if (typeof periodStart === 'undefined') {
                periodStart = '';
            }
            if (typeof periodEnd === 'undefined') {
                periodEnd = '';
            }
            var timezone = (campaign.zoneOffset || '+7').replace('+', '%2B');
            var url = void 0;
            if (periodEnd && periodStart) {
                url = REPORTS_API + '/' + campaign.id + '?reportMode=full&timeZone=' + timezone + '&start=' + periodStart + '&end=' + periodEnd;
            } else {
                url = OLD_REPORTS_API + '/id/' + campaign.id + '/win/csv?audioPath=' + (campaign.recordHost + '/' + campaign.clientId + '/' + campaign.id);
            }
            this.$http.get(url, { headers: this.prepareSecurityHeader(), timeout: 180000 }).then(function (response) {
                var s = response.headers['content-disposition'];
                var res = s.split('filename="').pop();
                res = res.split('"')[0];
                var blob = new Blob([response.data], { type: 'text/csv' });
                var a = window.document.createElement('a');
                a.href = window.URL.createObjectURL(blob);
                a.download = res;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }).catch(function (error) {
                _this3.openNotificationWithType('danger', 'Ошибка загрузки отчета');
                console.log(error);
            });
        },
        uploadPhones: function uploadPhones(inputId, campaign) {
            var input = document.querySelector('#' + inputId);
            if (input.files && input.files[0]) {
                if (!campaign.id) {
                    this.openNotificationWithType('danger', 'Перед загрузкой базы необходимо сохранить рассылку');
                } else {
                    this.handleUploadPhonesRequest(input.files[0], campaign);
                }
            }
        },
        handleUploadPhonesRequest: function handleUploadPhonesRequest(phonesFile, campaign) {
            var _this4 = this;

            this.$http.post(PHONEBASEUPLOADING_API + '/' + 'loadForCampaign', this.prepareMultipartFile(phonesFile, campaign.id), { headers: this.prepareSecurityHeader(), timeout: 180000 }).then(function (response) {
                if (response.status === 200) {
                    var message = '';
                    if (typeof response.data === 'string' || response.data instanceof String) {
                        message = response.data;
                    } else if (response.data && !response.data.message) {
                        message = response.data.message;
                    }
                    if (!message) {
                        _this4.openNotificationWithType('info', 'База загружена.');
                    } else {
                        _this4.openNotificationWithType('danger', message, 0);
                    }
                    // this.loadTasksCount(campaign)
                    // this.loadTasksCountPerformed(campaign)
                } else {
                    _this4.openNotificationWithType('danger', 'Ошибка загрузки файла');
                }
            }).catch(function (error) {
                _this4.openNotificationWithType('danger', 'Ошибка загрузки файла');
                console.log(error);
            });
        },

        // loadTasksCount (campaign) {
        //     this.$http.get(CALLTASKS_API + '/' + campaign.id + '/count', {headers: this.prepareSecurityHeader()})
        //         .then((response) => {
        //             campaign.tasksCount = response.data
        //         })
        //         .catch((error) => {
        //             console.log(error)
        //         })
        // },
        // loadTasksCountPerformed (campaign) {
        //     this.$http.get(CALLTASKS_API + '/' + campaign.id + '/countPerformed', {headers: this.prepareSecurityHeader()})
        //         .then((response) => {
        //             campaign.tasksCountPerformed = response.data
        //         })
        //         .catch((error) => {
        //             console.log(error)
        //         })
        // },
        prepareMultipartFile: function prepareMultipartFile(phonesFile, phonesCampaign) {
            var phonesFormData = new FormData();
            phonesFormData.append('file', phonesFile);
            phonesFormData.append('campaign', phonesCampaign);
            return phonesFormData;
        },
        uploadFile: function uploadFile(buttonId) {
            document.getElementById(buttonId).click();
        }
    }
});

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.canCreate(_vm.permissionKey)) ? _c('a', {
    staticClass: "button is-success",
    attrs: {
      "href": "#/campaigns/new",
      "disabled": !_vm.isActive
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.createCampaign')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-info is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.search')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchName),
      expression: "searchName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('campaigns.putCampaignsName')
    },
    domProps: {
      "value": (_vm.searchName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('name')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.title')) + _vm._s(_vm.sortIcon('name')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('client')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.client')) + _vm._s(_vm.sortIcon('client')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('scenario')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.scenario')) + _vm._s(_vm.sortIcon('scenario')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('date')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('campaigns.ringing')) + _vm._s(_vm.sortIcon('sortingDate')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('state')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.state')) + _vm._s(_vm.sortIcon('state')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('created')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.creationDate')) + _vm._s(_vm.sortIcon('dateCreated')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('campaigns.report')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.action')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.campaignsPage.content), function(campaign, index) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": '#/campaigns/' + campaign.id
      }
    }, [_vm._v(_vm._s(campaign.name))])]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(campaign.client) + "\n                  ")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": '#/scenarios/0/' + campaign.scenario
      }
    }, [_vm._v(_vm._s(campaign.scenarioName))])]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(campaign.scheduleStrategy === 'DAILY_TIME_INTERVAL' ? '' : _vm.getDate(campaign.sortingDate)) + " " + _vm._s(campaign.timeStart) + "-" + _vm._s(campaign.timeEnd) + " " + _vm._s(campaign.zoneOffset) + " UTC\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "statusTd"
    }, [_c('button', {
      staticClass: "button is-info is-outlined",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": true
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(_vm.getCampaignStateInfoTrans(campaign))))])]), _vm._v(" "), (_vm.canContinue(campaign)) ? _c('button', {
      staticClass: "button is-warning",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.getReadyCallTasksCSV(campaign)
        }
      }
    }, [_vm._m(3, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.unprocessed')))])]) : _vm._e(), _vm._v(" "), (_vm.canSetReadyStatus(campaign)) ? _c('button', {
      staticClass: "button is-info",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": !_vm.isActive,
        "disabled": _vm.appconfig.disableCampaignSetReadyState
      },
      on: {
        "click": function($event) {
          return _vm.openModal(campaign, 'readyStatus')
        }
      }
    }, [_vm._m(4, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.run')))])]) : _vm._e(), _vm._v(" "), (_vm.canPauseStatus(campaign)) ? _c('button', {
      staticClass: "button is-info",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.openModal(campaign, 'pauseStatus')
        }
      }
    }, [_vm._m(5, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.stop')))])]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.getDate(campaign.dateCreated)) + "\n                  ")]), _vm._v(" "), _c('td', [(!campaign.archiveStatus && _vm.canAccessAdditionalParameters(_vm.permissionKey)) ? _c('button', {
      staticClass: "button is-info",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.viewMonitor(campaign)
        }
      }
    }, [_vm._m(6, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.monitoring')))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "report"
    }, [_c('ReportGenerator', {
      attrs: {
        "campaign-id": campaign.id,
        "status": _vm.reportStatusMap[campaign.id]
      },
      on: {
        "update:campaignId": function($event) {
          return _vm.$set(campaign, "id", $event)
        },
        "update:campaign-id": function($event) {
          return _vm.$set(campaign, "id", $event)
        },
        "update:status": function($event) {
          return _vm.$set(_vm.reportStatusMap, campaign.id, $event)
        }
      }
    })], 1), _vm._v(" "), (campaign.state == 'Завершена') ? _c('button', {
      staticClass: "button is-info",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": !_vm.isActive
      },
      on: {
        "click": function($event) {
          return _vm.getSumConsume(campaign)
        }
      }
    }, [_vm._m(7, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.cost')))])]) : _vm._e()])]), _vm._v(" "), _c('td', [(_vm.canCreate(_vm.permissionKey)) ? _c('a', {
      staticClass: "button is-success",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "href": '#/campaigns/copy/' + campaign.id,
        "disabled": !_vm.isActive
      }
    }, [_vm._m(8, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.stop')))])]) : _vm._e(), _vm._v(" "), (!_vm.canDeleteState(campaign) && _vm.canDelete(_vm.permissionKey)) ? _c('button', {
      staticClass: "button is-light",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": !_vm.isActive
      },
      on: {
        "click": function($event) {
          return _vm.openModal(campaign, 'archive')
        }
      }
    }, [_vm._m(9, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.toArchive')))])]) : _vm._e(), _vm._v(" "), (_vm.canDeleteState(campaign) && _vm.canDelete(_vm.permissionKey)) ? _c('button', {
      staticClass: "button is-light",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": !_vm.isActive
      },
      on: {
        "click": function($event) {
          return _vm.openModal(campaign, 'delete')
        }
      }
    }, [_vm._m(10, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.delete')))])]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('Paging', {
    attrs: {
      "refresh": _vm.loadData,
      "per-page": _vm.perPage,
      "data": _vm.campaignsPage
    },
    on: {
      "update:data": function($event) {
        _vm.campaignsPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title,
      "confirmation": _vm.confirmation,
      "clipboard": false
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-stop-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-tv"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-copy"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-archive"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
}]}

/***/ }),
/* 466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Paging__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Paging___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Paging__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CampaignsCommon__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CampaignsCommon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CampaignsCommon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var CAMPAIGN_API = '/api/campaigns';
var PHONEBASEUPLOADING_API = '/outgoing-cpg-sec';




/* harmony default export */ __webpack_exports__["default"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_1__CampaignsCommon___default.a,
    name: 'DailyCampaigns',
    components: {
        Paging: __WEBPACK_IMPORTED_MODULE_0__components_Paging___default.a
    },
    data: function data() {
        return {
            campaignsPage: { content: [] },
            perPage: 16,
            searchName: '',
            showModal: null,
            title: '',
            actionCampaign: null,
            reportPeriodStart: [],
            reportPeriodEnd: [],
            last24Hours: '',
            now: ''
        };
    },

    created: function created() {
        this.last24Hours = this.getLast24Hours();
        this.now = this.getNowDate();
        this.loadData();
    },
    methods: {
        loadData: function loadData(page) {
            var that = this;
            page = page ? page - 1 : 0;
            var url = CAMPAIGN_API + '/filter' + '?page=' + page + '&pageSize=' + this.perPage + '&filter=' + this.searchName + '&scheduleStrategy=DAILY_TIME_INTERVAL,DAILY_TIME_INTERVAL_WITHOUT_TASK_UPDATE&showTasksCount=READY,POSTPONED';
            this.$http.get(url, { headers: this.prepareSecurityHeader() }).then(function (response) {
                that.campaignsPage = response.data;
                that.reportPeriodStart = [];
                that.reportPeriodEnd = [];
                for (var i = 0; i < that.campaignsPage.content.length; i++) {
                    that.reportPeriodStart.push(that.last24Hours);
                    that.reportPeriodEnd.push(that.now);
                }
            }).catch(function (error) {
                console.log(error);
                that.openNotificationWithType('danger', 'Ошибка загрузки списка рассылок. ');
            });
        },
        getLast24Hours: function getLast24Hours() {
            var last24Hours = new Date(new Date().getTime() - 24 * 3600 * 1000);
            var dd = last24Hours.getDate();
            var mm = last24Hours.getMonth() + 1; // January is 0!
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return last24Hours.getFullYear() + '-' + mm + '-' + dd;
        },
        getNowDate: function getNowDate() {
            var now = new Date(new Date().getTime());
            var dd = now.getDate();
            var mm = now.getMonth() + 1; // January is 0!
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return now.getFullYear() + '-' + mm + '-' + dd;
        },
        formatPeriodDate: function formatPeriodDate(date) {
            if (date) {
                var split = date.split('-');
                if (split.length === 3) {
                    return split[2] + '.' + split[1] + '.' + split[0];
                }
            }
            return '';
        },
        canDeletePhones: function canDeletePhones(campaign) {
            return !campaign.archiveStatus && campaign.tasksCount && campaign.tasksCount.READY > 0;
        },
        openModalDeletePhones: function openModalDeletePhones(campaign) {
            this.actionCampaign = campaign;
            this.title = 'удалить номера?';
            this.showModal = true;
        },
        confirmAction: function confirmAction() {
            this.showModal = false;
            if (this.title === 'удалить номера?') {
                this.deleteReadyTasks();
            }
            this.actionCampaign = null;
        },
        deleteReadyTasks: function deleteReadyTasks() {
            var _this = this;

            this.$http.delete(PHONEBASEUPLOADING_API + '/ready/' + this.actionCampaign.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
                _this.openNotificationWithType('info', 'Звонки удалены.');
            }).catch(function (error) {
                console.log(error);
                _this.openNotificationWithType('danger', 'Ошибка удаления звонков. ');
            });
        }
    }
});

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchName),
      expression: "searchName"
    }],
    staticClass: "input searchFilter",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('campaigns.putCampaignsName')
    },
    domProps: {
      "value": (_vm.searchName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-info is-outlined",
    on: {
      "click": function($event) {
        return _vm.loadData()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.search')))])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "paging-top"
  }, [_c('Paging', {
    attrs: {
      "refresh": _vm.loadData,
      "per-page": _vm.perPage,
      "data": _vm.campaignsPage,
      "pagingClass": 'top'
    },
    on: {
      "update:data": function($event) {
        _vm.campaignsPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow campaignsTable"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('common.title')))]), _vm._v(" "), (_vm.canSelectUser(_vm.permissionKey)) ? _c('th', {
    staticClass: "client"
  }, [_vm._v(_vm._s(_vm.$t('common.client')))]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('scenarios.scenario')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.state')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('campaigns.loadBase')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('campaigns.report')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.campaignsPage.content), function(campaign, index) {
    return _c('tr', [_c('td', {
      staticClass: "campaignNameCell"
    }, [_c('a', {
      attrs: {
        "href": '#/campaigns/' + campaign.id
      }
    }, [_vm._v(_vm._s(campaign.name))])]), _vm._v(" "), (_vm.canSelectUser(_vm.permissionKey)) ? _c('td', {
      staticClass: "clientNameCell"
    }, [_c('a', {
      attrs: {
        "href": '#/users/client/' + campaign.clientId
      }
    }, [_vm._v(_vm._s(campaign.client))])]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "scenarioNameCell"
    }, [_c('a', {
      attrs: {
        "href": '#/scenarios/' + campaign.id + '/' + campaign.scenario
      }
    }, [_vm._v(_vm._s(campaign.scenarioName))])]), _vm._v(" "), _c('td', {
      staticClass: "campaignStatusCell"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t(_vm.getCampaignStateInfoTrans(campaign))))]), _vm._v(" "), (_vm.canSetReadyStatus(campaign)) ? _c('button', {
      staticClass: "button is-info",
      attrs: {
        "disabled": !_vm.isActive
      },
      on: {
        "click": function($event) {
          return _vm.setReadyStatus(campaign)
        }
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.run')))])]) : _vm._e(), _vm._v(" "), (_vm.canPauseStatus(campaign)) ? _c('button', {
      staticClass: "button is-info",
      on: {
        "click": function($event) {
          return _vm.setPauseStatus(campaign)
        }
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.stop')))])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "loadPhonesCell"
    }, [_c('div', [_c('input', {
      staticClass: "button is-info",
      attrs: {
        "type": "button",
        "value": _vm.$t('common.actions.loadFromFile')
      },
      on: {
        "click": function($event) {
          return _vm.uploadFile('uploadPhones' + index)
        }
      }
    }), _vm._v(" "), _c('input', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": "uploadPhones" + index,
        "name": "load-phones",
        "type": "file",
        "accept": ".txt,.csv,.xls,.xlsx"
      },
      on: {
        "input": function($event) {
          return _vm.uploadPhones('uploadPhones' + index, campaign)
        }
      }
    })]), _vm._v(" "), (_vm.canDeletePhones(campaign)) ? _c('div', {
      staticClass: "deletePhonesDiv",
      on: {
        "click": function($event) {
          return _vm.openModalDeletePhones(campaign)
        }
      }
    }, [_c('button', {
      staticClass: "button delete-button is-dark"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('campaigns.report')))])])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "campaignReportCell"
    }, [_c('div', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.reportPeriodStart[index]),
        expression: "reportPeriodStart[index]"
      }],
      staticClass: "input reportPeriod",
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": (_vm.reportPeriodStart[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.reportPeriodStart, index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.reportPeriodEnd[index]),
        expression: "reportPeriodEnd[index]"
      }],
      staticClass: "input reportPeriod",
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": (_vm.reportPeriodEnd[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.reportPeriodEnd, index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "button is-info",
      on: {
        "click": function($event) {
          _vm.getReportCSV(campaign, _vm.formatPeriodDate(_vm.reportPeriodStart[index]), _vm.formatPeriodDate(_vm.reportPeriodEnd[index]))
        }
      }
    }, [_vm._m(3, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.load')) + " CSV")])])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "paging-bottom"
  }, [_c('Paging', {
    attrs: {
      "refresh": _vm.loadData,
      "per-page": _vm.perPage,
      "data": _vm.campaignsPage,
      "pagingClass": 'bottom'
    },
    on: {
      "update:data": function($event) {
        _vm.campaignsPage = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title,
      "confirmation": _vm.confirmation,
      "clipboard": false
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-stop-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])
}]}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Paging__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Paging___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Paging__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VisCommon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VisCommon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_VisCommon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BILLING_API = 'billing/';




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Balance',
  extends: __WEBPACK_IMPORTED_MODULE_1__components_VisCommon___default.a,
  components: {
    Paging: __WEBPACK_IMPORTED_MODULE_0__components_Paging___default.a
  },
  props: ['clientId', 'reloadClient', 'clientBalance'],
  data: function data() {
    return {
      addResourcePage: { content: [] },
      perPage: 8,
      title: '',
      replenishBalance: {},
      ivoiceResources: [],
      creditLimit: this.clientBalance.creditLimit,
      loading: false,
      currentSort: 'timestampUtcMillis',
      currentSortDir: 'desc',
      ascIcon: ' ▲',
      descIcon: ' ▼'
    };
  },

  created: function created() {
    this.loadIvoiceResources();
    this.loadAddResourcesData();
  },
  methods: {
    loadAddResourcesData: function loadAddResourcesData(page) {
      var that = this;
      this.loading = true;
      page = page ? page - 1 : 0;
      var url = BILLING_API + 'clientBalance/getAddResourcesList/' + this.$props.clientId + '?page=' + page + '&pageSize=' + this.perPage + '&sortDir=' + this.currentSortDir + '&sort=' + this.currentSort;
      this.$http.get(url, { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.loading = false;
        that.addResourcePage = response.data;
      }).catch(function (error) {
        that.loading = false;
        console.log(error);
        that.openNotificationWithType('danger', 'Ошибка загрузки списка пополнений. ');
      });
    },
    loadIvoiceResources: function loadIvoiceResources() {
      var that = this;
      this.loading = true;
      var url = BILLING_API + 'getBillingConfig/';
      this.$http.get(url, { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.loading = false;
        var initialReplenishBalance = {};
        response.data.response.ivoiceResources.map(function (resource) {
          initialReplenishBalance[resource.name] = 0;
          that.ivoiceResources.push(resource.name);
        });
        that.replenishBalance = initialReplenishBalance;
      }).catch(function (error) {
        that.loading = false;
        console.log(error);
        that.openNotificationWithType('danger', 'Ошибка загрузки списка ресурсов Ivoice. ');
      });
    },
    changeSort: function changeSort(s, dir) {
      if (!this.isSortCurrent(s, dir)) {
        this.currentSort = s;
        this.currentSortDir = dir;
        this.loadAddResourcesData();
      }
    },
    sortButtonClass: function sortButtonClass(s, dir) {
      return this.isSortCurrent(s, dir) ? 'current' : '';
    },
    isSortCurrent: function isSortCurrent(s, dir) {
      return s === this.currentSort && dir === this.currentSortDir;
    },
    replenishBalanceMethod: function replenishBalanceMethod() {
      var that = this;
      this.loading = true;
      var url = BILLING_API + 'clientBalance/addResources/' + this.$props.clientId;
      this.$http.post(url, this.replenishBalance, { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.loading = false;
        that.replenishBalance = {};
        that.ivoiceResources.forEach(function (item) {
          that.replenishBalance[item] = 0;
        });
        that.openNotificationWithType('info', 'Баланс успешно пополнен');
        that.$props.reloadClient();
        that.loadAddResourcesData();
      }).catch(function (error) {
        if (error.response && error.response.status != 200) {
          console.log(error.response.data);
        }
        that.loading = false;
        that.openNotificationWithType('danger', 'Ошибка пополнения баланса, код ошибки: ' + error.response.data.code);
      });
    },
    saveCreditLimit: function saveCreditLimit() {
      var that = this;
      this.loading = true;
      var url = BILLING_API + 'clientBalance/updateCreditLimit/' + this.$props.clientId;
      this.$http.post(url, this.creditLimit, { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.loading = false;
        that.openNotificationWithType('info', 'Кредитный лимит успешно обновлён');
        that.$props.reloadClient();
        that.loadAddResourcesData();
      }).catch(function (error) {
        if (error.response && error.response.status != 200) {
          console.log(error.response.data);
        }
        that.loading = false;
        that.openNotificationWithType('danger', 'Ошибка обновления кредитного лимита, код ошибки: ' + error.response.data.code);
      });
    }
  }
});

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "table-responsive"
  }, [_c('h2', [_vm._v("Текущий баланс")]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered currentBalance"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.clientBalance.balance), function(value, name) {
    return _c('tr', {
      key: name
    }, [_c('td', [_vm._v(_vm._s(name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(value))])])
  }), 0)])]), _vm._v(" "), (_vm.replenishBalance) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('h2', [_vm._v(" Пополнить баланс ")]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.replenishBalance), function(value, name) {
    return _c('tr', {
      key: name
    }, [_c('td', [_vm._v(" " + _vm._s(name))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.replenishBalance[name]),
        expression: "replenishBalance[name]",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "input",
      attrs: {
        "placeholder": "0",
        "type": "number"
      },
      domProps: {
        "value": (_vm.replenishBalance[name])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.replenishBalance, name, _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])])
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !!_vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.replenishBalanceMethod()
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Пополнить баланс")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('h2', [_vm._v(" Кредитный лимит ")]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.clientBalance.creditLimit), function(value, name) {
    return _c('tr', {
      key: name
    }, [_c('td', [_vm._v(" " + _vm._s(name))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.clientBalance.creditLimit[name]),
        expression: "clientBalance.creditLimit[name]",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "input",
      attrs: {
        "placeholder": "0",
        "type": "number"
      },
      domProps: {
        "value": (_vm.clientBalance.creditLimit[name])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.clientBalance.creditLimit, name, _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])])
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !!_vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.saveCreditLimit()
      }
    }
  }, [_vm._m(4), _vm._v(" "), _c('span', [_vm._v("Обновить кредитный лимит")])])])]), _vm._v(" "), (_vm.addResourcePage && _vm.addResourcePage.content) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('label', {
    staticClass: "label addLabel"
  }, [_vm._v("Пополнения")]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered is-striped is-narrow campaignsTable"
  }, [_c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "sortButton",
    class: _vm.sortButtonClass('timestampUtcMillis', 'asc'),
    on: {
      "click": function($event) {
        return _vm.changeSort('timestampUtcMillis', 'asc')
      }
    }
  }, [_vm._v(_vm._s(_vm.ascIcon) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "sortButton",
    class: _vm.sortButtonClass('timestampUtcMillis', 'desc'),
    on: {
      "click": function($event) {
        return _vm.changeSort('timestampUtcMillis', 'desc')
      }
    }
  }, [_vm._v(_vm._s(_vm.descIcon) + "\n          ")]), _vm._v("\n          дата\n        ")]), _vm._v(" "), _c('th', [_c('div', {
    staticClass: "sortButton",
    class: _vm.sortButtonClass('totalResourcesValueLong', 'asc'),
    on: {
      "click": function($event) {
        return _vm.changeSort('totalResourcesValueLong', 'asc')
      }
    }
  }, [_vm._v(_vm._s(_vm.ascIcon) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "sortButton",
    class: _vm.sortButtonClass('totalResourcesValueLong', 'desc'),
    on: {
      "click": function($event) {
        return _vm.changeSort('totalResourcesValueLong', 'desc')
      }
    }
  }, [_vm._v(_vm._s(_vm.descIcon) + "\n          ")]), _vm._v("\n          Пополняемые ресурсы\n        ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.addResourcePage.content), function(addResource) {
    return _c('tr', {
      key: addResource.id
    }, [_c('td', {
      staticClass: "date"
    }, [_vm._v("\n          " + _vm._s(_vm.getDateFormat((addResource.timestampUtcMillis / 1000) < 1000000000000 ? addResource.timestampUtcMillis : addResource.timestamp / 1000)) + "\n        ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "table-responsive"
    }, [_c('table', {
      staticClass: "table is-bordered currentBalance"
    }, [_vm._m(5, true), _vm._v(" "), _c('tbody', _vm._l((addResource.resources), function(value, name) {
      return _c('tr', {
        key: name
      }, [_c('td', [_vm._v(_vm._s(name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(value))])])
    }), 0)])])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "paging-bottom"
  }, [_c('Paging', {
    attrs: {
      "refresh": _vm.loadAddResourcesData,
      "per-page": _vm.perPage,
      "data": _vm.addResourcePage,
      "pagingClass": 'bottom'
    },
    on: {
      "update:data": function($event) {
        _vm.addResourcePage = $event
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ресурс")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ресурс")]), _vm._v(" "), _c('th', [_vm._v("Пополняемое значение")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ресурс")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ресурс")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])])
}]}

/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 1
    },
    step: {
      type: Number,
      default: 0.01
    },
    value: {
      type: Number,
      default: 0
    },
    type: String,
    name: String,
    size: String,
    isFullwidth: Boolean,
    disabled: Boolean,
    // orientation:
    vertical: Boolean
  },

  data: function data() {
    return {
      realValue: this.value
    };
  },
  beforeMount: function beforeMount() {
    if (this.max < this.min) {
      throw 'Unexpected range setting: Maximum cannot be less than minimum';
    }

    this.update(this.value);
  },
  mounted: function mounted() {
    this.$el.style.setProperty('--low', this.low);
    this.$el.style.setProperty('--high', this.high);
  },


  watch: {
    realValue: function realValue(newVal, oldVal) {
      if (Number(newVal) !== Number(oldVal)) {
        this.$el.style.setProperty('--high', this.high);
        this.$emit('change', newVal);
      }
    },
    value: function value(val) {
      this.update(val);
    }
  },

  methods: {
    update: function update(val) {
      if (val > this.max) {
        this.realValue = this.max;
      } else if (val < this.min) {
        this.realValue = this.min;
      } else {
        this.realValue = val;
      }
    }
  },

  computed: {
    low: function low() {
      return '0%';
    },
    high: function high() {
      return (this.realValue - this.min) / (this.max - this.min) * 100 + '%';
    },
    classObject: function classObject() {
      var _ref;

      var type = this.type,
          size = this.size,
          isFullwidth = this.isFullwidth;

      return _ref = {
        slider: true
      }, _defineProperty(_ref, 'is-' + type, type), _defineProperty(_ref, 'is-' + size, size), _defineProperty(_ref, 'is-fullwidth', isFullwidth), _ref;
    }
  }
});

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.realValue),
      expression: "realValue"
    }],
    class: _vm.classObject,
    attrs: {
      "type": "range",
      "min": _vm.min,
      "max": _vm.max,
      "step": _vm.step,
      "name": _vm.name,
      "orient": _vm.vertical && 'vertical',
      "disabled": _vm.disabled,
      "number": ""
    },
    domProps: {
      "value": (_vm.realValue)
    },
    on: {
      "__r": function($event) {
        _vm.realValue = $event.target.value
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_switch__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_switch__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VbSwitchWithTwoLabels',
  components: {
    VbSwitch: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_switch___default.a
  },
  props: ['model', 'labelLeft', 'labelRight', 'onchange'],
  data: function data() {
    return {
      checked: true
    };
  },
  mounted: function mounted() {
    this.checked = this._props.model;
  },

  methods: {
    setValue: function setValue(val) {
      if (this.checked !== val) {
        this.$el.querySelector('.switch').click();
      }
      if (this._props.onchange) {
        this._props.onchange(val);
      }
    }
  },
  watch: {
    model: function model(v) {
      this.setValue(v);
    }
  }
});

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "VbSwitchWithTwoLabels is-inline-block"
  }, [_c('span', {
    class: !_vm.checked ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.setValue(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.labelLeft))]), _vm._v(" "), _c('vb-switch', {
    attrs: {
      "type": "",
      "size": "medium"
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.checked ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.setValue(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.labelRight))])], 1)
},staticRenderFns: []}

/***/ }),
/* 478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'LoaderRollers1'
});

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lds-roller"
  }, [_c('div'), _c('div'), _c('div'), _c('div'), _c('div'), _c('div'), _c('div'), _c('div')])
}]}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DownloadError'
});

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("Упс. Произошла ошибка скачивания файла")])
},staticRenderFns: []}

/***/ }),
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cleave__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cleave__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var NotificationComponent = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  components: {
    Cleave: __WEBPACK_IMPORTED_MODULE_3_vue_cleave___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a
  },
  data: function data() {
    return {
      profile: {},
      isSaved: false
    };
  },

  created: function created() {
    this.handleProfile();
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'loggedRole', 'loggedId'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      };
    },
    save: function save() {
      if (this.profile.id === undefined) {
        this.saveNew();
      } else {
        this.update();
      }
    },
    saveNew: function saveNew() {
      var _this = this;

      //      if (this.user.username != '') {
      //        if (this.reg.test(this.user.username)) {
      console.log('saving new profile: ' + JSON.stringify(this.profile));
      this.$http.post(PROFILES_API, this.profile, { headers: this.prepareSecurityHeader() }).then(function (response) {
        if (response.data != '') {
          console.log(response.data);
          _this.isSaved = true;
          _this.profile = response.data;
          _this.openNotificationWithType('info', 'Профиль сохранен.');
          //                this.$router.push('/users/')
        } else {
          console.log('Already exist');
          _this.openNotificationWithType('danger', 'Такой профиль уже существует.');
        }
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка сохранения данных');
      });
      //        } else {
      //          errorMessage = 'Необходимо ввести корректный адрес электронной почты'
      //        }
      //      } else {
      //        errorMessage = 'Необходимо ввести адрес электронной почты'
      //      }
    },
    update: function update() {
      var _this2 = this;

      //      if (this.user.username != '') {
      //        if (this.reg.test(this.user.username)) {
      console.log('updating profile: ' + JSON.stringify(this.profile));
      this.$http.put(PROFILES_API, this.profile, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.isSaved = true;
        console.log(response.data);
        _this2.openNotificationWithType('info', 'Профиль сохранен.');
        //              this.$router.push('/users/')
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка сохранения данных');
      });
      //        } else {
      //          errorMessage = 'Необходимо ввести корректный адрес электронной почты'
      //        }
      //      } else {
      //        errorMessage = 'Необходимо ввести адрес электронной почты'
      //      }
    },
    handleProfile: function handleProfile() {
      if (this.$props.id) {
        console.log('loading profile: ' + this.profile.username);
        this.loadProfile();
      } else {
        console.log('creating new profile');
        this.notSaved();
        return {};
      }
    },
    loadProfile: function loadProfile() {
      var _this3 = this;

      this.$http({
        url: PROFILES_API + '/' + this.$props.id,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this3.profile = response.data;
        _this3.isSaved = true;
      }).catch(function (error) {
        console.log(error);
      });
    },
    uploadContract: function uploadContract(inputId) {
      var input = document.querySelector('#' + inputId);
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить профиль');
        } else {
          if (input.files[0].size > 10 * 1024 * 1024) {
            this.openNotificationWithType('danger', 'Слишком большой файл (> 10 Мб)');
          } else {
            this.handleUploadContractRequest(input.files[0]);
          }
        }
      }
    },
    handleUploadContractRequest: function handleUploadContractRequest(contractFile) {
      var _this4 = this;

      this.$http.post(PROFILES_API + '/' + 'loadContract', this.prepareMultipartFile(contractFile, this.$props.id), this.prepareSecurityHeader()).then(function (response) {
        console.log(response);
        if (response.status == 200) {
          _this4.openNotificationWithType('info', 'Файл загружен.');
          // this.loadTasksCount()
          _this4.loadProfile();
        } else {
          _this4.openNotificationWithType('danger', 'Ошибка загрузки файла');
          // this.loadTasksCount()
        }
      }).catch(function (error) {
        _this4.openNotificationWithType('danger', 'Ошибка загрузки файла');
        // this.loadTasksCount()
        console.log(error);
      });
      // this.loadTasksCountPerformed()
    },
    prepareMultipartFile: function prepareMultipartFile(contractFile, userId) {
      var contractFormData = new FormData();
      contractFormData.append('file', contractFile);
      contractFormData.append('id', userId);
      return contractFormData;
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: this.$i18n.messages[this.$i18n.locale].notifications.notification,
        message: message,
        type: type
      });
    },
    notSaved: function notSaved() {
      this.isSaved = false;
    },
    canEdit: function canEdit() {
      return this.loggedRole == 1;
    },
    cancel: function cancel() {
      this.$router.push('/users/' + this.$props.id);
    }
  }
});

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.username),
      expression: "profile.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.profile.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Идентификатор пользователя")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.id),
      expression: "profile.id"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": true
    },
    domProps: {
      "value": (_vm.profile.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Тип")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.roleId),
      expression: "profile.roleId"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "roleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Администратор")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Партнер")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Реферер")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Клиент")])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Статус")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.state),
      expression: "profile.state"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "FILL_PROFILE"
    }
  }, [_vm._v("Заполните личную карточку")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SIGN_CONTRACT"
    }
  }, [_vm._v("Ожидаем подписания договора")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "REFILL_BALANCE"
    }
  }, [_vm._v("Нужно пополнить баланс")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ACTIVE"
    }
  }, [_vm._v("Активен")])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("ФИО")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.fullname),
      expression: "profile.fullname"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "fullname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Часовой пояс (UTC)")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.timeZone),
      expression: "profile.timeZone"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "timeZone", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("0")]), _vm._v(" "), _c('option', [_vm._v("+1")]), _vm._v(" "), _c('option', [_vm._v("+2")]), _vm._v(" "), _c('option', [_vm._v("+3")]), _vm._v(" "), _c('option', [_vm._v("+4")]), _vm._v(" "), _c('option', [_vm._v("+5")]), _vm._v(" "), _c('option', [_vm._v("+6")]), _vm._v(" "), _c('option', [_vm._v("+7")]), _vm._v(" "), _c('option', [_vm._v("+8")]), _vm._v(" "), _c('option', [_vm._v("+9")]), _vm._v(" "), _c('option', [_vm._v("+10")]), _vm._v(" "), _c('option', [_vm._v("+11")]), _vm._v(" "), _c('option', [_vm._v("+12")])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Телефон")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.phone),
      expression: "profile.phone"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("ИНН")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.INN),
      expression: "profile.INN"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.INN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "INN", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Адрес")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.address),
      expression: "profile.address"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Паспорт")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.passport),
      expression: "profile.passport"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.passport)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "passport", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Вид деятельности")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.businessType),
      expression: "profile.businessType"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.businessType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "businessType", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Менеджер")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.manager),
      expression: "profile.manager"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.manager)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "manager", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Тариф")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.tariff),
      expression: "profile.tariff"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.tariff)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "tariff", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "id": "uploadFile",
      "value": "Загрузить скан договора (pdf, jpg, png; до 10 Мб)",
      "onclick": "document.getElementById('uploadContract').click();"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "uploadContract",
      "name": "load-contract",
      "type": "file",
      "accept": ".jpg,.png,.pdf"
    },
    on: {
      "input": function($event) {
        return _vm.uploadContract('uploadContract')
      }
    }
  }), _vm._v(" "), (_vm.profile.contractName != '') ? _c('a', {
    attrs: {
      "href": '/api/profiles/contract?userId=' + this.$props.id,
      "tag": "button"
    }
  }, [_vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-info"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]), _vm._v(" "), _c('span', [_vm._v("Просмотр договора")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
}]}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalAudio__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ModalAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_slider__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BaseComponent__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BaseComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__BaseComponent__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var audioGeneratorApi = '/audios/generate';
var audioUploadApi = '/audios/reSave';
var audioDeleteApi = '/audios';

/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_6__BaseComponent___default.a,
  props: ['answerTitle', 'answerText', 'answerAudioId', 'answerAudio', 'answerWords', 'answerTheme', 'answerVendor', 'answerSpeaker', 'answerEmotion', 'answerSpeed', 'scenarioId', 'client', 'isSaved', 'answerLocale', 'answerGenerationType'],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_4__ModalAudio___default.a,
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default.a,
    Collapse: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__["Item"],
    Slider: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_slider___default.a
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['loadedScenario', 'loggedId', 'loggedUser', 'authenticationToken'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    addParameter: function addParameter() {
      this.$emit('update:answerText', (this._props.answerText || '') + '{parameterName}');
    },
    genAudioRequest: function genAudioRequest(text) {
      var vendor = this._props.answerVendor || 'yandex';
      if (vendor === 'yandex') {
        return this.genAudioRequestByYandex(text);
      } else if (vendor === 'google') {
        return this.genAudioRequestByGoogle(text);
      }
      return request;
    },
    genAudioRequestByYandex: function genAudioRequestByYandex(text) {
      var request = {
        'commonParameters': {
          'client': this._props.client,
          'scenario': this._props.scenarioId,
          'audioName': this._props.name,
          'text': text
        },

        'vendorSpecificParameters': {
          'speaker': this._props.answerSpeaker,
          'emotion': this._props.answerEmotion,
          'speed': this._props.answerSpeed
        },

        'vendor': this._props.answerVendor || 'yandex'
        // if audio already generated, request must contain id, so backend will overwrite existing audio
      };if (this._props.id) {
        request.commonParameters.id = this._props.id;
      }
      console.log(JSON.stringify(request));
      return request;
    },
    genAudioRequestByGoogle: function genAudioRequestByGoogle(text) {
      var request = {
        'commonParameters': {
          'client': this._props.client,
          'scenario': this._props.scenarioId,
          'audioName': this._props.name,
          'text': text
        },

        'vendorSpecificParameters': {
          'languageCode': this._props.answerLocale,
          'voiceName': this._props.answerSpeaker,
          'speakingRate': this._props.answerSpeed
        },

        'vendor': this._props.answerVendor || 'yandex'
        // if audio already generated, request must contain id, so backend will overwrite existing audio
      };if (this._props.id) {
        request.commonParameters.id = this._props.id;
      }
      console.log(JSON.stringify(request));
      return request;
    },
    securityHeaders: function securityHeaders() {
      return {
        'testH': 'testHV',
        'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ'
      };
    },
    getAudioGeneratorUrl: function getAudioGeneratorUrl() {
      return audioGeneratorApi;
    },
    onLoadAudio: function onLoadAudio(data) {
      this.$emit('setAudioDuration', data);
    },
    genAudio: function genAudio() {
      var _this = this;

      var texts = this.parseText();
      var index = 0;

      var that = this;

      function requestSuccessCallback(data, number) {
        if (that.tmp.onLoading) {
          that.$emit('generateAudioHandler', {
            number: number,
            type: 'url',
            url: '/audios/' + data + '.wav',
            // url: `https://akvapark.app.ivoice.online/audios/a79818c0-adcb-11e9-9604-6b9f04b1d17d.wav`,
            theme: that._props.answerTheme
          });
          index++;
          if (index === texts.length) {
            that.tmp.onLoading = false;
          }
        }
      }
      function requestFailCallback(error) {
        that.tmp.onLoading = false;
        console.log(error);
        that.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
      }

      if (!this._props.isSaved) {
        this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий');
      } else {
        // this.tmp.onLoading = true
        this.$emit('generateAudioHandler', { theme: this._props.answerTheme });
        var headers = { headers: this.securityHeaders() };

        var _loop = function _loop(i) {
          if (texts[i].type === 'text') {
            var _request = _this.genAudioRequest(texts[i].text);
            _this.tmp.onLoading = true;
            _this.$http.post(_this.getAudioGeneratorUrl(), _request, headers).then(function (response) {
              requestSuccessCallback(response.data, i);
            }).catch(function (error) {
              requestFailCallback(error);
              // if (error || requestFailCallback) {
              //   requestSuccessCallback('111' + i, i)
              // }
            });
          } else {
            _this.$emit('generateAudioHandler', { number: i, type: 'param', paramName: texts[i].paramName, theme: _this._props.answerTheme });
            index++;
          }
        };

        for (var i = 0; i < texts.length; i++) {
          _loop(i);
        }
      }
    },
    parseText: function parseText() {
      var fullText = (this._props.answerText || '') + '';
      var texts = [];
      var symbol = '{';
      var finder = 'open_param';

      while (fullText.length) {
        var startParam = fullText.indexOf(symbol);
        if (startParam > -1) {
          var text = fullText.substr(0, startParam);
          if (text) {
            if (finder === 'open_param') {
              texts.push({
                type: 'text',
                text: text.replace('{', '').replace('}', '')
              });
            } else {
              texts.push({
                type: 'param',
                paramName: text.replace('{', '').replace('}', '')
              });
            }
          }
          finder = finder === 'open_param' ? 'close_param' : 'open_param';
          symbol = symbol === '{' ? '}' : '{';
          fullText = fullText.substr(startParam + 1);
        } else {
          if (fullText) {
            texts.push({
              type: 'text',
              text: fullText
            });
          }
          fullText = '';
        }
      }
      return texts;
    },
    getAudioId: function getAudioId(audio) {
      var url = audio.url;
      return url.substring(url.lastIndexOf('/audios/') + 8, url.lastIndexOf('.wav'));
    },
    deleteAudio: function deleteAudio(audio) {
      var that = this;
      this.$http.delete(audioDeleteApi + '/' + this.getAudioId(audio), { headers: this.prepareUploadHeaders() });
      // .then((response) => {
      //
      // })
      // .catch((error) => {
      //   console.log(error)
      //   // this.openNotificationWithType('danger', 'Ошибка удаления аудио. ')
      //   audio.theme = that._props.answerTheme
      //   that.$emit('deleteAudioHandler', audio)
      // })
      audio.theme = that._props.answerTheme;
      that.$emit('deleteAudioHandler', audio);
    },

    // uploadFile() {
    //   if (!this.isSaved) {
    //     this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий')
    //   } else {
    //     document.querySelector('.' + this._props.answerTheme + ' .loadAudio').click()
    //   }
    // },
    loadAudio: function loadAudio() {
      var input = document.querySelector('.' + this._props.answerTheme + ' .loadAudio');
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий');
        } else {
          this.handleUploadRequest(input.files[0]);
          // this.$refs[player].load()
        }
      }
    },
    handleUploadRequest: function handleUploadRequest(audioFile) {
      var _this2 = this;

      var that = this;
      this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile), this.prepareUploadHeaders()).then(function (response) {
        that.$emit('generateAudioHandler', {
          type: 'url',
          url: '/audios/' + response.data + '.wav',
          theme: that._props.answerTheme
        });
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
      });
    },
    prepareMultipartAudio: function prepareMultipartAudio(audioFile) {
      var audioFormData = new FormData();
      audioFormData.append('file', audioFile);
      audioFormData.append('name', this._props.answerTheme + '_name');
      audioFormData.append('id', this._props.answerAudioId);
      audioFormData.append('client', this._props.client);
      audioFormData.append('scenario', this._props.scenarioId);
      return audioFormData;
    },

    // activateTab (tabClass) {
    //   this.$emit('changeGenerationType', tabClass)
    // },
    prepareUploadHeaders: function prepareUploadHeaders() {
      return {
        'headers': {
          'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
          'Content-Type': 'multipart/form-data',
          'testH': 'testHV'
        }
      };
    }
  },
  data: function data() {
    return {
      tmp: {
        onLoadedAudio: '',
        onLoading: false,
        currentSpeaker: 'oksana',
        currentEmotion: 'neutral',
        currentSpeed: 1
      },
      speakerList: [{
        value: 'jane'
      }, {
        value: 'oksana'
      }, {
        value: 'alyss '
      }, {
        value: 'omazh'
      }, {
        value: 'zahar '
      }, {
        value: 'ermil '
      }],
      currentEmotion: 'neutral',
      emotionList: [{
        value: 'good'
      }, {
        value: 'neutral'
      }, {
        value: 'evil'
      }]
    };
  }
});

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "answer",
    class: _vm.answerTheme
  }, [_c('div', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.answerTitle))]), (_vm.answerWords) ? _c('div', {
    staticClass: "words"
  }, [_vm._v(" " + _vm._s(_vm.answerWords))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    staticClass: "textarea",
    domProps: {
      "value": _vm.answerText
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:answerText', $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped generate_audio_control"
  }, [_c('button', {
    staticClass: "button add_parameter",
    on: {
      "click": function($event) {
        return _vm.addParameter()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toAddParameter')) + " "), _c('span', [_vm._v("{}")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary generate_button",
    on: {
      "click": function($event) {
        return _vm.genAudio()
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.tmp.onLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.generateAudio')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary speaker"
  }, [_c('select', {
    staticClass: "form-control",
    domProps: {
      "value": _vm.answerSpeaker
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:answerSpeaker', $event.target.value)
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                        " + _vm._s(speaker.value) + "\n                      ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    staticClass: "form-control",
    domProps: {
      "value": _vm.answerEmotion
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:answerEmotion', $event.target.value)
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                        " + _vm._s(emotion.value) + "\n                      ")])
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "speed"
  }, [_c('slider', {
    attrs: {
      "size": "small",
      "value": parseFloat(_vm.answerSpeed),
      "min": 0.5,
      "step": 0.1,
      "max": 2
    },
    on: {
      "change": function($event) {
        return _vm.$emit('update:answerSpeed', $event)
      }
    }
  }), _vm._v("\n                    " + _vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.speed')) + ": " + _vm._s(_vm.answerSpeed) + "\n                  ")], 1)]), _vm._v(" "), (_vm.answerAudio && Array.isArray(_vm.answerAudio)) ? _c('div', {
    staticClass: "audio_list"
  }, _vm._l((_vm.answerAudio), function(audio) {
    return _c('div', {
      staticClass: "audio",
      class: audio.type
    }, [(audio.type === 'url' && audio.url) ? _c('audio', {
      ref: 'onPlayer',
      refInFor: true
    }, [_c('source', {
      attrs: {
        "src": audio.url
      }
    }), _vm._v("\n                      " + _vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.Your_browser_does_not_support_html5_audio_Try_chrome')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (audio.type === 'url' && audio.url) ? _c('audio-player', {
      attrs: {
        "file": audio.url,
        "onLoad": _vm.onLoadAudio
      }
    }) : _vm._e(), _vm._v(" "), (audio.type === 'url' && audio.url) ? _c('div', {
      staticClass: "deleteAudio",
      attrs: {
        "title": "Удалить аудио"
      },
      on: {
        "click": function($event) {
          return _vm.deleteAudio(audio)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-backspace fa-3x"
    })]) : _vm._e()], 1)
  }), 0) : (_vm.answerAudio && typeof _vm.answerAudio === 'string' || _vm.answerAudio instanceof String) ? _c('div', {
    staticClass: "audio_single"
  }, [_c('audio', {
    ref: 'onPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.answerAudio
    }
  }), _vm._v("\n                    " + _vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.Your_browser_does_not_support_html5_audio_Try_chrome')) + "\n                  ")]), _vm._v(" "), _c('audio-player', {
    attrs: {
      "file": _vm.answerAudio,
      "onLoad": _vm.onLoadAudio
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
}]}

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_modal__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translations_i18n__ = __webpack_require__(83);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_modal__["c" /* Modal */]
  },

  props: {
    visible: Boolean,
    title: String
  },

  methods: {
    close: function close() {
      this.$emit('close');
    }
  },
  i18n: __WEBPACK_IMPORTED_MODULE_1__translations_i18n__["a" /* default */]
});

/***/ }),
/* 493 */,
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return en; });
var en = {
  campaigns: {
    dailyLabel: '└─Daily',
    reportTexts: {
      createReportError: 'Report creation error '
    }
  },
  scenarios: {
    konstruktor: {
      canvas: {
        add: {
          sendSMS: 'send SMS',
          sendHttpRequest: 'send Http Request'
        },
        answer: {
          initAudio: {
            toPutUrl: 'Enter url',
            putUrl: 'Enter url',
            toAddUrl: 'Add url',
            toRemoveUrl: 'RemoveUrl',

            toUploadFromFile: 'Upload from file',
            toRemoveAll: 'Remove all',

            toAddParameter: 'Add Parameter',
            putParameterName: 'Enter Parameter',
            addParameter: 'Add Parameter',
            toRemoveParameter: 'Remove Parameter',

            Your_browser_does_not_support_html5_audio_Try_chrome: 'Your browser does not support html5 audio Try chrome'
          }
        }
      }
    }
  },
  callTasks: {
    states: {
      telephony_error_suspend: 'telephony error suspend'
    }
  },
  common: {
    timeInterval: {
      from: 'since',
      to: 'to'
    },
    actions: {
      reCreate: 'Recreate'
    }
  },
  testCall: {
    toPhoneNote: 'to call a phone, there must be a campaign with settings for outgoing calls',
    inBrowserNote: 'to call in the browser you must enable the microphone and reload the page'
  }
};

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateEnByRu;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ru__ = __webpack_require__(185);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var iterate = function iterate(obj) {
  Object.keys(obj).forEach(function (key) {
    // console.log('key: ' + key + ', value: ' + obj[key])
    if (_typeof(obj[key]) === 'object') {
      iterate(obj[key]);
    } else {
      var split = capitalizeFirstLetter(key).match(/[A-Z][a-z]+|[0-9]+/g);
      if (split) {
        for (var i = 0; i < split.length; i++) {
          if (i > 0) {
            split[i] = split[i].toLowerCase();
          }
        }
        obj[key] = split.join(' ');
      } else {
        obj[key] = capitalizeFirstLetter(key);
      }
    }
  });
};

function isObject(obj) {
  var type = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
  return type === 'function' || type === 'object' && !!obj;
}
function iterationCopy(src) {
  var target = {};
  for (var prop in src) {
    if (src.hasOwnProperty(prop)) {
      // if the value is a nested object, recursively copy all it's properties
      if (isObject(src[prop])) {
        target[prop] = iterationCopy(src[prop]);
      } else {
        target[prop] = src[prop];
      }
    }
  }
  return target;
}

function generateEnByRu() {
  // let ruToEn = Object.assign({}, JSON.parse(JSON.stringify(ru))) // copy
  var ruToEn = iterationCopy(__WEBPACK_IMPORTED_MODULE_0__ru__["a" /* ru */]); // copy
  iterate(ruToEn);
  return ruToEn;
}

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pl; });
var pl = {
  shell: {
    menu: 'Menu',
    exit: 'Wyjście',
    profile: 'Profil użytkownika',
    personalAccount: 'Konto użytkownika',
    developedBy: 'Developed by'
  },
  authentication: {
    authentication: 'Autoryzacja',
    registration: 'Rejestracja'
  },
  campaigns: {
    campaigns: 'Wysyałanie',
    dailyCampaigns: 'Aktywność dzienna',
    daily: 'Dzienne',
    dailyLabel: '└─Dzienne',
    campaign: 'Aktywność',
    newCampaign: 'Nowa wysyłka',
    campaignsArchive: 'Archiwum wysyłek',
    createCampaign: 'Utwórz wysyłkę',
    putCampaignsName: 'Wpisz nazwę wysyłki',
    ringing: 'Dzwonienie',
    report: 'Raport',
    unprocessed: 'Nie przetworzone',
    monitoring: 'Monitorowanie',
    cost: 'Koszt',
    toArchive: 'Do archiwum',
    loadBase: 'Wczytywanie bazy',
    putBaseFromClipboard: 'Wklej bazę ze schowka',
    deleteFailedCalls: 'Usuń nieudane połączenia',
    reportTexts: {
      createReport: 'Utwórz raport',
      reportIsBeingGeneratedNow: 'Raport jest generowany',
      createReportError: 'Błąd podczas tworzenia raportu'
    },
    states: {
      started: 'W toku',
      readyToRun: 'Gotowe do uruchomienia',
      preparing: 'W przygotowaniu',
      ready: 'Gotowe',
      finished: 'Zakończone',
      paused: 'Zatrzymane',
      canceled: 'Anulowane'
    },
    campaignParams: {
      campaignsParameters: 'Parametry wysyłki',
      callDate: 'Data połączeń',
      putCallDate: 'Wprowadź datę',
      timezone: 'Strefa czasowa UTC',
      callTime: 'Godziny połączeń',

      numberOfAttemptsToGetThrough: 'Liczba prób połączeń',
      intervalBetweenRepeatedCalls: 'Przerwa między kolejnymi próbami połączeń (minuty)',
      openScenario: 'Otwórz scenariusz',
      scenarioIsReady: 'Scenariusz gotowy',
      scenarioIsNotReady: 'Scenariusz nie gotowy',

      base: 'Baza',
      viewBase: 'Przegladaj bazę',
      removeBase: 'Usuń bazę',
      numbers: 'Numery',
      uploadedNumbers: 'Wczytano numery',
      reportByTestCalls: 'Raport z połączenia testowego',

      callResult: 'Rezultat połączeń',
      callsMonitoring: 'Monitoring połączeń'
    },
    additionalParameters: {
      additionalParameters: 'Dodatkowe parametry'
    },
    quotas: {
      quotas: 'Kwota',
      noLimit: 'Bez limitu',
      addQuota: 'Dodaj kwotę'
    }
  },
  testCall: {
    call: 'Połączenie',
    testCall: 'Połączenie testowe',
    callToNumber: 'Zadzwoń pod numer',
    putNumber: 'Wprowadź numer',
    viewTestResults: 'Wyświetl wyniki testu',
    testCallParameters: 'Parametry połączenia testowego',
    callToPhone: 'Połączenie z telefonem',
    calInBrowser: 'Połączenie w przeglądarce'
  },
  scenarios: {
    scenarios: 'Scenariusze',
    scenario: 'Scenariusz',
    createScenario: 'Utwórz scenariusz',
    newScenario: 'Nowy scenariusz',
    scenarioName: 'Nazwa scenariusza',
    putScenarioName: 'Wprowadź nazwę scenariusza',
    prepared: 'Gotowe',
    notPrepared: 'Nie gotowe',
    scenarioTemplate: 'Szablon scenariusza',

    chooseScenarioTemplate: 'Wybierz szablon scenariusza',
    konstruktor: {
      toolButtons: {
        testCall: 'Połączenie testowe',
        callToNumber: 'Połącz z numerem'
      },
      commonParams: {
        hideArrows: 'Ukryj strzałki'
      },
      canvas: {
        add: {
          robotAnswer: 'odpowiedź robota',
          recognition: 'rozpoznawanie',
          redirectToOperator: 'Dodaj przekierowanie do operatora',
          sendSMS: 'Wyślij SMS',
          sendHttpRequest: 'Wyślij żądanie http'
        },
        answer: {
          answer: 'Odpowiedź',
          startOfTalk: 'Początek rozmowy',
          stateQuestion: 'Status zapytania',
          silence: 'Cisza',
          illegibly: 'Nieczytelne',
          approve: 'Dobrze',
          deny: 'Negacja',
          custom: 'Indywidualny',
          anotherAnswer: 'Inna odpowiedź',
          foStatusValueUse: 'Dla podkreślenia stanu użyj',
          transcription: 'Transkrypcja',
          indicate: 'Wskaż',
          stateValue: 'Status zapytania',
          windowSizes: {
            smallSize: 'Mały rozmiar',
            mediumSize: 'Średni rozmiar',
            maxSize: 'Duży rozmiar'
          },
          synonyms: {
            addForAllWithSameTitle: 'Dodaj wszędzie , gdzie jest taka nazwa',
            addWord: 'Dodaj słowo lub frazę'
          },
          initAudio: {
            fromText: 'Z tekstu',
            toPutUrl: 'Wprowadź z URL',
            putUrl: 'Wprowadź adres URL',
            toAddUrl: 'Dodaj adres URL',
            toRemoveUrl: 'Usuń adres URL',

            toUploadFromFile: 'Wczytaj z pliku',
            toRemoveAll: 'Usuń wszystko',

            toAddParameter: 'Dodaj parametr',
            putParameterName: 'Wprowadź nazwę parametru',
            addParameter: 'Dodaj parametr',
            toRemoveParameter: 'Usuń parametr',
            speed: 'Prędkość',
            generateAudio: 'Generuj dzwięk',

            Your_browser_does_not_support_html5_audio_Try_chrome: 'Twoja przeglądarka nie obsługuje html5 audio. Spróbuj użyć Chrome.'
          },
          audioConfig: 'Konfiguracja audio',
          sipSubUrl: 'Adres SIP',
          sms: {
            gateway: 'Bramka',
            sender: 'Nadawca',
            messageText: 'Treść wiadomości'
          },
          httpRequest: {
            params: 'Parametry',
            headers: 'Headers',
            body: 'Body'
          }
        }
      },
      removeScenario: 'Usuń scenariusz'
    }
  },
  users: {
    users: 'Użytkownicy',
    user: 'Użytkownik',
    newUser: 'Nowy użytkownik',
    userData: 'Dane użytkownika'
  },
  callTasks: {
    testCallsByCampaign: 'Тестовые звонки по рассылке',
    phone: 'Telefon',
    state: 'Состояние',
    phoneNumber: 'Numer telefonu',
    byCampaign: 'по рассылке',
    states: {
      'failed': 'Недозвон',
      'dialing': 'Połączenie',
      'ongoing': 'Jest rozmowa',
      'performed': 'Gotowy',
      'postponed': 'Opóźniony',
      'ready': 'Kolejka',
      'telephony_error_suspend': 'Opóźniony',
      'canceled': 'Anulowany'
    }
  },
  permissions: {
    permissions: 'Uprawnienia'
  },
  appConfig: {
    appConfig: 'Ustawienia aplikacji'
  },
  common: {
    yes: 'Tak',
    no: 'Nie',
    timeInterval: {
      from: 'od',
      to: 'do'
    },
    search: 'Szukaj',
    title: 'Nazwa',
    client: 'Klient',
    template: 'Szablon',
    readiness: 'Gotowość',
    state: 'Status',
    creationDate: 'Data utworzenia',
    up: 'na górę',
    settings: 'Ustawienia',
    action: 'Czynność',
    actions: {
      add: 'Dodaj',
      delete: 'Usuń',
      save: 'Zapisz',
      cancel: 'Anuluj',
      close: 'Zamknij',
      connect: 'Połącz',
      run: 'Uruchom',
      stop: 'Zatrzymaj',
      copy: 'Kopiuj',
      load: 'Wczytaj',
      loadFromFile: 'Wczytaj z pliku',
      create: 'Utwórz',
      reCreate: 'Utwórz ponownie'
    },
    key: 'Klucz',
    parameter: 'Parametr',
    value: 'Wartość',
    language: 'Język',
    voice: 'Głos',
    time: {
      minutes: 'minuty',
      seconds: 'sekundy'
    },
    date: {
      days: {
        longhand: {
          sunday: 'niedziela',
          monday: 'poniedziałek',
          tuesday: 'wtorek',
          wednesday: 'środa',
          thursday: 'czwartek',
          friday: 'piątek',
          saturday: 'sobota'
        },
        shorthand: {
          sunday: 'niedz.',
          monday: 'pon.',
          tuesday: 'wt.',
          wednesday: 'śr.',
          thursday: 'czw.',
          friday: 'pt.',
          saturday: 'sob.'
        }
      },
      months: {
        January: 'styczeń',
        February: 'luty',
        March: 'larzec',
        April: 'kwiecień',
        May: 'maj',
        June: 'czerwiec',
        July: 'lipiec',
        August: 'sierpień',
        September: 'wrzesień',
        October: 'październik',
        November: 'listopad',
        December: 'grudzień'
      }
    },
    results: 'Wyniki',
    recognitionLogs: 'Dzienniki rozpoznawania',
    information: 'Informacja'
  },
  paging: {
    first: 'Pierwsza',
    previous: 'Poprzednia',
    next: 'Następna',
    last: 'Ostatnia'
  },
  errors: {
    downloadError: 'Błąd pobierania'
  },
  notifications: {
    notification: 'Powiadomienia',
    toAddRobotAnswerPleaseRemoveRedirectToOperator: 'Aby dodać odpowiedź robota, usuń przekierowanie do operatora',
    toAddRedirectToOperatorPleaseRemoveAllRobotAnswers: 'Aby dodać przekierowanie do operatora usuń wszystkie odpowiedzi robota',

    thereIsAlreadyHasARedirectToOperator: 'Istnieje już przekierowanie do operatora',

    errorLoadApplicationConfig: 'Błąd wczytywania ustawień aplikacji',
    errorLoadAudio: 'Błąd wczytywania dzwięku',

    beforeGenerateAudioYouShouldSaveScenario: 'Przed wygenerowaniem audio, zapisz scenariusz',

    beforeUploadFileYouShouldSaveScenario: 'Przed pobraniem pliku, zapisz scenariusz',

    beforeLoadAudioYouShouldSaveScenario: 'Przed pobraniem audio, zapisz scenariusz',

    campaign: {
      campaignIsReady: 'Рассылка подготовлена',
      errorStartCampaign: 'Ошибка запуска рассылки',
      campaignStopped: 'Рассылка остановлена',
      errorStopCampaign: 'Ошибка остановки рассылки',
      report: {
        errorLoadReport: 'Ошибка загрузки отчета'
      },
      errorDeletePhoneBase: 'Ошибка удаления телефонной базы',
      baseRemoved: 'База удалена'
    },

    scenario: {
      scenarioHasBeenRemoved: 'Scenariusz usunięty',

      errorRemoveScenario: 'Błąd usuwania scenariusza',
      errorToGetUserStatus: 'Błąd wczytywania statusu użytkownika',
      errorLoadScenarioList: 'Błąd wczytywania listy scenariuszy',
      errorLoadScenario: 'Błąd wczytywania scenariusza',

      scenarioSaved: 'Scenariusz zapisany',
      errorSaveScenario: 'Błąd zapisu scenariusza'
    },
    testCall: {
      testCallActivated: 'Uruchomiono połączenie testowe',
      errorCreatingTestCall: 'Błąd uruchamiania połączenia testowego',
      testCallNumberSaved: 'Номер тестового звонка сохранен',
      saveCampaignBeforeTestCall: 'Перед тестом необходимо сохранить рассылку'
    },
    callTasks: {
      errorLoadTestCallsPhoneNumbers: 'Ошибка загрузки тестовых телефонных номеров'
    }
  }
};

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "visible": _vm.visible
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('article', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h4', [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.$emit('confirm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__depricated_ScenarioQuestionRecognition__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__depricated_ScenarioQuestionRecognition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__depricated_ScenarioQuestionRecognition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__depricated_ScenarioQuestionYesNo__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__depricated_ScenarioQuestionYesNo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__depricated_ScenarioQuestionYesNo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__depricated_1_questionYesNo_i18__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__depricated_1_questionYesNo_i18___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__depricated_1_questionYesNo_i18__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__depricated_ScenarioTwoLevelYesNo__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__depricated_ScenarioTwoLevelYesNo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__depricated_ScenarioTwoLevelYesNo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__depricated_ScenarioQuestionInterview__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__depricated_ScenarioQuestionInterview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__depricated_ScenarioQuestionInterview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__depricated_ScenarioInterviewAFewQuestions__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__depricated_ScenarioInterviewAFewQuestions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__depricated_ScenarioInterviewAFewQuestions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__depricated_ScenarioNotice__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__depricated_ScenarioNotice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__depricated_ScenarioNotice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__depricated_ScenarioDentaPromotion__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__depricated_ScenarioDentaPromotion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__depricated_ScenarioDentaPromotion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__depricated_ScenarioAkvamir__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__depricated_ScenarioAkvamir___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__depricated_ScenarioAkvamir__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__konstruktor_ScenarioKonstruktor__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__konstruktor_ScenarioKonstruktor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__konstruktor_ScenarioKonstruktor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__authentication_CheckToken__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__audioCustomizer_AudioCustomizer__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__audioCustomizer_AudioCustomizer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__audioCustomizer_AudioCustomizer__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















// import {loadedScenario} from "../../store/getters";

__WEBPACK_IMPORTED_MODULE_11_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_12__authentication_CheckToken___default.a);

var api = '/api/scenarios';
var APPCONFIG_API = '/api/appConfig';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['campaignid', 'id'],

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["mapGetters"])(['authenticationToken'])),
  methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["mapMutations"])(['setLoadedScenario']), {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    loadAppConfig: function loadAppConfig() {
      var _this = this;

      var that = this;
      this.$http.get(APPCONFIG_API, { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.templates = response.data.activeScenarioTemplates;
        that.availableSmsGateways = response.data.availableSmsGateways;
        for (var i = 0; i < that.selectList.length; i++) {
          if (that.templates[that.selectList[i].name]) {
            that.activeSelectList.push(_this.selectList[i]);
          }
        }
        that.currentScenario = 'empty';
        that.loadScenario();
      }).catch(function (error) {
        console.log(error);
        that.openNotificationWithType('danger', that.$i18n.messages[that.$i18n.locale].notifications.errorLoadApplicationConfig);
      });
    },
    loadScenario: function loadScenario() {
      if (this.$props.id) {
        var that = this;
        this.$http.get(api + '/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
          that.setLoadedScenario(response.data);
          that.loadedScenario = response.data;
          that.currentScenario = that.loadedScenario.template;
          // return response.data
          console.log('loadedScenario ' + that.loadedScenario);
        }).catch(function (error) {
          console.log(error);
          that.openNotificationWithType('danger', that.$i18n.messages[that.$i18n.locale].notifications.scenario.errorLoadScenario);
        });
      } else {
        this.currentScenario = 'universal';

        this.setLoadedScenario(null);
        return null;
      }
    },
    setScenario: function setScenario(value) {
      this.loadedScenario = value;
    },
    otherTemplate: function otherTemplate(currentScenario) {
      if (!currentScenario || currentScenario === 'empty') {
        return false;
      }
      for (var i = 0; i < this.selectList.length; i++) {
        if (currentScenario === this.selectList[i].name) {
          return false;
        }
      }
      return true;
    }
  }),
  components: {
    AudioCustomizer: __WEBPACK_IMPORTED_MODULE_13__audioCustomizer_AudioCustomizer___default.a,
    Konstruktor: __WEBPACK_IMPORTED_MODULE_9__konstruktor_ScenarioKonstruktor___default.a,
    ScenarioAkvamir: __WEBPACK_IMPORTED_MODULE_8__depricated_ScenarioAkvamir___default.a,
    ScenarioQuestionRecognition: __WEBPACK_IMPORTED_MODULE_0__depricated_ScenarioQuestionRecognition___default.a,
    ScenarioQuestionYesNo: __WEBPACK_IMPORTED_MODULE_1__depricated_ScenarioQuestionYesNo___default.a,
    ScenarioQuestionYesNoMultiLang: __WEBPACK_IMPORTED_MODULE_2__depricated_1_questionYesNo_i18___default.a,
    ScenarioTwoLevelYesNo: __WEBPACK_IMPORTED_MODULE_3__depricated_ScenarioTwoLevelYesNo___default.a,
    ScenarioQuestionInterview: __WEBPACK_IMPORTED_MODULE_4__depricated_ScenarioQuestionInterview___default.a,
    ScenarioNotice: __WEBPACK_IMPORTED_MODULE_6__depricated_ScenarioNotice___default.a,
    ScenarioInterviewAFewQuestions: __WEBPACK_IMPORTED_MODULE_5__depricated_ScenarioInterviewAFewQuestions___default.a,
    ScenarioDentaPromotion: __WEBPACK_IMPORTED_MODULE_7__depricated_ScenarioDentaPromotion___default.a
  },
  created: function created() {
    this.checkToken();
    // this.currentScenario = this.selectList[0].name
    if (!this.$props.id) {
      console.log('creating new scenario');
      this.appconfig = this.loadAppConfig();
    } else {
      console.log('loading scenario: ' + this.name);
      this.appconfig = this.loadAppConfig();
    }
  },
  data: function data() {
    return {
      currentScenario: '',
      selectList: [{
        id: 1,
        name: 'recognition',
        label: 'Вопрос-распознавание'
      }, {
        id: 2,
        name: 'yesnoonequestion',
        label: '1 вопрос да/нет'
      }, {
        id: 3,
        name: 'yesnotwoquestions',
        label: '2 уровня вопросов да/нет'
      }, {
        id: 4,
        name: 'notification',
        label: 'Уведомление'
      }, {
        id: 5,
        name: 'poll',
        label: 'Опрос'
      }, {
        id: 6,
        name: 'dentapromotion',
        label: 'Denta promotion'
      }, {
        id: 7,
        name: 'akvamir',
        label: 'Аквамир'
      }, {
        id: 8,
        name: 'universal',
        label: 'Конструктор'
      }, {
        id: 9,
        name: 'yesnoonequestionmultilang',
        label: 'мультиязыч. 1 вопрос да/нет'
      }],
      activeSelectList: [],
      loadedScenario: null,
      templates: {
        name: '',
        active: false
      },
      availableSmsGateways: ['smsc', 'smscFit19', 'fitservicesms', 'semySms', 'acemaoutMedia', 'smsClub']
    };
  }
});

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalAudio__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ModalAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var NotificationComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var MessageComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default.a);
var openMessage = function openMessage() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  };

  return new MessageComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var api = '/api/scenarios';
var audioGeneratorApi = '/audios/generate';
var audioUploadApi = '/audios/reSave';
var audioDeleteApi = '/audios';
var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name', 'campaignid'],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_6__ModalAudio___default.a,
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a,
    Slider: __WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider___default.a
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['loadedScenario', 'loggedId', 'loggedUser', 'authenticationToken'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    insertPause: function insertPause(textareaId) {
      var textarea = document.getElementById(textareaId);
      var pausePattern = ' \\pause:1 ';
      if (document.selection) {
        textarea.focus();
        var sel = document.selection.createRange();
        sel.text = pausePattern;
      } else if (textarea.selectionStart || textarea.selectionStart == '0') {
        var startPos = textarea.selectionStart;
        var endPos = textarea.selectionEnd;
        textarea.value = textarea.value.substring(0, startPos) + pausePattern + textarea.value.substring(endPos, textarea.value.length);
        textarea.selectionStart = startPos + pausePattern.length;
        textarea.selectionEnd = startPos + pausePattern.length;
      } else {
        textarea.value += pausePattern;
        textarea.selectionStart = textarea.value.length;
      }
      textarea.focus();
    },

    changeRoute: function changeRoute(e) {
      this.$router.push({ path: '/scenarios' + e.target.value });
    },
    checkAudioDuration: function checkAudioDuration() {
      this.scenario.checkDuration = true;
      var len = document.querySelectorAll('audio').length;
      for (var i = 0; i < len; i++) {
        if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
          this.scenario.checkDuration = this.scenario.checkDuration && document.querySelectorAll('audio')[i].duration > 0;
        }
      }
      return this.scenario.checkDuration;
    },
    save: function save(showMessage) {
      if (this.checkAudioDuration()) {
        if (this.scenario.id === undefined) {
          this.saveNew(showMessage);
        } else {
          this.update(showMessage);
        }
      } else {
        this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с аудиофайлом нулевой длительности');
      }
    },
    saveNew: function saveNew(showMessage) {
      var _this = this;

      console.log('saving new scenario: ' + JSON.stringify(this.scenario));
      if (!this.scenario.parameters.questionGenerationState) {
        this.scenario.parameters.questionText = '';
      }
      this.scenario.parameters.questionSpeaker = this.tmp.currentSpeakerQuestion;
      this.scenario.parameters.questionEmotion = this.tmp.currentEmotionQuestion;
      this.scenario.parameters.questionSpeed = this.tmp.currentSpeedQuestion;

      this.scenario.parameters.conclusionSpeaker = this.tmp.currentSpeakerConclusion;
      this.scenario.parameters.conclusionEmotion = this.tmp.currentEmotionConclusion;
      this.scenario.parameters.conclusionSpeed = this.tmp.currentSpeedConclusion;

      this.$http.post(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.isSaved = true;
        if (showMessage) {
          _this.openNotificationWithType('info', 'Сценарий сохранен');
          _this.$emit('set', _this.scenario);
        }
        _this.scenario = response.data;
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    update: function update(showMessage) {
      var _this2 = this;

      console.log('updating scenario: ' + JSON.stringify(this.scenario));
      this.scenario.parameters.questionSpeaker = this.tmp.currentSpeakerQuestion;
      this.scenario.parameters.questionEmotion = this.tmp.currentEmotionQuestion;
      this.scenario.parameters.questionSpeed = this.tmp.currentSpeedQuestion;

      this.scenario.parameters.conclusionSpeaker = this.tmp.currentSpeakerConclusion;
      this.scenario.parameters.conclusionEmotion = this.tmp.currentEmotionConclusion;
      this.scenario.parameters.conclusionSpeed = this.tmp.currentSpeedConclusion;

      this.$http.put(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        console.log(response.data);
        _this2.isSaved = true;
        if (showMessage) {
          _this2.openNotificationWithType('info', 'Сценарий сохранен');
        }
        _this2.scenario = response.data;
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    uploadFile: function uploadFile(buttonId) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий');
      } else {
        document.getElementById(buttonId).click();
      }
    },
    genAudioRequest: function genAudioRequest(maybeId, audioName, text, speaker, emotion, speed) {
      var request = {
        'commonParameters': {
          'client': this.scenario.client,
          'scenario': this.scenario.id,
          'audioName': audioName,
          'text': text
        },

        'vendorSpecificParameters': {
          'speaker': speaker,
          'emotion': emotion,
          'speed': speed
        },

        'vendor': 'yandex'
      };
      if (maybeId) {
        request.id = maybeId;
      }
      console.log(request);
      return request;
    },
    prepareLoadAudioRequest: function prepareLoadAudioRequest(possibleId, uploadAudio) {
      var request = {
        'scenario': this.scenario.id,
        'client': this.scenario.client,
        'audioName': uploadAudio.filename,
        'audioBytes': uploadAudio
      };
      if (possibleId) {
        request.id = id;
      }
      return request;
    },
    securityHeaders: function securityHeaders() {
      return {
        'testH': 'testHV',
        'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ'
      };
    },
    onChangeGenerationState: function onChangeGenerationState(stateId, audioId, generatedAudioId, loadedAudioId, playerId) {
      if (this.scenario.parameters[stateId]) {
        this.scenario.parameters[audioId] = this.tmp[generatedAudioId];
        this.$refs[playerId][0].load();
      } else {
        this.scenario.parameters[audioId] = this.tmp[loadedAudioId];
        this.$refs[playerId][0].load();
      }
    },
    genAudio: function genAudio(audioId, audioValue, speaker, generationType, text, loadingStatus, audioName, emotion, speed) {
      console.log(emotion);
      console.log(this.tmp[emotion]);
      var request = this.genAudioRequest(this.scenario.parameters[audioId], audioName, this.scenario.parameters[text], this.tmp[speaker], this.tmp[emotion], this.tmp[speed]);
      this.handleGenerateRequest(audioId, audioValue, generationType, loadingStatus, request);
    },
    handleGenerateRequest: function handleGenerateRequest(audioId, audioValue, generationType, loadingStatus, request) {
      var _this3 = this;

      var headers = { headers: this.securityHeaders() };
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий');
      } else {
        this.tmp[loadingStatus] = true;
        this.$http.post(audioGeneratorApi, request, headers).then(function (response) {
          _this3.scenario.parameters[audioId] = response.data;
          _this3.tmp[generationType] = '/audios/' + _this3.scenario.parameters[audioId] + '.wav';
          _this3.scenario.parameters[audioValue] = _this3.tmp[generationType];
          _this3.tmp[loadingStatus] = false;
        }).catch(function (error) {
          console.log(error);
          _this3.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
        });
      }
    },
    loadAudio: function loadAudio(inputId, audioId, audioValue, generationType, audioName, player) {
      var input = document.querySelector('#' + inputId);
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий');
        } else {
          this.handleUploadRequest(audioId, audioValue, generationType, input.files[0], audioName);
          this.$refs[player].load();
        }
      }
    },
    handleUploadRequest: function handleUploadRequest(audioId, audioValue, generationType, audioFile, audioName) {
      var _this4 = this;

      this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile, audioId, audioName, this.scenario.client, this.scenario.id), this.prepareUploadHeaders()).then(function (response) {
        _this4.setAudioValue(audioId, generationType, audioValue, response);
      }).catch(function (error) {
        console.log(error);
        _this4.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
      });
    },
    deleteAudio: function deleteAudio(audioId, audioValue, generationType1, generationType2) {
      var _this5 = this;

      this.$http.delete(audioDeleteApi + '/' + this.scenario.parameters[audioId], { headers: this.prepareUploadHeaders() }).then(function (response) {
        _this5.deleteAudioValue(audioId, generationType1, generationType2, audioValue);
      }).catch(function (error) {
        console.log(error);
        _this5.openNotificationWithType('danger', 'Ошибка удаления аудио. ');
      });
    },
    prepareMultipartAudio: function prepareMultipartAudio(audioFile, audioId, audioName, audioClient, audioScenario) {
      var audioFormData = new FormData();
      audioFormData.append('file', audioFile);
      audioFormData.append('name', audioName);
      audioFormData.append('client', audioClient);
      audioFormData.append('scenario', audioScenario);
      audioFormData.append('id', this.scenario.parameters[audioId]);
      return audioFormData;
    },
    prepareUploadHeaders: function prepareUploadHeaders() {
      return {
        'headers': {
          'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
          'Content-Type': 'multipart/form-data',
          'testH': 'testHV'
        }
      };
    },
    setAudioValue: function setAudioValue(audioId, generationType, audioValue, response) {
      this.scenario.parameters[audioId] = response.data;
      this.tmp[generationType] = '/audios/' + this.scenario.parameters[audioId] + '.wav';
      this.scenario.parameters[audioValue] = this.tmp[generationType];
    },
    deleteAudioValue: function deleteAudioValue(audioId, generationType1, generationType2, audioValue) {
      this.scenario.parameters[audioId] = '';
      this.tmp[generationType1] = '';
      this.tmp[generationType2] = '';
      this.scenario.parameters[audioValue] = '';
    },
    load: function load() {
      var _this6 = this;

      this.$http({
        url: api + '/' + this.name,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('opening scenario ' + JSON.stringify(response.data));
        _this6.isSaved = true;
        _this6.scenario = response.data;
        _this6.question_audio = '/audios/' + _this6.scenario.parameters.questionId + '.wav';
        _this6.conclusionAudio = '/audios/' + _this6.scenario.parameters.conclusionId + '.wav';
      }).catch(function (error) {
        console.log(error);
        _this6.openNotificationWithType('danger', 'Ошибка загрузки сценария. ');
      });
    },
    cancel: function cancel() {
      if (this.$props.campaignid == 0) {
        this.$router.push('/scenarios/');
      } else {
        this.$router.push('/campaigns/' + this.$props.campaignid);
      }
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.currentAudio = null;
    },
    openModal: function openModal(audioId, audioValue, generationType, audioName) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед записью аудио необходимо сохранить сценарий');
      } else {
        this.showModal = true;
        this.currentAudio = new FormData();
        this.currentAudio.append('audioId', audioId);
        this.currentAudio.append('audioValue', audioValue);
        this.currentAudio.append('generationType', generationType);
        this.currentAudio.append('audioName', audioName);
      }
    },
    confirmAction: function confirmAction(value) {
      this.handleUploadRequest(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), this.currentAudio.get('generationType'), value.blob, this.currentAudio.get('audioName'));
      this.closeModal();
    },
    notSaved: function notSaved() {
      this.isSaved = false;
    },
    loadState: function loadState() {
      var _this7 = this;

      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this7.isActive = response.data;
        if (!_this7.isActive) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this7.openNotificationWithType('danger', _this7.$i18n.messages[_this7.$i18n.locale].scenarios.errorToGetUserStatus);
      });
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: this.$i18n.messages[this.$i18n.locale].notifications.notification,
        message: message,
        type: type
      });
    }
  },
  data: function data() {
    return {
      scenario: {
        template: 'recognition',
        parameters: {
          questionId: '',
          questionAudio: '',
          questionText: '',
          questionGenerationState: true,
          questionSpeaker: 'oksana',
          questionEmotion: 'neutral',
          questionSpeed: 1,

          conclusionId: '',
          conclusionAudio: '',
          conclusionText: '',
          conclusionGenerationState: true,
          conclusionSpeaker: 'oksana',
          conclusionEmotion: 'neutral',
          conclusionSpeed: 1
        },
        checkDuration: true
      },
      tmp: {
        generatedQuestionAudio: '',
        loadedQuestionAudio: '',
        questionLoading: false,
        currentSpeakerQuestion: 'oksana',
        currentEmotionQuestion: 'neutral',
        currentSpeedQuestion: 1,
        conclusionGeneratedAudio: '',
        conclusionLoadedAudio: '',
        conclusionLoading: false,
        currentSpeakerConclusion: 'oksana',
        currentEmotionConclusion: 'neutral',
        currentSpeedConclusion: 1
      },
      question_audio: '',
      conclusionAudio: '',
      speakerList: [{
        value: 'jane'
      }, {
        value: 'oksana'
      }, {
        value: 'alyss '
      }, {
        value: 'omazh'
      }, {
        value: 'zahar '
      }, {
        value: 'ermil '
      }],
      currentEmotion: 'neutral',
      emotionList: [{
        value: 'good'
      }, {
        value: 'neutral'
      }, {
        value: 'evil'
      }],
      currentSpeed: 1,
      isSaved: false,
      isActive: false,
      isReady: false,
      showModal: null,
      title: '',
      currentAudio: null
    };
  },

  created: function created() {
    this.loadState();
    if (this.name === undefined) {
      console.log('creating new scenario');
      this.notSaved();
    } else {
      console.log('loading scenario: ' + this.name);
      this.load();
    }
    this.$watch('scenario.parameters.questionAudio', function () {
      this.$refs.questionPlayer.load();
    });
    this.$watch('scenario.parameters.conclusionAudio', function () {
      this.$refs.conclusionPlayer.load();
    });
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }
      if (this.scenario.parameters.questionGenerationState) {
        this.tmp.generatedQuestionAudio = this.scenario.parameters.questionAudio;
      } else {
        this.tmp.loadedQuestionAudio = this.scenario.parameters.questionAudio;
      }
      this.tmp.currentSpeakerQuestion = this.scenario.parameters.questionSpeaker || this.tmp.currentSpeakerQuestion;
      this.tmp.currentEmotionQuestion = this.scenario.parameters.questionEmotion || this.tmp.currentEmotionQuestion;
      this.tmp.currentSpeedQuestion = this.scenario.parameters.questionSpeed || this.tmp.currentSpeedQuestion;

      if (this.scenario.parameters.conclusionGenerationState) {
        this.tmp.generatedConclusionAudio = this.scenario.parameters.conclusionAudio;
      } else {
        this.tmp.loadedConclusionAudio = this.scenario.parameters.conclusionAudio;
      }
      this.tmp.currentSpeakerConclusion = this.scenario.parameters.conclusionSpeaker || this.tmp.currentSpeakerConclusion;
      this.tmp.currentEmotionConclusion = this.scenario.parameters.conclusionEmotion || this.tmp.currentEmotionConclusion;
      this.tmp.currentSpeedConclusion = this.scenario.parameters.conclusionSpeed || this.tmp.currentSpeedConclusion;
    }
  },

  beforeUpdate: function beforeUpdate() {
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }
      if (this.scenario.parameters.questionGenerationState) {
        this.tmp.generatedQuestionAudio = this.scenario.parameters.questionAudio;
      } else {
        this.tmp.loadedQuestionAudio = this.scenario.parameters.questionAudio;
      }
      if (this.scenario.parameters.conclusionGenerationState) {
        this.tmp.generatedConclusionAudio = this.scenario.parameters.conclusionAudio;
      } else {
        this.tmp.loadedConclusionAudio = this.scenario.parameters.conclusionAudio;
      }
    }
  }
});

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.loadedScenario))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Название сценария")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.name),
      expression: "scenario.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название сценария"
    },
    domProps: {
      "value": (_vm.scenario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionGenerationState),
      expression: "scenario.parameters.questionGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionGenerationState', 'questionAudio', 'generatedQuestionAudio', 'loadedQuestionAudio', 'questionPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionGenerationState),
      expression: "scenario.parameters.questionGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionGenerationState', 'questionAudio', 'generatedQuestionAudio', 'loadedQuestionAudio', 'questionPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionText),
      expression: "scenario.parameters.questionText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionId', 'questionAudio', 'currentSpeakerQuestion', 'generatedQuestionAudio', 'questionText', 'questionLoading', 'question', 'currentEmotionQuestion', 'currentSpeedQuestion')
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.tmp.questionLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n          Сгенерировать аудио\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerQuestion),
      expression: "tmp.currentSpeakerQuestion"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerQuestion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n              " + _vm._s(speaker.value) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionQuestion),
      expression: "tmp.currentEmotionQuestion"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionQuestion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n              " + _vm._s(emotion.value) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedQuestion,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedQuestion = $event
      }
    }
  }), _vm._v("\n          Скорость: " + _vm._s(_vm.tmp.currentSpeedQuestion) + "\n        ")], 1), _vm._v(" "), (_vm.tmp.generatedQuestionAudio) ? _c('audio', {
    ref: 'questionPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionAudio
    }
  }), _vm._v("\n          Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.generatedQuestionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('loadAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "loadAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('loadAudio', 'questionId', 'questionAudio', 'loadedQuestionAudio', 'question', 'questionPlayer')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionId', 'questionAudio', 'loadedQuestionAudio', 'question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.loadedQuestionAudio) ? _c('audio', {
    ref: "questionPlayer"
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionAudio
    }
  }), _vm._v("\n          Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.loadedQuestionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionId', 'questionAudio', 'loadedQuestionAudio', 'generatedQuestionAudio')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Заключение")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.conclusionGenerationState),
      expression: "scenario.parameters.conclusionGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.conclusionGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "conclusionGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('conclusionGenerationState', 'conclusionAudio', 'generatedConclusionAudio', 'loadedConclusionAudio', 'conclusionPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.conclusionGenerationState),
      expression: "scenario.parameters.conclusionGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.conclusionGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "conclusionGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('conclusionGenerationState', 'conclusionAudio', 'generatedConclusionAudio', 'loadedConclusionAudio', 'conclusionPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.conclusionGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.conclusionText),
      expression: "scenario.parameters.conclusionText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.conclusionText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "conclusionText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('conclusionId', 'conclusionAudio', 'currentSpeakerConclusion', 'generatedConclusionAudio', 'conclusionText', 'conclusionLoading', 'conclusion', 'currentEmotionConclusion', 'currentSpeedConclusion')
      }
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.tmp.conclusionLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n        Сгенерировать аудио\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerConclusion),
      expression: "tmp.currentSpeakerConclusion"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerConclusion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n            " + _vm._s(speaker.value) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionConclusion),
      expression: "tmp.currentEmotionConclusion"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionConclusion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n            " + _vm._s(emotion.value) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedConclusion,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedConclusion = $event
      }
    }
  }), _vm._v("\n        Скорость: " + _vm._s(_vm.tmp.currentSpeedConclusion) + "\n      ")], 1), _vm._v(" "), (_vm.tmp.generatedConclusionAudio) ? _c('audio', {
    ref: 'conclusionPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.conclusionAudio
    }
  }), _vm._v("\n        Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.generatedConclusionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.conclusionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.conclusionGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('conclusionLoadAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "conclusionLoadAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('conclusionLoadAudio', 'conclusionId', 'conclusionAudio', 'loadedConclusionAudio', 'conclusion', 'conclusionPlayer')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('conclusionId', 'conclusionAudio', 'loadedConclusionAudio', 'conclusion')
      }
    }
  }), _vm._v(" "), (_vm.tmp.loadedConclusionAudio) ? _c('audio', {
    ref: "conclusionPlayer"
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.conclusionAudio
    }
  }), _vm._v("\n        Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.loadedConclusionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.conclusionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (this.scenario.parameters.conclusionId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('conclusionId', 'conclusionAudio', 'loadedConclusionAudio', 'generatedConclusionAudio')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(4), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.scenario.isReady) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Подготовлен")])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(8), _vm._v(" "), _c('span', [_vm._v("Не подготовлен")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-primary"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })]), _vm._v(" "), _c('span', [_vm._v("Рассчитать стоимость")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
}]}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_collapse__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalAudio__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ModalAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var NotificationComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var MessageComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default.a);
var openMessage = function openMessage() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  };

  return new MessageComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var api = '/api/scenarios';
var audioGeneratorApi = '/audios/generate';
var audioUploadApi = '/audios/reSave';
var audioDeleteApi = '/audios';
var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name', 'campaignid'],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_7__ModalAudio___default.a,
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a,
    Collapse: __WEBPACK_IMPORTED_MODULE_6_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_6_vue_bulma_collapse__["Item"],
    Slider: __WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider___default.a
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['loadedScenario', 'loggedId', 'loggedUser', 'authenticationToken'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },

    changeRoute: function changeRoute(e) {
      this.$router.push({ path: '/scenarios' + e.target.value });
    },
    checkAudioDuration: function checkAudioDuration() {
      this.scenario.checkDuration = true;
      var len = document.querySelectorAll('audio').length;
      for (var i = 0; i < len; i++) {
        if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
          this.scenario.checkDuration = this.scenario.checkDuration && document.querySelectorAll('audio')[i].duration > 0;
        }
      }
      return this.scenario.checkDuration;
    },
    save: function save(showMessage) {
      if (this.checkAudioDuration()) {
        this.scenario.parameters.mainSpeaker = this.tmp.currentSpeakerMain;
        this.scenario.parameters.mainEmotion = this.tmp.currentEmotionMain;
        this.scenario.parameters.mainSpeed = this.tmp.currentSpeedMain;

        this.scenario.parameters.onYesSpeaker = this.tmp.currentSpeakerYes;
        this.scenario.parameters.onYesEmotion = this.tmp.currentEmotionYes;
        this.scenario.parameters.onYesSpeed = this.tmp.currentSpeedYes;

        this.scenario.parameters.onNoSpeaker = this.tmp.currentSpeakerNo;
        this.scenario.parameters.onNoEmotion = this.tmp.currentEmotionNo;
        this.scenario.parameters.onNoSpeed = this.tmp.currentSpeedNo;

        if (this.scenario.id === undefined) {
          this.saveNew(showMessage);
        } else {
          this.update(showMessage);
        }
      } else {
        this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с аудиофайлом нулевой длительности');
      }
    },
    saveNew: function saveNew(showMessage) {
      var _this = this;

      console.log('saving new scenario: ' + JSON.stringify(this.scenario));

      if (!this.scenario.parameters.mainGenerationState) {
        this.scenario.parameters.mainQuestionText = '';
      }
      if (!this.scenario.parameters.onYesGenerationState) {
        this.scenario.parameters.onYesText = '';
      }
      if (!this.scenario.parameters.onNoGenerationState) {
        this.scenario.parameters.onNoText = '';
      }

      this.$http.post(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.isSaved = true;
        if (showMessage) {
          _this.openNotificationWithType('info', 'Сценарий сохранен');
          _this.$emit('set', _this.scenario);
        }
        _this.scenario = response.data;
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    update: function update(showMessage) {
      var _this2 = this;

      console.log('updating scenario: ' + JSON.stringify(this.scenario));
      this.$http.put(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.isSaved = true;
        _this2.scenario = response.data;
        if (showMessage) {
          _this2.openNotificationWithType('info', 'Сценарий сохранен');
        }
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    uploadFile: function uploadFile(buttonId) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий');
      } else {
        document.getElementById(buttonId).click();
      }
    },
    genAudioRequest: function genAudioRequest(maybeId, audioName, text, speaker, emotion, speed) {
      var request = {
        'client': this.scenario.client,
        'scenario': this.scenario.id,
        'audioName': audioName,
        'generator': 'yandex',
        'text': text,
        'parameters': {
          'speaker': speaker,
          'emotion': emotion,
          'speed': speed,
          'text': text
        }
        // if audio already generated, request must contain id, so backend will overwrite existing audio
      };if (maybeId) {
        request.id = maybeId;
      }
      return request;
    },
    securityHeaders: function securityHeaders() {
      return {
        'testH': 'testHV',
        'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ'
      };
    },
    onChangeGenerationState: function onChangeGenerationState(stateId, audioId, generatedAudioId, loadedAudioId, playerId) {
      if (this.scenario.parameters[stateId]) {
        this.scenario.parameters[audioId] = this.tmp[generatedAudioId];
        this.$refs[playerId][0].load();
      } else if (!this.tmp[stateId]) {
        this.scenario.parameters[audioId] = this.tmp[loadedAudioId];
        this.$refs[playerId][0].load();
      }
    },
    genAudio: function genAudio(id, audio, speaker, generatedAudio, text, loadingStatus, name, emotion, speed) {
      var _this3 = this;

      var request = this.genAudioRequest(this.scenario.parameters[id], name, this.scenario.parameters[text], this.tmp[speaker], this.tmp[emotion], this.tmp[speed]);
      var headers = { headers: this.securityHeaders() };
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий');
      } else {
        this.tmp[loadingStatus] = true;
        this.$http.post(audioGeneratorApi, request, headers).then(function (response) {
          _this3.handleGenRequest(id, audio, generatedAudio, response.data);
          _this3.tmp[loadingStatus] = false;
        }).catch(function (error) {
          console.log(error);
          _this3.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
          _this3.tmp[loadingStatus] = false;
        });
      }
    },
    handleGenRequest: function handleGenRequest(id, audio, generatedAudio, data) {
      this.scenario.parameters[id] = data;
      this.tmp[generatedAudio] = '/audios/' + data + '.wav';
      this.scenario.parameters[audio] = this.tmp[generatedAudio];
    },
    loadAudio: function loadAudio(inputId, audioId, audioValue, generationType, audioName, player) {
      var input = document.querySelector('#' + inputId);
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий');
        } else {
          this.handleUploadRequest(audioId, audioValue, generationType, input.files[0], audioName);
          this.$refs[player].load();
        }
      }
    },
    handleUploadRequest: function handleUploadRequest(audioId, audioValue, generationType, audioFile, audioName) {
      var _this4 = this;

      this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile, audioId, audioName, this.scenario.client, this.scenario.id), this.prepareUploadHeaders()).then(function (response) {
        _this4.setAudioValue(audioId, generationType, audioValue, response);
      }).catch(function (error) {
        console.log(error);
        _this4.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
      });
    },
    deleteAudio: function deleteAudio(audioId, audioValue, generationType1, generationType2) {
      var _this5 = this;

      this.$http.delete(audioDeleteApi + '/' + this.scenario.parameters[audioId], { headers: this.prepareUploadHeaders() }).then(function (response) {
        _this5.deleteAudioValue(audioId, generationType1, generationType2, audioValue);
      }).catch(function (error) {
        console.log(error);
        _this5.openNotificationWithType('danger', 'Ошибка удаления аудио. ');
      });
    },
    prepareMultipartAudio: function prepareMultipartAudio(audioFile, audioId, audioName, audioClient, audioScenario) {
      var audioFormData = new FormData();
      audioFormData.append('file', audioFile);
      audioFormData.append('name', audioName);
      audioFormData.append('client', audioClient);
      audioFormData.append('scenario', audioScenario);
      audioFormData.append('id', this.scenario.parameters[audioId]);
      return audioFormData;
    },
    prepareUploadHeaders: function prepareUploadHeaders() {
      return {
        'headers': {
          'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
          'Content-Type': 'multipart/form-data',
          'testH': 'testHV'
        }
      };
    },
    setAudioValue: function setAudioValue(audioId, generationType, audioValue, response) {
      this.scenario.parameters[audioId] = response.data;
      this.tmp[generationType] = '/audios/' + this.scenario.parameters[audioId] + '.wav';
      this.scenario.parameters[audioValue] = this.tmp[generationType];
    },
    deleteAudioValue: function deleteAudioValue(audioId, generationType1, generationType2, audioValue) {
      this.scenario.parameters[audioId] = '';
      this.tmp[generationType1] = '';
      this.tmp[generationType2] = '';
      this.scenario.parameters[audioValue] = '';
    },
    load: function load() {
      var _this6 = this;

      this.$http({
        url: api + '/' + this.name,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('opening scenario ' + JSON.stringify(response.data));
        _this6.scenario = response.data;
        _this6.q1audio = '/audios/' + _this6.scenario.parameters.mainQuestionId + '.wav';
        _this6.onQuestionYesAudio = '/audios/' + _this6.scenario.parameters.onYesId + '.wav';
        _this6.onQuestionNoAudio = '/audios/' + _this6.scenario.parameters.onNoId + '.wav';
        _this6.isSaved = true;
      }).catch(function (error) {
        console.log(error);
        _this6.openNotificationWithType('danger', 'Ошибка загрузки сценария. ');
      });
    },
    cancel: function cancel() {
      if (this.$props.campaignid == 0) {
        this.$router.push('/scenarios/');
      } else {
        this.$router.push('/campaigns/' + this.$props.campaignid);
      }
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.currentAudio = null;
    },
    openModal: function openModal(audioId, audioValue, generationType, audioName) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед записью аудио необходимо сохранить сценарий');
      } else {
        this.showModal = true;
        this.currentAudio = new FormData();
        this.currentAudio.append('audioId', audioId);
        this.currentAudio.append('audioValue', audioValue);
        this.currentAudio.append('generationType', generationType);
        this.currentAudio.append('audioName', audioName);
      }
    },
    confirmAction: function confirmAction(value) {
      this.handleUploadRequest(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), this.currentAudio.get('generationType'), value.blob, this.currentAudio.get('audioName'));
      this.closeModal();
    },
    notSaved: function notSaved() {
      this.isSaved = false;
    },
    loadState: function loadState() {
      var _this7 = this;

      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this7.isActive = response.data;
        if (!_this7.isActive) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this7.openNotificationWithType('danger', _this7.$i18n.messages[_this7.$i18n.locale].scenarios.errorToGetUserStatus);
      });
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: this.$i18n.messages[this.$i18n.locale].notifications.notification,
        message: message,
        type: type
      });
    }
  },
  data: function data() {
    return {
      scenario: {
        template: 'yesnoonequestion',
        parameters: {
          mainQuestionId: '',
          mainQuestionAudio: '',
          mainQuestionText: '',
          mainGenerationState: true,
          mainSpeaker: 'oksana',
          mainEmotion: 'neutral',
          mainSpeed: 1,

          onYesId: '',
          onYesAudio: '',
          onYesText: '',
          onYesGenerationState: true,
          onYesSMSText: '',
          onYesSpeaker: 'oksana',
          onYesEmotion: 'neutral',
          onYesSpeed: 1,

          onNoId: '',
          onNoAudio: '',
          onNoText: '',
          onNoGenerationState: true,
          onNoSpeaker: 'oksana',
          onNoEmotion: 'neutral',
          onNoSpeed: 1

        },
        checkDuration: true
      },
      tmp: {
        mainGeneratedAudio: '',
        mainLoadedAudio: '',
        mainLoading: false,
        currentSpeakerMain: 'oksana',
        currentEmotionMain: 'neutral',
        currentSpeedMain: 1,

        onYesGeneratedAudio: '',
        onYesLoadedAudio: '',
        onYesLoading: false,
        currentSpeakerYes: 'oksana',
        currentEmotionYes: 'neutral',
        currentSpeedYes: 1,

        onNoGeneratedAudio: '',
        onNoLoadedAudio: '',
        onNoLoading: false,
        currentSpeakerNo: 'oksana',
        currentEmotionNo: 'neutral',
        currentSpeedNo: 1
      },
      speakerList: [{
        value: 'jane'
      }, {
        value: 'oksana'
      }, {
        value: 'alyss '
      }, {
        value: 'omazh'
      }, {
        value: 'zahar '
      }, {
        value: 'ermil '
      }],
      currentEmotion: 'neutral',
      emotionList: [{
        value: 'good'
      }, {
        value: 'neutral'
      }, {
        value: 'evil'
      }],
      currentSpeed: 1,
      q1audio: '',
      onQuestionYesAudio: '',
      onQuestionNoAudio: '',
      isSaved: false,
      isActive: false,
      showModal: null,
      title: '',
      currentAudio: null
    };
  },

  created: function created() {
    this.loadState();
    if (!this.$props.name) {
      console.log('creating new scenario');
      this.notSaved();
    } else {
      console.log('loading scenario: ' + !this.$props.name);
      this.load();
    }
    this.$watch('scenario.parameters.mainQuestionAudio', function () {
      this.$refs.mainPlayer.load();
    });
    this.$watch('scenario.parameters.onYesAudio', function () {
      this.$refs.onYesPlayer.load();
    });
    this.$watch('scenario.parameters.onNoAudio', function () {
      this.$refs.onNoPlayer.load();
    });

    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }

      if (this.scenario.parameters.mainGenerationState) {
        this.tmp.mainGeneratedAudio = this.scenario.parameters.mainQuestionAudio;
      } else {
        this.tmp.mainLoadedAudio = this.scenario.parameters.mainQuestionAudio;
      }
      this.tmp.currentSpeakerMain = this.scenario.parameters.mainSpeaker || this.tmp.currentSpeakerMain;
      this.tmp.currentEmotionMain = this.scenario.parameters.mainEmotion || this.tmp.currentEmotionMain;
      this.tmp.currentSpeedMain = this.scenario.parameters.mainSpeed || this.tmp.currentSpeedMain;

      if (this.scenario.parameters.onYesGenerationState) {
        this.tmp.onYesGeneratedAudio = this.scenario.parameters.onYesAudio;
      } else {
        this.tmp.onYesLoadedAudio = this.scenario.parameters.onYesAudio;
      }
      this.tmp.currentSpeakerYes = this.scenario.parameters.onYesSpeaker || this.tmp.currentSpeakerYes;
      this.tmp.currentEmotionYes = this.scenario.parameters.onYesEmotion || this.tmp.currentEmotionYes;
      this.tmp.currentSpeedYes = this.scenario.parameters.onYesSpeed || this.tmp.currentSpeedYes;

      if (this.scenario.parameters.onNoGenerationState) {
        this.tmp.onNoGeneratedAudio = this.scenario.parameters.onNoAudio;
      } else {
        this.tmp.onNoLoadedAudio = this.scenario.parameters.onNoAudio;
      }
      this.tmp.currentSpeakerNo = this.scenario.parameters.onNoSpeaker || this.tmp.currentSpeakerNo;
      this.tmp.currentEmotionNo = this.scenario.parameters.onNoEmotion || this.tmp.currentEmotionNo;
      this.tmp.currentSpeedNo = this.scenario.parameters.onNoSpeed || this.tmp.currentSpeedNo;
    }
  },
  beforeUpdate: function beforeUpdate() {
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }

      if (this.scenario.parameters.mainGenerationState) {
        this.tmp.mainGeneratedAudio = this.scenario.parameters.mainQuestionAudio;
      } else {
        this.tmp.mainLoadedAudio = this.scenario.parameters.mainQuestionAudio;
      }
      // this.tmp.currentSpeakerMain = this.scenario.parameters.mainSpeaker || this.tmp.currentSpeakerMain
      // this.tmp.currentEmotionMain = this.scenario.parameters.mainEmotion || this.tmp.currentEmotionMain
      // this.tmp.currentSpeedMain = this.scenario.parameters.mainSpeed || this.tmp.currentSpeedMain

      if (this.scenario.parameters.onYesGenerationState) {
        this.tmp.onYesGeneratedAudio = this.scenario.parameters.onYesAudio;
      } else {
        this.tmp.onYesLoadedAudio = this.scenario.parameters.onYesAudio;
      }
      // this.tmp.currentSpeakerYes = this.scenario.parameters.onYesSpeaker || this.tmp.currentSpeakerYes
      // this.tmp.currentEmotionYes = this.scenario.parameters.onYesEmotion || this.tmp.currentEmotionYes
      // this.tmp.currentSpeedYes = this.scenario.parameters.onYesSpeed || this.tmp.currentSpeedYes

      if (this.scenario.parameters.onNoGenerationState) {
        this.tmp.onNoGeneratedAudio = this.scenario.parameters.onNoAudio;
      } else {
        this.tmp.onNoLoadedAudio = this.scenario.parameters.onNoAudio;
      }
      // this.tmp.currentSpeakerNo = this.scenario.parameters.onNoSpeaker || this.tmp.currentSpeakerNo
      // this.tmp.currentEmotionNo = this.scenario.parameters.onNoEmotion || this.tmp.currentEmotionNo
      // this.tmp.currentSpeedNo = this.scenario.parameters.onNoSpeed || this.tmp.currentSpeedNo
    }
  }
});

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.loadedScenario))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Название сценария")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.name),
      expression: "scenario.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название сценария"
    },
    domProps: {
      "value": (_vm.scenario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.mainGenerationState),
      expression: "scenario.parameters.mainGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.mainGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('mainGenerationState', 'mainQuestionAudio', 'mainGeneratedAudio', 'mainLoadedAudio', 'mainPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.mainGenerationState),
      expression: "scenario.parameters.mainGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.mainGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('mainGenerationState', 'mainQuestionAudio', 'mainGeneratedAudio', 'mainLoadedAudio', 'mainPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.mainGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.mainQuestionText),
      expression: "scenario.parameters.mainQuestionText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.mainQuestionText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "mainQuestionText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('mainQuestionId', 'mainQuestionAudio', 'currentSpeakerMain', 'mainGeneratedAudio', 'mainQuestionText', 'mainLoading', 'Main question', 'currentEmotionMain', 'currentSpeedMain')
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.tmp.mainLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n            Сгенерировать аудио\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerMain),
      expression: "tmp.currentSpeakerMain"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerMain", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                " + _vm._s(speaker.value) + "\n              ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionMain),
      expression: "tmp.currentEmotionMain"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionMain", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                " + _vm._s(emotion.value) + "\n              ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedMain,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedMain = $event
      }
    }
  }), _vm._v("\n            Скорость: " + _vm._s(_vm.tmp.currentSpeedMain) + "\n          ")], 1), _vm._v(" "), (_vm.tmp.mainGeneratedAudio) ? _c('audio', {
    ref: 'mainPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.mainQuestionAudio
    }
  }), _vm._v("\n            Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n          ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.mainGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.mainQuestionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.mainGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('mainLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "mainLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('mainLoadedAudio', 'mainQuestionId', 'mainQuestionAudio', 'mainLoadedAudio', 'Main question', 'mainPlayer')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('mainQuestionId', 'mainQuestionAudio', 'mainLoadedAudio', 'Main question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.mainLoadedAudio) ? _c('audio', {
    ref: 'mainPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.mainQuestionAudio
    }
  }), _vm._v("\n            Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n          ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.mainLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.mainQuestionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.mainQuestionId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('mainQuestionId', 'mainQuestionAudio', 'mainLoadedAudio', 'mainGeneratedAudio')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "second-layer positive-scenario"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Сообщение при ответе да")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onYesGenerationState),
      expression: "scenario.parameters.onYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.onYesGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('onYesGenerationState', 'onYesAudio', 'onYesGeneratedAudio', 'onYesLoadedAudio', 'onYesPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onYesGenerationState),
      expression: "scenario.parameters.onYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.onYesGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('onYesGenerationState', 'onYesAudio', 'onYesGeneratedAudio', 'onYesLoadedAudio', 'onYesPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), (_vm.scenario.parameters.onYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onYesText),
      expression: "scenario.parameters.onYesText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.onYesText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "onYesText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('onYesId', 'onYesAudio', 'currentSpeakerYes', 'onYesGeneratedAudio', 'onYesText', 'onYesLoading', 'Yes question', 'currentEmotionYes', 'currentSpeedYes')
      }
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.tmp.onYesLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                Сгенерировать аудио\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerYes),
      expression: "tmp.currentSpeakerYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                    " + _vm._s(speaker.value) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionYes),
      expression: "tmp.currentEmotionYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                    " + _vm._s(emotion.value) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedYes,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedYes = $event
      }
    }
  }), _vm._v("\n                Скорость: " + _vm._s(_vm.tmp.currentSpeedYes) + "\n              ")], 1), _vm._v(" "), (_vm.tmp.onYesGeneratedAudio) ? _c('audio', {
    ref: 'onYesPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.onYesAudio
    }
  }), _vm._v("\n                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.onYesGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.onYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.onYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('onYesLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "onYesLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('onYesLoadedAudio', 'onYesId', 'onYesAudio', 'onYesLoadedAudio', 'Yes question', 'onYesPlayer')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('onYesId', 'onYesAudio', 'onYesLoadedAudio', 'Yes question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.onYesLoadedAudio) ? _c('audio', {
    ref: 'onYesPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.onYesAudio
    }
  }), _vm._v("\n                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.onYesLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.onYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.onYesId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('onYesId', 'onYesAudio', 'onYesLoadedAudio', 'onYesGeneratedAudio')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e(), _vm._v(" "), _c('collapse', [_c('collapse-item', {
    staticClass: "positive-scenario",
    attrs: {
      "title": "Отправить СМС",
      "selected": _vm.scenario.parameters.onYesSMSText != ''
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onYesSMSText),
      expression: "scenario.parameters.onYesSMSText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.onYesSMSText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "onYesSMSText", $event.target.value)
      }
    }
  })])])], 1), _vm._v(" "), _c('p')], 1)]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding": "10px"
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "second-layer negative-scenario"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Сообщение при ответе нет")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onNoGenerationState),
      expression: "scenario.parameters.onNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.onNoGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('onNoGenerationState', 'onNoAudio', 'onNoGeneratedAudio', 'onNoLoadedAudio', 'onNoPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onNoGenerationState),
      expression: "scenario.parameters.onNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.onNoGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('onNoGenerationState', 'onNoAudio', 'onNoGeneratedAudio', 'onNoLoadedAudio', 'onNoPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.onNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onNoText),
      expression: "scenario.parameters.onNoText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.onNoText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "onNoText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('onNoId', 'onNoAudio', 'currentSpeakerNo', 'onNoGeneratedAudio', 'onNoText', 'onNoLoading', 'No question', 'currentEmotionNo', 'currentSpeedNo')
      }
    }
  }, [_vm._m(4), _vm._v(" "), (_vm.tmp.onNoLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n              Сгенерировать аудио\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerNo),
      expression: "tmp.currentSpeakerNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                  " + _vm._s(speaker.value) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionNo),
      expression: "tmp.currentEmotionNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                  " + _vm._s(emotion.value) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedNo,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedNo = $event
      }
    }
  }), _vm._v("\n              Скорость: " + _vm._s(_vm.tmp.currentSpeedNo) + "\n            ")], 1), _vm._v(" "), (_vm.tmp.onNoGeneratedAudio) ? _c('audio', {
    ref: 'onNoPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.onNoAudio
    }
  }), _vm._v("\n              Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.onNoGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.onNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.onNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('onNoLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "onNoLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('onNoLoadedAudio', 'onNoId', 'onNoAudio', 'onNoLoadedAudio', 'No question', 'onNoPlayer')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('onNoId', 'onNoAudio', 'onNoLoadedAudio', 'No question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.onNoLoadedAudio) ? _c('audio', {
    ref: 'onNoPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.onNoAudio
    }
  }), _vm._v("\n              Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.onNoLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.onNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.onNoId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('onNoId', 'onNoAudio', 'onNoLoadedAudio', 'onNoGeneratedAudio')
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(6), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), _vm._m(8), _vm._v(" "), (_vm.scenario.isReady) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(9), _vm._v(" "), _c('span', [_vm._v("Подготовлен")])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(10), _vm._v(" "), _c('span', [_vm._v("Не подготовлен")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-primary"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })]), _vm._v(" "), _c('span', [_vm._v("Рассчитать стоимость")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
}]}

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commonComponents_LocalVoice__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commonComponents_LocalVoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__commonComponents_LocalVoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Answer__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Answer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Answer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_ScenarioCommon__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_ScenarioCommon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__commonComponents_ScenarioCommon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ScenarioSaver__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ScenarioSaver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ScenarioSaver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_tags__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_tags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_tags__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ScenarioQuestionYesNoMultiLang',
  components: { ScenarioBar: __WEBPACK_IMPORTED_MODULE_3__ScenarioSaver___default.a, LocalVoice: __WEBPACK_IMPORTED_MODULE_0__commonComponents_LocalVoice___default.a, Answer: __WEBPACK_IMPORTED_MODULE_1__Answer___default.a, VueTags: __WEBPACK_IMPORTED_MODULE_4_vue_tags___default.a },
  props: ['name', 'campaignid'],
  extends: __WEBPACK_IMPORTED_MODULE_2__commonComponents_ScenarioCommon___default.a,
  data: function data() {
    return {
      scenario: {
        template: 'yesnoonequestionmultilang',
        parameters: {
          mainQuestionId: '',
          mainQuestionAudio: '',
          mainQuestionText: '',
          mainSpeed: 1,
          mainEmotion: 'neutral',
          mainQuestionAudioGenerationType: '',

          yesLocalizedVariants: [],
          onYesId: '',
          onYesAudio: '',
          onYesText: '',
          onYesSMSText: '',
          onYesSpeed: 1,
          onYesEmotion: 'neutral',
          onYesAudioGenerationType: '',

          noLocalizedVariants: [],
          onNoId: '',
          onNoAudio: '',
          onNoText: '',
          onNoSpeed: 1,
          onNoEmotion: 'neutral',
          onNoAudioGenerationType: '',

          locale: '',
          vendor: '',
          voiceName: ''
        },
        isSaved: false,
        isReady: true,
        checkDuration: true,
        name: ''
      }
    };
  },

  methods: {
    setScenarioExtend: function setScenarioExtend() {
      this.scenario.isReady = true;
      this.scenario.checkDuration = true;
    },
    setMainAudio: function setMainAudio(data) {
      this.scenario.parameters.mainQuestionAudio = data.url;
    },
    setYesAudio: function setYesAudio(data) {
      this.scenario.parameters.onYesAudio = data.url;
    },
    setNoAudio: function setNoAudio(data) {
      this.scenario.parameters.onNoAudio = data.url;
    },
    changeMainGenerationType: function changeMainGenerationType(type) {
      this.scenario.parameters.mainQuestionAudioGenerationType = type;
    },
    changeYesGenerationType: function changeYesGenerationType(type) {
      this.scenario.parameters.onYesAudioGenerationType = type;
    },
    changeNoGenerationType: function changeNoGenerationType(type) {
      this.scenario.parameters.onNoAudioGenerationType = type;
    }
  }
});

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LocalVoice',
  props: ['locale', 'vendor', 'voiceName'],
  data: function data() {
    return {
      parameters: {
        commonParameters: {
          locale: ''
        },
        voiceParameters: {
          vendor: '',
          voiceName: ''
        }
      },
      voices: {
        'Yandex': [{
          value: 'jane'
        }, {
          value: 'oksana'
        }, {
          value: 'alyss '
        }, {
          value: 'omazh'
        }, {
          value: 'zahar '
        }, {
          value: 'ermil '
        }],
        'Google': [],
        'Azure': []
      }
    };
  }
});

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "langVoiceParameters"
  }, [_c('div', {
    staticClass: "field is-horizontal locale"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Locale"
    },
    domProps: {
      "value": _vm.locale
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:locale', $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal vendor"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    domProps: {
      "value": _vm.vendor
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:vendor', $event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "yandex"
    }
  }, [_vm._v("Yandex")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "google"
    }
  }, [_vm._v("Google")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "azure"
    }
  }, [_vm._v("Azure")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal voice"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Voice Name"
    },
    domProps: {
      "value": _vm.voiceName
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:voiceName', $event.target.value)
      }
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-label is-normal"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Locale")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-label is-normal"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Generation vendor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-label is-normal"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Voice")])])
}]}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VisCommon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VisCommon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_VisCommon__);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ScenarioCommon',
  extends: __WEBPACK_IMPORTED_MODULE_0__components_VisCommon___default.a,
  methods: {
    setScenario: function setScenario(value) {
      this.scenario = value;
      if (this.scenario.id) {
        this.scenario.isSaved = true;
      }
      this.setScenarioExtend(value);
    },
    setScenarioExtend: function setScenarioExtend() {},
    generateWords: function generateWords(answer) {
      var words = answer.words || answer.variants || '';
      if (typeof words === 'string' || words instanceof String) {
        if (words.length && words.indexOf('(') < 0) {
          words = '(' + words + ')';
        }
        return words;
      } else if (Array.isArray(words)) {
        return '(' + words.join(', ') + ')';
      }
    },
    wordsEditorClass: function wordsEditorClass(words) {
      return !words || !words.length ? 'empty' : 'filled';
    }
  }
});

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseComponent__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BaseComponent__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var api = '/api/scenarios';
var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_1__BaseComponent___default.a,
  // name: 'Control',
  props: ['name', 'campaignid', 'checkDuration', 'scenario'],
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['loadedScenario', 'loggedId', 'loggedUser', 'authenticationToken'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },

    changeRoute: function changeRoute(e) {
      this.$router.push({ path: '/scenarios' + e.target.value });
    },
    load: function load() {
      var _this = this;

      this.$http({
        url: api + '/' + this._props.name,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        // console.log('opening scenario ' + JSON.stringify(response.data))
        _this.$emit('set', response.data);
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка загрузки сценария. ');
        _this.$emit('setDefault');
      });
    },

    // checkAudioDuration() {
    //   this._props.checkDuration = true
    //   let len = document.querySelectorAll('audio').length
    //   for (let i = 0; i < len; i++) {
    //     if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
    //       this._props.checkDuration = this._props.checkDuration && (document.querySelectorAll('audio')[i].duration > 0)
    //     }
    //   }
    //   return this._props.checkDuration
    // },
    save: function save(showMessage) {
      // if (this.checkAudioDuration()) {
      if (!this._props.scenario.id) {
        this.saveNew(showMessage);
      } else {
        this.update(showMessage);
      }
      // } else {
      //   this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с аудиофайлом нулевой длительности')
      // }
    },
    saveNew: function saveNew(showMessage) {
      var _this2 = this;

      this.$emit('initScenario', this._props.scenario);
      console.log('saving new scenario: ' + JSON.stringify(this._props.scenario));

      this.$http.post(api, this._props.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        if (showMessage) {
          _this2.openNotificationWithType('info', 'Сценарий сохранен');
        }
        _this2.$emit('set', response.data);
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    update: function update(showMessage) {
      var _this3 = this;

      this.$emit('initScenario', this._props.scenario);
      console.log('updating scenario: ' + JSON.stringify(this._props.scenario));
      this.$http.put(api, this._props.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        if (showMessage) {
          _this3.openNotificationWithType('info', 'Сценарий сохранен');
        }
        _this3.$emit('set', response.data);
      }).catch(function (error) {
        console.log(error);
        _this3.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    cancel: function cancel() {
      if (!this.$props.campaignid) {
        this.$router.push('/scenarios/');
      } else {
        this.$router.push('/campaigns/' + this.$props.campaignid);
      }
    },
    loadState: function loadState() {
      var _this4 = this;

      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this4.isActive = response.data;
        if (!_this4.isActive) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this4.openNotificationWithType('danger', _this4.$i18n.messages[_this4.$i18n.locale].scenarios.errorToGetUserStatus);
      });
    }
  },
  created: function created() {
    this.loadState();
    if (!this._props.name) {
      console.log('creating new scenario');
      this.$emit('setDefault');
    } else {
      console.log('loading scenario: ' + !this.$props.name);
      this.load();
    }
  }
});

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scenario_bar"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.save')))])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.close')))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
}]}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yesnoonequestionmultilang"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Scenario Name")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.name),
      expression: "scenario.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter Scenario Name"
    },
    domProps: {
      "value": (_vm.scenario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('local-voice', {
    attrs: {
      "locale": _vm.scenario.parameters.locale,
      "vendor": _vm.scenario.parameters.vendor,
      "voiceName": _vm.scenario.parameters.voiceName
    },
    on: {
      "update:locale": function($event) {
        return _vm.$set(_vm.scenario.parameters, "locale", $event)
      },
      "update:vendor": function($event) {
        return _vm.$set(_vm.scenario.parameters, "vendor", $event)
      },
      "update:voiceName": function($event) {
        return _vm.$set(_vm.scenario.parameters, "voiceName", $event)
      },
      "update:voice-name": function($event) {
        return _vm.$set(_vm.scenario.parameters, "voiceName", $event)
      }
    }
  }), _vm._v(" "), _c('answer', {
    attrs: {
      "answer-title": "Question",
      "answer-theme": "mainQuestion",
      "answer-audio-id": _vm.scenario.parameters.mainQuestionId,
      "answer-audio": _vm.scenario.parameters.mainQuestionAudio,
      "answer-text": _vm.scenario.parameters.mainQuestionText,
      "answer-vendor": _vm.scenario.parameters.vendor,
      "answer-locale": _vm.scenario.parameters.locale,
      "answer-speaker": _vm.scenario.parameters.voiceName,
      "answer-emotion": _vm.scenario.parameters.mainEmotion,
      "answer-speed": _vm.scenario.parameters.mainSpeed,
      "answer-generation-type": _vm.scenario.parameters.mainQuestionAudioGenerationType,
      "is-saved": _vm.scenario.isSaved,
      "client": _vm.scenario.client
    },
    on: {
      "update:answerAudioId": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionId", $event)
      },
      "update:answer-audio-id": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionId", $event)
      },
      "update:answerAudio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionAudio", $event)
      },
      "update:answer-audio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionAudio", $event)
      },
      "update:answerText": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionText", $event)
      },
      "update:answer-text": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionText", $event)
      },
      "update:answerVendor": function($event) {
        return _vm.$set(_vm.scenario.parameters, "vendor", $event)
      },
      "update:answer-vendor": function($event) {
        return _vm.$set(_vm.scenario.parameters, "vendor", $event)
      },
      "update:answerLocale": function($event) {
        return _vm.$set(_vm.scenario.parameters, "locale", $event)
      },
      "update:answer-locale": function($event) {
        return _vm.$set(_vm.scenario.parameters, "locale", $event)
      },
      "update:answerSpeaker": function($event) {
        return _vm.$set(_vm.scenario.parameters, "voiceName", $event)
      },
      "update:answer-speaker": function($event) {
        return _vm.$set(_vm.scenario.parameters, "voiceName", $event)
      },
      "update:answerEmotion": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainEmotion", $event)
      },
      "update:answer-emotion": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainEmotion", $event)
      },
      "update:answerSpeed": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainSpeed", $event)
      },
      "update:answer-speed": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainSpeed", $event)
      },
      "update:answerGenerationType": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionAudioGenerationType", $event)
      },
      "update:answer-generation-type": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionAudioGenerationType", $event)
      },
      "generateAudioHandler": _vm.setMainAudio,
      "changeGenerationType": _vm.changeMainGenerationType
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "second-layer positive-scenario"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wordsEditor",
    class: _vm.wordsEditorClass(_vm.scenario.parameters.yesLocalizedVariants)
  }, [_c('vue-tags', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var tag = ref.tag;
        var removeTag = ref.removeTag;
        var inputEventHandlers = ref.inputEventHandlers;
        var inputBindings = ref.inputBindings;

        return _c('div', {
          staticClass: "tags-input tags are-large"
        }, [_vm._l((_vm.scenario.parameters.yesLocalizedVariants), function(tag) {
          return _c('span', {
            staticClass: "tags-input-tag tag is-large"
          }, [_vm._v("\n                  " + _vm._s(tag) + "\n                  "), _c('button', {
            staticClass: "tags-input-remove delete",
            attrs: {
              "type": "button"
            },
            on: {
              "click": function($event) {
                return removeTag(tag)
              }
            }
          })])
        }), _vm._v(" "), _c('div', {
          staticClass: "control tags-input-text-div"
        }, [_c('input', _vm._g(_vm._b({
          staticClass: "tags-input-text input",
          attrs: {
            "placeholder": "добавте ответы \"Да\""
          }
        }, 'input', inputBindings, false), inputEventHandlers))])], 2)
      }
    }]),
    model: {
      value: (_vm.scenario.parameters.yesLocalizedVariants),
      callback: function($$v) {
        _vm.$set(_vm.scenario.parameters, "yesLocalizedVariants", $$v)
      },
      expression: "scenario.parameters.yesLocalizedVariants"
    }
  })], 1), _vm._v(" "), _c('answer', {
    attrs: {
      "answer-title": "",
      "answer-theme": "yes",
      "answer-audio-id": _vm.scenario.parameters.onYesId,
      "answer-audio": _vm.scenario.parameters.onYesAudio,
      "answer-text": _vm.scenario.parameters.onYesText,
      "answer-vendor": _vm.scenario.parameters.vendor,
      "answer-locale": _vm.scenario.parameters.locale,
      "answer-speaker": _vm.scenario.parameters.voiceName,
      "answer-emotion": _vm.scenario.parameters.onYesEmotion,
      "answer-speed": _vm.scenario.parameters.onYesSpeed,
      "answer-generation-type": _vm.scenario.parameters.onYesAudioGenerationType,
      "is-saved": _vm.scenario.isSaved,
      "client": _vm.scenario.client
    },
    on: {
      "update:answerAudioId": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesId", $event)
      },
      "update:answer-audio-id": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesId", $event)
      },
      "update:answerAudio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesAudio", $event)
      },
      "update:answer-audio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesAudio", $event)
      },
      "update:answerText": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesText", $event)
      },
      "update:answer-text": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesText", $event)
      },
      "update:answerVendor": function($event) {
        return _vm.$set(_vm.scenario.parameters, "vendor", $event)
      },
      "update:answer-vendor": function($event) {
        return _vm.$set(_vm.scenario.parameters, "vendor", $event)
      },
      "update:answerLocale": function($event) {
        return _vm.$set(_vm.scenario.parameters, "locale", $event)
      },
      "update:answer-locale": function($event) {
        return _vm.$set(_vm.scenario.parameters, "locale", $event)
      },
      "update:answerSpeaker": function($event) {
        return _vm.$set(_vm.scenario.parameters, "voiceName", $event)
      },
      "update:answer-speaker": function($event) {
        return _vm.$set(_vm.scenario.parameters, "voiceName", $event)
      },
      "update:answerEmotion": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesEmotion", $event)
      },
      "update:answer-emotion": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesEmotion", $event)
      },
      "update:answerSpeed": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesSpeed", $event)
      },
      "update:answer-speed": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesSpeed", $event)
      },
      "update:answerGenerationType": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesAudioGenerationType", $event)
      },
      "update:answer-generation-type": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesAudioGenerationType", $event)
      },
      "generateAudioHandler": _vm.setYesAudio,
      "changeGenerationType": _vm.changeYesGenerationType
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "second-layer negative-scenario"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "wordsEditor",
    class: _vm.wordsEditorClass(_vm.scenario.parameters.noLocalizedVariants)
  }, [_c('vue-tags', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var tag = ref.tag;
        var removeTag = ref.removeTag;
        var inputEventHandlers = ref.inputEventHandlers;
        var inputBindings = ref.inputBindings;

        return _c('div', {
          staticClass: "tags-input tags are-large"
        }, [_vm._l((_vm.scenario.parameters.noLocalizedVariants), function(tag) {
          return _c('span', {
            staticClass: "tags-input-tag tag is-large"
          }, [_vm._v("\n                  " + _vm._s(tag) + "\n                  "), _c('button', {
            staticClass: "tags-input-remove delete",
            attrs: {
              "type": "button"
            },
            on: {
              "click": function($event) {
                return removeTag(tag)
              }
            }
          })])
        }), _vm._v(" "), _c('div', {
          staticClass: "control tags-input-text-div"
        }, [_c('input', _vm._g(_vm._b({
          staticClass: "tags-input-text input",
          attrs: {
            "placeholder": "добавте ответы \"Нет\""
          }
        }, 'input', inputBindings, false), inputEventHandlers))])], 2)
      }
    }]),
    model: {
      value: (_vm.scenario.parameters.noLocalizedVariants),
      callback: function($$v) {
        _vm.$set(_vm.scenario.parameters, "noLocalizedVariants", $$v)
      },
      expression: "scenario.parameters.noLocalizedVariants"
    }
  })], 1), _vm._v(" "), _c('answer', {
    attrs: {
      "answer-title": "",
      "answer-theme": "no",
      "answer-audio-id": _vm.scenario.parameters.onNoId,
      "answer-audio": _vm.scenario.parameters.onNoAudio,
      "answer-text": _vm.scenario.parameters.onNoText,
      "answer-vendor": _vm.scenario.parameters.vendor,
      "answer-locale": _vm.scenario.parameters.locale,
      "answer-speaker": _vm.scenario.parameters.voiceName,
      "answer-emotion": _vm.scenario.parameters.onNoEmotion,
      "answer-speed": _vm.scenario.parameters.onNoSpeed,
      "answer-generation-type": _vm.scenario.parameters.onNoAudioGenerationType,
      "is-saved": _vm.scenario.isSaved,
      "client": _vm.scenario.client
    },
    on: {
      "update:answerAudioId": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoId", $event)
      },
      "update:answer-audio-id": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoId", $event)
      },
      "update:answerAudio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoAudio", $event)
      },
      "update:answer-audio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoAudio", $event)
      },
      "update:answerText": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoText", $event)
      },
      "update:answer-text": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoText", $event)
      },
      "update:answerVendor": function($event) {
        return _vm.$set(_vm.scenario.parameters, "vendor", $event)
      },
      "update:answer-vendor": function($event) {
        return _vm.$set(_vm.scenario.parameters, "vendor", $event)
      },
      "update:answerLocale": function($event) {
        return _vm.$set(_vm.scenario.parameters, "locale", $event)
      },
      "update:answer-locale": function($event) {
        return _vm.$set(_vm.scenario.parameters, "locale", $event)
      },
      "update:answerSpeaker": function($event) {
        return _vm.$set(_vm.scenario.parameters, "voiceName", $event)
      },
      "update:answer-speaker": function($event) {
        return _vm.$set(_vm.scenario.parameters, "voiceName", $event)
      },
      "update:answerEmotion": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoEmotion", $event)
      },
      "update:answer-emotion": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoEmotion", $event)
      },
      "update:answerSpeed": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoSpeed", $event)
      },
      "update:answer-speed": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoSpeed", $event)
      },
      "update:answerGenerationType": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoAudioGenerationType", $event)
      },
      "update:answer-generation-type": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoAudioGenerationType", $event)
      },
      "generateAudioHandler": _vm.setNoAudio,
      "changeGenerationType": _vm.changeNoGenerationType
    }
  })], 1), _vm._v(" "), _c('div', [_c('scenario-bar', {
    attrs: {
      "name": _vm.name,
      "is-saved": _vm.scenario.isSaved,
      "is-ready": true,
      "scenario": _vm.scenario
    },
    on: {
      "set": _vm.setScenario
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "title yesTitle"
  }, [_vm._v("Сообщение при ответе да")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "title noTitle"
  }, [_vm._v("Сообщение при ответе нет")])])
}]}

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_message__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalAudio__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ModalAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GenerateRepeatAudio__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GenerateRepeatAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__GenerateRepeatAudio__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var NotificationComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var MessageComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_6_vue_bulma_message___default.a);
var openMessage = function openMessage() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  };

  return new MessageComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var api = '/api/scenarios';
var audioGeneratorApi = '/audios/generate';
var audioUploadApi = '/audios/reSave';
var audioDeleteApi = '/audios';
var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name', 'campaignid'],
  components: {
    GenerateRepeatAudio: __WEBPACK_IMPORTED_MODULE_9__GenerateRepeatAudio___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_7__ModalAudio___default.a,
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_6_vue_bulma_message___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a,
    Collapse: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse__["Item"],
    Slider: __WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider___default.a
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['loadedScenario', 'loggedId', 'loggedUser', 'authenticationToken'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },

    changeRoute: function changeRoute(e) {
      this.$router.push({ path: '/scenarios' + e.target.value });
    },
    checkAudioDuration: function checkAudioDuration() {
      this.scenario.checkDuration = true;
      var len = document.querySelectorAll('audio').length;
      for (var i = 0; i < len; i++) {
        if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
          this.scenario.checkDuration = this.scenario.checkDuration && document.querySelectorAll('audio')[i].duration > 0;
        }
      }
      return this.scenario.checkDuration;
    },
    save: function save(showMessage) {
      if (this.checkAudioDuration()) {
        if (this.scenario.id === undefined) {
          this.saveNew(showMessage);
        } else {
          this.update(showMessage);
        }
      } else {
        this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с аудиофайлом нулевой длительности');
      }
    },
    saveNew: function saveNew(showMessage) {
      var _this = this;

      console.log('saving new scenario: ' + JSON.stringify(this.scenario));

      if (!this.scenario.parameters.questionFirstGenerationState) {
        this.scenario.parameters.questionFirstText = '';
      }
      this.scenario.parameters.questionFirstSpeaker = this.tmp.currentSpeakerFirst;
      this.scenario.parameters.questionFirstEmotion = this.tmp.currentEmotionFirst;
      this.scenario.parameters.questionFirstSpeed = this.tmp.currentSpeedFirst;

      if (!this.scenario.parameters.questionSecondYesGenerationState) {
        this.scenario.parameters.questionSecondYesText = '';
      }
      this.scenario.parameters.questionSecondYesSpeaker = this.tmp.currentSpeakerSecondYes;
      this.scenario.parameters.questionSecondYesEmotion = this.tmp.currentEmotionSecondYes;
      this.scenario.parameters.questionSecondYesSpeed = this.tmp.currentSpeedSecondYes;

      if (!this.scenario.parameters.questionSecondYesYesGenerationState) {
        this.scenario.parameters.questionSecondYesYesText = '';
      }
      this.scenario.parameters.questionSecondYesYesSpeaker = this.tmp.currentSpeakerSecondYesYes;
      this.scenario.parameters.questionSecondYesYesEmotion = this.tmp.currentEmotionSecondYesYes;
      this.scenario.parameters.questionSecondYesYesSpeed = this.tmp.currentSpeedSecondYesYes;

      if (!this.scenario.parameters.questionSecondYesNoGenerationState) {
        this.scenario.parameters.questionSecondYesNoText = '';
      }
      this.scenario.parameters.questionSecondYesNoSpeaker = this.tmp.currentSpeakerSecondYesNo;
      this.scenario.parameters.questionSecondYesNoEmotion = this.tmp.currentEmotionSecondYesNo;
      this.scenario.parameters.questionSecondYesNoSpeed = this.tmp.currentSpeedSecondYesNo;

      if (!this.scenario.parameters.questionSecondNoGenerationState) {
        this.scenario.parameters.questionSecondNoText = '';
      }
      this.scenario.parameters.questionSecondNoSpeaker = this.tmp.currentSpeakerSecondNo;
      this.scenario.parameters.questionSecondNoEmotion = this.tmp.currentEmotionSecondNo;
      this.scenario.parameters.questionSecondNoSpeed = this.tmp.currentSpeedSecondNo;

      if (!this.scenario.parameters.questionSecondNoYesGenerationState) {
        this.scenario.parameters.questionSecondNoYesText = '';
      }
      this.scenario.parameters.questionSecondNoYesSpeaker = this.tmp.currentSpeakerSecondNoYes;
      this.scenario.parameters.questionSecondNoYesEmotion = this.tmp.currentEmotionSecondNoYes;
      this.scenario.parameters.questionSecondNoYesSpeed = this.tmp.currentSpeedSecondNoYes;

      if (!this.scenario.parameters.questionSecondNoNoGenerationState) {
        this.scenario.parameters.questionSecondNoNoText = '';
      }
      this.scenario.parameters.questionSecondNoNoSpeaker = this.tmp.currentSpeakerSecondNoNo;
      this.scenario.parameters.questionSecondNoNoEmotion = this.tmp.currentEmotionSecondNoNo;
      this.scenario.parameters.questionSecondNoNoSpeed = this.tmp.currentSpeedSecondNoNo;

      this.scenario.parameters.questionSecondYesYesOptional = true;
      this.scenario.parameters.questionSecondYesNoOptional = true;
      this.scenario.parameters.questionSecondNoYesOptional = true;
      this.scenario.parameters.questionSecondNoNoOptional = true;

      this.$http.post(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.isSaved = true;
        if (showMessage) {
          _this.openNotificationWithType('info', 'Сценарий сохранен');
          _this.$emit('set', _this.scenario);
        }
        _this.scenario = response.data;
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    update: function update(showMessage) {
      var _this2 = this;

      this.scenario.parameters.questionSecondYesYesOptional = true;
      this.scenario.parameters.questionSecondYesNoOptional = true;
      this.scenario.parameters.questionSecondNoYesOptional = true;
      this.scenario.parameters.questionSecondNoNoOptional = true;

      this.scenario.parameters.questionFirstSpeaker = this.tmp.currentSpeakerFirst;
      this.scenario.parameters.questionFirstEmotion = this.tmp.currentEmotionFirst;
      this.scenario.parameters.questionFirstSpeed = this.tmp.currentSpeedFirst;

      this.scenario.parameters.questionSecondYesSpeaker = this.tmp.currentSpeakerSecondYes;
      this.scenario.parameters.questionSecondYesEmotion = this.tmp.currentEmotionSecondYes;
      this.scenario.parameters.questionSecondYesSpeed = this.tmp.currentSpeedSecondYes;

      this.scenario.parameters.questionSecondYesYesSpeaker = this.tmp.currentSpeakerSecondYesYes;
      this.scenario.parameters.questionSecondYesYesEmotion = this.tmp.currentEmotionSecondYesYes;
      this.scenario.parameters.questionSecondYesYesSpeed = this.tmp.currentSpeedSecondYesYes;

      this.scenario.parameters.questionSecondYesNoSpeaker = this.tmp.currentSpeakerSecondYesNo;
      this.scenario.parameters.questionSecondYesNoEmotion = this.tmp.currentEmotionSecondYesNo;
      this.scenario.parameters.questionSecondYesNoSpeed = this.tmp.currentSpeedSecondYesNo;

      this.scenario.parameters.questionSecondNoSpeaker = this.tmp.currentSpeakerSecondNo;
      this.scenario.parameters.questionSecondNoEmotion = this.tmp.currentEmotionSecondNo;
      this.scenario.parameters.questionSecondNoSpeed = this.tmp.currentSpeedSecondNo;

      this.scenario.parameters.questionSecondNoYesSpeaker = this.tmp.currentSpeakerSecondNoYes;
      this.scenario.parameters.questionSecondNoYesEmotion = this.tmp.currentEmotionSecondNoYes;
      this.scenario.parameters.questionSecondNoYesSpeed = this.tmp.currentSpeedSecondNoYes;

      this.scenario.parameters.questionSecondNoNoSpeaker = this.tmp.currentSpeakerSecondNoNo;
      this.scenario.parameters.questionSecondNoNoEmotion = this.tmp.currentEmotionSecondNoNo;
      this.scenario.parameters.questionSecondNoNoSpeed = this.tmp.currentSpeedSecondNoNo;

      console.log('updating scenario: ' + JSON.stringify(this.scenario));
      this.$http.put(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.isSaved = true;
        _this2.scenario = response.data;
        if (showMessage) {
          _this2.openNotificationWithType('info', 'Сценарий сохранен');
        }
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    uploadFile: function uploadFile(buttonId) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий');
      } else {
        document.getElementById(buttonId).click();
      }
    },
    genAudioRequest: function genAudioRequest(maybeId, audioName, text, speaker, emotion, speed) {
      var request = {
        'commonParameters': {
          'client': this.scenario.client,
          'scenario': this.scenario.id,
          'audioName': audioName,
          'text': text
        },

        'vendorSpecificParameters': {
          'speaker': speaker,
          'emotion': emotion,
          'speed': speed
        },

        'vendor': 'yandex'
        // if audio already generated, request must contain id, so backend will overwrite existing audio
      };if (maybeId) {
        request.id = maybeId;
      }
      return request;
    },
    securityHeaders: function securityHeaders() {
      return { 'testH': 'testHV', 'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ' };
    },
    onChangeGenerationState: function onChangeGenerationState(stateId, audioId, generatedAudioId, loadedAudioId, playerId) {
      if (this.scenario.parameters[stateId]) {
        this.scenario.parameters[audioId] = this.tmp[generatedAudioId];
        this.$refs[playerId][0].load();
      } else if (!this.tmp[stateId]) {
        this.scenario.parameters[audioId] = this.tmp[loadedAudioId];
        this.$refs[playerId][0].load();
      }
    },
    genAudio: function genAudio(id, audio, speaker, generatedAudio, text, loadingStatus, name, emotion, speed) {
      var _this3 = this;

      var request = this.genAudioRequest(this.scenario.parameters[id], name, this.scenario.parameters[text], this.tmp[speaker], this.tmp[emotion], this.tmp[speed]);
      var headers = { headers: this.securityHeaders() };
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий');
      } else {
        this.tmp[loadingStatus] = true;
        this.$http.post(audioGeneratorApi, request, headers).then(function (response) {
          _this3.handleGenRequest(id, audio, generatedAudio, response.data);
          _this3.tmp[loadingStatus] = false;
        }).catch(function (error) {
          console.log(error);
          _this3.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
          _this3.tmp[loadingStatus] = false;
        });
      }
    },
    handleGenRequest: function handleGenRequest(id, audio, generatedAudio, data) {
      this.scenario.parameters[id] = data;
      this.tmp[generatedAudio] = '/audios/' + data + '.wav';
      this.scenario.parameters[audio] = this.tmp[generatedAudio];
    },
    loadAudio: function loadAudio(inputId, audioId, audioValue, generationType, audioName, player) {
      var input = document.querySelector('#' + inputId);
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий');
        } else {
          this.handleUploadRequest(audioId, audioValue, generationType, input.files[0], audioName);
          this.$refs[player].load();
        }
      }
    },
    handleUploadRequest: function handleUploadRequest(audioId, audioValue, generationType, audioFile, audioName) {
      var _this4 = this;

      this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile, audioId, audioName, this.scenario.client, this.scenario.id), this.prepareUploadHeaders()).then(function (response) {
        _this4.setAudioValue(audioId, generationType, audioValue, response);
      }).catch(function (error) {
        console.log(error);
        _this4.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
      });
    },
    deleteAudio: function deleteAudio(audioId, audioValue, generationType1, generationType2) {
      var _this5 = this;

      this.$http.delete(audioDeleteApi + '/' + this.scenario.parameters[audioId], { headers: this.prepareUploadHeaders() }).then(function (response) {
        _this5.deleteAudioValue(audioId, generationType1, generationType2, audioValue);
      }).catch(function (error) {
        console.log(error);
        _this5.openNotificationWithType('danger', 'Ошибка удаления аудио. ');
      });
    },
    prepareMultipartAudio: function prepareMultipartAudio(audioFile, audioId, audioName, audioClient, audioScenario) {
      var audioFormData = new FormData();
      audioFormData.append('file', audioFile);
      audioFormData.append('name', audioName);
      audioFormData.append('client', audioClient);
      audioFormData.append('scenario', audioScenario);
      audioFormData.append('id', this.scenario.parameters[audioId]);
      return audioFormData;
    },
    prepareUploadHeaders: function prepareUploadHeaders() {
      return {
        'headers': {
          'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
          'Content-Type': 'multipart/form-data',
          'testH': 'testHV'
        }
      };
    },
    setAudioValue: function setAudioValue(audioId, generationType, audioValue, response) {
      this.scenario.parameters[audioId] = response.data;
      this.tmp[generationType] = '/audios/' + this.scenario.parameters[audioId] + '.wav';
      this.scenario.parameters[audioValue] = this.tmp[generationType];
    },
    deleteAudioValue: function deleteAudioValue(audioId, generationType1, generationType2, audioValue) {
      this.scenario.parameters[audioId] = '';
      this.tmp[generationType1] = '';
      this.tmp[generationType2] = '';
      this.scenario.parameters[audioValue] = '';
    },
    load: function load() {
      var _this6 = this;

      this.$http({
        url: api + '/' + this.name,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('opening scenario ' + JSON.stringify(response.data));
        _this6.isSaved = true;
        _this6.scenario = response.data;
        _this6.question_first_audio = '/audios/' + _this6.scenario.parameters.questionFirstId + '.wav';
        _this6.question_second_yes_audio = '/audios/' + _this6.scenario.parameters.questionSecondYesId + '.wav';
        _this6.question_second_yes_yes_audio = '/audios/' + _this6.scenario.parameters.questionSecondYesYesId + '.wav';
        _this6.question_second_yes_no_audio = '/audios/' + _this6.scenario.parameters.questionSecondYesNoId + '.wav';
        _this6.question_second_no_audio = '/audios/' + _this6.scenario.parameters.questionSecondNoId + '.wav';
        _this6.question_second_no_yes_audio = '/audios/' + _this6.scenario.parameters.questionSecondNoYesId + '.wav';
        _this6.question_second_no_no_audio = '/audios/' + _this6.scenario.parameters.questionSecondNoNoId + '.wav';
      }).catch(function (error) {
        console.log(error);
        _this6.openNotificationWithType('danger', 'Ошибка загрузки сценария. ');
      });
    },
    cancel: function cancel() {
      if (this.$props.campaignid == 0) {
        this.$router.push('/scenarios/');
      } else {
        this.$router.push('/campaigns/' + this.$props.campaignid);
      }
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.currentAudio = null;
    },
    openModal: function openModal(audioId, audioValue, generationType, audioName) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед записью аудио необходимо сохранить сценарий');
      } else {
        this.showModal = true;
        this.currentAudio = new FormData();
        this.currentAudio.append('audioId', audioId);
        this.currentAudio.append('audioValue', audioValue);
        this.currentAudio.append('generationType', generationType);
        this.currentAudio.append('audioName', audioName);
      }
    },
    confirmAction: function confirmAction(value) {
      this.handleUploadRequest(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), this.currentAudio.get('generationType'), value.blob, this.currentAudio.get('audioName'));
      this.closeModal();
    },
    notSaved: function notSaved() {
      this.isSaved = false;
    },
    loadState: function loadState() {
      var _this7 = this;

      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this7.isActive = response.data;
        if (!_this7.isActive) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this7.openNotificationWithType('danger', _this7.$i18n.messages[_this7.$i18n.locale].scenarios.errorToGetUserStatus);
      });
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: this.$i18n.messages[this.$i18n.locale].notifications.notification,
        message: message,
        type: type
      });
    }
  },
  data: function data() {
    return {
      scenario: {
        template: 'yesnotwoquestions',
        parameters: {
          questionFirstId: '',
          questionFirstAudio: '',
          questionFirstText: '',
          questionFirstGenerationState: true,
          questionFirstSpeaker: 'oksana',
          questionFirstEmotion: 'neutral',
          questionFirstSpeed: 1,
          questionFirstKey: '',

          questionFirstRepeatGenerationState: 'text',
          questionFirstRepeatAudio: '',
          questionFirstRepeatText: '',
          questionFirstRepeatSpeaker: 'oksana',
          questionFirstRepeatEmotion: 'neutral',
          questionFirstRepeatSpeed: 1,

          questionSecondYesId: '',
          questionSecondYesAudio: '',
          questionSecondYesText: '',
          questionSecondYesGenerationState: true,
          questionSecondYesSMSText: '',
          questionSecondYesSpeaker: 'oksana',
          questionSecondYesEmotion: 'neutral',
          questionSecondYesSpeed: 1,
          questionSecondYesKey: '',

          questionSecondYesYesId: '',
          questionSecondYesYesAudio: '',
          questionSecondYesYesText: '',
          questionSecondYesYesOptional: true,
          questionSecondYesYesGenerationState: true,
          questionSecondYesYesSMSText: '',
          questionSecondYesYesSpeaker: 'oksana',
          questionSecondYesYesEmotion: 'neutral',
          questionSecondYesYesSpeed: 1,

          questionSecondYesNoId: '',
          questionSecondYesNoAudio: '',
          questionSecondYesNoText: '',
          questionSecondYesNoOptional: true,
          questionSecondYesNoGenerationState: true,
          questionSecondYesNoSpeaker: 'oksana',
          questionSecondYesNoEmotion: 'neutral',
          questionSecondYesNoSpeed: 1,

          questionSecondNoId: '',
          questionSecondNoAudio: '',
          questionSecondNoText: '',
          questionSecondNoGenerationState: true,
          questionSecondNoSpeaker: 'oksana',
          questionSecondNoEmotion: 'neutral',
          questionSecondNoSpeed: 1,
          questionSecondNoKey: '',

          questionSecondNoYesId: '',
          questionSecondNoYesAudio: '',
          questionSecondNoYesText: '',
          questionSecondNoYesOptional: true,
          questionSecondNoYesGenerationState: true,
          questionSecondNoYesSpeaker: 'oksana',
          questionSecondNoYesEmotion: 'neutral',
          questionSecondNoYesSpeed: 1,

          questionSecondNoNoId: '',
          questionSecondNoNoAudio: '',
          questionSecondNoNoText: '',
          questionSecondNoNoOptional: true,
          questionSecondNoNoGenerationState: true,
          questionSecondNoNoSpeaker: 'oksana',
          questionSecondNoNoEmotion: 'neutral',
          questionSecondNoNoSpeed: 1
        },
        checkDuration: true
      },
      tmp: {
        questionFirstGeneratedAudio: '',
        questionFirstLoadedAudio: '',
        questionFirstLoading: false,
        currentSpeakerFirst: 'oksana',
        currentEmotionFirst: 'neutral',
        currentSpeedFirst: 1,

        questionSecondYesGeneratedAudio: '',
        questionSecondYesLoadedAudio: '',
        questionSecondYesLoading: false,
        currentSpeakerSecondYes: 'oksana',
        currentEmotionSecondYes: 'neutral',
        currentSpeedSecondYes: 1,

        questionSecondYesYesGeneratedAudio: '',
        questionSecondYesYesLoadedAudio: '',
        questionSecondYesYesLoading: false,
        currentSpeakerSecondYesYes: 'oksana',
        currentEmotionSecondYesYes: 'neutral',
        currentSpeedSecondYesYes: 1,

        questionSecondYesNoGeneratedAudio: '',
        questionSecondYesNoLoadedAudio: '',
        questionSecondYesNoLoading: false,
        currentSpeakerSecondYesNo: 'oksana',
        currentEmotionSecondYesNo: 'neutral',
        currentSpeedSecondYesNo: 1,

        questionSecondNoGeneratedAudio: '',
        questionSecondNoLoadedAudio: '',
        questionSecondNoLoading: false,
        currentSpeakerSecondNo: 'oksana',
        currentEmotionSecondNo: 'neutral',
        currentSpeedSecondNo: 1,

        questionSecondNoYesGeneratedAudio: '',
        questionSecondNoYesLoadedAudio: '',
        questionSecondNoYesLoading: false,
        currentSpeakerSecondNoYes: 'oksana',
        currentEmotionSecondNoYes: 'neutral',
        currentSpeedSecondNoYes: 1,

        questionSecondNoNoGeneratedAudio: '',
        questionSecondNoNoLoadedAudio: '',
        questionSecondNoNoLoading: false,
        currentSpeakerSecondNoNo: 'oksana',
        currentEmotionSecondNoNo: 'neutral',
        currentSpeedSecondNoNo: 1
      },
      speakerList: [{
        value: 'jane'
      }, {
        value: 'oksana'
      }, {
        value: 'alyss '
      }, {
        value: 'omazh'
      }, {
        value: 'zahar '
      }, {
        value: 'ermil '
      }],
      currentEmotion: 'neutral',
      emotionList: [{
        value: 'good'
      }, {
        value: 'neutral'
      }, {
        value: 'evil'
      }],
      currentSpeed: 1,
      question_first_audio: '',
      question_second_yes_audio: '',
      question_second_yes_yes_audio: '',
      question_second_yes_no_audio: '',
      question_second_no_audio: '',
      question_second_no_yes_audio: '',
      question_second_no_no_audio: '',
      isSaved: false,
      isActive: false,
      showModal: null,
      title: '',
      currentAudio: null
    };
  },

  created: function created() {
    this.loadState();
    if (this.name === undefined) {
      console.log('creating new scenario');
      this.notSaved();
    } else {
      console.log('loading scenario: ' + this.name);
      this.load();
    }
    this.$watch('scenario.parameters.questionFirstAudio', function () {
      this.$refs.onQuestionFirst.load();
    });
    this.$watch('scenario.parameters.questionSecondYesAudio', function () {
      this.$refs.onQuestionSecondYes.load();
    });
    this.$watch('scenario.parameters.questionSecondYesYesAudio', function () {
      this.$refs.onQuestionSecondYesYes.load();
    });
    this.$watch('scenario.parameters.questionSecondYesNoAudio', function () {
      this.$refs.onQuestionSecondYesNo.load();
    });
    this.$watch('scenario.parameters.questionSecondNoAudio', function () {
      this.$refs.onQuestionSecondNo.load();
    });
    this.$watch('scenario.parameters.questionSecondNoYesAudio', function () {
      this.$refs.onQuestionSecondNoYes.load();
    });
    this.$watch('scenario.parameters.questionSecondNoNoAudio', function () {
      this.$refs.onQuestionSecondNoNo.load();
    });

    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }

      if (this.scenario.parameters.questionFirstGenerationState) {
        this.tmp.questionFirstGeneratedAudio = this.scenario.parameters.questionFirstAudio;
      } else {
        this.tmp.questionFirstLoadedAudio = this.scenario.parameters.questionFirstAudio;
      }
      this.tmp.currentSpeakerFirst = this.scenario.parameters.questionFirstSpeaker || this.tmp.currentSpeakerFirst;
      this.tmp.currentEmotionFirst = this.scenario.parameters.questionFirstEmotion || this.tmp.currentEmotionFirst;
      this.tmp.currentSpeedFirst = this.scenario.parameters.questionFirstSpeed || this.tmp.currentSpeedFirst;

      if (this.scenario.parameters.questionSecondYesGenerationState) {
        this.tmp.questionSecondYesGeneratedAudio = this.scenario.parameters.questionSecondYesAudio;
      } else {
        this.tmp.questionSecondYesLoadedAudio = this.scenario.parameters.questionSecondYesAudio;
      }
      this.tmp.currentSpeakerSecondYes = this.scenario.parameters.questionSecondYesSpeaker || this.tmp.currentSpeakerSecondYes;
      this.tmp.currentEmotionSecondYes = this.scenario.parameters.questionSecondYesEmotion || this.tmp.currentEmotionSecondYes;
      this.tmp.currentSpeedSecondYes = this.scenario.parameters.questionSecondYesSpeed || this.tmp.currentSpeedSecondYes;

      if (this.scenario.parameters.questionSecondYesYesGenerationState) {
        this.tmp.questionSecondYesYesGeneratedAudio = this.scenario.parameters.questionSecondYesYesAudio;
      } else {
        this.tmp.questionSecondYesYesLoadedAudio = this.scenario.parameters.questionSecondYesYesAudio;
      }
      this.tmp.currentSpeakerSecondYesYes = this.scenario.parameters.questionSecondYesYesSpeaker || this.tmp.currentSpeakerSecondYesYes;
      this.tmp.currentEmotionSecondYesYes = this.scenario.parameters.questionSecondYesYesEmotion || this.tmp.currentEmotionSecondYesYes;
      this.tmp.currentSpeedSecondYesYes = this.scenario.parameters.questionSecondYesYesSpeed || this.tmp.currentSpeedSecondYesYes;

      if (this.scenario.parameters.questionSecondYesNoGenerationState) {
        this.tmp.questionSecondYesNoGeneratedAudio = this.scenario.parameters.questionSecondYesNoAudio;
      } else {
        this.tmp.questionSecondYesNoLoadedAudio = this.scenario.parameters.questionSecondYesNoAudio;
      }
      this.tmp.currentSpeakerSecondYesNo = this.scenario.parameters.questionSecondYesNoSpeaker || this.tmp.currentSpeakerSecondYesNo;
      this.tmp.currentEmotionSecondYesNo = this.scenario.parameters.questionSecondYesNoEmotion || this.tmp.currentEmotionSecondYesNo;
      this.tmp.currentSpeedSecondYesNo = this.scenario.parameters.questionSecondYesNoSpeed || this.tmp.currentSpeedSecondYesNo;

      if (this.scenario.parameters.questionSecondNoGenerationState) {
        this.tmp.questionSecondNoGeneratedAudio = this.scenario.parameters.questionSecondNoAudio;
      } else {
        this.tmp.questionSecondNoLoadedAudio = this.scenario.parameters.questionSecondNoAudio;
      }
      this.tmp.currentSpeakerSecondNo = this.scenario.parameters.questionSecondNoSpeaker || this.tmp.currentSpeakerSecondNo;
      this.tmp.currentEmotionSecondNo = this.scenario.parameters.questionSecondNoEmotion || this.tmp.currentEmotionSecondNo;
      this.tmp.currentSpeedSecondNo = this.scenario.parameters.questionSecondNoSpeed || this.tmp.currentSpeedSecondNo;

      if (this.scenario.parameters.questionSecondNoYesGenerationState) {
        this.tmp.questionSecondNoYesGeneratedAudio = this.scenario.parameters.questionSecondNoYesAudio;
      } else {
        this.tmp.questionSecondNoYesLoadedAudio = this.scenario.parameters.questionSecondNoYesAudio;
      }
      this.tmp.currentSpeakerSecondNoYes = this.scenario.parameters.questionSecondNoYesSpeaker || this.tmp.currentSpeakerSecondNoYes;
      this.tmp.currentEmotionSecondNoYes = this.scenario.parameters.questionSecondNoYesEmotion || this.tmp.currentEmotionSecondNoYes;
      this.tmp.currentSpeedSecondNoYes = this.scenario.parameters.questionSecondNoYesSpeed || this.tmp.currentSpeedSecondNoYes;

      if (this.scenario.parameters.questionSecondNoNoGenerationState) {
        this.tmp.questionSecondNoNoGeneratedAudio = this.scenario.parameters.questionSecondNoNoAudio;
      } else {
        this.tmp.questionSecondNoNoLoadedAudio = this.scenario.parameters.questionSecondNoNoAudio;
      }
      this.tmp.currentSpeakerSecondNoNo = this.scenario.parameters.questionSecondNoNoSpeaker || this.tmp.currentSpeakerSecondNoNo;
      this.tmp.currentEmotionSecondNoNo = this.scenario.parameters.questionSecondNoNoEmotion || this.tmp.currentEmotionSecondNoNo;
      this.tmp.currentSpeedSecondNoNo = this.scenario.parameters.questionSecondNoNoSpeed || this.tmp.currentSpeedSecondNoNo;
    }
  },
  beforeUpdate: function beforeUpdate() {
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }

      if (this.scenario.parameters.questionFirstGenerationState) {
        this.tmp.questionFirstGeneratedAudio = this.scenario.parameters.questionFirstAudio;
      } else {
        this.tmp.questionFirstLoadedAudio = this.scenario.parameters.questionFirstAudio;
      }

      if (this.scenario.parameters.questionSecondYesGenerationState) {
        this.tmp.questionSecondYesGeneratedAudio = this.scenario.parameters.questionSecondYesAudio;
      } else {
        this.tmp.questionSecondYesLoadedAudio = this.scenario.parameters.questionSecondYesAudio;
      }

      if (this.scenario.parameters.questionSecondYesYesGenerationState) {
        this.tmp.questionSecondYesYesGeneratedAudio = this.scenario.parameters.questionSecondYesYesAudio;
      } else {
        this.tmp.questionSecondYesYesLoadedAudio = this.scenario.parameters.questionSecondYesYesAudio;
      }

      if (this.scenario.parameters.questionSecondYesNoGenerationState) {
        this.tmp.questionSecondYesNoGeneratedAudio = this.scenario.parameters.questionSecondYesNoAudio;
      } else {
        this.tmp.questionSecondYesNoLoadedAudio = this.scenario.parameters.questionSecondYesNoAudio;
      }

      if (this.scenario.parameters.questionSecondNoGenerationState) {
        this.tmp.questionSecondNoGeneratedAudio = this.scenario.parameters.questionSecondNoAudio;
      } else {
        this.tmp.questionSecondNoLoadedAudio = this.scenario.parameters.questionSecondNoAudio;
      }

      if (this.scenario.parameters.questionSecondNoYesGenerationState) {
        this.tmp.questionSecondNoYesGeneratedAudio = this.scenario.parameters.questionSecondNoYesAudio;
      } else {
        this.tmp.questionSecondNoYesLoadedAudio = this.scenario.parameters.questionSecondNoYesAudio;
      }

      if (this.scenario.parameters.questionSecondNoNoGenerationState) {
        this.tmp.questionSecondNoNoGeneratedAudio = this.scenario.parameters.questionSecondNoNoAudio;
      } else {
        this.tmp.questionSecondNoNoLoadedAudio = this.scenario.parameters.questionSecondNoNoAudio;
      }
    }
  }
});

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_message__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalAudio__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ModalAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_slider__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_bulma_slider__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GenerateRepeatAudio',
  props: ['repeatData', 'speakerList', 'emotionList', 'stateName'],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_5__ModalAudio___default.a,
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_message___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a,
    Collapse: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__["Item"],
    Slider: __WEBPACK_IMPORTED_MODULE_6_vue_bulma_slider___default.a
  }
});

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('collapse', [_c('collapse-item', {
    staticClass: "second-layer",
    attrs: {
      "title": "Повтор при ошибки или молчании"
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatData.generationState),
      expression: "repeatData.generationState"
    }],
    attrs: {
      "type": "radio",
      "name": _vm.stateName + '_generateState',
      "value": "url"
    },
    domProps: {
      "checked": _vm._q(_vm.repeatData.generationState, "url")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.repeatData, "generationState", "url")
      }
    }
  }), _vm._v("Url аудио")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatData.generationState),
      expression: "repeatData.generationState"
    }],
    attrs: {
      "type": "radio",
      "name": _vm.stateName + '_generateState',
      "value": "load"
    },
    domProps: {
      "checked": _vm._q(_vm.repeatData.generationState, "load")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.repeatData, "generationState", "load")
      }
    }
  }), _vm._v("Загрузить аудио")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatData.generationState),
      expression: "repeatData.generationState"
    }],
    attrs: {
      "type": "radio",
      "name": _vm.stateName + '_generateState',
      "value": "text"
    },
    domProps: {
      "checked": _vm._q(_vm.repeatData.generationState, "text")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.repeatData, "generationState", "text")
      }
    }
  }), _vm._v("Сгенерировать аудио")])])]), _vm._v(" "), _c('span', [_vm._v("Выбрано: " + _vm._s(_vm.repeatData.generationState))]), _vm._v(" "), (_vm.repeatData.generationState === 'url') ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatData.questionAudio),
      expression: "repeatData.questionAudio"
    }],
    staticClass: "input url audioUrl",
    attrs: {
      "type": "url",
      "placeholder": "Url of audio"
    },
    domProps: {
      "value": (_vm.repeatData.questionAudio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.repeatData, "questionAudio", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.repeatData.questionAudio) ? _c('audio', [_c('source', {
    attrs: {
      "src": _vm.repeatData.questionAudio
    }
  }), _vm._v("\n          Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.repeatData.questionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.repeatData.questionAudio
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.repeatData.generationState === 'text') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatData.questionText),
      expression: "repeatData.questionText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.repeatData.questionText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.repeatData, "questionText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio()
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), _vm._v("\n              Сгенерировать аудио\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatData.currentSpeaker),
      expression: "repeatData.currentSpeaker"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.repeatData, "currentSpeaker", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                  " + _vm._s(speaker.value) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatData.currentEmotion),
      expression: "repeatData.currentEmotion"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.repeatData, "currentEmotion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                  " + _vm._s(emotion.value) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.repeatData.currentSpeed,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.repeatData.currentSpeed = $event
      }
    }
  }), _vm._v("\n          Скорость: " + _vm._s(_vm.repeatData.currentSpeed) + "\n        ")], 1), _vm._v(" "), (_vm.repeatData.questionAudio) ? _c('audio', [_c('source', {
    attrs: {
      "src": _vm.repeatData.questionAudio
    }
  }), _vm._v("\n          Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.repeatData.questionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.repeatData.questionAudio
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.repeatData.generationState === 'load') ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile()
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio()
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    }
  }), _vm._v(" "), (_vm.repeatData.questionAudio) ? _c('audio', [_c('source', {
    attrs: {
      "src": _vm.repeatData.questionAudio
    }
  }), _vm._v("\n              Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.repeatData.questionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.repeatData.questionAudio
    }
  }) : _vm._e()], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.loadedScenario))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Название сценария")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.name),
      expression: "scenario.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название сценария"
    },
    domProps: {
      "value": (_vm.scenario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label control"
  }, [_vm._v("Вопрос 1 "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionFirstKey),
      expression: "scenario.parameters.questionFirstKey"
    }],
    staticClass: "input questionKey",
    attrs: {
      "placeholder": "Введите ключ вопроса"
    },
    domProps: {
      "value": (_vm.scenario.parameters.questionFirstKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionFirstKey", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionFirstGenerationState),
      expression: "scenario.parameters.questionFirstGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionFirstGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionFirstGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionFirstGenerationState', 'questionFirstAudio', 'questionFirstGeneratedAudio', 'questionFirstLoadedAudio', 'onQuestionFirst')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionFirstGenerationState),
      expression: "scenario.parameters.questionFirstGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionFirstGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionFirstGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionFirstGenerationState', 'questionFirstAudio', 'questionFirstGeneratedAudio', 'questionFirstLoadedAudio', 'onQuestionFirst')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionFirstGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionFirstText),
      expression: "scenario.parameters.questionFirstText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionFirstText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionFirstText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionFirstId', 'questionFirstAudio', 'currentSpeakerFirst', 'questionFirstGeneratedAudio', 'questionFirstText', 'questionFirstLoading', 'First question', 'currentEmotionFirst', 'currentSpeedFirst')
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.tmp.questionFirstLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n              Сгенерировать аудио\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerFirst),
      expression: "tmp.currentSpeakerFirst"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerFirst", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                  " + _vm._s(speaker.value) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionFirst),
      expression: "tmp.currentEmotionFirst"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionFirst", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                  " + _vm._s(emotion.value) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedFirst,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedFirst = $event
      }
    }
  }), _vm._v("\n              Скорость: " + _vm._s(_vm.tmp.currentSpeedFirst) + "\n            ")], 1), _vm._v(" "), (_vm.tmp.questionFirstGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionFirst'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionFirstAudio
    }
  }), _vm._v("\n              Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionFirstGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionFirstAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionFirstGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionFirstLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionFirstLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionFirstLoadedAudio', 'questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'First question', 'onQuestionFirst')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'First question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionFirstLoadedAudio) ? _c('audio', {
    ref: 'onQuestionFirst'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionFirstAudio
    }
  }), _vm._v("\n              Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionFirstLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionFirstAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionFirstId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'questionFirstGeneratedAudio')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e(), _vm._v(" "), _c('generate-repeat-audio', {
    attrs: {
      "repeat-data": {
        generationState: _vm.scenario.parameters.questionFirstRepeatGenerationState,
        questionAudio: _vm.scenario.parameters.questionFirstRepeatAudio,
        questionText: _vm.scenario.parameters.questionFirstRepeatText
      },
      "speaker-List": _vm.speakerList,
      "emotion-list": _vm.emotionList,
      "state-name": 'questionFirst'
    }
  })], 1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "second-layer positive-scenario"
  }, [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос 2 / Сообщение (При ответе Да на Вопрос 1)  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesKey),
      expression: "scenario.parameters.questionSecondYesKey"
    }],
    staticClass: "input questionKey",
    attrs: {
      "placeholder": "Введите ключ вопроса"
    },
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondYesKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondYesKey", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesGenerationState),
      expression: "scenario.parameters.questionSecondYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondYesGenerationState', 'questionSecondYesAudio', 'questionSecondYesGeneratedAudio', 'questionSecondYesLoadedAudio', 'onQuestionSecondYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesGenerationState),
      expression: "scenario.parameters.questionSecondYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondYesGenerationState', 'questionSecondYesAudio', 'questionSecondYesGeneratedAudio', 'questionSecondYesLoadedAudio', 'onQuestionSecondYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesText),
      expression: "scenario.parameters.questionSecondYesText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondYesText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondYesText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionSecondYesId', 'questionSecondYesAudio', 'currentSpeakerSecondYes', 'questionSecondYesGeneratedAudio', 'questionSecondYesText', 'questionSecondYesLoading', 'Second yes question', 'currentEmotionSecondYes', 'currentSpeedSecondYes')
      }
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.tmp.questionSecondYesLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondYes),
      expression: "tmp.currentSpeakerSecondYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                     " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondYes),
      expression: "tmp.currentEmotionSecondYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondYes,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondYes = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondYes) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondYesGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondYesLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondYesLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionSecondYesLoadedAudio', 'questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'Second yes question', 'onQuestionSecondYes')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'Second yes question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondYesLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'questionSecondYesGeneratedAudio')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()]), _vm._v(" "), _c('collapse', [_c('collapse-item', {
    staticClass: "positive-scenario",
    attrs: {
      "title": "Отправить СМС",
      "selected": _vm.scenario.parameters.questionSecondYesSMSText != ''
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesSMSText),
      expression: "scenario.parameters.questionSecondYesSMSText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondYesSMSText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondYesSMSText", $event.target.value)
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "block is-flex"
  }, [_c('collapse', [_c('collapse-item', {
    staticClass: "second-layer positive-scenario",
    attrs: {
      "title": "Сообщение при ответе Да на Вопрос 2",
      "selected": _vm.scenario.parameters.questionSecondYesYesId != ''
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesYesGenerationState),
      expression: "scenario.parameters.questionSecondYesYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesYesGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesYesGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondYesYesGenerationState', 'questionSecondYesYesAudio', 'questionSecondYesYesGeneratedAudio', 'questionSecondYesYesLoadedAudio', 'onQuestionSecondYesYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesYesGenerationState),
      expression: "scenario.parameters.questionSecondYesYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesYesGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesYesGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondYesYesGenerationState', 'questionSecondYesYesAudio', 'questionSecondYesYesGeneratedAudio', 'questionSecondYesYesLoadedAudio', 'onQuestionSecondYesYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesYesText),
      expression: "scenario.parameters.questionSecondYesYesText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondYesYesText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondYesYesText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionSecondYesYesId', 'questionSecondYesYesAudio', 'currentSpeakerSecondYesYes', 'questionSecondYesYesGeneratedAudio', 'questionSecondYesYesText', 'questionSecondYesYesLoading', 'Second yes yes question', 'currentEmotionSecondYesYes', 'currentSpeedSecondYesYes')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), (_vm.tmp.questionSecondYesYesLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondYesYes),
      expression: "tmp.currentSpeakerSecondYesYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondYesYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                       " + _vm._s(speaker.value) + "\n                      ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondYesYes),
      expression: "tmp.currentEmotionSecondYesYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondYesYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                        " + _vm._s(emotion.value) + "\n                      ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondYesYes,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondYesYes = $event
      }
    }
  }), _vm._v("\n                    Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondYesYes) + "\n                  ")], 1), _vm._v(" "), (_vm.tmp.questionSecondYesYesGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYesYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesYesAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesYesGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondYesYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondYesYesLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondYesYesLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionSecondYesYesLoadedAudio', 'questionSecondYesYesId', 'questionSecondYesYesAudio', 'questionSecondYesYesLoadedAudio', 'Second yes yes question', 'onQuestionSecondYesYes')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondYesYesId', 'questionSecondYesYesAudio', 'questionSecondYesYesLoadedAudio', 'Second yes yes question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondYesYesLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYesYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesYesAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesYesLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesYesId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionSecondYesYesId', 'questionSecondYesYesAudio', 'questionSecondYesYesLoadedAudio', 'questionSecondYesYesGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()]), _vm._v(" "), _c('collapse', [_c('collapse-item', {
    staticClass: "positive-scenario",
    attrs: {
      "title": "Отправить СМС",
      "selected": _vm.scenario.parameters.questionSecondYesYesSMSText != ''
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesYesSMSText),
      expression: "scenario.parameters.questionSecondYesYesSMSText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondYesYesSMSText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondYesYesSMSText", $event.target.value)
      }
    }
  })])])], 1)], 1), _vm._v(" "), _c('collapse-item', {
    staticClass: "second-layer negative-scenario",
    attrs: {
      "title": "Сообщение при ответе Нет на Вопрос 2",
      "selected": _vm.scenario.parameters.questionSecondYesNoId != ''
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesNoGenerationState),
      expression: "scenario.parameters.questionSecondYesNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesNoGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesNoGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondYesNoGenerationState', 'questionSecondYesNoAudio', 'questionSecondYesNoGeneratedAudio', 'questionSecondYesNoLoadedAudio', 'onQuestionSecondYesNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesNoGenerationState),
      expression: "scenario.parameters.questionSecondYesNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesNoGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesNoGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondYesNoGenerationState', 'questionSecondYesNoAudio', 'questionSecondYesNoGeneratedAudio', 'questionSecondYesNoLoadedAudio', 'onQuestionSecondYesNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesNoText),
      expression: "scenario.parameters.questionSecondYesNoText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondYesNoText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondYesNoText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionSecondYesNoId', 'questionSecondYesNoAudio', 'currentSpeakerSecondYesNo', 'questionSecondYesNoGeneratedAudio', 'questionSecondYesNoText', 'questionSecondYesNoLoading', 'Second yes no question', 'currentEmotionSecondYesNo', 'currentSpeedSecondYesNo')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), (_vm.tmp.questionSecondYesNoLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondYesNo),
      expression: "tmp.currentSpeakerSecondYesNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondYesNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondYesNo),
      expression: "tmp.currentEmotionSecondYesNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondYesNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondYesNo,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondYesNo = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondYesNo) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondYesNoGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYesNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesNoAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesNoGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondYesNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondYesNoLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondYesNoLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionSecondYesNoLoadedAudio', 'questionSecondYesNoId', 'questionSecondYesNoAudio', 'questionSecondYesNoLoadedAudio', 'Second yes no question', 'onQuestionSecondYesNo')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondYesNoId', 'questionSecondYesNoAudio', 'questionSecondYesNoLoadedAudio', 'Second yes no question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondYesNoLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYesNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesNoAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesNoLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesNoId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionSecondYesNoId', 'questionSecondYesNoAudio', 'questionSecondYesNoLoadedAudio', 'questionSecondYesNoGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()])])], 1)], 1)], 1)]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding": "10px"
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "second-layer negative-scenario"
  }, [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос 2 / Сообщение (При ответе Нет на Вопрос 1) "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoKey),
      expression: "scenario.parameters.questionSecondNoKey"
    }],
    staticClass: "input questionKey",
    attrs: {
      "placeholder": "Введите ключ вопроса"
    },
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondNoKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondNoKey", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoGenerationState),
      expression: "scenario.parameters.questionSecondNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondNoGenerationState', 'questionSecondNoAudio', 'questionSecondNoGeneratedAudio', 'questionSecondNoLoadedAudio', 'onQuestionSecondNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoGenerationState),
      expression: "scenario.parameters.questionSecondNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondNoGenerationState', 'questionSecondNoAudio', 'questionSecondNoGeneratedAudio', 'questionSecondNoLoadedAudio', 'onQuestionSecondNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoText),
      expression: "scenario.parameters.questionSecondNoText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondNoText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondNoText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionSecondNoId', 'questionSecondNoAudio', 'currentSpeakerSecondNo', 'questionSecondNoGeneratedAudio', 'questionSecondNoText', 'questionSecondNoLoading', 'Second no question', 'currentEmotionSecondNo', 'currentSpeedSecondNo')
      }
    }
  }, [_vm._m(4), _vm._v(" "), (_vm.tmp.questionSecondNoLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondNo),
      expression: "tmp.currentSpeakerSecondNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondNo),
      expression: "tmp.currentEmotionSecondNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondNo,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondNo = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondNo) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondNoGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondNoLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondNoLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionSecondNoLoadedAudio', 'questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'Second no question', 'onQuestionSecondNo')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'Second no question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondNoLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'questionSecondNoGeneratedAudio')
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block is-flex"
  }, [_c('collapse', [_c('collapse-item', {
    staticClass: "second-layer positive-scenario",
    attrs: {
      "title": "Сообщение при ответе Да на Вопрос 2",
      "selected": _vm.scenario.parameters.questionSecondNoYesId != ''
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoYesGenerationState),
      expression: "scenario.parameters.questionSecondNoYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoYesGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoYesGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondNoYesGenerationState', 'questionSecondNoYesAudio', 'questionSecondNoYesGeneratedAudio', 'questionSecondNoYesLoadedAudio', 'onQuestionSecondNoYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoYesGenerationState),
      expression: "scenario.parameters.questionSecondNoYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoYesGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoYesGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondNoYesGenerationState', 'questionSecondNoYesAudio', 'questionSecondNoYesGeneratedAudio', 'questionSecondNoYesLoadedAudio', 'onQuestionSecondNoYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoYesText),
      expression: "scenario.parameters.questionSecondNoYesText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondNoYesText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondNoYesText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionSecondNoYesId', 'questionSecondNoYesAudio', 'currentSpeakerSecondNoYes', 'questionSecondNoYesGeneratedAudio', 'questionSecondNoYesText', 'questionSecondNoYesLoading', 'Second no yes question', 'currentEmotionSecondNoYes', 'currentSpeedSecondNoYes')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), (_vm.tmp.questionSecondNoYesLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondNoYes),
      expression: "tmp.currentSpeakerSecondNoYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondNoYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondNoYes),
      expression: "tmp.currentEmotionSecondNoYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondNoYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondNoYes,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondNoYes = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondNoYes) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondNoYesGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNoYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoYesAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoYesGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondNoYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondNoYesLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondNoYesLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionSecondNoYesLoadedAudio', 'questionSecondNoYesId', 'questionSecondNoYesAudio', 'questionSecondNoYesLoadedAudio', 'Second no yes question', 'onQuestionSecondNoYes')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondNoYesId', 'questionSecondNoYesAudio', 'questionSecondNoYesLoadedAudio', 'Second no yes question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondNoYesLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNoYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoYesAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoYesLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoYesId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionSecondNoYesId', 'questionSecondNoYesAudio', 'questionSecondNoYesLoadedAudio', 'questionSecondNoYesGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()])]), _vm._v(" "), _c('collapse-item', {
    staticClass: "second-layer negative-scenario",
    attrs: {
      "title": "Сообщение при ответе Нет на Вопрос 2",
      "selected": _vm.scenario.parameters.questionSecondNoNoId != ''
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoNoGenerationState),
      expression: "scenario.parameters.questionSecondNoNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoNoGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoNoGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondNoNoGenerationState', 'questionSecondNoNoAudio', 'questionSecondNoNoGeneratedAudio', 'questionSecondNoNoLoadedAudio', 'onQuestionSecondNoNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoNoGenerationState),
      expression: "scenario.parameters.questionSecondNoNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoNoGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoNoGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondNoNoGenerationState', 'questionSecondNoNoAudio', 'questionSecondNoNoGeneratedAudio', 'questionSecondNoNoLoadedAudio', 'onQuestionSecondNoNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoNoText),
      expression: "scenario.parameters.questionSecondNoNoText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondNoNoText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondNoNoText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionSecondNoNoId', 'questionSecondNoNoAudio', 'currentSpeakerSecondNoNo', 'questionSecondNoNoGeneratedAudio', 'questionSecondNoNoText', 'questionSecondNoNoLoading', 'Second no no question', 'currentEmotionSecondNoNo', 'currentSpeedSecondNoNo')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), (_vm.tmp.questionSecondNoNoLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondNoNo),
      expression: "tmp.currentSpeakerSecondNoNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondNoNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondNoNo),
      expression: "tmp.currentEmotionSecondNoNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondNoNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondNoNo,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondNoNo = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondNoNo) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondNoNoGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNoNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoNoAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoNoGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondNoNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondNoNoLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondNoNoLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionSecondNoNoLoadedAudio', 'questionSecondNoNoId', 'questionSecondNoNoAudio', 'questionSecondNoNoLoadedAudio', 'Second no no question', 'onQuestionSecondNoNo')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondNoNoId', 'questionSecondNoNoAudio', 'questionSecondNoNoLoadedAudio', 'Second no no question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondNoNoLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNoNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoNoAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoNoLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoNoId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionSecondNoNoId', 'questionSecondNoNoAudio', 'questionSecondNoNoLoadedAudio', 'questionSecondNoNoGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()])])], 1)], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(6), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), _vm._m(8), _vm._v(" "), (_vm.scenario.isReady) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(9), _vm._v(" "), _c('span', [_vm._v("Подготовлен")])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(10), _vm._v(" "), _c('span', [_vm._v("Не подготовлен")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-primary"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })]), _vm._v(" "), _c('span', [_vm._v("Рассчитать стоимость")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
}]}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_message__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalAudio__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ModalAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var NotificationComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var MessageComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_6_vue_bulma_message___default.a);
var openMessage = function openMessage() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  };

  return new MessageComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var api = '/api/scenarios';
var audioGeneratorApi = '/audios/generate';
var audioUploadApi = '/audios/save';
var audioDeleteApi = '/audios';
var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name', 'campaignid'],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_7__ModalAudio___default.a,
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_6_vue_bulma_message___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a,
    Collapse: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse__["Item"],
    Slider: __WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider___default.a
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['loadedScenario', 'loggedId', 'loggedUser', 'authenticationToken'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    addNewParameter: function addNewParameter() {
      this.scenario.parameters.dynamicQuestions.push({ generationState: true, text: '', audio: '', id: undefined, key: Math.floor(Math.random() * 99999999) + 1 });
      this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: '', dynamicLoadedAudio: '', dynamicLoading: false, dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
    },
    deleteParameter: function deleteParameter(i) {
      this.scenario.parameters.dynamicQuestions.splice(i, 1);
      this.tmp.dynamicTmp.splice(i, 1);
    },

    changeRoute: function changeRoute(e) {
      this.$router.push({ path: '/scenarios' + e.target.value });
    },
    checkAudioDuration: function checkAudioDuration() {
      this.scenario.checkDuration = true;
      var len = document.querySelectorAll('audio').length;
      for (var i = 0; i < len; i++) {
        if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
          this.scenario.checkDuration = this.scenario.checkDuration && document.querySelectorAll('audio')[i].duration > 0;
        }
      }
      return this.scenario.checkDuration;
    },
    save: function save(showMessage) {
      if (this.checkAudioDuration()) {
        if (this.scenario.id === undefined) {
          this.saveNew(showMessage);
        } else {
          this.update(showMessage);
        }
      } else {
        this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с аудиофайлом нулевой длительности');
      }
    },
    saveNew: function saveNew(showMessage) {
      var _this = this;

      console.log('saving new scenario: ' + JSON.stringify(this.scenario));
      if (!this.scenario.parameters.questionFirstGenerationState) {
        this.scenario.parameters.questionFirstText = '';
      }
      if (!this.scenario.parameters.questionSecondGenerationState) {
        this.scenario.parameters.questionSecondText = '';
      }
      if (!this.scenario.parameters.questionSecondYesGenerationState) {
        this.scenario.parameters.questionSecondYesText = '';
      }
      if (!this.scenario.parameters.questionSecondNoGenerationState) {
        this.scenario.parameters.questionSecondNoText = '';
      }
      this.scenario.parameters.dynamicQuestions.forEach(function (dynamicQuestion) {
        if (!dynamicQuestion.generationState) {
          dynamicQuestion.text = '';
        }
      });
      this.scenario.parameters.questionSecondYesOptional = true;
      this.scenario.parameters.questionSecondNoOptional = true;
      this.$http.post(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.isSaved = true;
        if (showMessage) {
          _this.openNotificationWithType('info', 'Сценарий сохранен');
          _this.$emit('set', _this.scenario);
        }
        _this.scenario = response.data;
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    update: function update(showMessage) {
      var _this2 = this;

      this.scenario.parameters.questionSecondYesOptional = true;
      this.scenario.parameters.questionSecondNoOptional = true;
      console.log('updating scenario: ' + JSON.stringify(this.scenario));
      this.$http.put(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.isSaved = true;
        _this2.scenario = response.data;
        if (showMessage) {
          _this2.openNotificationWithType('info', 'Сценарий сохранен');
        }
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    uploadFile: function uploadFile(buttonId) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий');
      } else {
        document.getElementById(buttonId).click();
      }
    },
    genAudioRequest: function genAudioRequest(maybeId, audioName, text, speaker, emotion, speed) {
      var request = {
        'commonParameters': {
          'client': this.scenario.client,
          'scenario': this.scenario.id,
          'audioName': audioName,
          'text': text
        },

        'vendorSpecificParameters': {
          'speaker': speaker,
          'emotion': emotion,
          'speed': speed
        },

        'vendor': 'yandex'

        // if audio already generated, request must contain id, so backend will overwrite existing audio
      };if (maybeId) {
        request.id = maybeId;
      }
      return request;
    },
    securityHeaders: function securityHeaders() {
      return { 'testH': 'testHV', 'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ' };
    },
    onChangeGenerationState: function onChangeGenerationState(state, index, key) {
      var parameter = this.scenario.parameters.dynamicQuestions[index];
      if (state) {
        parameter.audio = this.tmp.dynamicTmp[index].dynamicGeneratedAudio;
        this.$refs['audio-' + key][0].load();
      } else {
        parameter.audio = this.tmp.dynamicTmp[index].dynamicLoadedAudio;
        this.$refs['audio-' + key][0].load();
      }
    },
    loadAudio: function loadAudio(index, key) {
      var input = this.$refs['load-audio-' + key][0];
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий');
        } else {
          this.handleUploadRequest(index, key, input.files[0]);
        }
      }
    },
    handleUploadRequest: function handleUploadRequest(index, key, audioFile) {
      var _this3 = this;

      this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile), this.prepareUploadHeaders()).then(function (response) {
        _this3.setAudioValue(index, key, response);
      }).catch(function (error) {
        console.log(error);
        _this3.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
      });
    },
    deleteAudio: function deleteAudio(index) {
      var _this4 = this;

      this.$http.delete(audioDeleteApi + '/' + this.scenario.parameters.dynamicQuestions[index].id, { headers: this.prepareUploadHeaders() }).then(function (response) {
        _this4.deleteAudioValue(index);
      }).catch(function (error) {
        console.log(error);
        _this4.openNotificationWithType('danger', 'Ошибка удаления аудио. ');
      });
    },
    setAudioValue: function setAudioValue(index, key, response) {
      this.scenario.parameters.dynamicQuestions[index].id = response.data;
      this.tmp.dynamicTmp[index].dynamicLoadedAudio = '/audios/' + response.data + '.wav';
      this.scenario.parameters.dynamicQuestions[index].audio = this.tmp.dynamicTmp[index].dynamicLoadedAudio;
      this.$refs['audio-' + key][0].load();
    },
    deleteAudioValue: function deleteAudioValue(index) {
      this.scenario.parameters.dynamicQuestions[index].id = '';
      this.tmp.dynamicTmp[index].dynamicLoadedAudio = '';
      this.tmp.dynamicTmp[index].dynamicGeneratedAudio = '';
      this.scenario.parameters.dynamicQuestions[index].audio = '';
    },
    genAudio: function genAudio(index) {
      var _this5 = this;

      var parameter = this.scenario.parameters.dynamicQuestions[index];
      var text = parameter.text,
          id = parameter.id;

      var requestData = this.genAudioRequest(id, 'audioname' + (index + 1), text, this.tmp.dynamicTmp[index].dynamicSpeaker, this.tmp.dynamicTmp[index].dynamicEmotion, this.tmp.dynamicTmp[index].dynamicSpeed);
      var config = { headers: this.securityHeaders() };
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий');
      } else {
        this.tmp.dynamicTmp[index].dynamicLoading = true;
        this.$http.post(audioGeneratorApi, requestData, config).then(function (response) {
          _this5.handleGenRequest(parameter, index, response.data);
          _this5.tmp.dynamicTmp[index].dynamicLoading = false;
          _this5.$refs['audio-' + parameter.key][0].load();
        }).catch(function (error) {
          console.log(error);
          _this5.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
          _this5.tmp.dynamicTmp[index].dynamicLoading = false;
        });
      }
    },
    handleGenRequest: function handleGenRequest(parameter, index, data) {
      parameter.id = data;
      this.tmp.dynamicTmp[index].dynamicGeneratedAudio = '/audios/' + data + '.wav';
      parameter.audio = this.tmp.dynamicTmp[index].dynamicGeneratedAudio;
    },
    onChangeGenerationStateStatic: function onChangeGenerationStateStatic(stateId, audioId, generatedAudioId, loadedAudioId, playerId) {
      if (this.scenario.parameters[stateId]) {
        this.scenario.parameters[audioId] = this.tmp[generatedAudioId];
        this.$refs[playerId][0].load();
      } else {
        this.scenario.parameters[audioId] = this.tmp[loadedAudioId];
        this.$refs[playerId][0].load();
      }
    },
    genAudioStatic: function genAudioStatic(id, audio, speaker, generatedAudio, text, loadingStatus, name, emotion, speed) {
      var _this6 = this;

      var request = this.genAudioRequest(this.scenario.parameters[id], name, this.scenario.parameters[text], this.tmp[speaker], this.tmp[emotion], this.tmp[speed]);
      var headers = { headers: this.securityHeaders() };
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий');
      } else {
        this.tmp[loadingStatus] = true;
        this.$http.post(audioGeneratorApi, request, headers).then(function (response) {
          _this6.handleGenRequestStatic(id, audio, generatedAudio, response.data);
          _this6.tmp[loadingStatus] = false;
        }).catch(function (error) {
          console.log(error);
          _this6.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
          _this6.tmp[loadingStatus] = false;
        });
      }
    },
    handleGenRequestStatic: function handleGenRequestStatic(id, audio, generatedAudio, data) {
      this.scenario.parameters[id] = data;
      this.tmp[generatedAudio] = '/audios/' + data + '.wav';
      this.scenario.parameters[audio] = this.tmp[generatedAudio];
    },
    loadAudioStatic: function loadAudioStatic(inputId, audioId, audioValue, generationType, audioName, player) {
      var input = document.querySelector('#' + inputId);
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий');
        } else {
          this.handleUploadRequestStatic(audioId, audioValue, generationType, input.files[0], audioName);
          this.$refs[player].load();
        }
      }
    },
    handleUploadRequestStatic: function handleUploadRequestStatic(audioId, audioValue, generationType, audioFile, audioName) {
      var _this7 = this;

      this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile, audioName, this.scenario.client, this.scenario.id), this.prepareUploadHeaders()).then(function (response) {
        _this7.setAudioValueStatic(audioId, generationType, audioValue, response);
      }).catch(function (error) {
        console.log(error);
        _this7.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
      });
    },
    deleteAudioStatic: function deleteAudioStatic(audioId, audioValue, generationType1, generationType2) {
      var _this8 = this;

      this.$http.delete(audioDeleteApi + '/' + this.scenario.parameters[audioId], { headers: this.prepareUploadHeaders() }).then(function (response) {
        _this8.deleteAudioValueStatic(audioId, generationType1, generationType2, audioValue);
      }).catch(function (error) {
        console.log(error);
        _this8.openNotificationWithType('danger', 'Ошибка удаления аудио. ');
      });
    },
    prepareMultipartAudio: function prepareMultipartAudio(audioFile, audioName, audioClient, audioScenario) {
      var audioFormData = new FormData();
      audioFormData.append('file', audioFile);
      audioFormData.append('name', audioName);
      audioFormData.append('client', audioClient);
      audioFormData.append('scenario', audioScenario);
      return audioFormData;
    },
    prepareUploadHeaders: function prepareUploadHeaders() {
      return {
        'headers': {
          'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
          'Content-Type': 'multipart/form-data',
          'testH': 'testHV'
        }
      };
    },
    setAudioValueStatic: function setAudioValueStatic(audioId, generationType, audioValue, response) {
      this.scenario.parameters[audioId] = response.data;
      this.tmp[generationType] = '/audios/' + this.scenario.parameters[audioId] + '.wav';
      this.scenario.parameters[audioValue] = this.tmp[generationType];
    },
    deleteAudioValueStatic: function deleteAudioValueStatic(audioId, generationType1, generationType2, audioValue) {
      this.scenario.parameters[audioId] = '';
      this.tmp[generationType1] = '';
      this.tmp[generationType2] = '';
      this.scenario.parameters[audioValue] = '';
    },
    load: function load() {
      var _this9 = this;

      this.$http({
        url: api + '/' + this.name,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('opening scenario ' + JSON.stringify(response.data));
        _this9.isSaved = true;
        _this9.scenario = response.data;
        _this9.question_first_audio = '/audios/' + _this9.scenario.parameters.questionFirstId + '.wav';
        _this9.question_second_audio = '/audios/' + _this9.scenario.parameters.questionSecondId + '.wav';
        _this9.question_second_yes_audio = '/audios/' + _this9.scenario.parameters.questionSecondYesId + '.wav';
        _this9.question_second_no_audio = '/audios/' + _this9.scenario.parameters.questionSecondNoId + '.wav';
      }).catch(function (error) {
        console.log(error);
        _this9.openNotificationWithType('danger', 'Ошибка загрузки сценария. ');
      });
    },
    cancel: function cancel() {
      if (this.$props.campaignid == 0) {
        this.$router.push('/scenarios/');
      } else {
        this.$router.push('/campaigns/' + this.$props.campaignid);
      }
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.currentAudio = null;
    },
    openModal: function openModal(audioId, audioValue, generationType, audioName, isStatic) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед записью аудио необходимо сохранить сценарий');
      } else {
        this.showModal = true;
        this.currentAudio = new FormData();
        this.currentAudio.append('audioId', audioId);
        this.currentAudio.append('audioValue', audioValue);
        this.currentAudio.append('generationType', generationType);
        this.currentAudio.append('audioName', audioName);
        this.currentAudio.append('isStatic', isStatic);
      }
    },
    confirmAction: function confirmAction(value) {
      if (this.currentAudio.get('isStatic') == 'true') {
        this.handleUploadRequestStatic(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), this.currentAudio.get('generationType'), value.blob, this.currentAudio.get('audioName'));
        // this.$refs['questionPlayer'].load()
      } else {
        this.handleUploadRequest(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), value.blob);
        // var key = this.currentAudio.get('audioValue')
        // this.$refs[`audio-${key}`][0].load()
      }
      this.closeModal();
    },
    notSaved: function notSaved() {
      this.isSaved = false;
    },
    loadState: function loadState() {
      var _this10 = this;

      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this10.isActive = response.data;
        if (!_this10.isActive) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this10.openNotificationWithType('danger', _this10.$i18n.messages[_this10.$i18n.locale].scenarios.errorToGetUserStatus);
      });
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: this.$i18n.messages[this.$i18n.locale].notifications.notification,
        message: message,
        type: type
      });
    },
    clickLoadAudio: function clickLoadAudio(parameterkey) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий');
      } else {
        this.$refs['load-audio-' + parameterkey][0].click();
      }
    }
  },
  data: function data() {
    return {
      scenario: {
        template: 'poll',
        parameters: {
          questionFirstId: '',
          questionFirstAudio: '',
          questionFirstText: '',
          questionFirstGenerationState: true,

          questionSecondId: '',
          questionSecondAudio: '',
          questionSecondText: '',
          questionSecondGenerationState: true,

          questionSecondYesId: '',
          questionSecondYesAudio: '',
          questionSecondYesText: '',
          questionSecondYesOptional: true,
          questionSecondYesGenerationState: true,

          questionSecondNoId: '',
          questionSecondNoAudio: '',
          questionSecondNoText: '',
          questionSecondNoOptional: true,
          questionSecondNoGenerationState: true,

          dynamicQuestions: [{
            generationState: true,
            text: '',
            audio: '',
            id: undefined,
            key: 0
          }]
        },
        checkDuration: true
      },
      tmp: {
        questionFirstGeneratedAudio: '',
        questionFirstLoadedAudio: '',
        questionFirstLoading: false,
        currentSpeakerFirst: 'oksana',
        currentEmotionFirst: 'neutral',
        currentSpeedFirst: 1,

        questionSecondGeneratedAudio: '',
        questionSecondLoadedAudio: '',
        questionSecondLoading: false,
        currentSpeakerSecond: 'oksana',
        currentEmotionSecond: 'neutral',
        currentSpeedSecond: 1,

        questionSecondYesGeneratedAudio: '',
        questionSecondYesLoadedAudio: '',
        questionSecondYesLoading: false,
        currentSpeakerSecondYes: 'oksana',
        currentEmotionSecondYes: 'neutral',
        currentSpeedSecondYes: 1,

        questionSecondNoGeneratedAudio: '',
        questionSecondNoLoadedAudio: '',
        questionSecondNoLoading: false,
        currentSpeakerSecondNo: 'oksana',
        currentEmotionSecondNo: 'neutral',
        currentSpeedSecondNo: 1,

        dynamicTmp: [{
          dynamicGeneratedAudio: '',
          dynamicLoadedAudio: '',
          dynamicLoading: false,
          dynamicSpeaker: 'oksana',
          dynamicEmotion: 'neutral',
          dynamicSpeed: 1
        }]
      },
      speakerList: [{
        value: 'jane'
      }, {
        value: 'oksana'
      }, {
        value: 'alyss '
      }, {
        value: 'omazh'
      }, {
        value: 'zahar '
      }, {
        value: 'ermil '
      }],
      currentEmotion: 'neutral',
      emotionList: [{
        value: 'good'
      }, {
        value: 'neutral'
      }, {
        value: 'evil'
      }],
      currentSpeed: 1,
      question_first_audio: '',
      question_second_audio: '',
      question_second_yes_audio: '',
      question_second_no_audio: '',
      isSaved: false,
      isActive: false,
      showModal: null,
      title: '',
      currentAudio: null
    };
  },

  created: function created() {
    this.loadState();
    if (this.name === undefined) {
      console.log('creating new scenario');
      this.notSaved();
    } else {
      console.log('loading scenario: ' + this.name);
      this.load();
    }
    this.$watch('scenario.parameters.questionFirstAudio', function () {
      this.$refs.onQuestionFirst.load();
    });
    this.$watch('scenario.parameters.questionSecondAudio', function () {
      this.$refs.onQuestionSecond.load();
    });
    this.$watch('scenario.parameters.questionSecondYesAudio', function () {
      this.$refs.onQuestionSecondYes.load();
    });
    this.$watch('scenario.parameters.questionSecondNoAudio', function () {
      this.$refs.onQuestionSecondNo.load();
    });
    // for (let dynamicIndex = 0; dynamicIndex < this.scenario.parameters.dynamicQuestions.length; dynamicIndex++) {
    //  this.$watch('scenario.parameters.dynamicQuestions[dynamicIndex].audio', function () {
    //    const key = scenario.parameters.dynamicQuestions[dynamicIndex].key
    //    this.$refs[`audio-${key}`][0].load()
    //  })
    // }
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }
      if (this.scenario.parameters.questionFirstGenerationState) {
        this.tmp.questionFirstGeneratedAudio = this.scenario.parameters.questionFirstAudio;
      } else {
        this.tmp.questionFirstLoadedAudio = this.scenario.parameters.questionFirstAudio;
      }
      if (this.scenario.parameters.questionSecondGenerationState) {
        this.tmp.questionSecondGeneratedAudio = this.scenario.parameters.questionSecondAudio;
      } else {
        this.tmp.questionSecondLoadedAudio = this.scenario.parameters.questionSecondAudio;
      }
      if (this.scenario.parameters.questionSecondYesGenerationState) {
        this.tmp.questionSecondYesGeneratedAudio = this.scenario.parameters.questionSecondYesAudio;
      } else {
        this.tmp.questionSecondYesLoadedAudio = this.scenario.parameters.questionSecondYesAudio;
      }
      if (this.scenario.parameters.questionSecondNoGenerationState) {
        this.tmp.questionSecondNoGeneratedAudio = this.scenario.parameters.questionSecondNoAudio;
      } else {
        this.tmp.questionSecondNoLoadedAudio = this.scenario.parameters.questionSecondNoAudio;
      }
      for (var dynamicIndex = 0; dynamicIndex < this.scenario.parameters.dynamicQuestions.length; dynamicIndex++) {
        var audio = this.scenario.parameters.dynamicQuestions[dynamicIndex].audio;
        if (dynamicIndex != 0) {
          if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
            this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: audio, dynamicLoadedAudio: '', dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
          } else {
            this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: '', dynamicLoadedAudio: audio, dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
          }
        } else {
          if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
            this.tmp.dynamicTmp[dynamicIndex].dynamicGeneratedAudio = audio;
          } else {
            this.tmp.dynamicTmp[dynamicIndex].dynamicLoadedAudio = audio;
          }
        }
      }
    }
  },
  beforeUpdate: function beforeUpdate() {
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }
      if (this.scenario.parameters.questionFirstGenerationState) {
        this.tmp.questionFirstGeneratedAudio = this.scenario.parameters.questionFirstAudio;
      } else {
        this.tmp.questionFirstLoadedAudio = this.scenario.parameters.questionFirstAudio;
      }
      if (this.scenario.parameters.questionSecondGenerationState) {
        this.tmp.questionSecondGeneratedAudio = this.scenario.parameters.questionSecondAudio;
      } else {
        this.tmp.questionSecondLoadedAudio = this.scenario.parameters.questionSecondAudio;
      }
      if (this.scenario.parameters.questionSecondYesGenerationState) {
        this.tmp.questionSecondYesGeneratedAudio = this.scenario.parameters.questionSecondYesAudio;
      } else {
        this.tmp.questionSecondYesLoadedAudio = this.scenario.parameters.questionSecondYesAudio;
      }
      if (this.scenario.parameters.questionSecondNoGenerationState) {
        this.tmp.questionSecondNoGeneratedAudio = this.scenario.parameters.questionSecondNoAudio;
      } else {
        this.tmp.questionSecondNoLoadedAudio = this.scenario.parameters.questionSecondNoAudio;
      }
      for (var dynamicIndex = 0; dynamicIndex < this.scenario.parameters.dynamicQuestions.length; dynamicIndex++) {
        var audio = this.scenario.parameters.dynamicQuestions[dynamicIndex].audio;
        if (dynamicIndex != 0) {
          if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
            this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: audio, dynamicLoadedAudio: '', dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
          } else {
            this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: '', dynamicLoadedAudio: audio, dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
          }
        } else {
          if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
            this.tmp.dynamicTmp[dynamicIndex].dynamicGeneratedAudio = audio;
          } else {
            this.tmp.dynamicTmp[dynamicIndex].dynamicLoadedAudio = audio;
          }
        }
      }
    }
  }
});

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.loadedScenario))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Название сценария")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.name),
      expression: "scenario.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название сценария"
    },
    domProps: {
      "value": (_vm.scenario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос 1")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionFirstGenerationState),
      expression: "scenario.parameters.questionFirstGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionFirstGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionFirstGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionFirstGenerationState', 'questionFirstAudio', 'questionFirstGeneratedAudio', 'questionFirstLoadedAudio', 'onQuestionFirst')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionFirstGenerationState),
      expression: "scenario.parameters.questionFirstGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionFirstGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionFirstGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionFirstGenerationState', 'questionFirstAudio', 'questionFirstGeneratedAudio', 'questionFirstLoadedAudio', 'onQuestionFirst')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionFirstGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionFirstText),
      expression: "scenario.parameters.questionFirstText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionFirstText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionFirstText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudioStatic('questionFirstId', 'questionFirstAudio', 'currentSpeakerFirst', 'questionFirstGeneratedAudio', 'questionFirstText', 'questionFirstLoading', 'First question', 'currentEmotionFirst', 'currentSpeedFirst')
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.tmp.questionFirstLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                Сгенерировать аудио\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerFirst),
      expression: "tmp.currentSpeakerFirst"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerFirst", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                    " + _vm._s(speaker.value) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionFirst),
      expression: "tmp.currentEmotionFirst"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionFirst", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                    " + _vm._s(emotion.value) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedFirst,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedFirst = $event
      }
    }
  }), _vm._v("\n                Скорость: " + _vm._s(_vm.tmp.currentSpeedFirst) + "\n              ")], 1), _vm._v(" "), (_vm.tmp.questionFirstGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionFirst'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionFirstAudio
    }
  }), _vm._v("\n                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionFirstGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionFirstAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionFirstId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'questionFirstGeneratedAudio')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionFirstGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionFirstLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    ref: "questionFirstLoadedAudio",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionFirstLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudioStatic('questionFirstLoadedAudio', 'questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'First question', 'onQuestionFirst')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'First question', true)
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionFirstLoadedAudio) ? _c('audio', {
    ref: 'onQuestionFirst'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionFirstAudio
    }
  }), _vm._v("\n                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionFirstLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionFirstAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionFirstId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'questionFirstGeneratedAudio')
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e()])]), _vm._v(" "), _c('span', {
    staticClass: "second-layer positive-scenario add-button-wrapper"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Опрос (При ответе Да на Вопрос 1)")]), _vm._v(" "), _vm._l((_vm.scenario.parameters.dynamicQuestions), function(parameter, index) {
    return _c('div', {
      key: parameter.key
    }, [(_vm.scenario.parameters.dynamicQuestions.length != index + 1) ? _c('label', {
      staticClass: "label"
    }, [_vm._v("Вопрос опроса " + _vm._s(index + 1))]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.dynamicQuestions.length == index + 1) ? _c('label', {
      staticClass: "label"
    }, [_vm._v("Заключительное сообщение")]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.scenario.parameters.dynamicQuestions[index].generationState),
        expression: "scenario.parameters.dynamicQuestions[index].generationState"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": false,
        "checked": _vm._q(_vm.scenario.parameters.dynamicQuestions[index].generationState, false)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.scenario.parameters.dynamicQuestions[index], "generationState", false)
        }, function($event) {
          return _vm.onChangeGenerationState(parameter.generationState, index, parameter.key)
        }]
      }
    }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.scenario.parameters.dynamicQuestions[index].generationState),
        expression: "scenario.parameters.dynamicQuestions[index].generationState"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": true,
        "checked": _vm._q(_vm.scenario.parameters.dynamicQuestions[index].generationState, true)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.scenario.parameters.dynamicQuestions[index], "generationState", true)
        }, function($event) {
          return _vm.onChangeGenerationState(parameter.generationState, index, parameter.key)
        }]
      }
    }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (parameter.generationState) ? _c('div', [_c('p', {
      staticClass: "control"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.text),
        expression: "parameter.text"
      }],
      staticClass: "textarea",
      domProps: {
        "value": (parameter.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parameter, "text", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "control is-grouped"
    }, [_c('button', {
      staticClass: "button is-primary",
      on: {
        "click": function($event) {
          return _vm.genAudio(index)
        }
      }
    }, [_vm._m(3, true), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicLoading) ? _c('div', {
      staticClass: "loader spinner"
    }) : _vm._e(), _vm._v("\n                Сгенерировать аудио\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "select is-primary"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tmp.dynamicTmp[index].dynamicSpeaker),
        expression: "tmp.dynamicTmp[index].dynamicSpeaker"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tmp.dynamicTmp[index], "dynamicSpeaker", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.speakerList), function(speaker) {
      return _c('option', [_vm._v("\n                    " + _vm._s(speaker.value) + "\n                  ")])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "select is-primary"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tmp.dynamicTmp[index].dynamicEmotion),
        expression: "tmp.dynamicTmp[index].dynamicEmotion"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tmp.dynamicTmp[index], "dynamicEmotion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.emotionList), function(emotion) {
      return _c('option', [_vm._v("\n                    " + _vm._s(emotion.value) + "\n                  ")])
    }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
      attrs: {
        "size": "small",
        "value": _vm.tmp.dynamicTmp[index].dynamicSpeed,
        "min": 0.1,
        "step": 0.1,
        "max": 3
      },
      on: {
        "change": function($event) {
          _vm.tmp.dynamicTmp[index].dynamicSpeed = $event
        }
      }
    }), _vm._v("\n                Скорость: " + _vm._s(_vm.tmp.dynamicTmp[index].dynamicSpeed) + "\n              ")], 1), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicGeneratedAudio) ? _c('audio', {
      ref: ("audio-" + (parameter.key)),
      refInFor: true
    }, [_c('source', {
      attrs: {
        "src": parameter.audio
      }
    }), _vm._v("\n                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicGeneratedAudio) ? _c('audio-player', {
      attrs: {
        "file": parameter.audio
      }
    }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('button', {
      staticClass: "button is-link delete-button",
      on: {
        "click": function($event) {
          return _vm.deleteParameter(index)
        }
      }
    }, [_vm._m(4, true), _vm._v(" "), _c('span', [_vm._v("Удалить")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!parameter.generationState) ? _c('div', [_c('p', {
      staticClass: "control"
    }), _c('div', {
      staticClass: "control"
    }, [_c('input', {
      staticClass: "button is-info",
      attrs: {
        "type": "button",
        "value": "Загрузить из файла"
      },
      on: {
        "click": function($event) {
          return _vm.clickLoadAudio(parameter.key)
        }
      }
    }), _vm._v(" "), _c('input', {
      ref: ("load-audio-" + (parameter.key)),
      refInFor: true,
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "name": "load-audio",
        "type": "file",
        "accept": ".wav,.mp3"
      },
      on: {
        "input": function($event) {
          return _vm.loadAudio(index, parameter.key)
        }
      }
    }), _vm._v(" "), _c('input', {
      staticClass: "button is-info",
      attrs: {
        "type": "button",
        "value": "Записать с микрофона"
      },
      on: {
        "click": function($event) {
          return _vm.openModal(index, parameter.key, '', '', false)
        }
      }
    }), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicLoadedAudio) ? _c('audio', {
      ref: ("audio-" + (parameter.key)),
      refInFor: true
    }, [_c('source', {
      attrs: {
        "src": parameter.audio
      }
    }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicLoadedAudio) ? _c('audio-player', {
      attrs: {
        "file": parameter.audio
      }
    }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('button', {
      staticClass: "button is-link delete-button",
      on: {
        "click": function($event) {
          return _vm.deleteParameter(index)
        }
      }
    }, [_vm._m(5, true), _vm._v(" "), _c('span', [_vm._v("Удалить")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "button-center"
  }, [_c('button', {
    staticClass: "button is-primary is-outlined add-new",
    on: {
      "click": _vm.addNewParameter
    }
  }, [_vm._v("+")])])], 2), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "second-layer negative-scenario"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("При ответе Нет на Вопрос 1")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос 2 / Сообщение")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondGenerationState),
      expression: "scenario.parameters.questionSecondGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionSecondGenerationState', 'questionSecondAudio', 'questionSecondGeneratedAudio', 'questionSecondLoadedAudio', 'onQuestionSecond')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondGenerationState),
      expression: "scenario.parameters.questionSecondGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionSecondGenerationState', 'questionSecondAudio', 'questionSecondGeneratedAudio', 'questionSecondLoadedAudio', 'onQuestionSecond')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondText),
      expression: "scenario.parameters.questionSecondText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudioStatic('questionSecondId', 'questionSecondAudio', 'currentSpeakerSecond', 'questionSecondGeneratedAudio', 'questionSecondText', 'questionSecondLoading', 'Second question', 'currentEmotionSecond', 'currentSpeedSecond')
      }
    }
  }, [_vm._m(6), _vm._v(" "), (_vm.tmp.questionSecondLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecond),
      expression: "tmp.currentSpeakerSecond"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecond", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecond),
      expression: "tmp.currentEmotionSecond"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecond", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                    " + _vm._s(emotion.value) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecond,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecond = $event
      }
    }
  }), _vm._v("\n                Скорость: " + _vm._s(_vm.tmp.currentSpeedSecond) + "\n              ")], 1), _vm._v(" "), (_vm.tmp.questionSecondGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecond'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionSecondId', 'questionSecondAudio', 'questionSecondLoadedAudio', 'questionSecondGeneratedAudio')
      }
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudioStatic('questionSecondLoadedAudio', 'questionSecondId', 'questionSecondAudio', 'questionSecondLoadedAudio', 'Second question', 'onQuestionSecond')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondId', 'questionSecondAudio', 'questionSecondLoadedAudio', 'Second question', true)
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecond'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondAudio
    }
  }), _vm._v("\n                    Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionSecondId', 'questionSecondAudio', 'questionSecondLoadedAudio', 'questionSecondGeneratedAudio')
      }
    }
  }, [_vm._m(8), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block is-flex"
  }, [_c('collapse', [_c('collapse-item', {
    staticClass: "second-layer positive-scenario",
    attrs: {
      "title": "Сообщение при ответе Да на Вопрос 2",
      "selected": _vm.scenario.parameters.questionSecondYesId != ''
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesGenerationState),
      expression: "scenario.parameters.questionSecondYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionSecondYesGenerationState', 'questionSecondYesAudio', 'questionSecondYesGeneratedAudio', 'questionSecondYesLoadedAudio', 'onQuestionSecondYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesGenerationState),
      expression: "scenario.parameters.questionSecondYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionSecondYesGenerationState', 'questionSecondYesAudio', 'questionSecondYesGeneratedAudio', 'questionSecondYesLoadedAudio', 'onQuestionSecondYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesText),
      expression: "scenario.parameters.questionSecondYesText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondYesText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondYesText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudioStatic('questionSecondYesId', 'questionSecondYesAudio', 'currentSpeakerSecondYes', 'questionSecondYesGeneratedAudio', 'questionSecondYesText', 'questionSecondYesLoading', 'Second yes question', 'currentEmotionSecondYes', 'currentSpeedSecondYes')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), (_vm.tmp.questionSecondYesLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondYes),
      expression: "tmp.currentSpeakerSecondYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondYes),
      expression: "tmp.currentEmotionSecondYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondYes,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondYes = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondYes) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondYesGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'questionSecondYesGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondYesLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondYesLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudioStatic('questionSecondYesLoadedAudio', 'questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'Second yes question', 'onQuestionSecondYes')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'Second yes question', true)
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondYesLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'questionSecondYesGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e()])]), _vm._v(" "), _c('collapse-item', {
    staticClass: "second-layer negative-scenario",
    attrs: {
      "title": "Сообщение при ответе Нет на Вопрос 2",
      "selected": _vm.scenario.parameters.questionSecondNoId != ''
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoGenerationState),
      expression: "scenario.parameters.questionSecondNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionSecondNoGenerationState', 'questionSecondNoAudio', 'questionSecondNoGeneratedAudio', 'questionSecondNoLoadedAudio', 'onQuestionSecondNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoGenerationState),
      expression: "scenario.parameters.questionSecondNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionSecondNoGenerationState', 'questionSecondNoAudio', 'questionSecondNoGeneratedAudio', 'questionSecondNoLoadedAudio', 'onQuestionSecondNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoText),
      expression: "scenario.parameters.questionSecondNoText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondNoText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondNoText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudioStatic('questionSecondNoId', 'questionSecondNoAudio', 'currentSpeakerSecondNo', 'questionSecondNoGeneratedAudio', 'questionSecondNoText', 'questionSecondNoLoading', 'Second no question', 'currentEmotionSecondNo', 'currentSpeedSecondNo')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), (_vm.tmp.questionSecondNoLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondNo),
      expression: "tmp.currentSpeakerSecondNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondNo),
      expression: "tmp.currentEmotionSecondNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondNo,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondNo = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondNo) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondNoGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'questionSecondNoGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondNoLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondNoLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudioStatic('questionSecondNoLoadedAudio', 'questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'Second no question', 'onQuestionSecondNo')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'Second no question', true)
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondNoLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'questionSecondNoGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e()])])], 1)], 1)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(9), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(10), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), _vm._m(11), _vm._v(" "), (_vm.scenario.isReady) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(12), _vm._v(" "), _c('span', [_vm._v("Подготовлен")])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(13), _vm._v(" "), _c('span', [_vm._v("Не подготовлен")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-primary"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })]), _vm._v(" "), _c('span', [_vm._v("Рассчитать стоимость")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
}]}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalAudio__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ModalAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var NotificationComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var MessageComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default.a);
var openMessage = function openMessage() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  };

  return new MessageComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var api = '/api/scenarios';
var audioGeneratorApi = '/audios/generate';
var audioUploadApi = '/audios/save';
var audioDeleteApi = '/audios';
var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name', 'campaignid'],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_6__ModalAudio___default.a,
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a,
    Slider: __WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider___default.a
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['loadedScenario', 'loggedId', 'loggedUser', 'authenticationToken'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    addNewParameter: function addNewParameter() {
      this.scenario.parameters.dynamicQuestions.push({ generationState: true, text: '', audio: '', id: undefined, key: Math.floor(Math.random() * 99999999) + 1 });
      this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: '', dynamicLoadedAudio: '', dynamicLoading: false, dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
    },
    deleteParameter: function deleteParameter(i) {
      this.scenario.parameters.dynamicQuestions.splice(i, 1);
      this.tmp.dynamicTmp.splice(i, 1);
    },

    changeRoute: function changeRoute(e) {
      this.$router.push({ path: '/scenarios' + e.target.value });
    },
    checkAudioDuration: function checkAudioDuration() {
      this.scenario.checkDuration = true;
      var len = document.querySelectorAll('audio').length;
      for (var i = 0; i < len; i++) {
        if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
          this.scenario.checkDuration = this.scenario.checkDuration && document.querySelectorAll('audio')[i].duration > 0;
        }
      }
      return this.scenario.checkDuration;
    },
    save: function save(showMessage) {
      if (this.checkAudioDuration()) {
        if (this.scenario.id === undefined) {
          this.saveNew(showMessage);
        } else {
          this.update(showMessage);
        }
      } else {
        this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с аудиофайлом нулевой длительности');
      }
    },
    saveNew: function saveNew(showMessage) {
      var _this = this;

      console.log('saving new scenario: ' + JSON.stringify(this.scenario));
      this.scenario.parameters.dynamicQuestions.forEach(function (dynamicQuestion) {
        if (!dynamicQuestion.generationState) {
          dynamicQuestion.text = '';
        }
      });
      this.$http.post(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.isSaved = true;
        if (showMessage) {
          _this.openNotificationWithType('info', 'Сценарий сохранен');
          _this.$emit('set', _this.scenario);
        }
        _this.scenario = response.data;
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    update: function update(showMessage) {
      var _this2 = this;

      console.log('updating scenario: ' + JSON.stringify(this.scenario));
      this.$http.put(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.isSaved = true;
        _this2.scenario = response.data;
        if (showMessage) {
          _this2.openNotificationWithType('info', 'Сценарий сохранен');
        }
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    uploadFile: function uploadFile(buttonId) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий');
      } else {
        document.getElementById(buttonId).click();
      }
    },
    genAudioRequest: function genAudioRequest(maybeId, audioName, text, speaker, emotion, speed) {
      var request = {
        'commonParameters': {
          'client': this.scenario.client,
          'scenario': this.scenario.id,
          'audioName': audioName,
          'text': text
        },

        'vendorSpecificParameters': {
          'speaker': speaker,
          'emotion': emotion,
          'speed': speed
        },

        'vendor': 'yandex'
        // if audio already generated, request must contain id, so backend will overwrite existing audio
      };if (maybeId) {
        request.id = maybeId;
      }
      return request;
    },
    securityHeaders: function securityHeaders() {
      return { 'testH': 'testHV', 'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ' };
    },
    onChangeGenerationState: function onChangeGenerationState(state, index, key) {
      var parameter = this.scenario.parameters.dynamicQuestions[index];
      if (state) {
        parameter.audio = this.tmp.dynamicTmp[index].dynamicGeneratedAudio;
        this.$refs['audio-' + key][0].load();
      } else {
        parameter.audio = this.tmp.dynamicTmp[index].dynamicLoadedAudio;
        this.$refs['audio-' + key][0].load();
      }
    },
    loadAudio: function loadAudio(index, key) {
      var input = this.$refs['load-audio-' + key][0];
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий');
        } else {
          this.handleUploadRequest(index, key, input.files[0]);
        }
      }
    },
    handleUploadRequest: function handleUploadRequest(index, key, audioFile) {
      var _this3 = this;

      this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile), this.prepareUploadHeaders()).then(function (response) {
        _this3.setAudioValue(index, key, response);
      }).catch(function (error) {
        console.log(error);
        _this3.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
      });
    },
    deleteAudio: function deleteAudio(index) {
      var _this4 = this;

      this.$http.delete(audioDeleteApi + '/' + this.scenario.parameters.dynamicQuestions[index].id, { headers: this.prepareUploadHeaders() }).then(function (response) {
        _this4.deleteAudioValue(index);
      }).catch(function (error) {
        console.log(error);
        _this4.openNotificationWithType('danger', 'Ошибка удаления аудио. ');
      });
    },
    setAudioValue: function setAudioValue(index, key, response) {
      this.scenario.parameters.dynamicQuestions[index].id = response.data;
      this.tmp.dynamicTmp[index].dynamicLoadedAudio = '/audios/' + response.data + '.wav';
      this.scenario.parameters.dynamicQuestions[index].audio = this.tmp.dynamicTmp[index].dynamicLoadedAudio;
      this.$refs['audio-' + key][0].load();
    },
    deleteAudioValue: function deleteAudioValue(index) {
      this.scenario.parameters.dynamicQuestions[index].id = '';
      this.tmp.dynamicTmp[index].dynamicLoadedAudio = '';
      this.tmp.dynamicTmp[index].dynamicGeneratedAudio = '';
      this.scenario.parameters.dynamicQuestions[index].audio = '';
    },
    genAudio: function genAudio(index) {
      var _this5 = this;

      var parameter = this.scenario.parameters.dynamicQuestions[index];
      var text = parameter.text,
          id = parameter.id;

      var requestData = this.genAudioRequest(id, 'audioname' + (index + 1), text, this.tmp.dynamicTmp[index].dynamicSpeaker, this.tmp.dynamicTmp[index].dynamicEmotion, this.tmp.dynamicTmp[index].dynamicSpeed);
      var config = { headers: this.securityHeaders() };
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий');
      } else {
        this.tmp.dynamicTmp[index].dynamicLoading = true;
        this.$http.post(audioGeneratorApi, requestData, config).then(function (response) {
          _this5.handleGenRequest(parameter, index, response.data);
          _this5.tmp.dynamicTmp[index].dynamicLoading = false;
          _this5.$refs['audio-' + parameter.key][0].load();
        }).catch(function (error) {
          console.log(error);
          _this5.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
          _this5.tmp.dynamicTmp[index].dynamicLoading = false;
        });
      }
    },
    handleGenRequest: function handleGenRequest(parameter, index, data) {
      parameter.id = data;
      this.tmp.dynamicTmp[index].dynamicGeneratedAudio = '/audios/' + data + '.wav';
      parameter.audio = this.tmp.dynamicTmp[index].dynamicGeneratedAudio;
    },
    prepareMultipartAudio: function prepareMultipartAudio(audioFile, audioName, audioClient, audioScenario) {
      var audioFormData = new FormData();
      audioFormData.append('file', audioFile);
      audioFormData.append('name', audioName);
      audioFormData.append('client', audioClient);
      audioFormData.append('scenario', audioScenario);
      return audioFormData;
    },
    prepareUploadHeaders: function prepareUploadHeaders() {
      return {
        'headers': {
          'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
          'Content-Type': 'multipart/form-data',
          'testH': 'testHV'
        }
      };
    },
    load: function load() {
      var _this6 = this;

      this.$http({
        url: api + '/' + this.name,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('opening scenario ' + JSON.stringify(response.data));
        _this6.isSaved = true;
        _this6.scenario = response.data;
      }).catch(function (error) {
        console.log(error);
        _this6.openNotificationWithType('danger', 'Ошибка загрузки сценария. ');
      });
    },
    cancel: function cancel() {
      if (this.$props.campaignid == 0) {
        this.$router.push('/scenarios/');
      } else {
        this.$router.push('/campaigns/' + this.$props.campaignid);
      }
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.currentAudio = null;
    },
    openModal: function openModal(audioId, audioValue, generationType, audioName) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед записью аудио необходимо сохранить сценарий');
      } else {
        this.showModal = true;
        this.currentAudio = new FormData();
        this.currentAudio.append('audioId', audioId);
        this.currentAudio.append('audioValue', audioValue);
        this.currentAudio.append('generationType', generationType);
        this.currentAudio.append('audioName', audioName);
      }
    },
    confirmAction: function confirmAction(value) {
      this.handleUploadRequest(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), value.blob);
      // var key = this.currentAudio.get('audioValue')
      // this.$refs[`audio-${key}`][0].load()
      this.closeModal();
    },
    notSaved: function notSaved() {
      this.isSaved = false;
    },
    loadState: function loadState() {
      var _this7 = this;

      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this7.isActive = response.data;
        if (!_this7.isActive) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this7.openNotificationWithType('danger', _this7.$i18n.messages[_this7.$i18n.locale].scenarios.errorToGetUserStatus);
      });
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: this.$i18n.messages[this.$i18n.locale].notifications.notification,
        message: message,
        type: type
      });
    },
    clickLoadAudio: function clickLoadAudio(parameterkey) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий');
      } else {
        this.$refs['load-audio-' + parameterkey][0].click();
      }
    }
  },
  data: function data() {
    return {
      scenario: {
        template: 'poll',
        parameters: {
          dynamicQuestions: [{
            generationState: true,
            text: '',
            audio: '',
            id: undefined,
            key: 0
          }]
        },
        checkDuration: true
      },
      tmp: {
        dynamicTmp: [{
          dynamicGeneratedAudio: '',
          dynamicLoadedAudio: '',
          dynamicLoading: false,
          dynamicSpeaker: 'oksana',
          dynamicEmotion: 'neutral',
          dynamicSpeed: 1
        }]
      },
      speakerList: [{
        value: 'jane'
      }, {
        value: 'oksana'
      }, {
        value: 'alyss '
      }, {
        value: 'omazh'
      }, {
        value: 'zahar '
      }, {
        value: 'ermil '
      }],
      currentEmotion: 'neutral',
      emotionList: [{
        value: 'good'
      }, {
        value: 'neutral'
      }, {
        value: 'evil'
      }],
      currentSpeed: 1,
      isSaved: false,
      isActive: false,
      showModal: null,
      title: '',
      currentAudio: null
    };
  },

  created: function created() {
    this.loadState();
    if (this.name === undefined) {
      console.log('creating new scenario');
      this.notSaved();
    } else {
      console.log('loading scenario: ' + this.name);
      this.load();
    }
    // for (let dynamicIndex = 0; dynamicIndex < this.scenario.parameters.dynamicQuestions.length; dynamicIndex++) {
    //  this.$watch('scenario.parameters.dynamicQuestions[dynamicIndex].audio', function () {
    //    const key = scenario.parameters.dynamicQuestions[dynamicIndex].key
    //    this.$refs[`audio-${key}`][0].load()
    //  })
    // }
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }
      for (var dynamicIndex = 0; dynamicIndex < this.scenario.parameters.dynamicQuestions.length; dynamicIndex++) {
        var audio = this.scenario.parameters.dynamicQuestions[dynamicIndex].audio;
        if (dynamicIndex != 0) {
          if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
            this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: audio, dynamicLoadedAudio: '', dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
          } else {
            this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: '', dynamicLoadedAudio: audio, dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
          }
        } else {
          if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
            this.tmp.dynamicTmp[dynamicIndex].dynamicGeneratedAudio = audio;
          } else {
            this.tmp.dynamicTmp[dynamicIndex].dynamicLoadedAudio = audio;
          }
        }
      }
    }
  },
  beforeUpdate: function beforeUpdate() {
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }
      for (var dynamicIndex = 0; dynamicIndex < this.scenario.parameters.dynamicQuestions.length; dynamicIndex++) {
        var audio = this.scenario.parameters.dynamicQuestions[dynamicIndex].audio;
        if (dynamicIndex != 0) {
          if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
            this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: audio, dynamicLoadedAudio: '', dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
          } else {
            this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: '', dynamicLoadedAudio: audio, dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
          }
        } else {
          if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
            this.tmp.dynamicTmp[dynamicIndex].dynamicGeneratedAudio = audio;
          } else {
            this.tmp.dynamicTmp[dynamicIndex].dynamicLoadedAudio = audio;
          }
        }
      }
    }
  }
});

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.loadedScenario))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Название сценария")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.name),
      expression: "scenario.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название сценария"
    },
    domProps: {
      "value": (_vm.scenario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "second-layer add-button-wrapper"
  }, [_vm._l((_vm.scenario.parameters.dynamicQuestions), function(parameter, index) {
    return _c('div', {
      key: parameter.key
    }, [(_vm.scenario.parameters.dynamicQuestions.length != index + 1) ? _c('label', {
      staticClass: "label"
    }, [_vm._v("Вопрос опроса " + _vm._s(index + 1))]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.dynamicQuestions.length == index + 1) ? _c('label', {
      staticClass: "label"
    }, [_vm._v("Заключительное сообщение")]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.scenario.parameters.dynamicQuestions[index].generationState),
        expression: "scenario.parameters.dynamicQuestions[index].generationState"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": false,
        "checked": _vm._q(_vm.scenario.parameters.dynamicQuestions[index].generationState, false)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.scenario.parameters.dynamicQuestions[index], "generationState", false)
        }, function($event) {
          return _vm.onChangeGenerationState(parameter.generationState, index, parameter.key)
        }]
      }
    }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.scenario.parameters.dynamicQuestions[index].generationState),
        expression: "scenario.parameters.dynamicQuestions[index].generationState"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": true,
        "checked": _vm._q(_vm.scenario.parameters.dynamicQuestions[index].generationState, true)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.scenario.parameters.dynamicQuestions[index], "generationState", true)
        }, function($event) {
          return _vm.onChangeGenerationState(parameter.generationState, index, parameter.key)
        }]
      }
    }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (parameter.generationState) ? _c('div', [_c('p', {
      staticClass: "control"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.text),
        expression: "parameter.text"
      }],
      staticClass: "textarea",
      domProps: {
        "value": (parameter.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parameter, "text", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "control is-grouped"
    }, [_c('button', {
      staticClass: "button is-primary",
      on: {
        "click": function($event) {
          return _vm.genAudio(index)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicLoading) ? _c('div', {
      staticClass: "loader spinner"
    }) : _vm._e(), _vm._v("\n                Сгенерировать аудио\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "select is-primary"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tmp.dynamicTmp[index].dynamicSpeaker),
        expression: "tmp.dynamicTmp[index].dynamicSpeaker"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tmp.dynamicTmp[index], "dynamicSpeaker", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.speakerList), function(speaker) {
      return _c('option', [_vm._v("\n                    " + _vm._s(speaker.value) + "\n                  ")])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "select is-primary"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tmp.dynamicTmp[index].dynamicEmotion),
        expression: "tmp.dynamicTmp[index].dynamicEmotion"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tmp.dynamicTmp[index], "dynamicEmotion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.emotionList), function(emotion) {
      return _c('option', [_vm._v("\n                    " + _vm._s(emotion.value) + "\n                  ")])
    }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
      attrs: {
        "size": "small",
        "value": _vm.tmp.dynamicTmp[index].dynamicSpeed,
        "min": 0.1,
        "step": 0.1,
        "max": 3
      },
      on: {
        "change": function($event) {
          _vm.tmp.dynamicTmp[index].dynamicSpeed = $event
        }
      }
    }), _vm._v("\n                Скорость: " + _vm._s(_vm.tmp.dynamicTmp[index].dynamicSpeed) + "\n              ")], 1), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicGeneratedAudio) ? _c('audio', {
      ref: ("audio-" + (parameter.key)),
      refInFor: true
    }, [_c('source', {
      attrs: {
        "src": parameter.audio
      }
    }), _vm._v("\n                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicGeneratedAudio) ? _c('audio-player', {
      attrs: {
        "file": parameter.audio
      }
    }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('button', {
      staticClass: "button is-link delete-button",
      on: {
        "click": function($event) {
          return _vm.deleteParameter(index)
        }
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('span', [_vm._v("Удалить")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!parameter.generationState) ? _c('div', [_c('p', {
      staticClass: "control"
    }), _c('div', {
      staticClass: "control"
    }, [_c('input', {
      staticClass: "button is-info",
      attrs: {
        "type": "button",
        "value": "Загрузить из файла"
      },
      on: {
        "click": function($event) {
          return _vm.clickLoadAudio(parameter.key)
        }
      }
    }), _vm._v(" "), _c('input', {
      ref: ("load-audio-" + (parameter.key)),
      refInFor: true,
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "name": "load-audio",
        "type": "file",
        "accept": ".wav,.mp3"
      },
      on: {
        "input": function($event) {
          return _vm.loadAudio(index, parameter.key)
        }
      }
    }), _vm._v(" "), _c('input', {
      staticClass: "button is-info",
      attrs: {
        "type": "button",
        "value": "Записать с микрофона"
      },
      on: {
        "click": function($event) {
          return _vm.openModal(index, parameter.key, '', '')
        }
      }
    }), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicLoadedAudio) ? _c('audio', {
      ref: ("audio-" + (parameter.key)),
      refInFor: true
    }, [_c('source', {
      attrs: {
        "src": parameter.audio
      }
    }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicLoadedAudio) ? _c('audio-player', {
      attrs: {
        "file": parameter.audio
      }
    }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('button', {
      staticClass: "button is-link delete-button",
      on: {
        "click": function($event) {
          return _vm.deleteParameter(index)
        }
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('span', [_vm._v("Удалить")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "button-center"
  }, [_c('button', {
    staticClass: "button is-primary is-outlined add-new",
    on: {
      "click": _vm.addNewParameter
    }
  }, [_vm._v("+")])])], 2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(4), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.scenario.isReady) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(6), _vm._v(" "), _c('span', [_vm._v("Подготовлен")])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Не подготовлен")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-primary"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })]), _vm._v(" "), _c('span', [_vm._v("Рассчитать стоимость")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
}]}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalAudio__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ModalAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var NotificationComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var MessageComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default.a);
var openMessage = function openMessage() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  };

  return new MessageComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var api = '/api/scenarios';
var audioGeneratorApi = '/audios/generate';
var audioUploadApi = '/audios/reSave';
var audioDeleteApi = '/audios';
var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name', 'campaignid'],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_6__ModalAudio___default.a,
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a,
    Slider: __WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider___default.a
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['loadedScenario', 'loggedId', 'loggedUser', 'authenticationToken'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    insertPause: function insertPause(textareaId) {
      var textarea = document.getElementById(textareaId);
      var pausePattern = ' \\pause:1 ';
      if (document.selection) {
        textarea.focus();
        var sel = document.selection.createRange();
        sel.text = pausePattern;
      } else if (textarea.selectionStart || textarea.selectionStart == '0') {
        var startPos = textarea.selectionStart;
        var endPos = textarea.selectionEnd;
        textarea.value = textarea.value.substring(0, startPos) + pausePattern + textarea.value.substring(endPos, textarea.value.length);
        textarea.selectionStart = startPos + pausePattern.length;
        textarea.selectionEnd = startPos + pausePattern.length;
      } else {
        textarea.value += pausePattern;
        textarea.selectionStart = textarea.value.length;
      }
      textarea.focus();
    },

    changeRoute: function changeRoute(e) {
      this.$router.push({ path: '/scenarios' + e.target.value });
    },
    checkAudioDuration: function checkAudioDuration() {
      this.scenario.checkDuration = true;
      var len = document.querySelectorAll('audio').length;
      for (var i = 0; i < len; i++) {
        if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
          this.scenario.checkDuration = this.scenario.checkDuration && document.querySelectorAll('audio')[i].duration > 0;
        }
      }
      return this.scenario.checkDuration;
    },
    save: function save(showMessage) {
      if (this.checkAudioDuration()) {
        if (this.scenario.id === undefined) {
          this.saveNew(showMessage);
        } else {
          this.update(showMessage);
        }
      } else {
        this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с аудиофайлом нулевой длительности');
      }
    },
    saveNew: function saveNew(showMessage) {
      var _this = this;

      console.log('saving new scenario: ' + JSON.stringify(this.scenario));
      this.scenario.parameters.questionSpeaker = this.tmp.currentSpeaker;
      this.scenario.parameters.questionEmotion = this.tmp.currentEmotion;
      this.scenario.parameters.questionSpeed = this.tmp.currentSpeed;
      if (!this.scenario.parameters.questionGenerationState) {
        this.scenario.parameters.questionText = '';
      }
      this.$http.post(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.isSaved = true;
        if (showMessage) {
          _this.openNotificationWithType('info', 'Сценарий сохранен');
          _this.$emit('set', _this.scenario);
        }
        _this.scenario = response.data;
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    update: function update(showMessage) {
      var _this2 = this;

      console.log('updating scenario: ' + JSON.stringify(this.scenario));
      this.scenario.parameters.questionSpeaker = this.tmp.currentSpeaker;
      this.scenario.parameters.questionEmotion = this.tmp.currentEmotion;
      this.scenario.parameters.questionSpeed = this.tmp.currentSpeed;
      this.$http.put(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.isSaved = true;
        _this2.scenario = response.data;
        if (showMessage) {
          _this2.openNotificationWithType('info', 'Сценарий сохранен');
        }
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    uploadFile: function uploadFile(buttonId) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий');
      } else {
        document.getElementById(buttonId).click();
      }
    },
    genAudioRequest: function genAudioRequest(maybeId, audioName, text) {
      var request = {
        'commonParameters': {
          'client': this.scenario.client,
          'scenario': this.scenario.id,
          'audioName': audioName,
          'text': text
        },

        'vendorSpecificParameters': {
          'speaker': speaker,
          'emotion': emotion,
          'speed': speed
        },

        'vendor': 'yandex'
      };
      if (maybeId) {
        request.id = maybeId;
      }
      return request;
    },
    prepareLoadAudioRequest: function prepareLoadAudioRequest(possibleId, uploadAudio) {
      var request = {
        'scenario': this.scenario.id,
        'client': this.scenario.client,
        'audioName': uploadAudio.filename,
        'audioBytes': uploadAudio
      };
      if (possibleId) {
        request.id = id;
      }
      return request;
    },
    securityHeaders: function securityHeaders() {
      return {
        'testH': 'testHV',
        'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ'
      };
    },
    onChangeGenerationState: function onChangeGenerationState(stateId, audioId, generatedAudioId, loadedAudioId, playerId) {
      if (this.scenario.parameters[stateId]) {
        this.scenario.parameters[audioId] = this.tmp[generatedAudioId];
        this.$refs[playerId][0].load();
      } else {
        this.scenario.parameters[audioId] = this.tmp[loadedAudioId];
        this.$refs[playerId][0].load();
      }
    },
    genAudio: function genAudio(audioId, audioValue, generationType, questionText, loadingStatus, audioName) {
      var request = this.genAudioRequest(this.scenario.parameters[audioId], audioName, this.scenario.parameters[questionText]);
      this.handleGenerateRequest(audioId, audioValue, generationType, loadingStatus, request);
    },
    handleGenerateRequest: function handleGenerateRequest(audioId, audioValue, generationType, loadingStatus, request) {
      var _this3 = this;

      var headers = { headers: this.securityHeaders() };
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий');
      } else {
        this.tmp[loadingStatus] = true;
        this.$http.post(audioGeneratorApi, request, headers).then(function (response) {
          _this3.scenario.parameters[audioId] = response.data;
          _this3.tmp[generationType] = '/audios/' + _this3.scenario.parameters[audioId] + '.wav';
          _this3.scenario.parameters[audioValue] = _this3.tmp[generationType];
          _this3.tmp[loadingStatus] = false;
        }).catch(function (error) {
          console.log(error);
          _this3.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
        });
      }
    },
    loadAudio: function loadAudio(inputId, audioId, audioValue, generationType, audioName, player) {
      var input = document.querySelector('#' + inputId);
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий');
        } else {
          this.handleUploadRequest(audioId, audioValue, generationType, input.files[0], audioName);
          this.$refs[player].load();
        }
      }
    },
    handleUploadRequest: function handleUploadRequest(audioId, audioValue, generationType, audioFile, audioName) {
      var _this4 = this;

      this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile, audioID, audioName, this.scenario.client, this.scenario.id), this.prepareUploadHeaders()).then(function (response) {
        _this4.setAudioValue(audioId, generationType, audioValue, response);
      }).catch(function (error) {
        console.log(error);
        _this4.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
      });
    },
    deleteAudio: function deleteAudio(audioId, audioValue, generationType1, generationType2) {
      var _this5 = this;

      this.$http.delete(audioDeleteApi + '/' + this.scenario.parameters[audioId], { headers: this.prepareUploadHeaders() }).then(function (response) {
        _this5.deleteAudioValue(audioId, generationType1, generationType2, audioValue);
      }).catch(function (error) {
        console.log(error);
        _this5.openNotificationWithType('danger', 'Ошибка удаления аудио. ');
      });
    },
    prepareMultipartAudio: function prepareMultipartAudio(audioFile, audioId, audioName, audioClient, audioScenario) {
      var audioFormData = new FormData();
      audioFormData.append('file', audioFile);
      audioFormData.append('name', audioName);
      audioFormData.append('client', audioClient);
      audioFormData.append('scenario', audioScenario);
      audioFormData.append('id', this.scenario.parameters[audioId]);
      return audioFormData;
    },
    prepareUploadHeaders: function prepareUploadHeaders() {
      return {
        'headers': {
          'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
          'Content-Type': 'multipart/form-data',
          'testH': 'testHV'
        }
      };
    },
    setAudioValue: function setAudioValue(audioId, generationType, audioValue, response) {
      this.scenario.parameters[audioId] = response.data;
      this.tmp[generationType] = '/audios/' + this.scenario.parameters[audioId] + '.wav';
      this.scenario.parameters[audioValue] = this.tmp[generationType];
    },
    deleteAudioValue: function deleteAudioValue(audioId, generationType1, generationType2, audioValue) {
      this.scenario.parameters[audioId] = '';
      this.tmp[generationType1] = '';
      this.tmp[generationType2] = '';
      this.scenario.parameters[audioValue] = '';
    },
    load: function load() {
      var _this6 = this;

      this.$http({
        url: api + '/' + this.name,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('opening scenario ' + JSON.stringify(response.data));
        _this6.isSaved = true;
        _this6.scenario = response.data;
        _this6.question_audio = '/audios/' + _this6.scenario.parameters.questionId + '.wav';
      }).catch(function (error) {
        console.log(error);
        _this6.openNotificationWithType('danger', 'Ошибка загрузки сценария. ');
      });
    },
    cancel: function cancel() {
      if (this.$props.campaignid == 0) {
        this.$router.push('/scenarios/');
      } else {
        this.$router.push('/campaigns/' + this.$props.campaignid);
      }
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.currentAudio = null;
    },
    openModal: function openModal(audioId, audioValue, generationType, audioName) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед записью аудио необходимо сохранить сценарий');
      } else {
        this.showModal = true;
        this.currentAudio = new FormData();
        this.currentAudio.append('audioId', audioId);
        this.currentAudio.append('audioValue', audioValue);
        this.currentAudio.append('generationType', generationType);
        this.currentAudio.append('audioName', audioName);
      }
    },
    confirmAction: function confirmAction(value) {
      this.handleUploadRequest(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), this.currentAudio.get('generationType'), value.blob, this.currentAudio.get('audioName'));
      this.closeModal();
    },
    notSaved: function notSaved() {
      this.isSaved = false;
    },
    loadState: function loadState() {
      var _this7 = this;

      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this7.isActive = response.data;
        if (!_this7.isActive) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this7.openNotificationWithType('danger', _this7.$i18n.messages[_this7.$i18n.locale].scenarios.errorToGetUserStatus);
      });
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: this.$i18n.messages[this.$i18n.locale].notifications.notification,
        message: message,
        type: type
      });
    }
  },
  data: function data() {
    return {
      scenario: {
        template: 'notification',
        parameters: {
          questionId: '',
          questionAudio: '',
          questionText: '',
          questionGenerationState: true,

          questionSpeaker: 'oksana',
          questionEmotion: 'neutral',
          questionSpeed: 1
        },
        checkDuration: true
      },
      tmp: {
        generatedQuestionAudio: '',
        loadedQuestionAudio: '',
        questionLoading: false
      },
      question_audio: '',
      currentSpeaker: 'oksana',
      speakerList: [{
        value: 'jane'
      }, {
        value: 'oksana'
      }, {
        value: 'alyss '
      }, {
        value: 'omazh'
      }, {
        value: 'zahar '
      }, {
        value: 'ermil '
      }],
      currentEmotion: 'neutral',
      emotionList: [{
        value: 'good'
      }, {
        value: 'neutral'
      }, {
        value: 'evil'
      }],
      currentSpeed: 1,
      isSaved: false,
      isActive: false,
      showModal: null,
      title: '',
      currentAudio: null
    };
  },

  created: function created() {
    this.loadState();
    if (this.name === undefined) {
      console.log('creating new scenario');
      this.notSaved();
    } else {
      console.log('loading scenario: ' + this.name);
      this.load();
    }
    this.$watch('scenario.parameters.questionAudio', function () {
      this.$refs.questionPlayer.load();
    });
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }
      if (this.scenario.parameters.questionGenerationState) {
        this.tmp.generatedQuestionAudio = this.scenario.parameters.questionAudio;
      } else {
        this.tmp.loadedQuestionAudio = this.scenario.parameters.questionAudio;
      }

      this.tmp.currentSpeaker = this.scenario.parameters.questionSpeaker || this.tmp.currentSpeaker;
      this.tmp.currentEmotion = this.scenario.parameters.questionEmotion || this.tmp.currentEmotion;
      this.tmp.currentSpeed = this.scenario.parameters.questionSpeed || this.tmp.currentSpeed;
    }
  },

  beforeUpdate: function beforeUpdate() {
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }
      if (this.scenario.parameters.questionGenerationState) {
        this.tmp.generatedQuestionAudio = this.scenario.parameters.questionAudio;
      } else {
        this.tmp.loadedQuestionAudio = this.scenario.parameters.questionAudio;
      }
    }
  }
});

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.loadedScenario))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Название сценария")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.name),
      expression: "scenario.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название сценария"
    },
    domProps: {
      "value": (_vm.scenario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Сообщение")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionGenerationState),
      expression: "scenario.parameters.questionGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionGenerationState', 'questionAudio', 'generatedQuestionAudio', 'loadedQuestionAudio', 'questionPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionGenerationState),
      expression: "scenario.parameters.questionGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionGenerationState', 'questionAudio', 'generatedQuestionAudio', 'loadedQuestionAudio', 'questionPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionText),
      expression: "scenario.parameters.questionText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionId', 'questionAudio', 'generatedQuestionAudio', 'questionText', 'questionLoading', 'question')
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.tmp.questionLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n        Сгенерировать аудио\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSpeaker),
      expression: "currentSpeaker"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentSpeaker = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n            " + _vm._s(speaker.value) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentEmotion),
      expression: "currentEmotion"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentEmotion = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n            " + _vm._s(emotion.value) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.currentSpeed,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.currentSpeed = $event
      }
    }
  }), _vm._v("\n        Скорость: " + _vm._s(_vm.currentSpeed) + "\n      ")], 1), _vm._v(" "), (_vm.tmp.generatedQuestionAudio) ? _c('audio', {
    ref: 'questionPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionAudio
    }
  }), _vm._v("\n        Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.generatedQuestionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('loadAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "loadAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('loadAudio', 'questionId', 'questionAudio', 'loadedQuestionAudio', 'question', 'questionPlayer')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionId', 'questionAudio', 'loadedQuestionAudio', 'question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.loadedQuestionAudio) ? _c('audio', {
    ref: "questionPlayer"
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionAudio
    }
  }), _vm._v("\n        Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.loadedQuestionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionId', 'questionAudio', 'loadedQuestionAudio', 'generatedQuestionAudio')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), _vm._m(4), _vm._v(" "), (_vm.scenario.isReady) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v("Подготовлен")])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(6), _vm._v(" "), _c('span', [_vm._v("Не подготовлен")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-primary"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })]), _vm._v(" "), _c('span', [_vm._v("Рассчитать стоимость")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
}]}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Answer__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Answer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Answer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScenarioSaver__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScenarioSaver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ScenarioSaver__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name', 'campaignid'],
  components: { ScenarioBar: __WEBPACK_IMPORTED_MODULE_1__ScenarioSaver___default.a, Answer: __WEBPACK_IMPORTED_MODULE_0__Answer___default.a },
  data: function data() {
    return {
      scenario: {
        template: 'dentapromotion',
        client: '',
        parameters: {
          mainQuestionAudio: [],
          mainQuestionText: '',

          onYesAudio: [],
          onYesText: '',

          onNoAudio: [],
          onNoText: '',

          onFailAudio: [],
          onFailText: '',

          onSecondFailAudio: [],
          onSecondFailText: ''
        },
        checkDuration: true,
        isReady: false
      },

      isSaved: false
    };
  },

  methods: {
    setScenario: function setScenario(value) {
      this.scenario = value;
      if (!this.isSaved) {
        this.isSaved = true;
      }
    },
    setMainQuestionAudio: function setMainQuestionAudio(data) {
      this.scenario.parameters.mainQuestionAudio = this.generateAudio(data, { audio: this.scenario.parameters.mainQuestionAudio });
    },
    setYesAudio: function setYesAudio(data) {
      this.scenario.parameters.onYesAudio = this.generateAudio(data, { audio: this.scenario.parameters.onYesAudio });
    },
    setNoAudio: function setNoAudio(data) {
      this.scenario.parameters.onNoAudio = this.generateAudio(data, { audio: this.scenario.parameters.onNoAudio });
    },
    setFailAudio: function setFailAudio(data) {
      this.scenario.parameters.onFailAudio = this.generateAudio(data, { audio: this.scenario.parameters.onFailAudio });
    },
    setSecondFailAudio: function setSecondFailAudio(data) {
      this.scenario.parameters.onSecondFailAudio = this.generateAudio(data, { audio: this.scenario.parameters.onSecondFailAudio });
    },
    generateAudio: function generateAudio(data, answer) {
      if (data.type) {
        var audio = {
          type: data.type,
          url: data.url,
          param: data.paramName,
          number: data.number
        };
        var audioTmp = [];
        audioTmp.push(audio);
        if (answer.audio) {
          for (var i = 0; i < answer.audio.length; i++) {
            audioTmp.push(answer.audio[i]);
          }
        }
        audioTmp.sort(function (a, b) {
          return a.number > b.number ? 1 : -1;
        });
        return audioTmp;
      } else {
        return [];
      }
    },
    deleteMainQuestionAudio: function deleteMainQuestionAudio(data) {
      this.deleteAudio(this.scenario.parameters.mainQuestionAudio, data);
    },
    deleteYesAudio: function deleteYesAudio(data) {
      this.deleteAudio(this.scenario.parameters.onYesAudio, data);
    },
    deleteNoAudio: function deleteNoAudio(data) {
      this.deleteAudio(this.scenario.parameters.onNoAudio, data);
    },
    deleteFailAudio: function deleteFailAudio(data) {
      this.deleteAudio(this.scenario.parameters.onFailAudio, data);
    },
    deleteSecondFailAudio: function deleteSecondFailAudio(data) {
      this.deleteAudio(this.scenario.parameters.onSecondFailAudio, data);
    },
    deleteAudio: function deleteAudio(audio, data) {
      if (audio) {
        for (var i = 0; i < audio.length; i++) {
          if (audio[i] === data) {
            audio.splice(i, 1);
          }
        }
      }
    },
    setMainQuestionAudioDuration: function setMainQuestionAudioDuration(data) {
      this.setAudioDuration(this.scenario.parameters.mainQuestionAudio, data);
    },
    setRepeatAudioDuration: function setRepeatAudioDuration(data) {
      this.setAudioDuration(this.scenario.parameters.onFailAudio, data);
    },
    setAudioDuration: function setAudioDuration(audio, data) {
      if (audio && data && data.url && data.duration) {
        for (var i = 0; i < audio.length; i++) {
          if (audio[i].url === data.url) {
            audio[i].duration = data.duration;
          }
        }
      }
    }
  }
});

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "denta_promotion"
  }, [_c('div', [_c('div', {
    staticClass: "firstQuestion answer_shell center"
  }, [_c('answer', {
    attrs: {
      "answer-title": "Приветсвтие",
      "answer-audio": _vm.scenario.parameters.mainQuestionAudio,
      "answer-text": _vm.scenario.parameters.mainQuestionText,
      "is-saved": _vm.isSaved,
      "client": _vm.scenario.client
    },
    on: {
      "update:answerAudio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionAudio", $event)
      },
      "update:answer-audio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionAudio", $event)
      },
      "update:answerText": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionText", $event)
      },
      "update:answer-text": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionText", $event)
      },
      "generateAudioHandler": _vm.setMainQuestionAudio,
      "deleteAudioHandler": _vm.deleteMainQuestionAudio,
      "setAudioDuration": _vm.setMainQuestionAudioDuration
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "answers"
  }, [_c('div', {
    staticClass: "afterYes answer_shell"
  }, [_c('answer', {
    attrs: {
      "answer-title": "Да",
      "answer-audio": _vm.scenario.parameters.onYesAudio,
      "answer-text": _vm.scenario.parameters.onYesText,
      "is-saved": _vm.isSaved,
      "client": _vm.scenario.client
    },
    on: {
      "update:answerAudio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesAudio", $event)
      },
      "update:answer-audio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesAudio", $event)
      },
      "update:answerText": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesText", $event)
      },
      "update:answer-text": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesText", $event)
      },
      "generateAudioHandler": _vm.setYesAudio,
      "deleteAudioHandler": _vm.deleteYesAudio
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "afterNo answer_shell"
  }, [_c('answer', {
    attrs: {
      "answer-title": "Нет",
      "answer-audio": _vm.scenario.parameters.onNoAudio,
      "answer-text": _vm.scenario.parameters.onNoText,
      "is-saved": _vm.isSaved,
      "client": _vm.scenario.client
    },
    on: {
      "update:answerAudio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoAudio", $event)
      },
      "update:answer-audio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoAudio", $event)
      },
      "update:answerText": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoText", $event)
      },
      "update:answer-text": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoText", $event)
      },
      "generateAudioHandler": _vm.setNoAudio,
      "deleteAudioHandler": _vm.deleteNoAudio
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "afterFail answer_shell"
  }, [_c('answer', {
    attrs: {
      "answer-title": "Молчание/неразборчиво",
      "answer-audio": _vm.scenario.parameters.onFailAudio,
      "answer-text": _vm.scenario.parameters.onFailText,
      "is-saved": _vm.isSaved,
      "client": _vm.scenario.client
    },
    on: {
      "update:answerAudio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onFailAudio", $event)
      },
      "update:answer-audio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onFailAudio", $event)
      },
      "update:answerText": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onFailText", $event)
      },
      "update:answer-text": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onFailText", $event)
      },
      "generateAudioHandler": _vm.setFailAudio,
      "deleteAudioHandler": _vm.deleteFailAudio,
      "setAudioDuration": _vm.setRepeatAudioDuration
    }
  }), _vm._v(" "), _c('answer', {
    attrs: {
      "answer-title": "Второй раз молчание/неразборчиво",
      "answer-audio": _vm.scenario.parameters.onSecondFailAudio,
      "answer-text": _vm.scenario.parameters.onSecondFailText,
      "is-saved": _vm.isSaved,
      "client": _vm.scenario.client
    },
    on: {
      "update:answerAudio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onSecondFailAudio", $event)
      },
      "update:answer-audio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onSecondFailAudio", $event)
      },
      "update:answerText": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onSecondFailText", $event)
      },
      "update:answer-text": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onSecondFailText", $event)
      },
      "generateAudioHandler": _vm.setSecondFailAudio,
      "deleteAudioHandler": _vm.deleteSecondFailAudio
    }
  })], 1)])]), _vm._v(" "), _c('div', [_c('scenario-bar', {
    attrs: {
      "name": _vm.name,
      "is-saved": _vm.isSaved,
      "is-ready": _vm.scenario.isReady,
      "scenario": _vm.scenario
    },
    on: {
      "set": _vm.setScenario
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Answer__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Answer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Answer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScenarioSaver__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScenarioSaver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ScenarioSaver__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name', 'campaignid'],
  components: { ScenarioBar: __WEBPACK_IMPORTED_MODULE_1__ScenarioSaver___default.a, Answer: __WEBPACK_IMPORTED_MODULE_0__Answer___default.a },
  data: function data() {
    return {
      scenario: {
        template: 'akvamir',
        client: '',
        parameters: {
          mainQuestionId: '',
          mainQuestionAudio: [],
          mainQuestionText: '',
          mainGenerationState: true,

          answers: [{
            audio: [],
            text: '',
            generationState: true,
            title: 'Начало разговора',
            theme: 'start',
            speaker: 'oksana',
            emotion: 'neutral',
            speed: 1
          }, {
            audio: [],
            text: '',
            generationState: true,
            title: 'Проблема',
            words: '(не пришли билеты, нет чека, не правильно указана почта, деньги списались а ни...',
            theme: 'some_problem',
            speaker: 'oksana',
            emotion: 'neutral',
            speed: 1
          }, {
            audio: [],
            text: '',
            generationState: true,
            title: 'Отдел продаж',
            words: '(купить много билетов, корпоративная скидка, автобусные туры, юр лицо...',
            theme: 'sale_department',
            speaker: 'oksana',
            emotion: 'neutral',
            speed: 1
          }, {
            audio: [],
            text: '',
            generationState: true,
            title: 'Администратор',
            words: '(забыл, цепочка, кольцо, сережки, пропал, украли, оставил, гардероб)',
            theme: 'administrator',
            speaker: 'oksana',
            emotion: 'neutral',
            speed: 1
          }, {
            audio: [],
            text: '',
            generationState: true,
            title: 'Тариф',
            words: '(цена билета, поход, стоимость,заплатить, сколько, стоит, билет, вечерний, утренний...',
            theme: 'tariff',
            speaker: 'oksana',
            emotion: 'neutral',
            speed: 1
          }, {
            audio: [],
            text: '',
            generationState: true,
            title: 'Маршрут',
            words: '(доехать, адрес, добраться, вокзал, автовокзал, проехать, автобус, маршрутка...',
            theme: 'route',
            speaker: 'oksana',
            emotion: 'neutral',
            speed: 1
          }, {
            audio: [],
            text: '',
            generationState: true,
            title: 'Акция',
            words: '(скидка, спецпредложения, акция, дёшево, предложения, день рождения, именинник...',
            theme: 'stock',
            speaker: 'oksana',
            emotion: 'neutral',
            speed: 1
          }, {
            audio: [],
            text: '',
            generationState: true,
            title: 'Принадлежности',
            words: '(брать с собой, полотенце, тапочки, шапочка, жилет, круг, памперсы...',
            theme: 'accessories',
            speaker: 'oksana',
            emotion: 'neutral',
            speed: 1
          }, {
            audio: [],
            text: '',
            generationState: true,
            title: 'Льгота',
            words: '(многодетная, инвалид, участник, ветеран,боевых действий, Афганец, Чечня, Сирия...',
            theme: 'benefits',
            speaker: 'oksana',
            emotion: 'neutral',
            speed: 1
          }, {
            audio: [],
            text: '',
            generationState: true,
            title: 'Группа',
            words: '(туры, группы, групповые, групповой, класс, много человек, коллектив, компания)',
            theme: 'group',
            speaker: 'oksana',
            emotion: 'neutral',
            speed: 1
          }, {
            audio: [],
            text: '',
            generationState: true,
            title: 'Возврат',
            words: '(вернуть деньги, не смог посетить)',
            theme: 'return',
            speaker: 'oksana',
            emotion: 'neutral',
            speed: 1
          }, {
            audio: [],
            text: '',
            generationState: true,
            title: 'Сертификат',
            words: '(подарок, подарочный, доплата, срок годности)',
            theme: 'certificate',
            speaker: 'oksana',
            emotion: 'neutral',
            speed: 1
          }, {
            audio: [],
            text: '',
            generationState: true,
            title: 'Динопарк',
            words: '(динопарк, динозавр, юрского, шоу доисторических животных)',
            theme: 'dinosaurs',
            speaker: 'oksana',
            emotion: 'neutral',
            speed: 1
          }, {
            audio: [],
            text: '',
            generationState: true,
            title: 'Правила',
            words: '(правила, поведение)',
            theme: 'rules',
            speaker: 'oksana',
            emotion: 'neutral',
            speed: 1
          }, {
            audio: [],
            text: '',
            generationState: true,
            title: 'Все вопросы',
            words: '',
            theme: 'all_questions',
            speaker: 'oksana',
            emotion: 'neutral',
            speed: 1
          }]

        },
        checkDuration: true,
        isReady: false
      },

      isSaved: false
    };
  },

  methods: {
    setScenario: function setScenario(value) {
      if (value) {
        for (var i = 0; i < value.parameters.answers.length; i++) {
          value.parameters.answers[i].speaker = value.parameters.answers[i].speaker || 'oksana';
          value.parameters.answers[i].emotion = value.parameters.answers[i].emotion || 'neutral';
          value.parameters.answers[i].speed = value.parameters.answers[i].speed || 1;
        }
        if (value.parameters.answers.length && value.parameters.answers[0].theme !== 'start') {
          value.parameters.answers.unshift({
            audio: [],
            text: '',
            generationState: true,
            title: 'Начало разговора',
            theme: 'start',
            speaker: 'oksana',
            emotion: 'neutral',
            speed: 1
          });
        }
        if (value.parameters.answers.length && value.parameters.answers[value.parameters.answers.length - 2].theme !== 'rules') {
          value.parameters.answers.splice(value.parameters.answers.length - 1, 0, {
            audio: [],
            text: '',
            generationState: true,
            title: 'Динопарк',
            words: '(динопарк, динозавр, юрского, шоу доисторических животных)',
            theme: 'dinosaurs',
            speaker: 'oksana',
            emotion: 'neutral',
            speed: 1
          });
          value.parameters.answers.splice(value.parameters.answers.length - 1, 0, {
            audio: [],
            text: '',
            generationState: true,
            title: 'Правила',
            words: '(правила, поведение)',
            theme: 'rules',
            speaker: 'oksana',
            emotion: 'neutral',
            speed: 1
          });
        }
      }
      this.scenario = value;
      if (!this.isSaved) {
        this.isSaved = true;
      }
    },
    setAudio: function setAudio(data) {
      var answer = this.getAnswerObjByClass(data.theme);
      if (answer) {
        if (data.type) {
          var audio = {
            type: data.type,
            url: data.url,
            param: data.paramName,
            number: data.number
          };
          answer.audio = answer.audio || [];
          var audioTmp = [];
          audioTmp.push(audio);
          for (var i = 0; i < answer.audio.length; i++) {
            audioTmp.push(answer.audio[i]);
          }
          audioTmp.sort(function (a, b) {
            return a.number > b.number ? 1 : -1;
          });
          answer.audio = audioTmp;
        } else {
          answer.audio = [];
        }
      }
    },
    deleteAudio: function deleteAudio(data) {
      var answer = this.getAnswerObjByClass(data.theme);
      if (answer) {
        answer.audio[0].url = null;
      }
    },
    getAnswerObjByClass: function getAnswerObjByClass(answerTheme) {
      for (var i = 0; i < this.scenario.parameters.answers.length; i++) {
        var answer = this.scenario.parameters.answers[i];
        if (answer.theme.toLocaleLowerCase() === answerTheme.toLowerCase()) {
          return answer;
        }
      }
    }
  }
});

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "akvamir"
  }, [_c('div', _vm._l((_vm.scenario.parameters.answers), function(answer) {
    return _c('div', {
      staticClass: "answer_shell",
      class: answer.theme === 'start' ? 'start' : ''
    }, [_c('answer', {
      attrs: {
        "answer-title": answer.title,
        "answer-theme": answer.theme,
        "answer-words": answer.words,
        "answer-audio": answer.audio,
        "answer-text": answer.text,
        "answer-speaker": answer.speaker,
        "answer-emotion": answer.emotion,
        "answer-speed": answer.speed,
        "is-saved": _vm.isSaved,
        "client": _vm.scenario.client
      },
      on: {
        "update:answerAudio": function($event) {
          return _vm.$set(answer, "audio", $event)
        },
        "update:answer-audio": function($event) {
          return _vm.$set(answer, "audio", $event)
        },
        "update:answerText": function($event) {
          return _vm.$set(answer, "text", $event)
        },
        "update:answer-text": function($event) {
          return _vm.$set(answer, "text", $event)
        },
        "update:answerSpeaker": function($event) {
          return _vm.$set(answer, "speaker", $event)
        },
        "update:answer-speaker": function($event) {
          return _vm.$set(answer, "speaker", $event)
        },
        "update:answerEmotion": function($event) {
          return _vm.$set(answer, "emotion", $event)
        },
        "update:answer-emotion": function($event) {
          return _vm.$set(answer, "emotion", $event)
        },
        "update:answerSpeed": function($event) {
          return _vm.$set(answer, "speed", $event)
        },
        "update:answer-speed": function($event) {
          return _vm.$set(answer, "speed", $event)
        },
        "generateAudioHandler": _vm.setAudio,
        "deleteAudioHandler": _vm.deleteAudio
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', [_c('scenario-bar', {
    attrs: {
      "name": _vm.name,
      "is-saved": _vm.isSaved,
      "is-ready": _vm.scenario.isReady,
      "scenario": _vm.scenario
    },
    on: {
      "set": _vm.setScenario
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseEditableNode_vue__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseEditableNode_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__BaseEditableNode_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Redirect__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Redirect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Redirect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sms__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ScenarioInfo__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ScenarioInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ScenarioInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Zoom__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ToolButtons__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ToolButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ToolButtons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ScenarioCommonParams__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ScenarioCommonParams___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ScenarioCommonParams__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HttpRequest__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HttpRequest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__HttpRequest__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Konstruktor',
  props: ['name', 'campaignid', 'availableSmsGateways', 'pScenario'],
  components: { ScenarioCommonParams: __WEBPACK_IMPORTED_MODULE_6__ScenarioCommonParams___default.a, ToolButtons: __WEBPACK_IMPORTED_MODULE_5__ToolButtons___default.a, Zoom: __WEBPACK_IMPORTED_MODULE_4__Zoom___default.a, ScenarioInfo: __WEBPACK_IMPORTED_MODULE_3__ScenarioInfo___default.a },
  data: function data() {
    return {
      view: {
        nodeComponent: __WEBPACK_IMPORTED_MODULE_0__BaseEditableNode_vue___default.a,
        nodeRedirectComponent: __WEBPACK_IMPORTED_MODULE_1__Redirect___default.a,
        nodeSmsComponent: __WEBPACK_IMPORTED_MODULE_2__Sms___default.a,
        nodeHttpRequestComponent: __WEBPACK_IMPORTED_MODULE_7__HttpRequest___default.a
      },
      scenario: {
        id: '',
        template: 'universal',
        client: '',
        parameters: {
          states: [{
            data: {
              audio: [],
              id: '',
              title: this.$i18n.messages[this.$i18n.locale].scenarios.konstruktor.canvas.answer.startOfTalk,
              stateQuestion: this.$i18n.messages[this.$i18n.locale].scenarios.konstruktor.canvas.answer.startOfTalk,
              // titleTrans: 'scenarios.konstruktor.canvas.answer.startOfTalk',
              words: [],
              isSilence: false, // Молчание
              isIllegibly: false, // Не разборчиво
              generationAudioType: 'generateFromText',
              searchStrategy: '',
              simulatedDelayMillis: 0,
              emotion: '',
              vendor: '',
              lang: '',
              speaker: '',
              speed: '',
              googleSsmlType: ''
            },
            view: {
              // w: 780,
              // h: 277,
              top: 20,
              left: 400, // ToDo
              baseHeight: 277,
              windowType: 'big'
            },
            startNode: true
          }],
          connections: [],
          visual: {
            connector: 'Straight',
            hideArrows: false
          },
          common: {
            locale: 'ru-RU',
            recognitionDriver: 'google'
          }
        },
        checkDuration: true
      }
    };
  },

  methods: {
    setScenario: function setScenario(value) {
      this.initScenario(value);
      this.reDrawScenario();
    },
    initScenario: function initScenario(value) {
      if (value) {
        if (!value.parameters.visual) {
          value.parameters.visual = {
            connector: 'Straight',
            hideArrows: false,
            compactWindows: false
          };
        }
        if (!value.parameters.common) {
          value.parameters.common = {
            locale: 'ru-RU',
            recognitionDriver: 'google'
          };
        }
        if (!value.parameters.common.recognitionDriver) {
          value.parameters.common.recognitionDriver = 'google';
        }
        this.scenario = value;
        var scenarioObj = document.querySelector('.active_scenario_universal');
        if (scenarioObj) {
          if (this.scenario.id) {
            scenarioObj.classList.add('is-saved');
          } else {
            scenarioObj.classList.remove('is-saved');
          }
        }
      }
    },
    reDrawScenario: function reDrawScenario() {
      this.$children[0].drawScenario(this.scenario.parameters);
    },
    getNodeAudio: function getNodeAudio(node) {
      var audio = [];
      var audioItems = node.querySelectorAll('.audio_list .audio.audio_item');
      for (var i = 0; i < audioItems.length; i++) {
        var audioItem = audioItems[i];
        var audioObj = audioItem.querySelector('audio source');
        var audioParamObj = audioItem.querySelector('.audioParam');
        if (audioObj) {
          audio.push({
            type: 'url',
            id: audioItem.querySelector('.id').value,
            url: audioObj.getAttribute('src'),
            number: audioItem.querySelector('.number').value,
            duration: audioItem.querySelector('.audioDuration').value
          });
        } else if (audioParamObj) {
          audio.push({
            type: 'param',
            paramName: audioParamObj.value,
            vendor: node.parentElement.parentElement.querySelector('select.vendor').value,
            voice: node.parentElement.parentElement.querySelector('.speaker .voice').value,
            number: audioItem.querySelector('.number').value
          });
        }
      }
      audio.sort(function (a, b) {
        return a.number > b.number ? 1 : -1;
      });
      return audio;
    },
    getNodeWords: function getNodeWords(node) {
      var words = [];
      var tagsStr = (node.querySelector('.wordsEditor .tags-input.tags').textContent || '').split('\n');
      for (var i = 0; i < tagsStr.length; i++) {
        var tagStr = tagsStr[i].trim();
        if (tagStr && tagsStr.length) {
          words.push(tagStr);
        }
      }
      return words;
    },
    initAnswersFromCanvas: function initAnswersFromCanvas(toolkit) {
      var states = [];
      var nodes = document.querySelectorAll('#Konstruktor .flowchart-object.answer_shell');
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        var view = {
          // w: node.offsetWidth,
          // h: node.offsetHeight,
          top: node.offsetTop,
          left: node.offsetLeft
        };
        if (node.classList.contains('medium')) {
          view.windowType = 'medium';
        } else if (node.classList.contains('small')) {
          view.windowType = 'small';
        }
        var state = {
          text: node.querySelector('.main .text').value,
          audio: this.getNodeAudio(node.querySelector('.mainAudioList')),
          generationAudioType: node.querySelector('.tab-content.is-active .generationType').value,
          id: node.id,
          title: node.querySelector('.answerTitle').innerText,
          stateQuestion: node.querySelector('input.stateQuestion').value,
          stateValue: node.querySelector('input.stateValue').value,
          useTranscribeByValue: !node.querySelector('.value .switch input').checked,
          words: this.getNodeWords(node),
          isSilence: node.querySelector('input.checkbox.isSilence').checked,
          isIllegibly: node.querySelector('input.checkbox.isIllegibly').checked,
          simulatedDelayMillis: node.querySelector('.simulatedDelayMillis').value,
          vendor: node.querySelector('.main .generate_audio_control select.vendor') ? node.querySelector('.main .generate_audio_control select.vendor').value : '',
          lang: node.querySelector('.main .generate_audio_control .lang') ? node.querySelector('.main .generate_audio_control .lang').value : '',
          speaker: node.querySelector('.main .generate_audio_control .voice') ? node.querySelector('.main .generate_audio_control .voice').value : '',
          emotion: node.querySelector('.main .generate_audio_control .emotion') ? node.querySelector('.main .generate_audio_control .emotion').value : '',
          speed: node.querySelector('.main .speed.generate_audio_control input') ? node.querySelector('.main .speed.generate_audio_control input').value : '',
          googleSsmlType: node.querySelector('.main .ssmlType') ? node.querySelector('.main .ssmlType').value : ''
        };
        var searchStrategyObj = node.querySelector('.searchStrategy');
        var searchStrategyTrObj = searchStrategyObj.closest('tr');
        if (searchStrategyObj && searchStrategyObj.style.display !== 'none' && searchStrategyTrObj && searchStrategyTrObj.style.display !== 'none') {
          state.searchStrategy = searchStrategyObj.value;
        }

        state.recognitionDriver = node.querySelector('.playSourceConfig .recognitionDriver').value;
        state.timeout = node.querySelector('.playSourceConfig .timeout').value;
        state.startCollectBeforePlayEnd = node.querySelector('.playSourceConfig .startCollectBeforePlayEnd').value;
        state.waitingInputTimeout = node.querySelector('.playSourceConfig .waitingInputTimeout').value;
        state.silenceAfterSpeechTimeout = node.querySelector('.playSourceConfig .silenceAfterSpeechTimeout').value;
        state.delayBeforeCollect = node.querySelector('.playSourceConfig .delayBeforeCollect').value;

        var fullState = { data: state, view: view, startNode: !!node.classList.contains('start-node') };
        var redirectData = toolkit.getRedirectData(node.id);
        if (redirectData) {
          fullState.redirectSipNumber = redirectData.sip;
          fullState.redirectView = redirectData;
        }
        fullState.smsData = toolkit.getSmsData(node.id);
        fullState.httpRequestData = toolkit.getHttpRequestData(node.id);

        states.push(fullState);
      }
      return states;
    },
    initInOutStatesFromCanvas: function initInOutStatesFromCanvas() {
      var states = [];
      var nodes = document.querySelectorAll('#Konstruktor .flowchart-object.inOutState_shell');
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        var view = {
          top: node.offsetTop,
          left: node.offsetLeft
        };
        var isSilence = node.querySelector('input.checkbox.isSilence').checked;
        var isIllegibly = node.querySelector('input.checkbox.isIllegibly').checked;
        var recognitionDriver = '';
        var driverObj = node.querySelector('.driver select');
        if (driverObj) {
          recognitionDriver = driverObj.value;
        }
        var state = {
          id: node.id,
          title: node.querySelector('.answerTitle').value,
          // stateQuestion: node.querySelector('input.stateQuestion').value,
          // stateValue: node.querySelector('input.stateValue').value,
          words: !isSilence && !isIllegibly ? this.getNodeWords(node) : [],
          isSilence: isSilence,
          isIllegibly: isIllegibly,
          recognitionDriver: recognitionDriver
        };

        var fullState = { data: state, view: view, type: 'inOutState' };
        states.push(fullState);
      }
      return states;
    },
    initOutStatesFromCanvas: function initOutStatesFromCanvas() {
      var states = [];
      var nodes = document.querySelectorAll('#Konstruktor .flowchart-object.outState_shell');
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        var view = {
          top: node.offsetTop,
          left: node.offsetLeft
        };
        var state = {
          id: node.id,
          title: node.querySelector('.answerTitle').value
        };

        var fullState = { data: state, view: view, type: 'outState' };
        states.push(fullState);
      }
      return states;
    },
    initScenarioFromCanvas: function initScenarioFromCanvas() {
      console.log('initScenarioFromCanvas');
      var toolkit = this.$children[0];
      var parameters = {
        states: [],
        connections: []
      };
      var answers = this.initAnswersFromCanvas(toolkit);
      var inOutStates = this.initInOutStatesFromCanvas();
      var outStates = this.initOutStatesFromCanvas();

      for (var i = 0; i < answers.length; i++) {
        parameters.states.push(answers[i]);
      }
      for (var _i = 0; _i < inOutStates.length; _i++) {
        parameters.states.push(inOutStates[_i]);
      }
      for (var _i2 = 0; _i2 < outStates.length; _i2++) {
        parameters.states.push(outStates[_i2]);
      }

      var connections = toolkit.getAllConnections();
      if (connections) {
        for (var _i3 = 0; _i3 < connections.length; _i3++) {
          var connection = {
            sourceId: connections[_i3].sourceId,
            targetId: connections[_i3].targetId
          };
          parameters.connections.push(connection);
        }
      }
      var common = this.scenario.parameters.common;
      var visual = this.scenario.parameters.visual;
      var parametersDefaultValues = this.scenario.parameters.parametersDefaultValues;
      this.scenario.parameters = parameters;
      this.scenario.parameters.visual = visual;
      this.scenario.parameters.common = common;
      this.scenario.parameters.parametersDefaultValues = parametersDefaultValues;
    },
    hideArrowsChange: function hideArrowsChange(_hideArrowsChange) {
      if (this.scenario) {
        this.scenario.parameters.visual = this.scenario.parameters.visual || {};
        this.scenario.parameters.visual.hideArrows = _hideArrowsChange;
        if (_hideArrowsChange) {
          document.getElementById('canvas').classList.add('hidden_arrows');
        } else {
          document.getElementById('canvas').classList.remove('hidden_arrows');
        }
      }
    },
    scenarioNameChange: function scenarioNameChange(name) {
      this.scenario.name = name;
    },
    localeChange: function localeChange(locale) {
      this.scenario.parameters.common = this.scenario.parameters.common || {};
      this.scenario.parameters.common.locale = locale;
    },
    recognitionDriverChange: function recognitionDriverChange(driver) {
      this.scenario.parameters.common = this.scenario.parameters.common || {};
      this.scenario.parameters.common.recognitionDriver = driver;
    }
  },
  created: function created() {
    window.addEventListener('scroll', function (event) {
      var konstruktor = document.getElementById('Konstruktor');
      if (konstruktor) {
        if (this.scrollY > 16) {
          konstruktor.classList.add('scrolled');
        } else {
          konstruktor.classList.remove('scrolled');
        }
      }
    });
    this.initScenario(this._props.pScenario);
  },
  mounted: function mounted() {
    this.reDrawScenario();
  }
});

/***/ }),
/* 544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsplumb_extends_jsplumb_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UniversalAnswer__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UniversalAnswer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__UniversalAnswer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseComponent__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BaseComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InOutState__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InOutState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__InOutState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OutState__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OutState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__OutState__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import i18n from '../../../translations/i18n'

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { OutState: __WEBPACK_IMPORTED_MODULE_4__OutState___default.a, InOutState: __WEBPACK_IMPORTED_MODULE_3__InOutState___default.a, UniversalAnswer: __WEBPACK_IMPORTED_MODULE_1__UniversalAnswer___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__jsplumb_extends_jsplumb_vue__["a" /* BaseNodeComponent */]],
  extends: __WEBPACK_IMPORTED_MODULE_2__BaseComponent___default.a,
  props: [],
  methods: {
    getScenarioLang: function getScenarioLang() {
      var lang = 'ru-RU';
      var scenarioLangs = document.querySelectorAll('.scenarioLang');
      var scenarioLang = null;
      if (scenarioLangs) {
        scenarioLang = scenarioLangs[scenarioLangs.length - 1];
        lang = scenarioLang.value;
      }
      return lang;
    },
    getVendor: function getVendor() {
      var obj = this.$el.querySelector('.vendor');
      if (obj) {
        return obj.value;
      } else {
        return '';
      }
    },
    getSpeaker: function getSpeaker() {
      var obj = this.$el.querySelector('.voice');
      if (obj) {
        return obj.value;
      } else {
        return '';
      }
    },
    addAnswer: function addAnswer(availableSmsGateways) {
      if (this.hasRedirect()) {
        this.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].notifications.toAddRobotAnswerPleaseRemoveRedirectToOperator);
        return;
      }

      var element = this.$el;
      var thisComponent = this;
      var toolkit = this.getToolkit();
      var sourceConnections = toolkit.getConnections({ source: element.id, scope: '*' }, true);
      var data = {
        data: {
          audio: [],
          id: '',
          title: this.$i18n.messages[this.$i18n.locale].scenarios.konstruktor.canvas.answer.answer + ' ' + (1 + sourceConnections.length),
          stateQuestion: this.$i18n.messages[this.$i18n.locale].scenarios.konstruktor.canvas.answer.answer + ' ' + (1 + sourceConnections.length),
          lang: this.getScenarioLang(),
          vendor: this.getVendor(),
          speaker: this.getSpeaker()
        },
        view: {
          // w: 580,
          // h: 256,
          top: element.offsetTop + element.offsetHeight + 100,
          left: element.offsetLeft + (element.clientWidth - 580) / 2.0
        },
        titleEditable: true
      };
      var newComponent = toolkit.addNode(data, this.obj.scenarioId, availableSmsGateways);
      toolkit.addCustomConnection(thisComponent, newComponent);
    },
    addRedirect: function addRedirect(redirectNumber, redirectView) {
      redirectView = redirectView || {};
      if (this.hasAnswers()) {
        this.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].notifications.toAddRedirectToOperatorPleaseRemoveAllRobotAnswers);
        return;
      } else if (this.hasRedirect()) {
        this.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].notifications.thereIsAlreadyHasARedirectToOperator);
        return;
      }

      var element = this.$el;
      var toolkit = this.getToolkit();
      var data = {
        view: {
          w: redirectView.w || 256,
          h: redirectView.h || 128,
          top: redirectView.top || element.offsetTop + element.offsetHeight + 64,
          left: redirectView.left || element.offsetLeft + (element.clientWidth - 256) / 2.0,
          id: redirectView.id || null
        },
        redirect: redirectNumber || ''
      };
      var newComponent = toolkit.addRedirectNode(data);
      toolkit.addCustomConnection(this, newComponent);
    },
    addSMS: function addSMS(smsConfig, smsView, availableSmsGateways) {
      smsConfig = smsConfig || {};
      smsView = smsView || {};
      var element = this.$el;
      var toolkit = this.getToolkit();
      var data = {
        view: {
          w: smsView.w || 430,
          h: smsView.h || 163,
          top: smsView.top || element.offsetTop + element.offsetHeight + 64,
          left: smsView.left || element.offsetLeft + (element.clientWidth - 256) / 2.0,
          id: smsView.id || null
        },
        data: {
          text: smsConfig.text || '',
          gateway: smsConfig.gateway || 'smsc',
          sender: smsConfig.sender || ''
        },
        availableSmsGateways: availableSmsGateways
      };
      var newComponent = toolkit.addSmsNode(data);
      toolkit.addCustomConnection(this, newComponent);
    },
    addHttpRequest: function addHttpRequest(reqData, view) {
      reqData = reqData || {};
      view = view || {};
      var element = this.$el;
      var toolkit = this.getToolkit();
      if (view.id && toolkit.allNodes[view.id]) {
        toolkit.addCustomConnection(this, toolkit.allNodes[view.id]);
      } else {
        var data = {
          view: {
            w: view.w || 920,
            h: view.h || 256,
            top: view.top || element.offsetTop + element.offsetHeight + 64,
            left: view.left || element.offsetLeft + (element.clientWidth - 256) / 2.0,
            id: view.id || null
          },
          data: {
            method: reqData.method || 'GET',
            url: reqData.url || '',
            headers: reqData.headers || { 'Content-Type': 'application/json' },
            params: reqData.params || [],
            body: reqData.body || ''
          }
        };
        var newComponent = toolkit.addHttpRequestNode(data);
        toolkit.addCustomConnection(this, newComponent);
      }
    },
    addInOutState: function addInOutState(availableSmsGateways) {
      var element = this.$el;
      var thisComponent = this;
      var toolkit = this.getToolkit();
      var data = {
        type: 'inOutState',
        data: {
          id: '',
          title: this.$i18n.messages[this.$i18n.locale].scenarios.konstruktor.canvas.add.recognition
        },
        view: {
          w: 300,
          h: 300,
          top: element.offsetTop + element.offsetHeight + 100,
          left: element.offsetLeft + (element.clientWidth - 580) / 2.0
        }
      };
      var newComponent = toolkit.addNode(data, this.obj.scenarioId, availableSmsGateways);
      toolkit.addCustomConnection(thisComponent, newComponent);
    },
    deleteNode: function deleteNode() {
      var toolkit = this.getToolkit();
      toolkit.customRemoveNode(this.$el.id);
    },
    hasRedirect: function hasRedirect() {
      var toolkit = this.getToolkit();
      var firstTarget = toolkit.getFirstTarget(this);
      if (firstTarget) {
        return firstTarget.isRedirect;
      } else {
        return false;
      }
    },
    hasAnswers: function hasAnswers() {
      var toolkit = this.getToolkit();
      var firstTarget = toolkit.getFirstTarget(this);
      if (firstTarget) {
        return firstTarget.isAnswer;
      } else {
        return false;
      }
    },
    hasSms: function hasSms() {
      var toolkit = this.getToolkit();
      var allTargets = toolkit.getAllTargets(this);
      for (var i = 0; i < allTargets.length; i++) {
        if (allTargets[i].isSms) {
          return true;
        }
      }
      return false;
    },
    getNodeClass: function getNodeClass() {
      var classStr = '';
      if (this.obj.startNode) {
        classStr += 'start-node ';
      }
      if (this.obj.type === 'outState') {
        classStr += 'outState_shell ';
      } else if (this.obj.type === 'inOutState') {
        classStr += 'inOutState_shell ';
      } else {
        classStr += 'answer_shell ';
      }
      classStr += this.obj.view.windowType || '';
      // classStr += (' ConnectionsToTargetsSize-' + this.getConnectionsToTargetsSize(true))
      return classStr;
    },

    // getConnectionsToTargetsSize(withoutSilenceAndIllegibly) {
    //     let toolkit = this.getToolkit()
    //     if (toolkit) {
    //         let connections = toolkit.getConnections({source:this.$el.id})
    //         if (connections && connections.length) {
    //             if (!withoutSilenceAndIllegibly) {
    //                 return connections.length
    //             } else {
    //                 let size = 0
    //                 for (let i = 0; i < connections.length; i++) {
    //                     let targetId = connections[i].targetId
    //                     let target = toolkit.allNodes[targetId]
    //                     if (target.$el.classList.contains('outState_shell')) {
    //                         return 3
    //                     } else {
    //                         let isSilenceObj = target.$el.querySelector('input.checkbox.isSilence')
    //                         let isIllegiblyObj = target.$el.querySelector('input.checkbox.isIllegibly')
    //                         let isSilence = isSilenceObj && isSilenceObj.checked
    //                         let isIllegibly = isIllegiblyObj && isIllegiblyObj.checked
    //                         if (!isSilence && !isIllegibly) {
    //                             size++
    //                         }
    //                     }
    //                 }
    //                 return size
    //             }
    //         } else {
    //             return 0
    //         }
    //     } else {
    //         return 0
    //     }
    // },
    setNodeHeight: function setNodeHeight(count, notRepaint) {
      var newHeight = void 0;
      if (this.obj.view.windowType === 'medium' || this.obj.view.windowType === 'small') {
        newHeight = this.getBaseHeight() + Math.floor(0 + count) * 32;
      } else {
        newHeight = this.getBaseHeight() + Math.floor((1 + count) / 2) * 32;
      }
      var heightChange = this.obj && this.obj.view && (!this.obj.view.h || this.obj.view.h !== newHeight);
      this.obj.view.h = newHeight;
      if (heightChange && this.$el) {
        this.$el.style.height = newHeight + 'px';
      }
      if (!notRepaint && this.getToolkit()) {
        setInterval(this.getToolkit().repaintEverything, 500);
      }
    },
    setNodeWidth: function setNodeWidth() {
      var newWidth = this.getWidth();
      var widthChange = this.obj && this.obj.view && (!this.obj.view.w || this.obj.view.w !== newWidth);
      this.obj.view.w = newWidth;
      if (widthChange && this.$el) {
        this.$el.style.width = newWidth + 'px';
      }
    },
    setNodeMedium: function setNodeMedium(repaint) {
      this.obj.view.windowType = 'medium';
      var validUrlCount = 0;
      if (this.obj.data.audio && this.obj.data.audio.length) {
        for (var i = 0; i < this.obj.data.audio.length; i++) {
          if (this.obj.data.audio[i].url && this.obj.data.audio[i].type === 'url') {
            validUrlCount++;
          }
        }
      }
      this.setNodeHeight(validUrlCount);
      this.setNodeWidth();
      this.$el.classList.remove('small');
      this.$el.classList.add('medium');
      this.$el.classList.remove('big');
      if (repaint) {
        setInterval(this.getToolkit().repaintEverything, 500);
      }
    },
    setNodeSmall: function setNodeSmall(repaint) {
      this.obj.view.windowType = 'small';
      var validUrlCount = 0;
      if (this.obj.data.audio && this.obj.data.audio.length) {
        for (var i = 0; i < this.obj.data.audio.length; i++) {
          if (this.obj.data.audio[i].url && this.obj.data.audio[i].type === 'url') {
            validUrlCount++;
          }
        }
      }
      this.setNodeHeight(validUrlCount);
      this.setNodeWidth();
      this.$el.classList.add('small');
      this.$el.classList.remove('medium');
      this.$el.classList.remove('big');
      if (repaint) {
        setInterval(this.getToolkit().repaintEverything, 500);
      }
    },
    setNodeBig: function setNodeBig(repaint) {
      this.obj.view.windowType = 'big';
      var validUrlCount = 0;
      if (this.obj.data.audio && this.obj.data.audio.length) {
        for (var i = 0; i < this.obj.data.audio.length; i++) {
          if (this.obj.data.audio[i].url && this.obj.data.audio[i].type === 'url') {
            validUrlCount++;
          }
        }
      }
      this.setNodeHeight(validUrlCount);
      this.setNodeWidth();
      this.$el.classList.remove('small');
      this.$el.classList.remove('medium');
      this.$el.classList.add('big');
      if (repaint) {
        setInterval(this.getToolkit().repaintEverything, 500);
      }
    },
    getBaseHeight: function getBaseHeight() {
      if (this.obj.type === 'outState') {
        return 64;
      } else if (this.obj.type === 'inOutState') {
        return 300;
      } else {
        if (this.obj.view.windowType === 'medium') {
          return 162;
        } else if (this.obj.view.windowType === 'small') {
          return 80;
        } else {
          if (this.obj.startNode) {
            return 240;
          } else {
            return 223;
          }
        }
      }
    },
    getWidth: function getWidth() {
      if (this.obj.type === 'outState') {
        return 666;
      } else if (this.obj.type === 'inOutState') {
        return 300;
      } else {
        if (this.obj.view.windowType === 'medium') {
          return 400;
        } else if (this.obj.view.windowType === 'small') {
          return 200;
        } else {
          // if (this.obj.startNode) {
          //     return 780
          // } else {
          //     return 678
          // }
          return 805;
        }
      }
    },
    addWordsForAllByTitle: function addWordsForAllByTitle(data) {
      var allFlowchartObject = document.querySelectorAll('.flowchart-object');
      if (allFlowchartObject) {
        for (var i = 0; i < allFlowchartObject.length; i++) {
          var flowchartObject = allFlowchartObject[i];
          var titleObj = flowchartObject.querySelector('.title .answerTitle');
          var title = titleObj.outerText || titleObj.value;
          if (title && data.title && title.toLowerCase() === data.title.toLowerCase()) {
            var wordsEditorObj = flowchartObject.querySelector('.wordsEditor');
            var tagsObj = wordsEditorObj.querySelector('.tags-input.tags');
            var tags = tagsObj.getElementsByClassName('tag');
            for (var j = 0; j < data.tags.length; j++) {
              var hasTag = false;
              if (tags) {
                for (var k = 0; k < tags.length && !hasTag; k++) {
                  if (tags[k].outerText.trim() === data.tags[j].trim()) {
                    hasTag = true;
                  }
                }
              }
              if (!hasTag) {
                tagsObj.insertAdjacentHTML('beforeend', '<span class="tags-input-tag tag is-medium">' + data.tags[j] + '\n' + '<button type="button" class="tags-input-remove delete"></button></span>');
              }
            }
          }
        }
      }
    }
  },
  created: function created() {
    var validUrlCount = 0;
    if (this.obj.data.audio && this.obj.data.audio.length) {
      for (var i = 0; i < this.obj.data.audio.length; i++) {
        if (this.obj.data.audio[i].url && this.obj.data.audio[i].type === 'url') {
          validUrlCount++;
        }
      }
    }
    this.setNodeHeight(validUrlCount);
  }
  // i18n: i18n

});

/***/ }),
/* 546 */,
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalAudio__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ModalAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_slider__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BaseComponent__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BaseComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__BaseComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_tags__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_tags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_tags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bulma_switch__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bulma_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_bulma_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_VbSwitchWithTwoLabels__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_VbSwitchWithTwoLabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_VbSwitchWithTwoLabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__googleVoices__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_codemirror__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_codemirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_codemirror__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_codemirror_mode_htmlmixed_htmlmixed_js__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_codemirror_mode_htmlmixed_htmlmixed_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_codemirror_mode_htmlmixed_htmlmixed_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















var audioGeneratorApi = '/audios/generate';
// const audioGeneratorApi = '/audios/generate'
var audioUploadApi = '/audios/saveNew';
var audioDeleteApi = '/audios';

/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_6__BaseComponent___default.a,
  props: ['startNode', 'answerId', 'answerTitle', 'answerStateQuestion', 'answerTranskribValue', 'answerStateValue', 'answerWords', 'answerText', 'answerAudio', 'answerGenerationType', 'answerIsSilence', 'answerIsIllegibly', 'answerSearchStrategy', 'answerRecognitionDriver', 'answerTimeout', 'answerStartCollectBeforePlayEnd', 'answerStartCollectBeforePlayEnd', 'answerWaitingInputTimeout', 'answerSilenceAfterSpeechTimeout', 'answerDelayBeforeCollect', 'remove', 'addWordsForAllByTitle', 'answerCurrentVendor', 'answerCurrentLang', 'answerCurrentSpeaker', 'answerGoogleSsmlType', 'answerCurrentEmotion', 'answerCurrentSpeed', 'answerRepeat', 'answerRepeatFail', 'setNodeHeight', 'setWindowSmall', 'setWindowMedium', 'setWindowBig', 'getScenarioLang', 'answerSimulatedDelayMillis'],
  components: {
    VbSwitchWithTwoLabels: __WEBPACK_IMPORTED_MODULE_9__components_VbSwitchWithTwoLabels___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_4__ModalAudio___default.a,
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default.a,
    Collapse: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__["Item"],
    Slider: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_slider___default.a,
    VueTags: __WEBPACK_IMPORTED_MODULE_7_vue_tags___default.a,
    VbSwitch: __WEBPACK_IMPORTED_MODULE_8_vue_bulma_switch___default.a,
    codemirror: __WEBPACK_IMPORTED_MODULE_11_vue_codemirror__["codemirror"]
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['loadedScenario', 'loggedId', 'loggedUser', 'authenticationToken'])),
  methods: {
    activateTab: function activateTab(tabClass) {
      var tabs = this.$el.querySelectorAll('.tab, .tab-content');
      for (var i = 0; i < tabs.length; i++) {
        tabs[i].classList.remove('is-active');
      }
      tabs = this.$el.querySelectorAll('.' + tabClass);
      for (var _i = 0; _i < tabs.length; _i++) {
        tabs[_i].classList.add('is-active');
      }

      this.activeTab = 'main';
    },
    getScenarioId: function getScenarioId() {
      return document.querySelector('#Konstruktor .scenarioId').value;
    },
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },

    changeRoute: function changeRoute(e) {
      this.$router.push({ path: '/scenarios' + e.target.value });
    },

    addParameter: function addParameter() {
      this.tmp.text = (this.tmp.text || '') + '{parameterName}';
    },
    onVendorChange: function onVendorChange() {
      if (this.tmp.currentVendor === 'google') {
        this.tmp.currentSpeaker = this.googleVoicesMapList && this.googleVoicesMapList[this.tmp.currentLang] ? this.googleVoicesMapList[this.tmp.currentLang][0].value : '';
      } else if (this.tmp.currentVendor === 'api-host-kz') {
        this.tmp.currentSpeaker = '2018';
      } else if (this.tmp.currentVendor === 'tinkoff') {
        this.tmp.currentSpeaker = 'alyona';
        this.tmp.currentEmotion = 'funny';
      } else {
        this.tmp.currentSpeaker = 'oksana';
      }
    },
    onGoogleLanguageChange: function onGoogleLanguageChange() {
      this.tmp.currentSpeaker = this.googleVoicesMapList && this.googleVoicesMapList[this.tmp.currentLang] ? this.googleVoicesMapList[this.tmp.currentLang][0].value : '';
    },
    onTinkoffSpeakerChange: function onTinkoffSpeakerChange() {
      if (this.tmp.currentSpeaker === 'alyona') {
        this.tmp.currentEmotion = 'funny';
      }
      if (this.tmp.currentSpeaker === 'dorofeev') {
        this.tmp.currentEmotion = 'neutral';
      }
      if (this.tmp.currentSpeaker === 'maxim') {
        this.tmp.currentEmotion = '';
      }
    },
    genAudioRequest: function genAudioRequest(text) {
      var request = void 0;
      if (this.tmp.currentVendor === 'google') {
        request = this.genAudioRequestByGoogle(text);
      } else if (this.tmp.currentVendor === 'api-host-kz') {
        request = this.genAudioRequestByApiHost(text);
      } else if (this.tmp.currentVendor === 'tinkoff') {
        request = this.genAudioRequestByTinkoff(text);
      } else {
        request = this.genAudioRequestByYandex(text);
      }
      return request;
    },
    genAudioRequestByYandex: function genAudioRequestByYandex(text) {
      var request = {
        'commonParameters': {
          'client': this.getScenarioId(),
          'scenario': this.getScenarioId(),
          'audioName': this._props.name,
          'text': text
        },

        'vendorSpecificParameters': {
          'speaker': this.tmp.currentSpeaker,
          'emotion': this.tmp.currentEmotion,
          'speed': this.tmp.currentSpeed
        },

        'vendor': 'yandex'
      };
      console.log(JSON.stringify(request));
      return request;
    },
    genAudioRequestByApiHost: function genAudioRequestByApiHost(text) {
      var request = {
        'commonParameters': {
          'client': this.getScenarioId(),
          'scenario': this.getScenarioId(),
          'audioName': this._props.name,
          'text': text
        },

        'vendorSpecificParameters': {
          'speaker': this.tmp.currentSpeaker,
          'emotion': this.tmp.currentEmotion,
          'speed': this.tmp.currentSpeed
        },

        'vendor': 'api-host-kz'
      };
      console.log(JSON.stringify(request));
      return request;
    },
    genAudioRequestByTinkoff: function genAudioRequestByTinkoff(text) {
      var request = {
        'commonParameters': {
          'client': this.getScenarioId(),
          'scenario': this.getScenarioId(),
          'audioName': this._props.name,
          'text': text
        },

        'vendorSpecificParameters': {
          'speaker': this.tmp.currentSpeaker,
          'emotion': this.tmp.currentEmotion,
          'speed': this.tmp.currentSpeed
        },

        'vendor': 'tinkoff'
      };
      console.log(JSON.stringify(request));
      return request;
    },
    genAudioRequestByGoogle: function genAudioRequestByGoogle(text) {
      var request = {
        'commonParameters': {
          'client': this.getScenarioId(),
          'scenario': this.getScenarioId(),
          'audioName': this._props.name,
          'text': text
        },

        'vendorSpecificParameters': {
          'languageCode': this.tmp.currentLang,
          'voiceName': this.tmp.currentSpeaker,
          'speakingRate': this.tmp.currentSpeed
        },

        'vendor': 'google'

        // 'text': (this.tmp.googleSsmlType !== 'ssml') ? text : '',
        // 'ssml': (this.tmp.googleSsmlType === 'ssml') ? text : '', TODO support ssml

      };console.log(JSON.stringify(request));
      return request;
    },
    securityHeaders: function securityHeaders() {
      return {
        'testH': 'testHV',
        'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ'
      };
    },
    getValidAudioUrlsCount: function getValidAudioUrlsCount() {
      var validUrlCount = 0;
      var audioList = void 0;
      audioList = this.tmp.audio;
      if (audioList && audioList.length) {
        for (var i = 0; i < audioList.length; i++) {
          if (audioList[i].url && audioList[i].type === 'url') {
            validUrlCount++;
          }
        }
      }
      return validUrlCount;
    },
    getAudioSizeClass: function getAudioSizeClass() {
      var validUrlCount = this.getValidAudioUrlsCount();
      return validUrlCount ? validUrlCount === 1 ? 'size_1' : validUrlCount > 2 ? 'size_2 size_more_2' : 'size_2' : 'empty';
    },
    getAudioClass: function getAudioClass(audio) {
      var classStr = '' + audio.type;
      if (audio.type === 'url' && audio.urlIndex) {
        if (audio.urlIndex % 2) {
          classStr += ' first_url';
        } else {
          classStr += ' second_url';
        }
      }
      return classStr;
    },
    removeAudioItems: function removeAudioItems() {
      for (var i = 0; i < this.tmp.audio.length; i++) {
        if (this.tmp.audio[i].id) {
          this.deleteAudioFromBase(this.tmp.audio[i].id);
        }
      }
      this.tmp.audio = [{ type: 'url', number: 1 }];
      // this.deleteAudiosFromBase()
    },
    removeAudioItem: function removeAudioItem(audio) {
      var filtered = this.tmp.audio.filter(function (value, index, arr) {
        return value !== audio;
      });
      this.tmp.audio = filtered;
      if (audio.id) {
        this.deleteAudioFromBase(audio.id);
      }
    },
    addAudioItem: function addAudioItem(type) {
      var maxNumber = 1;
      for (var i = 0; i < this.tmp.audio.length; i++) {
        if ((this.tmp.audio[i].number || 0) > maxNumber) {
          maxNumber = this.tmp.audio[i].number;
        }
      }
      this.pushAudio({
        number: maxNumber + 1,
        type: type
      });
    },
    pushAudio: function pushAudio(audio) {
      var audioList = void 0;
      audioList = this.tmp.audio;
      audioList.push(audio);
      audioList.sort(function (a, b) {
        return (a.number || 0) > (b.number || 0) ? 1 : -1;
      });
      this.setAudiosUrlIndex(audioList);
    },
    setAudiosUrlIndex: function setAudiosUrlIndex(audioList) {
      if (audioList && audioList.length) {
        var urlIndex = 0;
        for (var i = 0; i < audioList.length; i++) {
          if (audioList[i].type === 'url') {
            urlIndex++;
            audioList[i].urlIndex = urlIndex;
          }
        }
      }
    },
    getAudioGeneratorUrl: function getAudioGeneratorUrl() {
      return audioGeneratorApi;
    },
    genAudio: function genAudio(texts) {
      var _this = this;

      var index = 0;
      var that = this;

      function requestSuccessCallback(data, number) {
        if (that.tmp.onLoading) {
          that.pushAudio({
            id: data,
            number: number,
            type: 'url',
            url: '/audios/' + data + '.wav'
          });
          index++;
          if (index === texts.length) {
            that.tmp.onLoading = false;
            that._props.setNodeHeight(that.getValidAudioUrlsCount());
          }
        }
      }

      function requestFailCallback(error, i) {
        console.log(error);
        that.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].notifications.errorLoadAudio);
        that.tmp.onLoading = false;
        if (!i) {
          that._props.setNodeHeight(that.getValidAudioUrlsCount());
        }
      }

      if (!this.getScenarioId()) {
        this.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].notifications.beforeGenerateAudioYouShouldSaveScenario);
      } else {
        this.tmp.onLoading = true;
        this.removeAudioItems();
        this.tmp.audio = [];
        var headers = { headers: this.securityHeaders() };

        var _loop = function _loop(i) {
          if (texts[i].type === 'text') {
            var request = _this.genAudioRequest(texts[i].text);
            _this.$http.post(_this.getAudioGeneratorUrl(), request, headers).then(function (response) {
              requestSuccessCallback(response.data, i);
            }).catch(function (error) {
              requestFailCallback(error, i);
              // if (error || requestFailCallback) {
              //   requestSuccessCallback('111' + i, i)
              // }
            });
          } else {
            that.pushAudio({
              number: i,
              type: 'param',
              paramName: texts[i].paramName
            });
            index++;
          }
        };

        for (var i = 0; i < texts.length; i++) {
          _loop(i);
        }
      }
    },
    genMainAudio: function genMainAudio() {
      var texts = this.parseText(this.tmp.text);
      this.genAudio(texts, 'main');
    },
    parseText: function parseText(pText) {
      var fullText = ((pText || '') + '').trim();
      var texts = [];
      var symbol = '{';
      var finder = 'open_param';

      while (fullText.length) {
        var startParam = fullText.indexOf(symbol);
        if (startParam > -1) {
          var text = fullText.substr(0, startParam);
          if (text) {
            if (finder === 'open_param') {
              var textPart = text.replace('{', '').replace('}', '').trim();
              if (textPart) {
                if (/\d/.test(textPart) || textPart.match(/[a-z]/i) != null || textPart.match(/[а-я]/i) != null) {
                  texts.push({
                    type: 'text',
                    text: textPart
                  });
                }
              }
            } else {
              texts.push({
                type: 'param',
                paramName: text.replace('{', '').replace('}', '')
              });
            }
          }
          finder = finder === 'open_param' ? 'close_param' : 'open_param';
          symbol = symbol === '{' ? '}' : '{';
          fullText = fullText.substr(startParam + 1);
        } else {
          if (fullText) {
            texts.push({
              type: 'text',
              text: fullText
            });
          }
          fullText = '';
        }
      }
      return texts;
    },
    uploadFile: function uploadFile() {
      if (!this.getScenarioId()) {
        this.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].notifications.beforeUploadFileYouShouldSaveScenario);
      } else {
        this.$el.getElementsByClassName('loadFile')[0].click();
      }
    },
    loadAudio: function loadAudio() {
      var _this2 = this;

      var that = this;
      var input = this.$el.getElementsByClassName('loadFile')[0];
      if (input.files && input.files[0]) {
        if (!this.getScenarioId()) {
          this.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].notifications.beforeLoadAudioYouShouldSaveScenario);
        } else {
          this.$http.post(audioUploadApi, this.prepareMultipartAudio(input.files[0], this.tmp.id, this.getScenarioId(), this.getScenarioId()), this.prepareUploadHeaders()).then(function (response) {
            if (that.tmp.audio && that.tmp.audio.length === 1 && that.tmp.audio[0].type === 'url' && !that.tmp.audio[0].url) {
              that.tmp.audio = [];
            }
            that.tmp.audio.push({
              id: response.data,
              number: 1,
              type: 'url',
              url: '/audios/' + response.data + '.wav'
            });
          }).catch(function (error) {
            console.log(error);
            _this2.openNotificationWithType('danger', _this2.$i18n.messages[_this2.$i18n.locale].notifications.errorLoadAudio);
            // if (that.tmp.audio && that.tmp.audio.length === 1 && that.tmp.audio[0].type === 'url' && !that.tmp.audio[0].url) {
            //   that.tmp.audio = []
            // }
            // that.tmp.audio.push({
            //   number: 1,
            //   type: 'url',
            //   url: `/audios/111.wav`
            // })
          });
        }
      }
    },

    // deleteAudiosFromBase() {
    //   if (this.getScenarioId()) {
    //     this.$http.delete(`${audioDeleteApi}/byScenario/${this.getScenarioId()}`, {headers: this.prepareUploadHeaders()})
    //   }
    // },
    deleteAudioFromBase: function deleteAudioFromBase(audioId) {
      if (this.getScenarioId()) {
        this.$http.delete(audioDeleteApi + '/' + audioId, { headers: this.prepareUploadHeaders() });
      }
    },
    prepareMultipartAudio: function prepareMultipartAudio(audioFile, audioName, audioClient, audioScenario) {
      var audioFormData = new FormData();
      audioFormData.append('file', audioFile);
      audioFormData.append('name', audioName);
      audioFormData.append('client', audioClient);
      audioFormData.append('scenario', audioScenario);
      return audioFormData;
    },
    prepareUploadHeaders: function prepareUploadHeaders() {
      return {
        'headers': {
          'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
          'Content-Type': 'multipart/form-data',
          'testH': 'testHV'
        }
      };
    },
    confirmAction: function confirmAction(value) {
      this.handleUploadRequest(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), this.currentAudio.get('generationType'), value.blob, this.currentAudio.get('audioName'));
      this.closeModal();
    },
    showAllAudios: function showAllAudios() {
      this.allAudios = true;
    },
    closeAllAudios: function closeAllAudios() {
      this.allAudios = false;
    },
    openAnswerOptionEditor: function openAnswerOptionEditor(elem) {
      // if (!this._props.startNode) {
      this.editOption = true;
      // }
    },
    closeAnswerOptionEditor: function closeAnswerOptionEditor() {
      this.editOption = false;
    },
    wordsStrFormat: function wordsStrFormat() {
      if (this.tmp.tags) {
        var tagsStr = this.tmp.tags.join(', ');
        if (tagsStr.length > 44 - (this.tmp.title || '').length) {
          return tagsStr.substr(0, 41 - (this.tmp.title || '').length) + '...';
        } else {
          return tagsStr;
        }
      } else {
        return '';
      }
    }
  },
  data: function data() {
    return {
      tmp: {
        audio: [],
        tags: [],
        title: '',
        stateValue: '',
        useSetValue: true,
        stateQuestion: '',
        isSilence: false,
        isIllegibly: false,
        generationAudioType: 'generateFromText',
        searchStrategy: 'EQUALS',
        recognitionDriver: '',
        simulatedDelayMillis: 0,
        timeout: '',
        startCollectBeforePlayEnd: '',
        waitingInputTimeout: '',
        silenceAfterSpeechTimeout: '',
        delayBeforeCollect: '',

        text: '',
        onLoading: false,
        currentLang: '',

        currentSpeaker: 'oksana',
        currentVendor: 'yandex',
        currentEmotion: 'good',
        currentSpeed: 1,

        googleSsmlType: 'text'
      },
      apiHostSpeakerList: [{
        value: '2018',
        label: 'Асель'
      }, {
        value: '2019',
        label: 'Асель (TEL)'
      }],
      tinkoffSpeakerList: [{
        value: 'alyona',
        label: 'Алена'
      }, {
        value: 'dorofeev',
        label: 'Дорофеев'
      }, {
        value: 'maxim',
        label: 'Максим'
      }],
      yandexSpeakerList: [{
        value: 'jane',
        label: 'Жанна'
      }, {
        value: 'oksana',
        label: 'Оксана'
      }, {
        value: 'alyss',
        label: 'Алиса'
      }, {
        value: 'omazh',
        label: 'Маша'
      }, {
        value: 'zahar',
        label: 'Захар'
      }, {
        value: 'ermil',
        label: 'Эрмиль'
      }, {
        value: 'alena',
        label: 'Алёна',
        premium: true
      }, {
        value: 'filipp',
        label: 'Филипп',
        premium: true
      }],
      googleVoicesMapList: __WEBPACK_IMPORTED_MODULE_10__googleVoices__["b" /* googleVoicesMapList */],
      googleLanguages: __WEBPACK_IMPORTED_MODULE_10__googleVoices__["a" /* googleLanguages */],
      // currentEmotion: 'neutral',
      emotionList: [{
        value: 'good',
        label: 'радостное'
      }, {
        value: 'neutral',
        label: 'нейтральное'
      }, {
        value: 'evil',
        label: 'плохое'
      }],
      emotionAlenaList: [{
        value: '',
        label: 'обычное'
      }, {
        value: 'sad',
        label: 'грустное'
      }, {
        value: 'funny',
        label: 'веселое'
      }, {
        value: 'flirt',
        label: 'флирт'
      }],
      emotionDorofeevList: [{
        value: 'neutral',
        label: 'обычное'
      }, {
        value: 'drama',
        label: 'драма'
      }, {
        value: 'comedy',
        label: 'комедия'
      }, {
        value: 'info',
        label: 'инфо'
      }, {
        value: 'tragedy',
        label: 'трагедия'
      }],
      editOption: false,
      allAudios: false,
      showPlaySourceConfig: false,
      activeTab: ''
    };
  },
  mounted: function mounted() {
    this.tmp.audio = this._props.answerAudio;
    if (!this.tmp.audio || !this.tmp.audio.length) {
      this.tmp.audio = [{ type: 'url', number: 1 }];
    }
    this.setAudiosUrlIndex(this.tmp.audio);

    this.tmp.title = '' + (this._props.answerTitle || '');
    this.tmp.id = '' + (this._props.answerId || '');
    this.tmp.stateQuestion = '' + (this._props.answerStateQuestion || '');
    this.tmp.stateValue = '' + (this._props.answerStateValue || '');
    this.tmp.useSetValue = !this._props.answerTranskribValue;

    var tags = [];
    if (this._props.answerWords) {
      for (var i = 0; i < this._props.answerWords.length; i++) {
        tags.push('' + this._props.answerWords[i]);
      }
    }
    this.tmp.tags = tags;
    this.tmp.text = '' + (this._props.answerText || '');

    this.tmp.isSilence = this._props.answerIsSilence;
    this.tmp.isIllegibly = this._props.answerIsIllegibly;

    this.tmp.searchStrategy = this._props.answerSearchStrategy || 'EQUALS';
    this.tmp.recognitionDriver = this._props.answerRecognitionDriver || '';
    this.tmp.timeout = this._props.answerTimeout;
    this.tmp.startCollectBeforePlayEnd = this._props.answerStartCollectBeforePlayEnd;
    this.tmp.waitingInputTimeout = this._props.answerWaitingInputTimeout;
    this.tmp.silenceAfterSpeechTimeout = this._props.answerSilenceAfterSpeechTimeout;
    this.tmp.delayBeforeCollect = this._props.answerDelayBeforeCollect;

    this.tmp.generationAudioType = this._props.answerGenerationType || this.tmp.generationAudioType;

    this.tmp.currentVendor = this._props.answerCurrentVendor || this.tmp.currentVendor;
    this.tmp.currentLang = this._props.answerCurrentLang || this.tmp.currentLang;
    if (!this.tmp.currentLang) {
      this.tmp.currentLang = this._props.getScenarioLang();
    }

    this.tmp.currentSpeaker = this._props.answerCurrentSpeaker || this.tmp.currentSpeaker;
    this.tmp.currentEmotion = this._props.answerCurrentEmotion || this.tmp.currentEmotion;
    this.tmp.currentSpeed = this._props.answerCurrentSpeed || this.tmp.currentSpeed;
    this.tmp.simulatedDelayMillis = this._props.answerSimulatedDelayMillis || this.tmp.simulatedDelayMillis;
    this.tmp.googleSsmlType = this._props.answerGoogleSsmlType || this.tmp.googleSsmlType;
  }
});

/***/ }),
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "answer",
    class: _vm.startNode ? 'start-node' : ''
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "answerTitle",
    on: {
      "dblclick": function($event) {
        return _vm.openAnswerOptionEditor()
      }
    }
  }, [_vm._v(_vm._s(_vm.tmp.title) + "\n      ")]), _vm._v(" "), (_vm.tmp.isSilence) ? _c('div', {
    staticClass: "silence_or_illegibly silence",
    on: {
      "dblclick": function($event) {
        return _vm.openAnswerOptionEditor()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-comment-slash"
  })]) : _vm._e(), _vm._v(" "), (_vm.tmp.isIllegibly) ? _c('div', {
    staticClass: "silence_or_illegibly illegibly",
    on: {
      "dblclick": function($event) {
        return _vm.openAnswerOptionEditor()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-comment-dots"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tmp.tags && _vm.tmp.tags.length > 0),
      expression: "tmp.tags && tmp.tags.length > 0"
    }],
    staticClass: "answerWords",
    on: {
      "dblclick": function($event) {
        return _vm.openAnswerOptionEditor()
      }
    }
  }, [_c('span', {
    staticClass: "bkt"
  }, [_vm._v("(")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.wordsStrFormat()))]), _c('span', {
    staticClass: "bkt"
  }, [_vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "answerOptionEdit hidden_for_client_automation",
    on: {
      "click": function($event) {
        return _vm.openAnswerOptionEditor()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-edit"
  })]), _vm._v(" "), _c('div', {
    staticClass: "windowButtons"
  }, [_c('button', {
    staticClass: "window-small window-change-type",
    attrs: {
      "aria-label": _vm.$t('scenarios.konstruktor.canvas.answer.windowSizes.smallSize')
    },
    on: {
      "click": function($event) {
        return _vm.setWindowSmall(true)
      }
    }
  }, [_c('i', {
    staticClass: "far fa-window-minimize"
  })]), _vm._v(" "), _c('button', {
    staticClass: "window-medium window-change-type",
    attrs: {
      "aria-label": _vm.$t('scenarios.konstruktor.canvas.answer.windowSizes.mediumSize')
    },
    on: {
      "click": function($event) {
        return _vm.setWindowMedium(true)
      }
    }
  }, [_c('i', {
    staticClass: "far fa-window-restore"
  })]), _vm._v(" "), _c('button', {
    staticClass: "window-big window-change-type",
    attrs: {
      "aria-label": _vm.$t('scenarios.konstruktor.canvas.answer.windowSizes.maxSize')
    },
    on: {
      "click": function($event) {
        return _vm.setWindowBig(true)
      }
    }
  }, [_c('i', {
    staticClass: "far fa-window-maximize"
  })]), _vm._v(" "), _c('button', {
    staticClass: "delete hidden_for_client_automation",
    attrs: {
      "aria-label": "delete"
    },
    on: {
      "click": function($event) {
        return _vm.remove()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.editOption),
      expression: "!!editOption"
    }],
    staticClass: "wordsEditor"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('div', {
    staticClass: "modal-card-title"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.title),
      expression: "tmp.title"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "title"
    },
    domProps: {
      "value": (_vm.tmp.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeAnswerOptionEditor()
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "nonStartNode"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox isSilence"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.isSilence),
      expression: "tmp.isSilence"
    }],
    staticClass: "isSilence checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tmp.isSilence) ? _vm._i(_vm.tmp.isSilence, null) > -1 : (_vm.tmp.isSilence)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tmp.isSilence,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tmp, "isSilence", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tmp, "isSilence", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tmp, "isSilence", $$c)
        }
      }
    }
  }), _vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.silence')))]), _vm._v(" "), _c('label', {
    staticClass: "checkbox isIllegibly"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.isIllegibly),
      expression: "tmp.isIllegibly"
    }],
    staticClass: "isIllegibly checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tmp.isIllegibly) ? _vm._i(_vm.tmp.isIllegibly, null) > -1 : (_vm.tmp.isIllegibly)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tmp.isIllegibly,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tmp, "isIllegibly", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tmp, "isIllegibly", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tmp, "isIllegibly", $$c)
        }
      }
    }
  }), _vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.illegibly')))])]), _vm._v(" "), _c('div', {
    staticClass: "is-block value"
  }, [_c('label', {
    staticClass: "is-block"
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.foStatusValueUse')) + ": ")]), _vm._v(" "), _c('div', {
    staticClass: "is-block"
  }, [_c('vb-switch-with-two-labels', {
    attrs: {
      "model": _vm.tmp.useSetValue,
      "label-left": _vm.$t('scenarios.konstruktor.canvas.answer.transcription'),
      "label-right": _vm.$t('scenarios.konstruktor.canvas.answer.indicate')
    },
    on: {
      "update:model": function($event) {
        return _vm.$set(_vm.tmp, "useSetValue", $event)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.stateValue),
      expression: "tmp.stateValue"
    }],
    staticClass: "input stateValue",
    attrs: {
      "placeholder": _vm.$t('scenarios.konstruktor.canvas.answer.stateValue')
    },
    domProps: {
      "value": (_vm.tmp.stateValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "stateValue", $event.target.value)
      }
    }
  })], 1)]), _vm._v(" "), _c('vue-tags', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var tag = ref.tag;
        var removeTag = ref.removeTag;
        var inputEventHandlers = ref.inputEventHandlers;
        var inputBindings = ref.inputBindings;

        return _c('div', {
          staticClass: "tags-input tags are-large"
        }, [_c('button', {
          staticClass: "button addForAll",
          attrs: {
            "type": "button",
            "title": _vm.$t('scenarios.konstruktor.canvas.answer.synonyms.addForAllWithSameTitle')
          },
          on: {
            "click": function($event) {
              return _vm.addWordsForAllByTitle(_vm.tmp)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-copy"
        })]), _vm._v(" "), _vm._l((_vm.tmp.tags), function(tag) {
          return _c('span', {
            staticClass: "tags-input-tag tag is-large"
          }, [_vm._v("\n                " + _vm._s(tag) + "\n                "), _c('button', {
            staticClass: "tags-input-remove delete",
            attrs: {
              "type": "button"
            },
            on: {
              "click": function($event) {
                return removeTag(tag)
              }
            }
          })])
        }), _vm._v(" "), _c('div', {
          staticClass: "control"
        }, [_c('input', _vm._g(_vm._b({
          staticClass: "tags-input-text input",
          attrs: {
            "placeholder": _vm.$t('scenarios.konstruktor.canvas.answer.synonyms.addWord') + '...'
          }
        }, 'input', inputBindings, false), inputEventHandlers))])], 2)
      }
    }]),
    model: {
      value: (_vm.tmp.tags),
      callback: function($$v) {
        _vm.$set(_vm.tmp, "tags", $$v)
      },
      expression: "tmp.tags"
    }
  })], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.stateQuestion),
      expression: "tmp.stateQuestion"
    }],
    staticClass: "input stateQuestion",
    attrs: {
      "placeholder": _vm.$t('scenarios.konstruktor.canvas.answer.stateQuestion')
    },
    domProps: {
      "value": (_vm.tmp.stateQuestion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "stateQuestion", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tabs is-boxed"
  }, [_c('ul', [_c('li', {
    staticClass: "tab generateFromText",
    class: _vm.answerGenerationType === 'generateFromText' || !_vm.answerGenerationType ? 'is-active' : '',
    attrs: {
      "data-type": "generateFromText"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.activateTab('generateFromText')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.fromText')))])])]), _vm._v(" "), _c('li', {
    staticClass: "tab inputUrls",
    class: _vm.answerGenerationType === 'inputUrls' ? 'is-active' : '',
    attrs: {
      "data-type": "inputUrls"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.activateTab('inputUrls')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toPutUrl')))])])]), _vm._v(" "), _c('li', {
    staticClass: "tab uploadFile",
    class: _vm.answerGenerationType === 'uploadFile' ? 'is-active' : '',
    attrs: {
      "data-type": "uploadFile"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.activateTab('uploadFile')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toUploadFromFile')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tabs-content"
  }, [_c('div', {
    staticClass: "tab-content generateFromText main",
    class: _vm.answerGenerationType === 'generateFromText' || !_vm.answerGenerationType ? 'is-active' : ''
  }, [_c('input', {
    staticClass: "generationType",
    attrs: {
      "type": "hidden",
      "value": "generateFromText"
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.text),
      expression: "tmp.text"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.tmp.currentVendor.toLowerCase() !== 'google' || _vm.tmp.googleSsmlType !== 'ssml'),
      expression: "tmp.currentVendor.toLowerCase()!=='google' || tmp.googleSsmlType !== 'ssml'"
    }],
    staticClass: "textarea text",
    domProps: {
      "value": (_vm.tmp.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('codemirror', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tmp.currentVendor.toLowerCase() === 'google' && _vm.tmp.googleSsmlType === 'ssml'),
      expression: "tmp.currentVendor.toLowerCase()==='google' && tmp.googleSsmlType === 'ssml'"
    }],
    staticClass: "text",
    attrs: {
      "options": {
        mode: 'text/html',
        lineWrapping: true,
        showCursorWhenSelecting: true
      }
    },
    model: {
      value: (_vm.tmp.text),
      callback: function($$v) {
        _vm.$set(_vm.tmp, "text", $$v)
      },
      expression: "tmp.text"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped generate_audio_controls"
  }, [_c('button', {
    staticClass: "button add_parameter generate_audio_control generate_audio_control_first",
    attrs: {
      "title": _vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toAddParameter')
    },
    on: {
      "click": function($event) {
        return _vm.addParameter()
      }
    }
  }, [_c('span', [_vm._v("{ + }")])]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary vendorControl generate_audio_control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentVendor),
      expression: "tmp.currentVendor"
    }],
    staticClass: "form-control vendor",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentVendor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onVendorChange]
    }
  }, [_c('option', {
    attrs: {
      "value": "yandex"
    }
  }, [_vm._v("Yandex")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "google"
    }
  }, [_vm._v("Google")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "api-host-kz"
    }
  }, [_vm._v("Api Host Kz")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "tinkoff"
    }
  }, [_vm._v("Tinkoff")])])]), _vm._v(" "), _c('div', {
    staticClass: "is-primary speaker generate_audio_control"
  }, [(_vm.tmp.currentVendor.toLowerCase() === 'yandex') ? _c('div', {
    staticClass: "select yandex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeaker),
      expression: "tmp.currentSpeaker"
    }],
    staticClass: "form-control voice",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeaker", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.yandexSpeakerList), function(speaker) {
    return _c('option', {
      class: speaker.premium ? 'premium' : '',
      domProps: {
        "value": speaker.value
      }
    }, [_vm._v("\n                  " + _vm._s(speaker.label + (speaker.premium ? (" " + " " + " " + " " + " " + " " + " " + "👑") : "")) + "\n                ")])
  }), 0)]) : (_vm.tmp.currentVendor.toLowerCase() === 'api-host-kz') ? _c('div', {
    staticClass: "select api-host-kz"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeaker),
      expression: "tmp.currentSpeaker"
    }],
    staticClass: "form-control voice",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeaker", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.apiHostSpeakerList), function(speaker) {
    return _c('option', {
      domProps: {
        "value": speaker.value
      }
    }, [_vm._v("\n                  " + _vm._s(speaker.label) + "\n                ")])
  }), 0)]) : (_vm.tmp.currentVendor.toLowerCase() === 'tinkoff') ? _c('div', {
    staticClass: "select api-host-kz"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeaker),
      expression: "tmp.currentSpeaker"
    }],
    staticClass: "form-control voice",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeaker", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onTinkoffSpeakerChange]
    }
  }, _vm._l((_vm.tinkoffSpeakerList), function(speaker) {
    return _c('option', {
      domProps: {
        "value": speaker.value
      }
    }, [_vm._v("\n                  " + _vm._s(speaker.label) + "\n                ")])
  }), 0)]) : _c('div', {
    staticClass: "google"
  }, [(_vm.googleLanguages) ? _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentLang),
      expression: "tmp.currentLang"
    }],
    staticClass: "form-control lang",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentLang", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onGoogleLanguageChange]
    }
  }, _vm._l((_vm.googleLanguages), function(language) {
    return _c('option', {
      domProps: {
        "value": language.value
      }
    }, [_vm._v("\n                    " + _vm._s(language.label) + "\n                  ")])
  }), 0)]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentLang),
      expression: "tmp.currentLang"
    }],
    staticClass: "input form-control lang",
    attrs: {
      "type": "text",
      "placeholder": "lang"
    },
    domProps: {
      "value": (_vm.tmp.currentLang)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "currentLang", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.googleVoicesMapList && _vm.googleVoicesMapList[_vm.tmp.currentLang]) ? _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeaker),
      expression: "tmp.currentSpeaker"
    }],
    staticClass: "form-control voice",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeaker", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.googleVoicesMapList[_vm.tmp.currentLang]), function(speaker) {
    return _c('option', {
      domProps: {
        "value": speaker.value
      }
    }, [_vm._v("\n                    " + _vm._s(speaker.label) + "\n                  ")])
  }), 0)]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeaker),
      expression: "tmp.currentSpeaker"
    }],
    staticClass: "input form-control voice",
    attrs: {
      "type": "text",
      "placeholder": "voiceName"
    },
    domProps: {
      "value": (_vm.tmp.currentSpeaker)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "currentSpeaker", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.googleSsmlType),
      expression: "tmp.googleSsmlType"
    }],
    staticClass: "form-control ssmlType",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "googleSsmlType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "text"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.text')) + "\n                  ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ssml"
    }
  }, [_vm._v("\n                    SSML\n                  ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tmp.currentVendor.toLowerCase() === 'yandex'),
      expression: "tmp.currentVendor.toLowerCase()==='yandex'"
    }],
    staticClass: "select is-primary generate_audio_control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotion),
      expression: "tmp.currentEmotion"
    }],
    staticClass: "form-control emotion",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', {
      domProps: {
        "value": emotion.value
      }
    }, [_vm._v("\n                " + _vm._s(emotion.label) + "\n              ")])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tmp.currentVendor.toLowerCase() === 'api-host-kz'),
      expression: "tmp.currentVendor.toLowerCase()==='api-host-kz'"
    }],
    staticClass: "select is-primary generate_audio_control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotion),
      expression: "tmp.currentEmotion"
    }],
    staticClass: "form-control emotion",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', {
      domProps: {
        "value": emotion.value
      }
    }, [_vm._v("\n                " + _vm._s(emotion.label) + "\n              ")])
  }), 0)]), _vm._v(" "), (_vm.tmp.currentSpeaker.toLowerCase() === 'alyona') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tmp.currentVendor.toLowerCase() === 'tinkoff'),
      expression: "tmp.currentVendor.toLowerCase()==='tinkoff'"
    }],
    staticClass: "select is-primary generate_audio_control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotion),
      expression: "tmp.currentEmotion"
    }],
    staticClass: "form-control emotion",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionAlenaList), function(emotion) {
    return _c('option', {
      domProps: {
        "value": emotion.value
      }
    }, [_vm._v("\n                " + _vm._s(emotion.label) + "\n              ")])
  }), 0)]) : (_vm.tmp.currentSpeaker.toLowerCase() === 'dorofeev') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tmp.currentVendor.toLowerCase() === 'tinkoff'),
      expression: "tmp.currentVendor.toLowerCase()==='tinkoff'"
    }],
    staticClass: "select is-primary generate_audio_control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotion),
      expression: "tmp.currentEmotion"
    }],
    staticClass: "form-control emotion",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionDorofeevList), function(emotion) {
    return _c('option', {
      domProps: {
        "value": emotion.value
      }
    }, [_vm._v("\n                " + _vm._s(emotion.label) + "\n              ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "speed generate_audio_control"
  }, [_c('slider', {
    attrs: {
      "size": "small",
      "value": parseFloat(_vm.tmp.currentSpeed),
      "min": 0.5,
      "step": 0.1,
      "max": 2
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeed = $event
      }
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.speed')) + ": " + _vm._s(_vm.tmp.currentSpeed) + "\n          ")], 1), _vm._v(" "), _c('button', {
    staticClass: "button is-primary generate_button generate_audio_control generate_audio_control_last",
    attrs: {
      "disabled": !_vm.tmp.text
    },
    on: {
      "click": function($event) {
        return _vm.genMainAudio()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.generateAudio')) + "\n          ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-content inputUrls",
    class: _vm.answerGenerationType === 'inputUrls' ? 'is-active' : ''
  }, [_c('input', {
    staticClass: "generationType",
    attrs: {
      "type": "hidden",
      "value": "inputUrls"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "control urls",
    class: _vm.tmp.audio.length === 1 ? 'singleItem' : (_vm.tmp.audio.length > 3 ? 'more3_items' : '')
  }, [_vm._l((_vm.tmp.audio), function(audio) {
    return _c('div', {
      staticClass: "urlForAudio"
    }, [(audio.type === 'url') ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (audio.url),
        expression: "audio.url"
      }],
      staticClass: "input url",
      attrs: {
        "placeholder": _vm.$t('scenarios.konstruktor.canvas.answer.initAudio.putUrl')
      },
      domProps: {
        "value": (audio.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(audio, "url", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fas fa-minus-square fa-3x remove_audio_item",
      attrs: {
        "title": _vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toRemoveUrl')
      },
      on: {
        "click": function($event) {
          return _vm.removeAudioItem(audio)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (audio.type === 'param') ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (audio.paramName),
        expression: "audio.paramName"
      }],
      staticClass: "input param",
      attrs: {
        "placeholder": _vm.$t('scenarios.konstruktor.canvas.answer.initAudio.putParameterName')
      },
      domProps: {
        "value": (audio.paramName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(audio, "paramName", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fas fa-minus-square fa-3x remove_audio_item",
      attrs: {
        "title": _vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toRemoveParameter')
      },
      on: {
        "click": function($event) {
          return _vm.removeAudioItem(audio)
        }
      }
    })]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "add_url",
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "title": _vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toAddUrl')
    },
    on: {
      "click": function($event) {
        return _vm.addAudioItem('url')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-link fa-2x add_audio_item"
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-plus-square fa-3 add_audio_item"
  })]), _vm._v(" "), _c('div', {
    staticClass: "add_param",
    staticStyle: {
      "display": "inline",
      "margin-left": "20px"
    },
    attrs: {
      "title": _vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toAddParameter')
    },
    on: {
      "click": function($event) {
        return _vm.addAudioItem('param')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-audio-description fa-2x add_audio_item"
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-plus-square fa-3 add_audio_item"
  })])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tab-content uploadFile",
    class: _vm.answerGenerationType === 'uploadFile' ? 'is-active' : ''
  }, [_c('input', {
    staticClass: "generationType",
    attrs: {
      "type": "hidden",
      "value": "uploadFile"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "control uploadFromFileDiv"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": _vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toUploadFromFile')
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile()
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "loadFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getValidAudioUrlsCount() > 0),
      expression: "getValidAudioUrlsCount()>0"
    }],
    staticClass: "button is-delete",
    attrs: {
      "type": "button",
      "value": _vm.$t('scenarios.konstruktor.canvas.answer.initAudio.toRemoveAll')
    },
    on: {
      "click": function($event) {
        return _vm.removeAudioItems()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "mainAudioList",
    class: _vm.getAudioSizeClass()
  }, [_c('div', {
    staticClass: "audio_list"
  }, _vm._l((_vm.tmp.audio), function(audio) {
    return _c('div', {
      staticClass: "audio audio_item",
      class: _vm.getAudioClass(audio)
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (audio.id),
        expression: "audio.id"
      }],
      staticClass: "id",
      attrs: {
        "type": "hidden"
      },
      domProps: {
        "value": (audio.id)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(audio, "id", $event.target.value)
        }
      }
    }), _vm._v(" "), (audio.url || audio.paramName) ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (audio.number),
        expression: "audio.number"
      }],
      staticClass: "number",
      attrs: {
        "type": "hidden"
      },
      domProps: {
        "value": (audio.number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(audio, "number", $event.target.value)
        }
      }
    }), _vm._v(" "), (audio.type === 'url') ? _c('audio', {
      ref: 'onPlayer',
      refInFor: true
    }, [_c('source', {
      attrs: {
        "src": audio.url
      }
    }), _vm._v("\n              " + _vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.Your_browser_does_not_support_html5_audio_Try_chrome')) + "\n            ")]) : _vm._e(), _vm._v(" "), (audio.type === 'url') ? _c('audio-player', {
      attrs: {
        "file": audio.url,
        "onLoad": function(data) {
          audio.duration = data.duration
        }
      }
    }) : _vm._e(), _vm._v(" "), (audio.type === 'param') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (audio.paramName),
        expression: "audio.paramName"
      }],
      staticClass: "audioParam",
      attrs: {
        "type": "hidden"
      },
      domProps: {
        "value": (audio.paramName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(audio, "paramName", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (audio.type === 'url') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (audio.duration),
        expression: "audio.duration"
      }],
      staticClass: "audioDuration",
      attrs: {
        "type": "hidden"
      },
      domProps: {
        "value": (audio.duration)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(audio, "duration", $event.target.value)
        }
      }
    }) : _vm._e()], 1) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.getAudioSizeClass()
  }, [_c('button', {
    staticClass: "audioConfig hidden_for_client_automation",
    attrs: {
      "aria-label": _vm.$t('scenarios.konstruktor.canvas.answer.audioConfig')
    },
    on: {
      "click": function($event) {
        _vm.showPlaySourceConfig = !_vm.showPlaySourceConfig
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-cog"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.showPlaySourceConfig),
      expression: "!!showPlaySourceConfig"
    }],
    staticClass: "playSourceConfig"
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('div', {
    staticClass: "modal-card-title"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.settings')) + " SpeechCollect")])])]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close",
      "title": _vm.$t('common.actions.close')
    },
    on: {
      "click": function($event) {
        _vm.showPlaySourceConfig = false
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('common.key')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.value')))])])]), _vm._v(" "), _c('tbody', [_c('tr', {}, [_c('td', {
    staticClass: "key"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.recognition.recognitionDriver')))])]), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.recognitionDriver),
      expression: "tmp.recognitionDriver"
    }],
    staticClass: "form-control recognitionDriver",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "recognitionDriver", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.default')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "google"
    }
  }, [_vm._v("Google")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "yandex"
    }
  }, [_vm._v("Yandex")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3itech"
    }
  }, [_vm._v("3-itech(KZ)")])])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "searchStrategyTr"
  }, [_vm._m(0), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.searchStrategy),
      expression: "tmp.searchStrategy"
    }],
    staticClass: "searchStrategy",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "searchStrategy", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "title": "Используется как стратегия по умолчанию\n\n    Проверяет на наличие синонимов внутри всего распознанного текста\n\n    Рекомендуется:\n    1) Для длинных меню, где абонент может перебивать робота\n    2) Для вопросов, у которых нет пересекающихся синонимов, например:\n         - Синоним ОДОБРЕНИЕ: \"да\", \"ага\", \"конечно\"\n         - Синоним ОТРИЦАНИЕ: \"нет\", \"да нет наверное\", \"ни за что\"\n         Если абонент начнет говорить фразу \"да нет наверное\" (фактически по этой фразе робот должен отнести ответ к ветке ОТРИЦАНИЕ)\n         Но этого не произойдет, потому что как только робот услышит \"да\", он среагирует на него и в результат запишет ОДОБРЕНИЕ\n\n    Не рекомендуется:\n    - Для NPS - сценариев, у которых среди вариантов ответа присутствуют цифры больше 9, потому что если абонент\n    ответит десять (некоторые вендоры распознавания вернут это значение в виде цифры), робот получит для обработки\n    строку \"10\". В таком случае стратегия в ответе абонента среагирует на \"1\" и запишет её в результат.",
      "value": "CONTAINS"
    }
  }, [_vm._v("contains\n                          ")]), _vm._v(" "), _c('option', {
    attrs: {
      "title": "Стратегия реагирует на полное совпадение распознанного текста с синонимами.\n\n   Рекомендуется:\n   - Для вопросов, в которых ожидается конкретная фраза. Хорошо подойдет для вопросов с большим количеством не пересекающихся синонимов.",
      "value": "EQUALS"
    }
  }, [_vm._v("equals\n                          ")]), _vm._v(" "), _c('option', {
    attrs: {
      "title": "Стратегия разбивает строку на отдельные слова и сравнивает со списком синонимов\n    (фразы-синонимы должны быть СТРОГО из одного слова )\n\n    Рекомендуется:\n    - Для NPS-вопросов - сценариев, например, оценка какого-либо сервиса по цифровой шкале.\n\n    Не рекомендуется:\n    - Для вопросов, у которых фразы-синонимы состоят более чем из одного слова - робот их проигнорирует",
      "value": "EQUALS_WITH_RECOGNITION_SPLITTING"
    }
  }, [_vm._v("equals with recognition splitting\n                          ")]), _vm._v(" "), _c('option', {
    attrs: {
      "title": "Стратегия реагирует на полное совпадение распознанного текста с синонимами.\n\n    Рекомендуется:\n    - Для вопросов, в которых ожидается конкретная фраза. Хорошо подойдет для вопросов с большим количеством синонимов.\n    Пересекаются синонимы в разных ветках или нет, для этой стратегии не важно.",
      "value": "EQUALS_FULL_SPEECH"
    }
  }, [_vm._v("equals\n                            full speech\n                          ")])])])])])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.timeout),
      expression: "tmp.timeout"
    }],
    staticClass: "input timeout",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.tmp.timeout)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "timeout", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.startCollectBeforePlayEnd),
      expression: "tmp.startCollectBeforePlayEnd"
    }],
    staticClass: "input startCollectBeforePlayEnd",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.tmp.startCollectBeforePlayEnd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "startCollectBeforePlayEnd", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.waitingInputTimeout),
      expression: "tmp.waitingInputTimeout"
    }],
    staticClass: "input waitingInputTimeout",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.tmp.waitingInputTimeout)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "waitingInputTimeout", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.silenceAfterSpeechTimeout),
      expression: "tmp.silenceAfterSpeechTimeout"
    }],
    staticClass: "input silenceAfterSpeechTimeout",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.tmp.silenceAfterSpeechTimeout)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "silenceAfterSpeechTimeout", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.delayBeforeCollect),
      expression: "tmp.delayBeforeCollect"
    }],
    staticClass: "input delayBeforeCollect",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.tmp.delayBeforeCollect)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "delayBeforeCollect", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(6), _vm._v(" "), _c('td', {
    staticClass: "value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.simulatedDelayMillis),
      expression: "tmp.simulatedDelayMillis"
    }],
    staticClass: "input simulatedDelayMillis",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.tmp.simulatedDelayMillis)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "simulatedDelayMillis", $event.target.value)
      }
    }
  })])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "key"
  }, [_c('span', [_vm._v("Search Strategy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "key"
  }, [_c('span', [_vm._v("Timeout")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "key"
  }, [_c('span', [_vm._v("Start Collect Before PlayEnd")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "key"
  }, [_c('span', [_vm._v("Waiting Input Timeout")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "key"
  }, [_c('span', [_vm._v("Silence After Speech Timeout")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "key"
  }, [_c('span', [_vm._v("Delay Before Collect")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "key"
  }, [_c('span', [_vm._v("Simulated Delay Millis")])])
}]}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseComponent__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__BaseComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tags__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_tags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_collapse__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__standardSynonyms__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__suggestion_item_template_vue__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__suggestion_item_template_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__suggestion_item_template_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(563);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InOutState',
  extends: __WEBPACK_IMPORTED_MODULE_0__BaseComponent___default.a,
  props: ['answerTitle', 'answerStateQuestion', 'answerStateValue', 'answerWords', 'remove', 'addWordsForAllByTitle', 'answerIsSilence', 'answerIsIllegibly', 'answerRecognitionDriver'],
  components: {
    VueTags: __WEBPACK_IMPORTED_MODULE_1_vue_tags___default.a,
    Collapse: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_collapse__["Item"]
  },
  methods: {
    setSilence: function setSilence() {
      this.tmp.isIntro = false;
      this.tmp.title = this.$t('scenarios.konstruktor.canvas.answer.silence');
      this.tmp.isSilence = true;
    },
    setIllegibly: function setIllegibly() {
      this.tmp.isIntro = false;
      this.tmp.title = this.$t('scenarios.konstruktor.canvas.answer.illegibly');
      this.tmp.isIllegibly = true;
    },
    setCustom: function setCustom() {
      this.tmp.isIntro = false;
      this.tmp.title = this.$t('scenarios.konstruktor.canvas.answer.custom');
    },
    setApprove: function setApprove() {
      var _this = this;

      this.tmp.isIntro = false;
      this.tmp.title = this.$t('scenarios.konstruktor.canvas.answer.approve');
      var approveSynonyms = this.standardSynonyms.find(function (el) {
        return el.name.toLowerCase() === _this.$t('common.yes').toLowerCase();
      });
      for (var i = 0; i < approveSynonyms.words.length; i++) {
        this.tmp.tags.push('' + approveSynonyms.words[i]);
      }
    },
    setDeny: function setDeny() {
      var _this2 = this;

      this.tmp.isIntro = false;
      this.tmp.title = this.$t('scenarios.konstruktor.canvas.answer.deny');
      var denySynonyms = this.standardSynonyms.find(function (el) {
        return el.name.toLowerCase() === _this2.$t('common.no').toLowerCase();
      });
      for (var i = 0; i < denySynonyms.words.length; i++) {
        this.tmp.tags.push('' + denySynonyms.words[i]);
      }
    }
  },
  data: function data() {
    return {
      tmp: {
        title: '',
        stateValue: '',
        stateQuestion: '',
        tags: [],
        isSilence: false,
        isIllegibly: false,
        isIntro: true
      },
      suggestionItems: [],
      suggestionItem: '',
      itemTemplate: __WEBPACK_IMPORTED_MODULE_4__suggestion_item_template_vue___default.a,
      standardSynonyms: __WEBPACK_IMPORTED_MODULE_3__standardSynonyms__["a" /* standardSynonyms */]
    };
  },
  mounted: function mounted() {
    this.tmp.title = '' + (this._props.answerTitle || '');
    this.tmp.stateValue = '' + (this._props.answerStateValue || '');
    this.tmp.stateQuestion = '' + (this._props.answerStateValue || '');
    var tags = [];
    if (this._props.answerWords) {
      for (var i = 0; i < this._props.answerWords.length; i++) {
        tags.push('' + this._props.answerWords[i]);
      }
    }
    this.tmp.tags = tags;
    this.tmp.isSilence = this._props.answerIsSilence;
    this.tmp.isIllegibly = this._props.answerIsIllegibly;

    if (this.tmp.isSilence || this.tmp.isIllegibly || this.tmp.tags.length !== 0) {
      this.tmp.isIntro = false;
    }

    // this.$el.querySelector('.suggestionDiv input').classList.add('input')
    var that = this;
    Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* autocomplete */])(this.$el.querySelector('input.tags-input-text'), this.standardSynonyms, 64, function (words) {
      for (var j = 0; j < words.length; j++) {
        var word = words[j];
        if (!that.tmp.tags.includes(word)) {
          that.tmp.tags.push(word);
        }
      }
    });
  }
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return standardSynonyms; });
var standardSynonyms = [{
  name: 'да',
  words: ['да', 'да-да', 'да да', 'дада', 'ну да', 'согласен', 'ага', 'угу', 'конечно', 'верно', 'так точно', 'да-да-да', 'да да да', 'дадада', 'ok']
}, {
  name: 'нет',
  words: ['нет', 'неа', 'нео', 'neo', 'не надо', 'не нужно', 'не хочу', 'ни за что', 'ни в коем случае', 'не хотим', 'не можем']
}, {
  name: 'yes',
  words: ['yes', 'okay', 'yeah', 'right', 'ready', 'really', 'wish', 'verily', 'sure', 'okay', 'sure', 'easy', 'well', 'well yes', 'Well, of course', 'However', 'OK']
}, {
  name: 'no',
  words: ['no', 'no no', 'not at all', 'wait', 'pipes', 'no fools', 'look for a fool', 'do not', 'not necessary', 'I do not want', 'no shit', 'nope', 'impossible', 'out of place']
}, {
  name: 'tak',
  words: ['tak', 'dobrze', 'tak', 'dobrze', 'gotowe', 'naprawdę', 'życzę', 'bardzo', 'jasne', 'dobrze', 'jasne', 'łatwe', 'dobrze', 'cóż tak', 'cóż', 'oczywiście', 'jednak', 'ok']
}, {
  name: 'nie',
  words: ['nie', 'nie nie', 'wcale nie', 'czekaj', 'rury', 'nie ma głupców', 'szukaj głupca', 'nie', 'nie jest konieczne', 'nie chcę', 'nie ma gówna', 'niemożliwe', 'nie na miejscu']
}];

/***/ }),
/* 560 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: { required: true }
  }
});

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b', [_vm._v("#" + _vm._s(_vm.item.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.words.join(', ')))])])
},staticRenderFns: []}

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return autocomplete; });
var autocomplete = function autocomplete(inp, arr, maxTextLength, selectedCb) {
  /* the autocomplete function takes two arguments,
  the text field element and an array of possible autocompleted values: */
  var currentFocus;
  /* execute a function when someone writes in the text field: */
  inp.addEventListener('input', function (e) {
    if (!arr) {
      return false;
    }
    var a;
    var b;
    var i;
    var val = this.value;
    /* close any already open lists of autocompleted values */
    closeAllLists();
    if (!val) {
      return false;
    }
    currentFocus = -1;
    /* create a DIV element that will contain the items (values): */
    a = document.createElement('DIV');
    a.setAttribute('id', this.id + 'autocomplete-list');
    a.setAttribute('class', 'autocomplete-items');
    /* append the DIV element as a child of the autocomplete container: */
    this.parentNode.appendChild(a);
    /* for each item in the array... */
    for (i = 0; i < arr.length; i++) {
      /* check if the item starts with the same letters as the text field value: */
      // if (arr[i].name.includes(val)) {
      if (arr[i].name === val.toLowerCase()) {
        /* create a DIV element for each matching element: */
        b = document.createElement('DIV');
        /* make the matching letters bold: */
        b.innerHTML = '<strong style="margin-right: 8px">' + arr[i].name + '</strong> ';
        b.innerHTML += cutText(arr[i].words.join(', '));
        /* insert a input field that will hold the current array item's value: */
        b.innerHTML += "<input type='hidden' value='" + arr[i].words.join(', ') + "'>";
        /* execute a function when someone clicks on the item value (DIV element): */
        b.addEventListener('click', function (e) {
          /* insert the value for the autocomplete text field: */

          var words = this.getElementsByTagName('input')[0].value.split(', ');
          selectedCb(words);
          // for (let j = 0; j < words.length; j++) {
          //   let word = words[j]
          //   selectedCb()
          //   if (!that.tmp.tags.includes(word)) {
          //     that.tmp.tags.push(word)
          //   }
          // }
          inp.value = '';
          inp.dispatchEvent(new Event('change'));
          /* close the list of autocompleted values,
          (or any other open lists of autocompleted values: */
          closeAllLists();
        });
        a.appendChild(b);
      }
    }
  });
  /* execute a function presses a key on the keyboard: */
  inp.addEventListener('keydown', function (e) {
    var x = document.getElementById(this.id + 'autocomplete-list');
    if (x) x = x.getElementsByTagName('div');
    if (e.keyCode === 40) {
      /* If the arrow DOWN key is pressed,
      increase the currentFocus variable: */
      currentFocus++;
      /* and and make the current item more visible: */
      addActive(x);
    } else if (e.keyCode === 38) {
      // up
      /* If the arrow UP key is pressed,
      decrease the currentFocus variable: */
      currentFocus--;
      /* and and make the current item more visible: */
      addActive(x);
    } else if (e.keyCode === 13) {
      /* If the ENTER key is pressed, prevent the form from being submitted, */
      e.preventDefault();
      if (currentFocus > -1) {
        /* and simulate a click on the 'active' item: */
        if (x) x[currentFocus].click();
      }
    }
  });

  function cutText(text) {
    if (maxTextLength && text && text.length > maxTextLength) {
      var firstComma = text.indexOf(',', maxTextLength);
      return text.substr(0, firstComma) + '...';
    } else {
      return text;
    }
  }

  function addActive(x) {
    /* a function to classify an item as 'active': */
    if (!x) return false;
    /* start by removing the 'active' class on all items: */
    removeActive(x);
    if (currentFocus >= x.length) currentFocus = 0;
    if (currentFocus < 0) currentFocus = x.length - 1;
    /* add class 'autocomplete-active': */
    x[currentFocus].classList.add('autocomplete-active');
  }

  function removeActive(x) {
    /* a function to remove the 'active' class from all autocomplete items: */
    for (var i = 0; i < x.length; i++) {
      x[i].classList.remove('autocomplete-active');
    }
  }

  function closeAllLists(elmnt) {
    /* close all autocomplete lists in the document,
    except the one passed as an argument: */
    var x = document.getElementsByClassName('autocomplete-items');
    for (var i = 0; i < x.length; i++) {
      if (elmnt !== x[i] && elmnt !== inp) {
        x[i].parentNode.removeChild(x[i]);
      }
    }
  }
};

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "state control",
    class: (_vm.tmp.isSilence ? 'isSilence' : '') + ' ' + (_vm.tmp.isIllegibly ? 'isIllegibly' : '')
  }, [_c('div', {
    staticClass: "title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.title),
      expression: "tmp.title"
    }],
    staticClass: "answerTitle",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.title')
    },
    domProps: {
      "value": (_vm.tmp.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "windowButtons"
  }, [_c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": _vm.$t('common.actions.delete')
    },
    on: {
      "click": function($event) {
        return _vm.remove()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wordsEditor"
  }, [_c('div', {
    staticClass: "control",
    class: _vm.tmp.isIntro ? 'hide-input' : ''
  }, [_c('label', {
    staticClass: "checkbox isSilence"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.isSilence),
      expression: "tmp.isSilence"
    }],
    staticClass: "isSilence checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tmp.isSilence) ? _vm._i(_vm.tmp.isSilence, null) > -1 : (_vm.tmp.isSilence)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tmp.isSilence,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tmp, "isSilence", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tmp, "isSilence", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tmp, "isSilence", $$c)
        }
      }
    }
  }), _vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.silence')))]), _vm._v(" "), _c('label', {
    staticClass: "checkbox isIllegibly"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.isIllegibly),
      expression: "tmp.isIllegibly"
    }],
    staticClass: "isIllegibly checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tmp.isIllegibly) ? _vm._i(_vm.tmp.isIllegibly, null) > -1 : (_vm.tmp.isIllegibly)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tmp.isIllegibly,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tmp, "isIllegibly", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tmp, "isIllegibly", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tmp, "isIllegibly", $$c)
        }
      }
    }
  }), _vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.anotherAnswer')))])]), _vm._v(" "), _c('vue-tags', {
    class: _vm.tmp.isIntro ? 'hide-input' : '',
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var tag = ref.tag;
        var removeTag = ref.removeTag;
        var inputEventHandlers = ref.inputEventHandlers;
        var inputBindings = ref.inputBindings;

        return _c('div', {
          staticClass: "tags-input tags are-medium"
        }, [_c('div', {
          staticClass: "control autocomplete"
        }, [_c('input', _vm._g(_vm._b({
          staticClass: "tags-input-text input",
          attrs: {
            "placeholder": _vm.$t('scenarios.konstruktor.canvas.answer.synonyms.addWord') + '...'
          }
        }, 'input', inputBindings, false), inputEventHandlers))]), _vm._v(" "), _c('button', {
          staticClass: "button addForAll",
          attrs: {
            "type": "button",
            "title": _vm.$t('scenarios.konstruktor.canvas.answer.synonyms.addForAllWithSameTitle')
          },
          on: {
            "click": function($event) {
              return _vm.addWordsForAllByTitle(_vm.tmp)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-copy"
        })]), _vm._v(" "), _vm._l((_vm.tmp.tags), function(tag) {
          return _c('span', {
            staticClass: "tags-input-tag tag is-medium"
          }, [_vm._v("\n           " + _vm._s(tag) + "\n           "), _c('button', {
            staticClass: "tags-input-remove delete",
            attrs: {
              "type": "button"
            },
            on: {
              "click": function($event) {
                return removeTag(tag)
              }
            }
          })])
        })], 2)
      }
    }]),
    model: {
      value: (_vm.tmp.tags),
      callback: function($$v) {
        _vm.$set(_vm.tmp, "tags", $$v)
      },
      expression: "tmp.tags"
    }
  }), _vm._v(" "), (_vm.tmp.isIntro) ? _c('div', {
    staticClass: "button-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "button choose-state",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setApprove()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.approve')))]), _vm._v(" "), _c('button', {
    staticClass: "button choose-state",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setDeny()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.deny')))]), _vm._v(" "), _c('button', {
    staticClass: "button choose-state",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setSilence()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.silence')))]), _vm._v(" "), _c('button', {
    staticClass: "button choose-state",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setIllegibly()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.illegibly')))]), _vm._v(" "), _c('button', {
    staticClass: "button choose-state",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setCustom()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.custom')))])]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseComponent__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__BaseComponent__);
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'OutState',
    extends: __WEBPACK_IMPORTED_MODULE_0__BaseComponent___default.a,
    // mixins:[ BaseNodeComponent ],
    props: ['answerTitle', 'remove'],
    methods: {},
    data: function data() {
        return {
            tmp: {
                title: ''
            }
        };
    },
    mounted: function mounted() {
        this.tmp.title = '' + (this._props.answerTitle || '');
    }
});

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "state control"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.title),
      expression: "tmp.title"
    }],
    staticClass: "answerTitle",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.title')
    },
    domProps: {
      "value": (_vm.tmp.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "windowButtons"
  }, [_c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": _vm.$t('common.actions.delete')
    },
    on: {
      "click": function($event) {
        return _vm.remove()
      }
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flowchart-object jsplumb-draggable jsplumb-droppable",
    class: _vm.getNodeClass(),
    style: ({
      left: _vm.obj.view.left + "px",
      top: _vm.obj.view.top + "px",
      width: _vm.getWidth() + "px",
      height: _vm.obj.view.h + "px"
    }),
    attrs: {
      "id": _vm.obj.data.id
    }
  }, [(_vm.obj.type === 'outState') ? _c('out-state', {
    attrs: {
      "answer-title": _vm.obj.data.title,
      "remove": _vm.deleteNode
    }
  }) : _vm._e(), _vm._v(" "), (_vm.obj.type === 'inOutState') ? _c('in-out-state', {
    attrs: {
      "answer-title": _vm.obj.data.title,
      "answer-state-question": _vm.obj.data.stateQuestion,
      "answer-state-value": _vm.obj.data.stateValue,
      "answer-words": _vm.obj.data.words,
      "answer-is-illegibly": _vm.obj.data.isIllegibly,
      "answer-is-silence": _vm.obj.data.isSilence,
      "remove": _vm.deleteNode,
      "addWordsForAllByTitle": _vm.addWordsForAllByTitle
    }
  }) : _vm._e(), _vm._v(" "), (_vm.obj.type !== 'inOutState' && _vm.obj.type !== 'outState') ? _c('universal-answer', {
    attrs: {
      "start-node": _vm.obj.startNode,
      "answer-id": _vm.obj.data.id,
      "answer-title": _vm.obj.data.title,
      "answer-state-question": _vm.obj.data.stateQuestion,
      "answer-transkrib-value": _vm.obj.data.useTranscribeByValue,
      "answer-state-value": _vm.obj.data.stateValue,
      "answer-words": _vm.obj.data.words,
      "answer-audio": _vm.obj.data.audio,
      "answer-text": _vm.obj.data.text,
      "answer-generation-type": _vm.obj.data.generationAudioType,
      "answer-is-silence": _vm.obj.data.isSilence,
      "answer-is-illegibly": _vm.obj.data.isIllegibly,
      "answer-search-strategy": _vm.obj.data.searchStrategy,
      "answer-recognition-driver": _vm.obj.data.recognitionDriver,
      "answer-timeout": _vm.obj.data.timeout,
      "answer-start-collect-before-play-end": _vm.obj.data.startCollectBeforePlayEnd,
      "answer-waiting-input-timeout": _vm.obj.data.waitingInputTimeout,
      "answer-silence-after-speech-timeout": _vm.obj.data.silenceAfterSpeechTimeout,
      "answer-delay-before-collect": _vm.obj.data.delayBeforeCollect,
      "answer-current-emotion": _vm.obj.data.emotion,
      "answer-current-vendor": _vm.obj.data.vendor,
      "answer-current-lang": _vm.obj.data.lang,
      "answer-current-speaker": _vm.obj.data.speaker,
      "answer-current-speed": _vm.obj.data.speed,
      "answerGoogleSsmlType": _vm.obj.data.googleSsmlType,
      "answer-repeat": _vm.obj.data.repeat,
      "answer-simulated-delay-millis": _vm.obj.data.simulatedDelayMillis,
      "scenario-id": _vm.obj.scenarioId,
      "remove": _vm.deleteNode,
      "setNodeHeight": _vm.setNodeHeight,
      "setWindowSmall": _vm.setNodeSmall,
      "setWindowMedium": _vm.setNodeMedium,
      "setWindowBig": _vm.setNodeBig,
      "addWordsForAllByTitle": _vm.addWordsForAllByTitle,
      "get-scenario-lang": _vm.getScenarioLang
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "add hidden_for_client_automation"
  }, [(_vm.obj.type === 'inOutState') ? _c('i', {
    staticClass: "fas fa-comment-medical add_answer",
    attrs: {
      "title": _vm.$t('common.actions.add') + ' ' + _vm.$t('scenarios.konstruktor.canvas.add.robotAnswer')
    },
    on: {
      "click": function($event) {
        return _vm.addAnswer(_vm.obj.availableSmsGateways)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.obj.type !== 'inOutState') ? _c('i', {
    staticClass: "fas fa-network-wired add_state",
    attrs: {
      "title": _vm.$t('common.actions.add') + ' ' + _vm.$t('scenarios.konstruktor.canvas.add.recognition')
    },
    on: {
      "click": function($event) {
        return _vm.addInOutState(_vm.obj.availableSmsGateways)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fas fa-user-tie add_redirect",
    attrs: {
      "title": _vm.$t('common.actions.add') + ' ' + _vm.$t('scenarios.konstruktor.canvas.add.redirectToOperator')
    },
    on: {
      "click": function($event) {
        return _vm.addRedirect()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fab fa-connectdevelop connect",
    attrs: {
      "title": _vm.$t('common.actions.connect')
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-sms addSms",
    class: _vm.obj.availableSmsGateways && _vm.obj.availableSmsGateways.length ? 'hasSmsGateways' : '',
    attrs: {
      "title": _vm.$t('scenarios.konstruktor.canvas.add.sendSMS')
    },
    on: {
      "click": function($event) {
        return _vm.addSMS(null, null, _vm.obj.availableSmsGateways)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-file-code hidden_for_client addHttpRequest",
    attrs: {
      "title": _vm.$t('scenarios.konstruktor.canvas.add.sendHttpRequest')
    },
    on: {
      "click": function($event) {
        return _vm.addHttpRequest()
      }
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsplumb_extends_jsplumb_vue__ = __webpack_require__(66);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import i18n from '../../../translations/i18n'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Redirect',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__jsplumb_extends_jsplumb_vue__["a" /* BaseNodeComponent */]]
  // i18n: i18n
});

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flowchart-object jsplumb-draggable jsplumb-droppable",
    style: ({
      left: _vm.obj.view.left + "px",
      top: _vm.obj.view.top + "px",
      width: _vm.obj.view.w + "px",
      height: _vm.obj.view.h + "px"
    }),
    attrs: {
      "id": _vm.obj.view.id
    }
  }, [_c('div', {
    staticClass: "redirect_shell"
  }, [_c('div', {
    staticClass: "title control"
  }, [_c('div', {
    staticClass: "redirectTitle"
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.add.redirectToOperator')))]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "delete"
    },
    on: {
      "click": function($event) {
        return _vm.deleteNode()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.redirect),
      expression: "obj.redirect"
    }],
    staticClass: "input sipNumber",
    attrs: {
      "placeholder": _vm.$t('scenarios.konstruktor.canvas.answer.sipSubUrl'),
      "title": _vm.$t('scenarios.konstruktor.canvas.answer.sipDubUrl')
    },
    domProps: {
      "value": (_vm.obj.redirect)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj, "redirect", $event.target.value)
      }
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsplumb_extends_jsplumb_vue__ = __webpack_require__(66);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sms',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__jsplumb_extends_jsplumb_vue__["a" /* BaseNodeComponent */]],
  props: ['deleteNode'],
  data: function data() {
    return {
      gateways: {
        acemountMedia: 'Acemount Media',
        smsc: 'Smsc',
        smscFit19: 'Smsc Fit19',
        fitservicesms: 'Fit Service',
        semySms: 'Semy Sms',
        smsClub: 'Sms club'
      }
    };
  },
  created: function created() {
    if (this.obj.availableSmsGateways && this.obj.availableSmsGateways.length >= 1 && !this.obj.data.gateway) {
      this.obj.data.gateway = this.obj.availableSmsGateways[0];
    }
  }
});

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flowchart-object jsplumb-draggable jsplumb-droppable",
    style: ({
      left: _vm.obj.view.left + "px",
      top: _vm.obj.view.top + "px",
      width: _vm.obj.view.w + "px",
      height: _vm.obj.view.h + "px"
    }),
    attrs: {
      "id": _vm.obj.view.id
    }
  }, [_c('div', {
    staticClass: "sms_shell"
  }, [_c('div', {
    staticClass: "title control"
  }, [_c('div', {
    staticClass: "smsTitle"
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.add.sendSMS')))]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "delete"
    },
    on: {
      "click": function($event) {
        return _vm.deleteNode()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('div', {
    staticClass: "is-overlay overlay-for-not-admin"
  }), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-label is-normal is-inline-block"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.sms.gateway')))])]), _vm._v(" "), _c('div', {
    staticClass: "field-body is-inline-block"
  }, [_c('div', {
    staticClass: "field is-narrow"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.data.gateway),
      expression: "obj.data.gateway"
    }],
    staticClass: "smsGateway",
    attrs: {
      "name": "smsGateway"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.obj.data, "gateway", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.obj.availableSmsGateways), function(gateway) {
    return _c('option', {
      domProps: {
        "value": gateway
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.gateways[gateway]) + "\n                  ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "field-body is-inline-block sender-field"
  }, [_c('div', {
    staticClass: "field-label is-normal is-inline-block"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.sms.sender')))])]), _vm._v(" "), _c('div', {
    staticClass: "field-body is-inline-block"
  }, [_c('div', {
    staticClass: "field is-narrow"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.data.sender),
      expression: "obj.data.sender"
    }],
    staticClass: "input sender",
    domProps: {
      "value": (_vm.obj.data.sender)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj.data, "sender", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.data.text),
      expression: "obj.data.text"
    }],
    staticClass: "textarea smsText",
    attrs: {
      "placeholder": _vm.$t('scenarios.konstruktor.canvas.answer.sms.messageText'),
      "title": _vm.$t('scenarios.konstruktor.canvas.answer.sms.messageText')
    },
    domProps: {
      "value": (_vm.obj.data.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj.data, "text", $event.target.value)
      }
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ScenarioInfo',
  props: ['campaignId', 'scenarioId'],
  data: function data() {
    return {
      audioRoot: 'http://voicebot.ivoice.online' + '/' + (this._props.client || ''),
      redirectRoot: 'sofia/gateway/' + (this._props.client || '')
    };
  }
});

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scenario_info"
  }, [(_vm.campaignId && _vm.campaignId !== '0') ? _c('span', [_vm._v("Campaign ID: " + _vm._s(_vm.campaignId))]) : _vm._e(), _vm._v(" "), (_vm.scenarioId) ? _c('span', [_vm._v("Scenario ID: " + _vm._s(_vm.scenarioId))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Zoom',
    props: ['elementId'],
    data: function data() {
        return {
            transform: 1
        };
    },

    methods: {
        zoomIn: function zoomIn() {
            if (this.transform < 1) {
                // this.transform = this.transform + 0.05
                this.transform = this.transform + 0.1;
                this.setZoom(this.transform);
            }
        },
        zoomOut: function zoomOut() {
            if (this.transform > 0.5) {
                // this.transform = this.transform - 0.05
                this.transform = this.transform - 0.1;
                this.setZoom(this.transform);
            }
        },
        setZoom: function setZoom(zoom) {
            var scale = 'scale(' + zoom + ')';
            var canvas = document.getElementById(this._props.elementId);
            canvas.style.transform = scale;
        }
    }
});

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zoom"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light",
    attrs: {
      "disabled": _vm.transform === 1
    },
    on: {
      "click": function($event) {
        return _vm.zoomIn()
      }
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "button is-light",
    attrs: {
      "disabled": _vm.transform <= 0.5
    },
    on: {
      "click": function($event) {
        return _vm.zoomOut()
      }
    }
  }, [_vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-search-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-search-minus"
  })])
}]}

/***/ }),
/* 581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseComponent__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BaseComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TestCall__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TestCall___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TestCall__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var api = '/api/scenarios';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { TestCall: __WEBPACK_IMPORTED_MODULE_2__TestCall___default.a },
  extends: __WEBPACK_IMPORTED_MODULE_1__BaseComponent___default.a,
  // name: 'Control',
  props: ['name', 'campaignId', 'scenario'],
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['loadedScenario', 'loggedId', 'loggedUser', 'authenticationToken'])),
  data: function data() {
    return {
      testCall: false
    };
  },

  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      // console.log(this.authenticationToken)
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },

    changeRoute: function changeRoute(e) {
      this.$router.push({ path: '/scenarios' + e.target.value });
    },
    // load() {
    //   let that = this
    //   this.$http({
    //     url: api + '/' + this._props.name,
    //     headers: this.prepareSecurityHeader()
    //   }).then((response) => {
    //     // console.log('opening scenario ' + JSON.stringify(response.data))
    //     that.$emit('set', response.data)
    //   }).catch((error) => {
    //     console.log(error)
    //     this.openNotificationWithType('danger', that.$i18n.messages[that.$i18n.locale].notifications.scenario.errorLoadScenario)
    //     this.$emit('setDefault')
    //   })
    // },
    save: function save(showMessage) {
      if (this.isValid()) {
        if (!this._props.scenario.id) {
          this.saveNew(showMessage);
        } else {
          this.update(showMessage);
        }
      }
    },
    isValid: function isValid() {
      if (!this.checkDuplicateTitleBlock()) {
        this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с одинаковыми названиями блоков');
        return false;
      }
      return true;
    },
    checkDuplicateTitleBlock: function checkDuplicateTitleBlock() {
      this.$emit('initScenario', this._props.scenario);
      var states = this._props.scenario.parameters.states;
      console.log(states);
      var statesSet = new Set();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = states[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var state = _step.value;

          console.log(state);
          if (state.type == 'inOutState') {
            continue;
          }
          if (!statesSet.has(state.data.title)) {
            statesSet.add(state.data.title);
          } else {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;

      // for (let i = 0; i < states.length - 1; i++) {
      //   for (let j = i + 1; j < states.length; j++) {
      //     console.log(states[i])
      //     if (states[i].data.title === states[j].data.title &&
      //       states[i].type !== 'inOutState' &&
      //       states[j].type !== 'inOutState') {
      //       return false
      //     }
      //   }
      // }
      // return true
    },
    saveNew: function saveNew(showMessage) {
      var _this = this;

      this.$emit('initScenario', this._props.scenario);
      // console.log('saving new scenario: ' + JSON.stringify(this._props.scenario))
      var that = this;
      this.$http.post(api, this._props.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        if (showMessage) {
          _this.openNotificationWithType('info', that.$i18n.messages[that.$i18n.locale].notifications.scenario.scenarioSaved);
        }
        _this.$emit('set', response.data);
        // that.createCampaign(response.data.id)
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', that.$i18n.messages[that.$i18n.locale].notifications.scenario.errorSaveScenario);
      });
    },
    update: function update(showMessage) {
      var _this2 = this;

      this.$emit('initScenario', this._props.scenario);
      // console.log('updating scenario: ' + JSON.stringify(this._props.scenario))
      var that = this;
      this.$http.put(api, this._props.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        if (showMessage) {
          _this2.openNotificationWithType('info', that.$i18n.messages[that.$i18n.locale].notifications.scenario.scenarioSaved);
        }
        _this2.$emit('set', response.data);
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', that.$i18n.messages[that.$i18n.locale].notifications.scenario.errorSaveScenario);
      });
    },
    readJsonFile: function readJsonFile(jsonFile) {
      var _this3 = this;

      var reader = new FileReader();
      reader.addEventListener('load', function (loadEvent) {
        try {
          var json = JSON.parse(loadEvent.target.result);
          _this3.$emit('set', {
            template: json.template,
            parameters: json.parameters,
            inUse: json.inUse,
            isReady: json.isReady,
            checkDuration: json.checkDuration
          });
          // console.log(json);
        } catch (error) {
          console.error(error);
        }
      });
      reader.readAsText(jsonFile);
    },
    importScenario: function importScenario() {
      document.getElementById('jsonFile').click();
    },
    exportScenario: function exportScenario() {
      // function encode(s) {
      //   let out = []
      //   for (let i = 0; i < s.length; i++) {
      //     out[i] = s.charCodeAt(i)
      //   }
      //   return new Uint8Array(out)
      // }

      this.$emit('initScenario', this._props.scenario);

      var data = {
        template: this._props.scenario.template,
        parameters: this._props.scenario.parameters,
        inUse: this._props.scenario.inUse,
        isReady: this._props.scenario.isReady,
        checkDuration: this._props.scenario.checkDuration

        // data = encode(JSON.stringify(data, null, 4))
      };data = JSON.stringify(data, null, 4);

      var blob = new Blob([data], {
        type: 'application/octet-stream'
      });

      var link = document.createElement('a');
      link.setAttribute('href', URL.createObjectURL(blob));
      link.setAttribute('download', this._props.scenario.name + '.json');

      var event = document.createEvent('MouseEvents');
      event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
      link.dispatchEvent(event);
    },
    cancel: function cancel() {
      if (!this.$props.campaignId) {
        this.$router.push('/scenarios/');
      } else {
        this.$router.push('/campaigns/' + this.$props.campaignId);
      }
    },
    showTestCall: function showTestCall() {
      this.testCall = true;
    },
    closeTestCall: function closeTestCall() {
      this.testCall = false;
    }
  },
  created: function created() {
    // this.loadState()
    if (!this._props.name) {
      console.log('creating new scenario');
      this.$emit('setDefault');
    } else {
      // console.log('loading scenario: ' + !this.$props.name)
      // this.load()
    }
  },
  mounted: function mounted() {
    var that = this;
    document.getElementById('jsonFile').addEventListener('change', function (changeEvent) {
      changeEvent.stopPropagation();
      changeEvent.preventDefault();
      that.readJsonFile(changeEvent.target.files[0]);
    }, false);
  }
});

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DebugDialog__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DebugDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DebugDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VbSwitchWithTwoLabels__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VbSwitchWithTwoLabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_VbSwitchWithTwoLabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseComponent__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BaseComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sip_js__ = __webpack_require__(588);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var GET_CAMPAIGNS_API = '/api/scenarios/getCampaigns';
var CAMPAIGNS_API = '/api/campaigns';
var CALLTASKTESTING_API = '/api/callTasks/testCall';
var WEBRTC_DIALPLAN_CONDITION = 'api/appConfig/dialplanCondition';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TestCall',
  components: { DebugDialog: __WEBPACK_IMPORTED_MODULE_0__DebugDialog___default.a, VbSwitchWithTwoLabels: __WEBPACK_IMPORTED_MODULE_1__components_VbSwitchWithTwoLabels___default.a },
  extends: __WEBPACK_IMPORTED_MODULE_2__BaseComponent___default.a,
  props: ['campaignId', 'scenario', 'closeTestCall'],
  data: function data() {
    return {
      callToPhone: true,
      testPhone: '',
      creatingTestCall: false,
      testPhoneParametersArray: [{
        key: '',
        value: ''
      }],
      tmp: {
        campaignId: '',
        campaignList: []
      },
      debuggingDialog: false,
      webSocketSessionId: '',

      webRtcSimple: null,
      webRtcDialplanCondition: ''
    };
  },

  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    deleteTestPhoneParameter: function deleteTestPhoneParameter(index) {
      this.testPhoneParametersArray.splice(index, 1);
    },
    addTestPhoneParameter: function addTestPhoneParameter() {
      this.testPhoneParametersArray.push({});
    },
    prepareTestPhone: function prepareTestPhone(campaignId, testPhone, testPhoneParametersArray) {
      var testCallTaskDto = {
        phone: testPhone,
        campaign: campaignId,
        parameters: {}
      };
      testCallTaskDto.parameters = testPhoneParametersArray;
      this.saveTestCallParamsToCookie(testCallTaskDto);
      return testCallTaskDto;
    },
    saveTestCallParamsToCookie: function saveTestCallParamsToCookie(testCallTaskDto) {
      var name = 'app.ivoice.online.testCall.' + testCallTaskDto.campaign;
      var value = 'phone:' + testCallTaskDto.phone;
      for (var parameter in testCallTaskDto.parameters) {
        if (parameter && parameter !== 'undefined' && parameter !== 'webDomen' && parameter !== 'webSocketSessionId') {
          value += '_' + parameter + ':' + testCallTaskDto.parameters[parameter];
        }
      }

      document.cookie = name + '=' + value;
    },
    getTestCallParamsFromCookie: function getTestCallParamsFromCookie(campaignId) {
      var name = 'app.ivoice.online.testCall.' + campaignId;
      // let matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'))
      var matches = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      if (matches && matches.length && matches.length > 1) {
        var testCallTaskStr = matches ? decodeURIComponent(matches[2]) : undefined;
        if (testCallTaskStr) {
          var testCallTaskDto = {
            phone: '',
            parameters: {}
          };
          var paramsArray = testCallTaskStr.split('_');
          for (var i = 0; i < paramsArray.length; i++) {
            var param = paramsArray[i].split(':');
            if (i === 0 && param[0] === 'phone') {
              testCallTaskDto.phone = param[1];
            } else {
              testCallTaskDto.parameters[param[0]] = param[1];
            }
          }
          return testCallTaskDto;
        }
      }
      return undefined;
    },
    guid: function guid() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      }

      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    },
    prepareTestPhoneParameters: function prepareTestPhoneParameters() {
      this.webSocketSessionId = this.guid();

      var params = {};
      if (this.testPhoneParametersArray) {
        for (var i = 0; i < this.testPhoneParametersArray.length; i++) {
          if (this.testPhoneParametersArray[i][0] && this.testPhoneParametersArray[i][0] !== 'undefined') {
            params[this.testPhoneParametersArray[i][0]] = this.testPhoneParametersArray[i][1];
          }
        }
      }
      params.webDomen = 'https://' + document.location.host + '/api/dialogState/receive';
      params.webSocketSessionId = this.webSocketSessionId;

      return params;
    },
    callTestToPhone: function callTestToPhone() {
      var _this = this;

      var that = this;
      // if (this.testPhone.trim() !== '' && this.tmp.campaignId && this.tmp.campaignId !== '0') {
      this.creatingTestCall = true;
      console.log('saving new testing call task: ' + JSON.stringify(this.testPhone));
      this.$http.post(CALLTASKTESTING_API, this.prepareTestPhone(this.tmp.campaignId, this.testPhone, this.prepareTestPhoneParameters()), { headers: this.prepareSecurityHeader() }).then(function () {
        _this.creatingTestCall = false;
        that.openNotificationWithType('success', that.$i18n.messages[_this.$i18n.locale].notifications.testCall.testCallActivated);
        // that.debuggingDialog = true // ToDo
      }).catch(function (error) {
        _this.creatingTestCall = false;
        console.log(error);
        that.openNotificationWithType('danger', that.$i18n.messages[_this.$i18n.locale].notifications.testCall.errorCreatingTestCall);
      });
    },
    initWebRtc: function initWebRtc() {
      var options = {
        media: {
          local: {
            audio: this.$el.getElementsByClassName('localAudio')[0]
          },
          remote: {
            audio: this.$el.getElementsByClassName('remoteAudio')[0]
          },
          constraints: { audio: true, video: false // audio only call
          } },
        aor: 'sip:1010@ws.tehnoprom.ivoice.online', // caller
        userAgentOptions: {
          authorizationUsername: '1010',
          authorizationPassword: 'ivoice123'
        },
        delegate: {
          onCallCreated: function onCallCreated() {
            console.log('onCallCreated. ');
          },
          onCallAnswered: function onCallAnswered() {
            console.log('onCallAnswered. ');
          },
          onCallReceived: function onCallReceived(data) {
            console.log('onCallReceived. ' + data);
          },
          onMessageReceived: function onMessageReceived(data) {
            console.log('onMessageReceived. ' + data);
          },
          onCallHangup: function onCallHangup() {
            console.log('onCallHangup. ');
          },
          onServerDisconnect: function onServerDisconnect() {
            console.log('onServerDisconnect. ');
          }
        }
      };

      var simple = new __WEBPACK_IMPORTED_MODULE_3_sip_js__["a" /* Web */].SimpleUser('wss://ws.tehnoprom.ivoice.online:7443', options);

      return simple;
    },
    callTestInBrowser: function callTestInBrowser() {
      var _this2 = this;

      var that = this;
      this.webSocketSessionId = this.guid();
      this.creatingTestCall = true;
      this.$http.post(CAMPAIGNS_API + '/prepareForWebRtc/' + this._props.scenario.id, {}, { headers: this.prepareSecurityHeader() }).then(function () {
        that.creatingTestCall = false;
        that.webRtcSimple.connect().then(function () {
          return that.webRtcSimple.call('sip:' + that.webRtcDialplanCondition + '@ws.tehnoprom.ivoice.online');
        }).catch(function (error) {
          console.log('error. ' + error);
        });
        // that.debuggingDialog = true // ToDo
      }).catch(function (error) {
        that.creatingTestCall = false;
        console.log(error);
        that.openNotificationWithType('danger', that.$i18n.messages[_this2.$i18n.locale].notifications.testCall.errorCreatingTestCall);
      });
    },
    callTest: function callTest() {
      if (this.callToPhone) {
        this.callTestToPhone();
      } else {
        this.callTestInBrowser();
      }
    },
    onDialogFinish: function onDialogFinish() {
      this.debuggingDialog = false;
      console.log('onDialogFinish ');
    },
    onDialogNewMessage: function onDialogNewMessage(nodeId) {
      // ToDo
      console.log('onDialogNewMessage ' + nodeId);
    },
    loadCampaignList: function loadCampaignList(scenarioId) {
      var _this3 = this;

      var that = this;
      if (scenarioId || this._props.scenario.id) {
        this.$http({
          url: GET_CAMPAIGNS_API + '/' + (scenarioId || this._props.scenario.id),
          headers: this.prepareSecurityHeader()
        }).then(function (response) {
          var campaignIds = response.data;
          if (campaignIds && campaignIds.length > 0) {
            that.tmp.campaignList = campaignIds;
            _this3.setCampaignId(that.tmp.campaignList[0].id);
          } else {
            that.callToPhone = false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    initCampaign: function initCampaign(scenarioId) {
      if (!this._props.campaignId || this._props.campaignId === '0') {
        this.loadCampaignList(scenarioId);
      } else {
        this.tmp.campaignList = [this._props.campaignId];
        this.setCampaignId(this.tmp.campaignList[0].id);
      }
    },
    setCampaignId: function setCampaignId(campaignId) {
      this.tmp.campaignId = campaignId;
      var testCallTaskDto = this.getTestCallParamsFromCookie(campaignId);
      if (testCallTaskDto) {
        this.testPhone = testCallTaskDto.phone;
        if (testCallTaskDto.parameters && Object.entries(testCallTaskDto.parameters).length) {
          this.testPhoneParametersArray = [];
          for (var parameter in testCallTaskDto.parameters) {
            this.testPhoneParametersArray.push([parameter, testCallTaskDto.parameters[parameter]]);
          }
        }
      }
    },
    callToPhoneOnChangeEvent: function callToPhoneOnChangeEvent(val) {
      this.callToPhone = !!val;
    },
    loadWebRtcDialplanCondition: function loadWebRtcDialplanCondition() {
      var that = this;
      this.$http({
        url: WEBRTC_DIALPLAN_CONDITION,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        that.webRtcDialplanCondition = response.data;
      }).catch(function (error) {
        console.log(error);
        that.callToPhone = true;
      });
    }
  },
  created: function created() {
    this.loadWebRtcDialplanCondition();
    this.initCampaign(this._props.scenario ? this._props.scenario.id : null);
  },
  mounted: function mounted() {
    this.webRtcSimple = this.initWebRtc();
  }
});

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DebugDialog',
  props: ['onNewMessage', 'onFinish', 'webSocketSessionId'],
  data: function data() {
    return {
      messages: []
    };
  },

  methods: {
    timeFormat: function timeFormat(time) {
      return time.getHours() + ':' + time.getMinutes() + ':' + time.getSeconds();
    },
    getMessageClass: function getMessageClass(message) {
      return message.state + ' ' + (message.state === 'ROBOT_SPEECH' ? 'Robot' : 'Human');
    },
    startWebSocketDebugDialog: function startWebSocketDebugDialog() {
      var _this = this;

      this.messages = [];
      var that = this;
      var socketProtocol = 'ws';
      var pageProtocol = window.location.href.split('://')[0] || '';
      if (pageProtocol.toLowerCase() === 'https') {
        socketProtocol = 'wss';
      }
      this.ws = new window.WebSocket(socketProtocol + '://' + document.location.host + '/startDialog');
      this.ws.onmessage = function (data) {
        return _this.webSocketHandler(data.data);
      };
      this.ws.onopen = function () {
        var data = JSON.stringify({
          sessionId: _this._props.webSocketSessionId
        });
        that.ws.send(data);
      };
    },
    webSocketHandler: function webSocketHandler(message) {
      var dialog = JSON.parse(message);
      if (dialog.state === 'hangup') {
        this.finishWebSocketDebugDialog();
        this._props.onFinish();
      } else {
        this.messages.push(dialog);
        this._props.onNewMessage(dialog.nodeId);
      }
    },
    finishWebSocketDebugDialog: function finishWebSocketDebugDialog() {
      if (this.state.ws != null) {
        this.state.ws.close();
      }
    }
  },
  created: function created() {
    this.startWebSocketDebugDialog();
  }
});

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messages && _vm.messages.length),
      expression: "messages && messages.length"
    }],
    staticClass: "msger"
  }, [_c('main', {
    staticClass: "msger-chat"
  }, _vm._l((_vm.messages), function(message) {
    return _c('div', [_c('div', {
      staticClass: "msg",
      class: _vm.getMessageClass(message)
    }, [_c('div', {
      staticClass: "msg-img"
    }), _vm._v(" "), _c('div', {
      staticClass: "msg-bubble"
    }, [_c('div', {
      staticClass: "msg-info"
    }, [_vm._v("\"msg-info-time\"}>" + _vm._s(_vm.timeFormat(new Date())))])]), _vm._v(" "), _c('div', {
      staticClass: "msg-label optionLabel"
    }, [_vm._v("\n          " + _vm._s(message.optionLabel) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "msg-text recognitionText"
    }, [_vm._v("\n          " + _vm._s(message.recognitionText) + "\n        ")])])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "test_call"
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('div', {
    staticClass: "modal-card-title"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('testCall.testCall')))])])]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close",
      "title": _vm.$t('common.actions.close')
    },
    on: {
      "click": function($event) {
        return _vm.closeTestCall()
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body",
    class: _vm.testPhoneParametersArray.length > 3 ? 'scrolled' : ''
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "webRtcDialplanCondition",
    attrs: {
      "v-model": _vm.webRtcDialplanCondition,
      "placeholder": "webRtcDialplanCondition"
    }
  }), _vm._v(" "), _c('vb-switch-with-two-labels', {
    attrs: {
      "model": _vm.callToPhone,
      "label-left": _vm.$t('testCall.calInBrowser'),
      "label-right": _vm.$t('testCall.callToPhone'),
      "onchange": _vm.callToPhoneOnChangeEvent
    },
    on: {
      "update:model": function($event) {
        _vm.callToPhone = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.callToPhone && _vm.tmp.campaignList.length),
      expression: "!!callToPhone && tmp.campaignList.length"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.testPhone),
      expression: "testPhone"
    }],
    staticClass: "input phone",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('callTasks.phoneNumber')
    },
    domProps: {
      "value": (_vm.testPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.testPhone = $event.target.value
      }
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.callToPhone && _vm.tmp.campaignList.length),
      expression: "!!callToPhone && tmp.campaignList.length"
    }],
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.campaignId),
      expression: "tmp.campaignId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "campaignId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.tmp.campaignList), function(campaign) {
    return _c('option', {
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v(_vm._s(campaign.name))])
  }), 0)]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "is-small note"
  }, [(_vm.callToPhone) ? _c('div', [_vm._v(_vm._s(_vm.$t('testCall.toPhoneNote')))]) : _c('div', [_vm._v(_vm._s(_vm.$t('testCall.inBrowserNote')))])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('common.key')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.value')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.testPhoneParametersArray), function(param, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[0]),
        expression: "param[0]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (param[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 0, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-light",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.deleteTestPhoneParameter(index)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.delete')))])])])])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
    staticClass: "button is-light addParam",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.addTestPhoneParameter
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.add')))])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])], 2)])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": (_vm.callToPhone && !_vm.testPhone) || (!_vm.callToPhone && !_vm.webRtcDialplanCondition) || _vm.creatingTestCall
    },
    on: {
      "click": function($event) {
        return _vm.callTest()
      }
    }
  }, [(_vm.callToPhone) ? _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-phone-volume"
  })]) : _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-headset"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('testCall.call')))])]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "title": _vm.$t('common.actions.close')
    },
    on: {
      "click": function($event) {
        return _vm.closeTestCall()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.actions.cancel')))])]), _vm._v(" "), (_vm.debuggingDialog) ? _c('DebugDialog', {
    attrs: {
      "on-finish": _vm.onDialogFinish,
      "on-new-message": _vm.onDialogNewMessage,
      "web-socket-session-id": _vm.webSocketSessionId
    },
    on: {
      "update:webSocketSessionId": function($event) {
        _vm.webSocketSessionId = $event
      },
      "update:web-socket-session-id": function($event) {
        _vm.webSocketSessionId = $event
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('audio', {
    staticClass: "remoteAudio"
  }), _vm._v(" "), _c('audio', {
    staticClass: "localAudio"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })])
}]}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scenario_bar"
  }, [_c('p', {
    staticClass: "control firstGroup"
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "jsonFile",
      "name": "jsonFile"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button importScenario",
    on: {
      "click": function($event) {
        return _vm.importScenario()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.import')))])]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.exportScenario()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.export')))])])]), _vm._v(" "), _c('p', {
    staticClass: "control secondGroup"
  }, [_c('button', {
    staticClass: "button is-primary saveScenarioButton",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.save')))])]), _vm._v(" "), (!!this._props.scenario.id) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        return _vm.showTestCall()
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('testCall.testCall')))])]) : _vm._e()]), _vm._v(" "), (!!this._props.scenario.id) ? _c('test-call', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.testCall),
      expression: "!!testCall"
    }],
    attrs: {
      "close-test-call": _vm.closeTestCall,
      "scenario": _vm.scenario,
      "campaign-id": _vm.campaignId
    },
    on: {
      "update:scenario": function($event) {
        _vm.scenario = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-file-import"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-file-export"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-phone-volume"
  })])
}]}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__googleVoices__ = __webpack_require__(201);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['hideArrows', 'scenarioName', 'locale', 'recognitionDriver'],
  methods: {
    scenarioNameChange: function scenarioNameChange() {
      this.$emit('scenarioNameChange', this.name);
    },
    hideArrowsChange: function hideArrowsChange() {
      this.$emit('hideArrowsChange', this.hideArrowsVar);
    },
    localeChange: function localeChange() {
      this.$emit('localeChange', this.lang);
    },
    recognitionDriverChange: function recognitionDriverChange() {
      this.$emit('recognitionDriverChange', this.driver);
    }
  },
  created: function created() {
    console.log(this._props.hideArrows);
    this.name = this._props.scenarioName;
    this.lang = this._props.locale + '';
    this.driver = this._props.recognitionDriver;
    this.hideArrowsVar = this._props.hideArrows;
  },
  data: function data() {
    return {
      name: '',
      hideArrowsVar: '',
      googleLanguages: __WEBPACK_IMPORTED_MODULE_0__googleVoices__["a" /* googleLanguages */],
      lang: '',
      driver: ''
    };
  }
});

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scenario_common_params"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.title')))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('scenarios.scenarioName')
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "change": function($event) {
        return _vm.scenarioNameChange()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hideArrowsVar),
      expression: "hideArrowsVar"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.hideArrowsVar) ? _vm._i(_vm.hideArrowsVar, null) > -1 : (_vm.hideArrowsVar)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.hideArrowsVar,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.hideArrowsVar = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.hideArrowsVar = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.hideArrowsVar = $$c
        }
      }, function($event) {
        return _vm.hideArrowsChange()
      }]
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('scenarios.konstruktor.commonParams.hideArrows')) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "commonParameters"
  }, [_c('div', {
    staticClass: "field is-horizontal locale"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.language')))])]), _vm._v(" "), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [(_vm.googleLanguages) ? _c('div', {
    staticClass: "select langSelect"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lang),
      expression: "lang"
    }],
    staticClass: "form-control lang scenarioLang",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.lang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.localeChange()
      }]
    }
  }, _vm._l((_vm.googleLanguages), function(language) {
    return _c('option', {
      domProps: {
        "value": language.value
      }
    }, [_vm._v("\n                  " + _vm._s(language.label) + "\n                ")])
  }), 0)]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locale),
      expression: "locale"
    }],
    staticClass: "input scenarioLang",
    attrs: {
      "type": "text",
      "placeholder": "Locale"
    },
    domProps: {
      "value": (_vm.locale)
    },
    on: {
      "change": function($event) {
        return _vm.localeChange()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.locale = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal locale"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.recognition.recognitionDriver')))])]), _vm._v(" "), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver),
      expression: "driver"
    }],
    staticClass: "form-control vendor",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.driver = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.recognitionDriverChange()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "google"
    }
  }, [_vm._v("Google")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "yandex"
    }
  }, [_vm._v("Yandex")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "tinkoff"
    }
  }, [_vm._v("Tinkoff")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3itech"
    }
  }, [_vm._v("3-itech")])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsplumb_extends_jsplumb_vue__ = __webpack_require__(66);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HttpRequest',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__jsplumb_extends_jsplumb_vue__["a" /* BaseNodeComponent */]],
  data: function data() {
    return {
      headersAsList: [],
      paramsAsList: []
    };
  },
  created: function created() {
    for (var key in this.obj.data.headers) {
      this.headersAsList.push({
        key: key,
        value: this.obj.data.headers[key]
      });
    }
    for (var i = this.headersAsList.length; i < 4; i++) {
      this.headersAsList.push({
        key: '',
        value: ''
      });
    }

    for (var _key in this.obj.data.params) {
      this.paramsAsList.push({
        key: _key,
        value: this.obj.data.params[_key]
      });
    }
    for (var _i = this.paramsAsList.length; _i < 4; _i++) {
      this.paramsAsList.push({
        key: '',
        value: ''
      });
    }
  }
});

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flowchart-object jsplumb-draggable jsplumb-droppable",
    style: ({
      left: _vm.obj.view.left + "px",
      top: _vm.obj.view.top + "px",
      width: _vm.obj.view.w + "px",
      height: _vm.obj.view.h + "px"
    }),
    attrs: {
      "id": _vm.obj.view.id
    }
  }, [_c('div', {
    staticClass: "http_request_shell"
  }, [_c('div', {
    staticClass: "title control"
  }, [_c('div', {
    staticClass: "httpRequestTitle"
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.add.sendHttpRequest')))]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": _vm.$t('common.actions.delete')
    },
    on: {
      "click": function($event) {
        return _vm.deleteNode()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('div', {
    staticClass: "is-overlay overlay-for-not-admin"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "field has-addons has-addons-centered"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.data.method),
      expression: "obj.data.method"
    }],
    staticClass: "method",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.obj.data, "method", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "GET"
    }
  }, [_vm._v("GET")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "POST"
    }
  }, [_vm._v("POST")])])])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.data.url),
      expression: "obj.data.url"
    }],
    staticClass: "input url",
    attrs: {
      "type": "url",
      "placeholder": "url"
    },
    domProps: {
      "value": (_vm.obj.data.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj.data, "url", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "paramsHeadersBody"
  }, [_c('table', [_c('thead', [_c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.httpRequest.params')))]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.httpRequest.headers')))]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.httpRequest.body')))])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('div', {
    staticClass: "paramsList"
  }, [_c('table', [_c('tbody', _vm._l((_vm.paramsAsList), function(param, index) {
    return _c('tr', {
      staticClass: "param"
    }, [_c('td', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param.key),
        expression: "param.key"
      }],
      staticClass: "input key",
      attrs: {
        "type": "text",
        "placeholder": _vm.$t('common.key')
      },
      domProps: {
        "value": (param.key)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, "key", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param.value),
        expression: "param.value"
      }],
      staticClass: "input value",
      attrs: {
        "type": "text",
        "placeholder": _vm.$t('common.value')
      },
      domProps: {
        "value": (param.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, "value", $event.target.value)
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "headersList"
  }, [_c('table', [_c('tbody', _vm._l((_vm.headersAsList), function(header, index) {
    return _c('tr', {
      staticClass: "header"
    }, [_c('td', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (header.key),
        expression: "header.key"
      }],
      staticClass: "input key",
      attrs: {
        "type": "text",
        "placeholder": _vm.$t('common.key')
      },
      domProps: {
        "value": (header.key)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(header, "key", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (header.value),
        expression: "header.value"
      }],
      staticClass: "input value",
      attrs: {
        "type": "text",
        "placeholder": _vm.$t('common.value')
      },
      domProps: {
        "value": (header.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(header, "value", $event.target.value)
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "bodyTd"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.data.body),
      expression: "obj.data.body"
    }],
    staticClass: "textarea body",
    attrs: {
      "placeholder": "json",
      "title": "json"
    },
    domProps: {
      "value": (_vm.obj.data.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj.data, "body", $event.target.value)
      }
    }
  })])])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Konstruktor"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.id),
      expression: "scenario.id"
    }],
    staticClass: "scenarioId",
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.scenario.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.id),
      expression: "scenario.id"
    }],
    staticClass: "clientId",
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.scenario.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "jtk-demo-main",
    attrs: {
      "id": "jtk-demo-flowchart"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "jtk-demo-canvas canvas-wide flowchart-demo jtk-surface jtk-surface-nopan",
    attrs: {
      "id": "canvas"
    }
  }, [_c('jsplumb-toolkit', {
    ref: "toolkitComponent",
    attrs: {
      "view": _vm.view,
      "scenarioId": _vm.scenario.id,
      "client": _vm.name,
      "available-sms-gateways": _vm.availableSmsGateways
    },
    on: {
      "update:scenarioId": function($event) {
        return _vm.$set(_vm.scenario, "id", $event)
      },
      "update:scenario-id": function($event) {
        return _vm.$set(_vm.scenario, "id", $event)
      },
      "update:availableSmsGateways": function($event) {
        _vm.availableSmsGateways = $event
      },
      "update:available-sms-gateways": function($event) {
        _vm.availableSmsGateways = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "zoomShell"
  }, [_c('zoom', {
    attrs: {
      "element-id": "canvas"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "scenarioBarShell"
  }, [_c('tool-buttons', {
    attrs: {
      "name": _vm.name,
      "scenario": _vm.scenario,
      "campaign-id": _vm.campaignid
    },
    on: {
      "update:scenario": function($event) {
        _vm.scenario = $event
      },
      "set": _vm.setScenario,
      "setDefault": _vm.setScenario,
      "initScenario": _vm.initScenarioFromCanvas
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "scenarioCommonParametersViewShell"
  }, [_c('ScenarioCommonParams', {
    attrs: {
      "hide-arrows": _vm.scenario.parameters.visual.hideArrows,
      "scenario-name": _vm.scenario.name,
      "locale": _vm.scenario.parameters.common.locale,
      "recognition-driver": _vm.scenario.parameters.common.recognitionDriver
    },
    on: {
      "hideArrowsChange": _vm.hideArrowsChange,
      "scenarioNameChange": _vm.scenarioNameChange,
      "localeChange": _vm.localeChange,
      "recognitionDriverChange": _vm.recognitionDriverChange
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Answer__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Answer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Answer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sms__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Sms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__konstruktor_ToolButtons__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__konstruktor_ToolButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__konstruktor_ToolButtons__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'AudioCustomizer',
    props: ['name', 'campaignid', 'pScenario'],
    components: { Answer: __WEBPACK_IMPORTED_MODULE_0__Answer___default.a, Sms: __WEBPACK_IMPORTED_MODULE_1__Sms___default.a, ToolButtons: __WEBPACK_IMPORTED_MODULE_2__konstruktor_ToolButtons___default.a },
    data: function data() {
        return {
            scenario: {
                client: '',
                parameters: {
                    commonParameters: {
                        locale: ''
                    },
                    voiceParameters: {
                        vendor: '',
                        voiceName: ''
                    },
                    audio: [],
                    sms: []
                }
            },
            voices: {
                'Yandex': [{
                    value: 'jane'
                }, {
                    value: 'oksana'
                }, {
                    value: 'alyss '
                }, {
                    value: 'omazh'
                }, {
                    value: 'zahar '
                }, {
                    value: 'ermil '
                }],
                'Google': [],
                'Azure': []
            }
        };
    },

    methods: {
        setScenario: function setScenario(value) {
            this.scenario = value;
        },
        setAudio: function setAudio(data) {
            var answer = this.getAnswerObjByClass(data.theme);
            if (answer) {
                if (data.type) {
                    var sound = {
                        type: data.type,
                        url: data.url,
                        param: data.paramName,
                        number: data.number
                    };
                    answer.sounds = answer.sounds || [];
                    var audioTmp = [];
                    audioTmp.push(sound);
                    for (var i = 0; i < answer.sounds.length; i++) {
                        audioTmp.push(answer.sounds[i]);
                    }
                    audioTmp.sort(function (a, b) {
                        return a.number > b.number ? 1 : -1;
                    });
                    answer.sounds = audioTmp;
                    console.log(this.scenario);
                } else {
                    answer.sounds = [];
                    console.log(this.scenario);
                }
            }
        },
        deleteAudio: function deleteAudio(data) {
            var answer = this.getAnswerObjByClass(data.theme);
            if (answer) {
                answer.sounds = [];
            }
        },
        getAnswerObjByClass: function getAnswerObjByClass(answerTheme) {
            for (var i = 0; i < this.scenario.parameters.audio.length; i++) {
                var answer = this.scenario.parameters.audio[i];
                if (answer.name.toLocaleLowerCase() === answerTheme.toLowerCase()) {
                    return answer;
                }
            }
        },
        generateWords: function generateWords(answer) {
            var words = answer.words || answer.variants || '';
            if (typeof words === 'string' || words instanceof String) {
                if (words.length && words.indexOf('(') < 0) {
                    words = '(' + words + ')';
                }
                return words;
            } else if (Array.isArray(words)) {
                return '(' + words.join(', ') + ')';
            }
        }
    },
    mounted: function mounted() {
        this.setScenario(this._props.pScenario);
    }
});

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['smsTitle', 'smsText', 'smsTheme', 'isSaved']
});

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sms",
    class: _vm.smsTheme
  }, [_c('div', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.smsTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    staticClass: "textarea",
    domProps: {
      "value": _vm.smsText
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:smsText', $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audioCustomizer"
  }, [_c('div', {
    staticClass: "commonParameters"
  }, [_c('div', {
    staticClass: "field is-horizontal locale"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.language')))])]), _vm._v(" "), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.commonParameters.locale),
      expression: "scenario.parameters.commonParameters.locale"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Locale"
    },
    domProps: {
      "value": (_vm.scenario.parameters.commonParameters.locale)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters.commonParameters, "locale", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal vendor"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.voiceParameters.vendor),
      expression: "scenario.parameters.voiceParameters.vendor"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.scenario.parameters.voiceParameters, "vendor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "yandex"
    }
  }, [_vm._v("Yandex")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "google"
    }
  }, [_vm._v("Google")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "azure"
    }
  }, [_vm._v("Azure")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal voice"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.voice')))])]), _vm._v(" "), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.voiceParameters.voiceName),
      expression: "scenario.parameters.voiceParameters.voiceName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "voiceName"
    },
    domProps: {
      "value": (_vm.scenario.parameters.voiceParameters.voiceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters.voiceParameters, "voiceName", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', [_vm._l((_vm.scenario.parameters.audio), function(answer) {
    return _c('div', {
      staticClass: "answer_shell"
    }, [_c('answer', {
      attrs: {
        "answer-title": answer.title,
        "answer-theme": answer.name,
        "answer-words": _vm.generateWords(answer),
        "answer-audio": answer.sounds,
        "answer-text": answer.text,
        "answer-vendor": _vm.scenario.parameters.voiceParameters.vendor,
        "answer-locale": _vm.scenario.parameters.commonParameters.locale,
        "answer-speaker": _vm.scenario.parameters.voiceParameters.voiceName,
        "answer-emotion": answer.emotion,
        "answer-speed": answer.speed,
        "is-saved": true,
        "client": _vm.scenario.client,
        "scenario-id": _vm.scenario.id
      },
      on: {
        "update:answerAudio": function($event) {
          return _vm.$set(answer, "sounds", $event)
        },
        "update:answer-audio": function($event) {
          return _vm.$set(answer, "sounds", $event)
        },
        "update:answerText": function($event) {
          return _vm.$set(answer, "text", $event)
        },
        "update:answer-text": function($event) {
          return _vm.$set(answer, "text", $event)
        },
        "update:answerVendor": function($event) {
          return _vm.$set(_vm.scenario.parameters.voiceParameters, "vendor", $event)
        },
        "update:answer-vendor": function($event) {
          return _vm.$set(_vm.scenario.parameters.voiceParameters, "vendor", $event)
        },
        "update:answerLocale": function($event) {
          return _vm.$set(_vm.scenario.parameters.commonParameters, "locale", $event)
        },
        "update:answer-locale": function($event) {
          return _vm.$set(_vm.scenario.parameters.commonParameters, "locale", $event)
        },
        "update:answerSpeaker": function($event) {
          return _vm.$set(_vm.scenario.parameters.voiceParameters, "voiceName", $event)
        },
        "update:answer-speaker": function($event) {
          return _vm.$set(_vm.scenario.parameters.voiceParameters, "voiceName", $event)
        },
        "update:answerEmotion": function($event) {
          return _vm.$set(answer, "emotion", $event)
        },
        "update:answer-emotion": function($event) {
          return _vm.$set(answer, "emotion", $event)
        },
        "update:answerSpeed": function($event) {
          return _vm.$set(answer, "speed", $event)
        },
        "update:answer-speed": function($event) {
          return _vm.$set(answer, "speed", $event)
        },
        "generateAudioHandler": _vm.setAudio,
        "deleteAudioHandler": _vm.deleteAudio
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.scenario.parameters.sms), function(sms) {
    return _c('div', {
      staticClass: "sms_shell"
    }, [_c('sms', {
      attrs: {
        "sms-title": sms.title,
        "sms-theme": sms.name,
        "sms-text": sms.text,
        "is-saved": true
      },
      on: {
        "update:smsText": function($event) {
          return _vm.$set(sms, "text", $event)
        },
        "update:sms-text": function($event) {
          return _vm.$set(sms, "text", $event)
        }
      }
    })], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "scenarioBarShell"
  }, [_c('tool-buttons', {
    attrs: {
      "name": _vm.name,
      "scenario": _vm.scenario,
      "campaign-id": _vm.campaignid
    },
    on: {
      "update:scenario": function($event) {
        _vm.scenario = $event
      },
      "set": _vm.setScenario,
      "setDefault": _vm.setScenario
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-label is-normal"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Generation vendor")])])
}]}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'active_scenario_' + _vm.currentScenario
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadedScenario === null),
      expression: "loadedScenario === null"
    }],
    staticClass: "choose_scenario"
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeSelectList.length > 1),
      expression: "activeSelectList.length > 1"
    }],
    staticClass: "label"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('scenarios.scenarioTemplate')) + "\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeSelectList.length > 1),
      expression: "activeSelectList.length > 1"
    }],
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentScenario),
      expression: "currentScenario"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.loadedScenario !== null
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentScenario = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "empty",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.chooseScenarioTemplate')))]), _vm._v(" "), _vm._l((_vm.activeSelectList), function(scenario) {
    return _c('option', {
      domProps: {
        "value": scenario.name
      }
    }, [_vm._v("\n            " + _vm._s(scenario.label) + "\n          ")])
  })], 2)])]), _vm._v(" "), (_vm.currentScenario === _vm.selectList[0].name) ? _c('scenario-question-recognition', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[1].name) ? _c('scenario-question-yes-no', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[2].name) ? _c('scenario-two-level-yes-no', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[3].name) ? _c('scenario-notice', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[4].name) ? _c('scenario-question-interview', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[5].name) ? _c('scenario-denta-promotion', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[6].name) ? _c('scenario-akvamir', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.otherTemplate(_vm.currentScenario)) ? _c('AudioCustomizer', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id,
      "p-scenario": _vm.loadedScenario
    },
    on: {
      "set": _vm.setScenario,
      "update:pScenario": function($event) {
        _vm.loadedScenario = $event
      },
      "update:p-scenario": function($event) {
        _vm.loadedScenario = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[7].name) ? _c('Konstruktor', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id,
      "available-sms-gateways": _vm.availableSmsGateways,
      "p-scenario": _vm.loadedScenario
    },
    on: {
      "set": _vm.setScenario,
      "update:availableSmsGateways": function($event) {
        _vm.availableSmsGateways = $event
      },
      "update:available-sms-gateways": function($event) {
        _vm.availableSmsGateways = $event
      },
      "update:pScenario": function($event) {
        _vm.loadedScenario = $event
      },
      "update:p-scenario": function($event) {
        _vm.loadedScenario = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[8].name) ? _c('scenario-question-yes-no-multi-lang', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e()], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_message__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission___default.a);

var NotificationComponent = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var MessageComponent = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_message___default.a);
var openMessage = function openMessage() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  };

  return new MessageComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var api = '/api/scenarios';
var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_1__Modal___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_message___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification___default.a
  },

  data: function data() {
    return {
      scenarios: [],
      sortedScenarios: [],
      currentPage: 1,
      perPage: 10,
      maxVisibleButtons: 10,
      currentSort: 'dateCreated',
      currentSortDir: 'desc',
      ascIcon: ' ▲',
      descIcon: ' ▼',
      searchName: '',
      scenarioToDelete: null,
      showModal: null,
      title: '',
      isActive: false,
      permissionKey: 'scenario'
    };
  },


  created: function created() {
    this.checkToken();
    this.loadState();
    this.loadData();
  },

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['loggedId', 'authenticationToken']), {
    totalPages: function totalPages() {
      return Math.max(Math.ceil(this.scenarios.length / this.perPage), 1);
    },
    startPage: function startPage() {
      if (this.currentPage === 1) {
        return 1;
      }

      if (this.currentPage === this.totalPages) {
        return Math.max(this.totalPages - this.maxVisibleButtons + 1, 1);
      }

      return this.currentPage - 1;
    },
    endPage: function endPage() {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
    },
    pages: function pages() {
      var range = [];
      for (var i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        });
      }
      return range;
    },
    isInFirstPage: function isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage: function isInLastPage() {
      return this.currentPage === this.totalPages;
    }
  }),

  methods: _extends({
    loadData: function loadData() {
      var _this = this;

      this.setLoadedScenario(null);
      var that = this;
      this.$http.get(api, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.scenarios = response.data;
        _this.sortedScenarios = _this.sortedScenario();
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', that.$i18n.messages[that.$i18n.locale].notifications.scenario.errorLoadScenarioList);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapMutations"])(['setLoadedScenario']), {
    sortedScenario: function sortedScenario() {
      var _this2 = this;

      return this.scenarios.filter(this.filterByName).sort(function (a, b) {
        var modifier = 1;
        if (_this2.currentSortDir === 'desc') modifier = -1;
        if (a[_this2.currentSort] < b[_this2.currentSort]) return -1 * modifier;
        if (a[_this2.currentSort] > b[_this2.currentSort]) return 1 * modifier;
        return 0;
      }).filter(function (row, index) {
        var start = (_this2.currentPage - 1) * _this2.perPage;
        var end = _this2.currentPage * _this2.perPage;
        if (index >= start && index < end) return true;
      });
    },
    sort: function sort(s) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
      this.sortedScenarios = this.sortedScenario();
    },

    filterByName: function filterByName(scenario) {
      if (this.searchName.length === 0) {
        return true;
      }
      return scenario.name.toLowerCase().indexOf(this.searchName.toLowerCase()) > -1;
    },
    searchByName: function searchByName() {
      this.sortedScenarios = this.sortedScenario();
    },
    sortIcon: function sortIcon(s) {
      if (s === this.currentSort) {
        if (this.currentSortDir === 'asc') {
          return this.ascIcon;
        } else {
          return this.descIcon;
        }
      } else {
        return '';
      }
    },
    closeModal: function closeModal() {
      this.scenarioToDelete = null;
      this.showModal = false;
    },
    openModal: function openModal(scenario) {
      this.scenarioToDelete = scenario;
      this.title = this.$i18n.messages[this.$i18n.locale].scenarios.removeScenario + '?';
      this.showModal = true;
    },
    confirmAction: function confirmAction() {
      if (this.scenarioToDelete) {
        this.removeScenario();
        this.scenarioToDelete = null;
      }
      this.closeModal();
    },
    removeScenario: function removeScenario() {
      var _this3 = this;

      this.$http.delete(api + '/' + this.scenarioToDelete.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this3.openNotificationWithType('info', _this3.$i18n.messages[_this3.$i18n.locale].notification.scenario.scenarioHasBeenRemoved);
        _this3.loadData();
      }).catch(function (error) {
        console.log(error);
        _this3.openNotificationWithType('danger', _this3.$i18n.messages[_this3.$i18n.locale].notification.scenario.errorRemoveScenario);
      });
    },
    isRemove: function isRemove(index) {
      return this.isDependentCampaign(index);
    },
    isDependentCampaign: function isDependentCampaign(index) {
      return !this.scenarios[index].inUse;
    },
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    onClickFirstPage: function onClickFirstPage() {
      this.onPageChange(1);
    },
    onClickPreviousPage: function onClickPreviousPage() {
      this.onPageChange(this.currentPage - 1);
    },
    onClickPage: function onClickPage(page) {
      this.onPageChange(page);
    },
    onClickNextPage: function onClickNextPage() {
      this.onPageChange(this.currentPage + 1);
    },
    onClickLastPage: function onClickLastPage() {
      this.onPageChange(this.totalPages);
    },
    isPageActive: function isPageActive(page) {
      return this.currentPage === page;
    },
    onPageChange: function onPageChange(page) {
      this.currentPage = page;
      this.sortedScenarios = this.sortedScenario();
    },
    loadState: function loadState() {
      var _this4 = this;

      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this4.isActive = response.data;
        if (!_this4.isActive) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this4.openNotificationWithType('danger', _this4.$i18n.messages[_this4.$i18n.locale].notification.scenario.errorToGetUserStatus);
      });
    },
    getDate: function getDate(date) {
      var d = new Date(Number(date));
      var day = d.getUTCDate();
      var month = d.getUTCMonth() + 1;
      var year = d.getUTCFullYear();
      if (day < 10) day = '0' + day;
      if (month < 10) month = '0' + month;
      return day + '.' + month + '.' + year;
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: this.$i18n.messages[this.$i18n.locale].notifications.notification,
        message: message,
        type: type
      });
    }
  })
});

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.canCreate(_vm.permissionKey)) ? _c('a', {
    staticClass: "button is-success",
    attrs: {
      "href": "#/scenarios/0/new",
      "disabled": !_vm.isActive
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('scenarios.createScenario')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-info is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.search')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchName),
      expression: "searchName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('scenarios.putScenarioName')
    },
    domProps: {
      "value": (_vm.searchName)
    },
    on: {
      "change": _vm.searchByName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('name')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.title')) + _vm._s(_vm.sortIcon('name')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('client')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.client')) + _vm._s(_vm.sortIcon('client')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('template')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.template')) + _vm._s(_vm.sortIcon('template')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('isReady')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.readiness')) + _vm._s(_vm.sortIcon('isReady')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('dateCreated')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.creationDate')) + _vm._s(_vm.sortIcon('dateCreated')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.action')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedScenarios), function(scenario, index) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": '#/scenarios/0/' + scenario.id
      }
    }, [_vm._v(_vm._s(scenario.name))])]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(scenario.client) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(scenario.template) + "\n                ")]), _vm._v(" "), _c('td', [(scenario.isReady) ? _c('button', {
      staticClass: "button is-success is-outlined",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": true
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('scenarios.prepared')))])]) : _c('button', {
      staticClass: "button is-danger is-outlined",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": true
      }
    }, [_vm._m(3, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('scenarios.notPrepared')))])])]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.getDate(scenario.dateCreated)) + "\n                ")]), _vm._v(" "), _c('td', [(_vm.isRemove(index) && _vm.canDelete(_vm.permissionKey)) ? _c('button', {
      staticClass: "button is-light",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": !_vm.isActive
      },
      on: {
        "click": function($event) {
          return _vm.openModal(scenario, 'delete')
        }
      }
    }, [_vm._m(4, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.delete')))])]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-navigation"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to first page"
    },
    on: {
      "click": _vm.onClickFirstPage
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('paging.first')) + "\n              ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to previous page"
    },
    on: {
      "click": _vm.onClickPreviousPage
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('paging.previous')) + "\n              ")])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      staticClass: "pagination-item"
    }, [_c('button', {
      class: {
        activepage: _vm.isPageActive(page.name)
      },
      attrs: {
        "type": "button",
        "disabled": page.isDisabled,
        "aria-label": ("Go to page number " + (page.name))
      },
      on: {
        "click": function($event) {
          return _vm.onClickPage(page.name)
        }
      }
    }, [_vm._v("\n                " + _vm._s(page.name) + "\n              ")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to next page"
    },
    on: {
      "click": _vm.onClickNextPage
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('paging.next')) + "\n              ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to last page"
    },
    on: {
      "click": _vm.onClickLastPage
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('paging.last')) + "\n              ")])])], 2)])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
}]}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default.a);

var NotificationComponent = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var APPCONFIG_API = '/api/appConfig';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a
  },
  data: function data() {
    return {
      appConfig: {},
      appConfigArray: [{
        key: '',
        value: ''
      }],
      activeScenarioTemplatesArray: [{
        key: '',
        value: ''
      }],
      phonePreprocessingParametersArray: [{
        key: '',
        value: ''
      }]
    };
  },

  created: function created() {
    this.checkToken();
    this.loadConfig();
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'loggedId'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    loadConfig: function loadConfig() {
      var _this = this;

      this.$http.get(APPCONFIG_API + '/dto', { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.appConfig = response.data;
        _this.appConfigArray = Object.entries(_this.appConfig);
        _this.activeScenarioTemplatesArray = [];
        for (var i = 0; i < _this.appConfigArray.length; i++) {
          if (_this.appConfigArray[i][0] === 'activeScenarioTemplates') {
            _this.activeScenarioTemplatesArray = Object.entries(Object.entries(_this.appConfig)[i][1]);
          }
        }
        _this.phonePreprocessingParametersArray = Object.entries(_this.appConfig.defaultPhonePreprocessingStrategyParameters);
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ');
      });
    },
    save: function save(showMessage) {
      this.appConfig = {};
      for (var i = 0; i < this.appConfigArray.length; i++) {
        var item = this.appConfigArray[i];
        this.appConfig[item[0]] = item[1];
      }
      this.appConfig.activeScenarioTemplates = {};
      for (var _i = 0; _i < this.activeScenarioTemplatesArray.length; _i++) {
        var _item = this.activeScenarioTemplatesArray[_i];
        this.appConfig.activeScenarioTemplates[_item[0]] = _item[1];
      }
      this.appConfig.defaultPhonePreprocessingStrategyParameters = {};
      for (var _i2 = 0; _i2 < this.phonePreprocessingParametersArray.length; _i2++) {
        var _item2 = this.phonePreprocessingParametersArray[_i2];
        this.appConfig.defaultPhonePreprocessingStrategyParameters[_item2[0]] = _item2[1];
      }
      this.update(showMessage);
    },
    update: function update(showMessage) {
      var _this2 = this;

      console.log('updating app config: ' + JSON.stringify(this.appConfig));
      this.$http.put(APPCONFIG_API, this.appConfig, { headers: this.prepareSecurityHeader() }).then(function (response) {
        if (showMessage) {
          _this2.openNotificationWithType('info', 'Параметры приложения сохранены.');
        }
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка сохранения параметров приложения. ');
      });
    },
    canEdit: function canEdit() {
      return true;
    },
    cancel: function cancel() {
      this.$router.push('/campaigns');
    },
    deletePhonePreprocessingParameter: function deletePhonePreprocessingParameter(index) {
      this.phonePreprocessingParametersArray.splice(index, 1);
    },
    addPhonePreprocessingParameter: function addPhonePreprocessingParameter() {
      this.phonePreprocessingParametersArray.push({});
    },
    openNotificationWithType: function openNotificationWithType(type, message, duration) {
      openNotification({
        title: this.$i18n.messages[this.$i18n.locale].notifications.notification,
        message: message,
        type: type,
        duration: duration
      });
    }
  }
});

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.appConfigArray), function(param, index) {
    return _c('tr', [(param[0] != 'activeScenarioTemplates' && param[0] != 'defaultPhonePreprocessingStrategyParameters') ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[0]),
        expression: "param[0]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": (param[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 0, $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (param[0] != 'activeScenarioTemplates' && param[0] != 'defaultPhonePreprocessingStrategyParameters') ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": !_vm.canEdit()
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    })]) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.phonePreprocessingParametersArray), function(param, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[0]),
        expression: "param[0]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": !_vm.canEdit()
      },
      domProps: {
        "value": (param[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 0, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": !_vm.canEdit()
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-light",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.deletePhonePreprocessingParameter(index)
        }
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('span', [_vm._v("Удалить")])])])])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
    staticClass: "button is-light",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.addPhonePreprocessingParameter
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("Добавить")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.activeScenarioTemplatesArray), function(param, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[0]),
        expression: "param[0]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": (param[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 0, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": !_vm.canEdit()
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [(_vm.canEdit()) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(6), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("App Config")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Ключ")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Phone Preprocessing Parameters")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Active Scenario Templates")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Scenario Template")]), _vm._v(" "), _c('th', [_vm._v("Activity")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
}]}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cleave__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_tabs__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission___default.a);

var NotificationComponent = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var AUTH_API = '/api/auth';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  components: {
    Cleave: __WEBPACK_IMPORTED_MODULE_3_vue_cleave___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a,
    Tabs: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_tabs__["b" /* Tabs */],
    TabPane: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_tabs__["a" /* TabPane */]
  },
  data: function data() {
    return {
      permissionKey: 'permission',
      permissionMapByRole: {
        SuperAdministrator: [],
        Administrator: [],
        Partner: [],
        Referrer: [],
        Client: [],
        ClientAutomation: []
      }
    };
  },

  created: function created() {
    this.checkToken();
    this.handlePermissions();
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'loggedUser', 'loggedId'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      };
    },
    save: function save() {
      var _this = this;

      this.$http.post(AUTH_API + '/setPermissions', this.permissionMapByRole, { headers: this.prepareSecurityHeader() }).then(function (response) {}).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка сохранения пользовательских разрешений');
      });
    },
    handlePermissions: function handlePermissions() {
      console.log('loading permissions');
      this.loadPermissions('SuperAdministrator');
      this.loadPermissions('Administrator');
      this.loadPermissions('Partner');
      this.loadPermissions('Referrer');
      this.loadPermissions('Client');
      this.loadPermissions('ClientAutomation');
    },
    loadPermissions: function loadPermissions(role) {
      var _this2 = this;

      this.$http.get(AUTH_API + '/getPermissions/' + role, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.permissionMapByRole[role] = [];
        var arrPermissions = JSON.parse(JSON.stringify(Object.entries(response.data)));
        for (var i = 0, len = arrPermissions.length; i < len; i++) {
          var permission = [];
          permission.push(arrPermissions[i][0]);
          permission.push((arrPermissions[i][1] & 1) === 1);
          permission.push((arrPermissions[i][1] & 2) === 2);
          permission.push((arrPermissions[i][1] & 4) === 4);
          permission.push((arrPermissions[i][1] & 8) === 8);
          permission.push((arrPermissions[i][1] & 16) === 16);
          permission.push((arrPermissions[i][1] & 32) === 32);
          permission.push((arrPermissions[i][1] & 64) === 64);
          permission.push((arrPermissions[i][1] & 128) === 128);
          _this2.permissionMapByRole[role].push(permission);
        }
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка загрузки пользовательских разрешений. ');
      });
    },
    setDefaultPermissions: function setDefaultPermissions() {
      var _this3 = this;

      this.$http.post(AUTH_API + '/setDefaultPermissions', { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this3.handlePermissions();
        _this3.openNotificationWithType('warning', 'Установлены значения по умолчанию');
      }).catch(function (error) {
        console.log(error);
        _this3.openNotificationWithType('danger', 'Ошибка загрузки разрешений "По умолчанию". ');
      });
    },
    cancel: function cancel() {
      this.$router.push('/campaigns');
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: this.$i18n.messages[this.$i18n.locale].notifications.notification,
        message: message,
        type: type
      });
    }
  }
});

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('tabs', {
    attrs: {
      "type": "boxed"
    }
  }, [_c('tab-pane', {
    attrs: {
      "label": "SUPERADMIN"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Create")]), _vm._v(" "), _c('th', [_vm._v("Read")]), _vm._v(" "), _c('th', [_vm._v("Update")]), _vm._v(" "), _c('th', [_vm._v("Delete")]), _vm._v(" "), _c('th', [_vm._v("Campaign:Moderate / User:SelectUser")]), _vm._v(" "), _c('th', [_vm._v("Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState")]), _vm._v(" "), _c('th', [_vm._v("Campaign:AccessAdditionalParameters / User:UpdateUserPayment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.permissionMapByRole.SuperAdministrator), function(permission) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(permission[0]))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[1]),
        expression: "permission[1]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[1]"
      },
      domProps: {
        "checked": Array.isArray(permission[1]) ? _vm._i(permission[1], "permission[1]") > -1 : (permission[1])
      },
      on: {
        "change": function($event) {
          var $$a = permission[1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[1]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 1, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[2]),
        expression: "permission[2]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[2]"
      },
      domProps: {
        "checked": Array.isArray(permission[2]) ? _vm._i(permission[2], "permission[2]") > -1 : (permission[2])
      },
      on: {
        "change": function($event) {
          var $$a = permission[2],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[2]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 2, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 2, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 2, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[3]),
        expression: "permission[3]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[3]"
      },
      domProps: {
        "checked": Array.isArray(permission[3]) ? _vm._i(permission[3], "permission[3]") > -1 : (permission[3])
      },
      on: {
        "change": function($event) {
          var $$a = permission[3],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[3]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 3, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 3, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 3, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[4]),
        expression: "permission[4]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[4]"
      },
      domProps: {
        "checked": Array.isArray(permission[4]) ? _vm._i(permission[4], "permission[4]") > -1 : (permission[4])
      },
      on: {
        "change": function($event) {
          var $$a = permission[4],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[4]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 4, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 4, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 4, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[5]),
        expression: "permission[5]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[5]"
      },
      domProps: {
        "checked": Array.isArray(permission[5]) ? _vm._i(permission[5], "permission[5]") > -1 : (permission[5])
      },
      on: {
        "change": function($event) {
          var $$a = permission[5],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[5]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 5, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 5, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 5, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[6]),
        expression: "permission[6]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[6]"
      },
      domProps: {
        "checked": Array.isArray(permission[6]) ? _vm._i(permission[6], "permission[6]") > -1 : (permission[6])
      },
      on: {
        "change": function($event) {
          var $$a = permission[6],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[6]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 6, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 6, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 6, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[7]),
        expression: "permission[7]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[7]"
      },
      domProps: {
        "checked": Array.isArray(permission[7]) ? _vm._i(permission[7], "permission[7]") > -1 : (permission[7])
      },
      on: {
        "change": function($event) {
          var $$a = permission[7],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[7]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 7, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 7, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 7, $$c)
          }
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "ADMIN"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Create")]), _vm._v(" "), _c('th', [_vm._v("Read")]), _vm._v(" "), _c('th', [_vm._v("Update")]), _vm._v(" "), _c('th', [_vm._v("Delete")]), _vm._v(" "), _c('th', [_vm._v("Campaign:Moderate / User:SelectUser")]), _vm._v(" "), _c('th', [_vm._v("Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState")]), _vm._v(" "), _c('th', [_vm._v("Campaign:AccessAdditionalParameters / User:UpdateUserPayment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.permissionMapByRole.Administrator), function(permission) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(permission[0]))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[1]),
        expression: "permission[1]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[1]"
      },
      domProps: {
        "checked": Array.isArray(permission[1]) ? _vm._i(permission[1], "permission[1]") > -1 : (permission[1])
      },
      on: {
        "change": function($event) {
          var $$a = permission[1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[1]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 1, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[2]),
        expression: "permission[2]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[2]"
      },
      domProps: {
        "checked": Array.isArray(permission[2]) ? _vm._i(permission[2], "permission[2]") > -1 : (permission[2])
      },
      on: {
        "change": function($event) {
          var $$a = permission[2],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[2]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 2, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 2, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 2, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[3]),
        expression: "permission[3]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[3]"
      },
      domProps: {
        "checked": Array.isArray(permission[3]) ? _vm._i(permission[3], "permission[3]") > -1 : (permission[3])
      },
      on: {
        "change": function($event) {
          var $$a = permission[3],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[3]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 3, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 3, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 3, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[4]),
        expression: "permission[4]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[4]"
      },
      domProps: {
        "checked": Array.isArray(permission[4]) ? _vm._i(permission[4], "permission[4]") > -1 : (permission[4])
      },
      on: {
        "change": function($event) {
          var $$a = permission[4],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[4]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 4, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 4, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 4, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[5]),
        expression: "permission[5]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[5]"
      },
      domProps: {
        "checked": Array.isArray(permission[5]) ? _vm._i(permission[5], "permission[5]") > -1 : (permission[5])
      },
      on: {
        "change": function($event) {
          var $$a = permission[5],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[5]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 5, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 5, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 5, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[6]),
        expression: "permission[6]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[6]"
      },
      domProps: {
        "checked": Array.isArray(permission[6]) ? _vm._i(permission[6], "permission[6]") > -1 : (permission[6])
      },
      on: {
        "change": function($event) {
          var $$a = permission[6],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[6]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 6, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 6, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 6, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[7]),
        expression: "permission[7]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[7]"
      },
      domProps: {
        "checked": Array.isArray(permission[7]) ? _vm._i(permission[7], "permission[7]") > -1 : (permission[7])
      },
      on: {
        "change": function($event) {
          var $$a = permission[7],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[7]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 7, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 7, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 7, $$c)
          }
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "PARTNER"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Create")]), _vm._v(" "), _c('th', [_vm._v("Read")]), _vm._v(" "), _c('th', [_vm._v("Update")]), _vm._v(" "), _c('th', [_vm._v("Delete")]), _vm._v(" "), _c('th', [_vm._v("Campaign:Moderate / User:SelectUser")]), _vm._v(" "), _c('th', [_vm._v("Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState")]), _vm._v(" "), _c('th', [_vm._v("Campaign:AccessAdditionalParameters / User:UpdateUserPayment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.permissionMapByRole.Partner), function(permission) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(permission[0]))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[1]),
        expression: "permission[1]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[1]"
      },
      domProps: {
        "checked": Array.isArray(permission[1]) ? _vm._i(permission[1], "permission[1]") > -1 : (permission[1])
      },
      on: {
        "change": function($event) {
          var $$a = permission[1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[1]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 1, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[2]),
        expression: "permission[2]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[2]"
      },
      domProps: {
        "checked": Array.isArray(permission[2]) ? _vm._i(permission[2], "permission[2]") > -1 : (permission[2])
      },
      on: {
        "change": function($event) {
          var $$a = permission[2],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[2]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 2, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 2, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 2, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[3]),
        expression: "permission[3]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[3]"
      },
      domProps: {
        "checked": Array.isArray(permission[3]) ? _vm._i(permission[3], "permission[3]") > -1 : (permission[3])
      },
      on: {
        "change": function($event) {
          var $$a = permission[3],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[3]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 3, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 3, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 3, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[4]),
        expression: "permission[4]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[4]"
      },
      domProps: {
        "checked": Array.isArray(permission[4]) ? _vm._i(permission[4], "permission[4]") > -1 : (permission[4])
      },
      on: {
        "change": function($event) {
          var $$a = permission[4],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[4]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 4, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 4, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 4, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[5]),
        expression: "permission[5]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[5]"
      },
      domProps: {
        "checked": Array.isArray(permission[5]) ? _vm._i(permission[5], "permission[5]") > -1 : (permission[5])
      },
      on: {
        "change": function($event) {
          var $$a = permission[5],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[5]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 5, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 5, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 5, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[6]),
        expression: "permission[6]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[6]"
      },
      domProps: {
        "checked": Array.isArray(permission[6]) ? _vm._i(permission[6], "permission[6]") > -1 : (permission[6])
      },
      on: {
        "change": function($event) {
          var $$a = permission[6],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[6]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 6, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 6, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 6, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[7]),
        expression: "permission[7]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[7]"
      },
      domProps: {
        "checked": Array.isArray(permission[7]) ? _vm._i(permission[7], "permission[7]") > -1 : (permission[7])
      },
      on: {
        "change": function($event) {
          var $$a = permission[7],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[7]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 7, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 7, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 7, $$c)
          }
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "REFERRER"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Create")]), _vm._v(" "), _c('th', [_vm._v("Read")]), _vm._v(" "), _c('th', [_vm._v("Update")]), _vm._v(" "), _c('th', [_vm._v("Delete")]), _vm._v(" "), _c('th', [_vm._v("Campaign:Moderate / User:SelectUser")]), _vm._v(" "), _c('th', [_vm._v("Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState")]), _vm._v(" "), _c('th', [_vm._v("Campaign&Client:AccessAdditionalParameters / User:UpdateUserPayment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.permissionMapByRole.Referrer), function(permission) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(permission[0]))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[1]),
        expression: "permission[1]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[1]"
      },
      domProps: {
        "checked": Array.isArray(permission[1]) ? _vm._i(permission[1], "permission[1]") > -1 : (permission[1])
      },
      on: {
        "change": function($event) {
          var $$a = permission[1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[1]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 1, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[2]),
        expression: "permission[2]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[2]"
      },
      domProps: {
        "checked": Array.isArray(permission[2]) ? _vm._i(permission[2], "permission[2]") > -1 : (permission[2])
      },
      on: {
        "change": function($event) {
          var $$a = permission[2],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[2]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 2, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 2, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 2, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[3]),
        expression: "permission[3]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[3]"
      },
      domProps: {
        "checked": Array.isArray(permission[3]) ? _vm._i(permission[3], "permission[3]") > -1 : (permission[3])
      },
      on: {
        "change": function($event) {
          var $$a = permission[3],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[3]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 3, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 3, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 3, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[4]),
        expression: "permission[4]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[4]"
      },
      domProps: {
        "checked": Array.isArray(permission[4]) ? _vm._i(permission[4], "permission[4]") > -1 : (permission[4])
      },
      on: {
        "change": function($event) {
          var $$a = permission[4],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[4]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 4, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 4, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 4, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[5]),
        expression: "permission[5]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[5]"
      },
      domProps: {
        "checked": Array.isArray(permission[5]) ? _vm._i(permission[5], "permission[5]") > -1 : (permission[5])
      },
      on: {
        "change": function($event) {
          var $$a = permission[5],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[5]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 5, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 5, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 5, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[6]),
        expression: "permission[6]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[6]"
      },
      domProps: {
        "checked": Array.isArray(permission[6]) ? _vm._i(permission[6], "permission[6]") > -1 : (permission[6])
      },
      on: {
        "change": function($event) {
          var $$a = permission[6],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[6]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 6, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 6, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 6, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[7]),
        expression: "permission[7]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[7]"
      },
      domProps: {
        "checked": Array.isArray(permission[7]) ? _vm._i(permission[7], "permission[7]") > -1 : (permission[7])
      },
      on: {
        "change": function($event) {
          var $$a = permission[7],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[7]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 7, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 7, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 7, $$c)
          }
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "CLIENT"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Create")]), _vm._v(" "), _c('th', [_vm._v("Read")]), _vm._v(" "), _c('th', [_vm._v("Update")]), _vm._v(" "), _c('th', [_vm._v("Delete")]), _vm._v(" "), _c('th', [_vm._v("Campaign:Moderate / User:SelectUser")]), _vm._v(" "), _c('th', [_vm._v("Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState")]), _vm._v(" "), _c('th', [_vm._v("Campaign:AccessAdditionalParameters / User:UpdateUserPayment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.permissionMapByRole.Client), function(permission) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(permission[0]))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[1]),
        expression: "permission[1]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[1]"
      },
      domProps: {
        "checked": Array.isArray(permission[1]) ? _vm._i(permission[1], "permission[1]") > -1 : (permission[1])
      },
      on: {
        "change": function($event) {
          var $$a = permission[1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[1]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 1, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[2]),
        expression: "permission[2]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[2]"
      },
      domProps: {
        "checked": Array.isArray(permission[2]) ? _vm._i(permission[2], "permission[2]") > -1 : (permission[2])
      },
      on: {
        "change": function($event) {
          var $$a = permission[2],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[2]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 2, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 2, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 2, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[3]),
        expression: "permission[3]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[3]"
      },
      domProps: {
        "checked": Array.isArray(permission[3]) ? _vm._i(permission[3], "permission[3]") > -1 : (permission[3])
      },
      on: {
        "change": function($event) {
          var $$a = permission[3],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[3]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 3, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 3, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 3, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[4]),
        expression: "permission[4]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[4]"
      },
      domProps: {
        "checked": Array.isArray(permission[4]) ? _vm._i(permission[4], "permission[4]") > -1 : (permission[4])
      },
      on: {
        "change": function($event) {
          var $$a = permission[4],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[4]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 4, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 4, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 4, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[5]),
        expression: "permission[5]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[5]"
      },
      domProps: {
        "checked": Array.isArray(permission[5]) ? _vm._i(permission[5], "permission[5]") > -1 : (permission[5])
      },
      on: {
        "change": function($event) {
          var $$a = permission[5],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[5]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 5, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 5, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 5, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[6]),
        expression: "permission[6]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[6]"
      },
      domProps: {
        "checked": Array.isArray(permission[6]) ? _vm._i(permission[6], "permission[6]") > -1 : (permission[6])
      },
      on: {
        "change": function($event) {
          var $$a = permission[6],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[6]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 6, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 6, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 6, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[7]),
        expression: "permission[7]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[7]"
      },
      domProps: {
        "checked": Array.isArray(permission[7]) ? _vm._i(permission[7], "permission[7]") > -1 : (permission[7])
      },
      on: {
        "change": function($event) {
          var $$a = permission[7],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[7]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 7, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 7, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 7, $$c)
          }
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "CLIENT_AUTOMATION"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Create")]), _vm._v(" "), _c('th', [_vm._v("Read")]), _vm._v(" "), _c('th', [_vm._v("Update")]), _vm._v(" "), _c('th', [_vm._v("Delete")]), _vm._v(" "), _c('th', [_vm._v("Campaign:Moderate / User:SelectUser")]), _vm._v(" "), _c('th', [_vm._v("Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState")]), _vm._v(" "), _c('th', [_vm._v("Campaign:AccessAdditionalParameters / User:UpdateUserPayment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.permissionMapByRole.ClientAutomation), function(permission) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(permission[0]))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[1]),
        expression: "permission[1]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[1]"
      },
      domProps: {
        "checked": Array.isArray(permission[1]) ? _vm._i(permission[1], "permission[1]") > -1 : (permission[1])
      },
      on: {
        "change": function($event) {
          var $$a = permission[1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[1]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 1, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[2]),
        expression: "permission[2]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[2]"
      },
      domProps: {
        "checked": Array.isArray(permission[2]) ? _vm._i(permission[2], "permission[2]") > -1 : (permission[2])
      },
      on: {
        "change": function($event) {
          var $$a = permission[2],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[2]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 2, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 2, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 2, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[3]),
        expression: "permission[3]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[3]"
      },
      domProps: {
        "checked": Array.isArray(permission[3]) ? _vm._i(permission[3], "permission[3]") > -1 : (permission[3])
      },
      on: {
        "change": function($event) {
          var $$a = permission[3],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[3]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 3, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 3, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 3, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[4]),
        expression: "permission[4]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[4]"
      },
      domProps: {
        "checked": Array.isArray(permission[4]) ? _vm._i(permission[4], "permission[4]") > -1 : (permission[4])
      },
      on: {
        "change": function($event) {
          var $$a = permission[4],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[4]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 4, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 4, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 4, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[5]),
        expression: "permission[5]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[5]"
      },
      domProps: {
        "checked": Array.isArray(permission[5]) ? _vm._i(permission[5], "permission[5]") > -1 : (permission[5])
      },
      on: {
        "change": function($event) {
          var $$a = permission[5],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[5]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 5, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 5, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 5, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[6]),
        expression: "permission[6]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[6]"
      },
      domProps: {
        "checked": Array.isArray(permission[6]) ? _vm._i(permission[6], "permission[6]") > -1 : (permission[6])
      },
      on: {
        "change": function($event) {
          var $$a = permission[6],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[6]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 6, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 6, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 6, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[7]),
        expression: "permission[7]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[7]"
      },
      domProps: {
        "checked": Array.isArray(permission[7]) ? _vm._i(permission[7], "permission[7]") > -1 : (permission[7])
      },
      on: {
        "change": function($event) {
          var $$a = permission[7],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[7]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 7, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 7, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 7, $$c)
          }
        }
      }
    })])])
  }), 0)])])])], 1), _vm._v(" "), (_vm.canUpdate(_vm.permissionKey)) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), (_vm.canUpdate(_vm.permissionKey)) ? _c('button', {
    staticClass: "button is-warning",
    on: {
      "click": _vm.setDefaultPermissions
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Установить значения по умолчанию")])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-industry"
  })])
}]}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VisCommon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VisCommon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_VisCommon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clientes_Balance__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clientes_Balance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__clientes_Balance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_tabs__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_loaders_LoaderRollers1__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_loaders_LoaderRollers1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_loaders_LoaderRollers1__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var USERS_API = '/api/userProfileClient';
var BILLING_API = '/billing/resources';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserNew',
  props: ['id'],
  extends: __WEBPACK_IMPORTED_MODULE_0__components_VisCommon___default.a,
  components: {
    LoaderRollers1: __WEBPACK_IMPORTED_MODULE_4__components_loaders_LoaderRollers1___default.a,
    Balance: __WEBPACK_IMPORTED_MODULE_1__clientes_Balance___default.a,
    Tabs: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_tabs__["b" /* Tabs */],
    TabPane: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_tabs__["a" /* TabPane */]
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['authenticationToken', 'loggedUser', 'loggedRole', 'loggedId'])),
  data: function data() {
    return {
      permissionKey: 'user',
      userProfileClient: {
        user: {
          roleId: 16
        },
        client: {
          clientConfig: {
            defaultPostponingConfig: {
              parameters: {}
            }
          },
          billingEnable: '',
          tariff: '',
          costCenterId: ''
        },
        profile: {}
      },
      clientConfigArray: [{
        key: '',
        value: ''
      }],
      tariffs: [{ name: '', id: '' }],
      costCenters: [],
      availableSmsGatewaysStr: '',
      saving: false
    };
  },
  created: function created() {
    this.loadCostCenters();
    if (this.$props.id && this.$props.id !== 'new') {
      this.load();
      this.loadTariffs();
    }
  },

  methods: {
    load: function load() {
      var _this = this;

      var that = this;
      this.$http({
        url: USERS_API + '/getUserProfileClient/' + this.$props.id,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        that.userProfileClient = response.data;
        if (that.userProfileClient.user) {
          that.userProfileClient.user.password = '';
        }
        if (that.userProfileClient.client && that.userProfileClient.client.clientConfig && that.userProfileClient.client.clientConfig.availableSmsGateways) {
          that.availableSmsGatewaysStr = that.userProfileClient.client.clientConfig.availableSmsGateways.join();
        }
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка загрузки пользователя. ');
      });
    },
    isSimpleParam: function isSimpleParam(param) {
      // return true
      return param.length === 2 && (typeof param[1] === 'string' || param[1] instanceof String || !param[1]);
    },
    loadTariffs: function loadTariffs() {
      var that = this;
      var url = BILLING_API + '/tariffs';
      this.$http.get(url, { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.tariffs = that.tariffs.concat(response.data);
      }).catch(function (error) {
        console.log(error);
        that.openNotificationWithType('danger', 'Ошибка загрузки списка тарифов. ');
      });
    },
    loadCostCenters: function loadCostCenters() {
      var that = this;
      var url = USERS_API + '/getCostCenters';
      this.$http.get(url, { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.costCenters = that.costCenters.concat(response.data.response);
      }).catch(function (error) {
        console.log(error);
        that.openNotificationWithType('danger', 'Ошибка загрузки списка центров затрат. ');
      });
    },
    generateTariffLabel: function generateTariffLabel(tariff) {
      var label = void 0;
      if (tariff.name) {
        label = tariff.name + ' ';
      }
      if (tariff.resources) {
        var resources = '';
        for (var key in tariff.resources) {
          if (tariff.resources[key].unitCost || tariff.resources[key].unitCost === 0) {
            if (resources) {
              resources += ';   ';
            }
            resources = resources + key + ':' + tariff.resources[key].unitCost;
          }
        }
        label = label + '  (' + resources + ')';
      }
      return label;
    },
    saveLoginPassword: function saveLoginPassword() {
      this.save('/saveLoginPassword/' + this.userProfileClient.profile.id, {
        username: this.userProfileClient.user.username,
        password: this.userProfileClient.user.password
      });
    },
    saveProfile: function saveProfile() {
      this.save('/saveProfile/' + this.userProfileClient.profile.id, {
        name: this.userProfileClient.client.name,
        roleId: this.userProfileClient.user.roleId,
        costCenterId: this.userProfileClient.client.costCenterId
      });
    },
    saveClientConfig: function saveClientConfig() {
      var split = (this.availableSmsGatewaysStr || '').split(',');
      for (var i = 0; i < split.length; i++) {
        split[i] = split[i].trim();
      }
      this.userProfileClient.client.clientConfig.availableSmsGateways = split;
      this.save('/saveClientConfig/' + this.userProfileClient.profile.id, {
        billingEnable: this.userProfileClient.client.billingEnable || '',
        tariff: this.userProfileClient.client.tariff || ''
      }, this.userProfileClient.client.clientConfig);
    },
    saveNew: function saveNew() {
      this.save('/saveNew/', {
        name: this.userProfileClient.client.name,
        roleId: this.userProfileClient.user.roleId,
        username: this.userProfileClient.user.username,
        password: this.userProfileClient.user.password,
        costCenterId: this.userProfileClient.client.costCenterId
      }, null, true);
    },
    save: function save(suburl, params, data, reload, cb) {
      var _this2 = this;

      var that = this;
      this.saving = true;
      var paramsUrl = '?a=1';
      if (params) {
        for (var key in params) {
          paramsUrl += '&' + key + '=' + params[key];
        }
      }
      this.$http.post(USERS_API + suburl + paramsUrl, data, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.saving = false;
        that.openNotificationWithType('info', 'Данные сохранены.');
        if (!that.$props.id || that.$props.id === 'new') {
          that.$props.id = response.data;
          // document.location.replace(document.location.replace('new', that.$props.id))
        }
        if (reload) {
          that.load();
        }
      }).catch(function (error) {
        _this2.saving = false;
        console.log(error);
        that.openNotificationWithType('danger', error.response.data);
      });
    }
  }
});

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [(_vm.userProfileClient.profile.id) ? _c('article', {
    staticClass: "tile is-child box"
  }, [_c('tabs', {
    attrs: {
      "type": "boxed"
    }
  }, [_c('tab-pane', {
    attrs: {
      "label": "Логин и пароль"
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Логин")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.user.username),
      expression: "userProfileClient.user.username"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "Введите логин",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userProfileClient.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userProfileClient.user, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Пароль")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.user.password),
      expression: "userProfileClient.user.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Введите пароль",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userProfileClient.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userProfileClient.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": function($event) {
        return _vm.saveLoginPassword()
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _vm._v(" "), _c('span', [_vm._v("Сохранить")])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "Профиль пользователя"
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Отображаемое имя")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.client.name),
      expression: "userProfileClient.client.name"
    }],
    staticClass: "input displayName",
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userProfileClient.client.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userProfileClient.client, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Тип")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.user.roleId),
      expression: "userProfileClient.user.roleId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.userProfileClient.user, "roleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.loggedRole <= 1) ? _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("СуперАдминистратор")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 2) ? _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Администратор")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 4) ? _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Партнер")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 8) ? _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Реферер")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 16) ? _c('option', {
    attrs: {
      "value": "16"
    }
  }, [_vm._v("Клиент")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 32) ? _c('option', {
    attrs: {
      "value": "32"
    }
  }, [_vm._v("Клиент Автоматизации")]) : _vm._e()])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Центр затрат")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.client.costCenterId),
      expression: "userProfileClient.client.costCenterId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.userProfileClient.client, "costCenterId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.costCenters), function(costCenter) {
    return _c('option', {
      domProps: {
        "value": costCenter.id
      }
    }, [_vm._v("\n                  " + _vm._s(costCenter.name) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.saveProfile
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _vm._v(" "), _c('span', [_vm._v("Сохранить")])])]), _vm._v(" "), (_vm.userProfileClient && _vm.userProfileClient.client && _vm.userProfileClient.client.clientConfig) ? _c('tab-pane', {
    attrs: {
      "label": "Client Config"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Ключ")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])]), _vm._v(" "), _c('tbody', [_vm._l((Object.entries(_vm.userProfileClient.client.clientConfig)), function(param, index) {
    return _c('tr', [(_vm.isSimpleParam(param) && param[0] !== 'availableSmsGateways') ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[0]),
        expression: "param[0]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": (param[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 0, $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.isSimpleParam(param) && param[0] !== 'availableSmsGateways') ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "placeholder": "Параметр не указан",
        "type": "text"
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    })]) : _vm._e()])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": "",
      "value": "Доступные смс шлюзы"
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.availableSmsGatewaysStr),
      expression: "availableSmsGatewaysStr"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "Параметр не указан",
      "type": "text"
    },
    domProps: {
      "value": (_vm.availableSmsGatewaysStr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.availableSmsGatewaysStr = $event.target.value
      }
    }
  })])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Перезвон по-умолчанию")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('input', {
    staticClass: "input",
    attrs: {
      "value": "Стратегия",
      "type": "text",
      "readonly": ""
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.client.clientConfig.defaultPostponingConfig.strategy),
      expression: "userProfileClient.client.clientConfig.defaultPostponingConfig.strategy"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "Параметр не указан",
      "type": "text"
    },
    domProps: {
      "value": (_vm.userProfileClient.client.clientConfig.defaultPostponingConfig.strategy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userProfileClient.client.clientConfig.defaultPostponingConfig, "strategy", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    staticClass: "input",
    attrs: {
      "value": "Количество попыток",
      "type": "text",
      "readonly": ""
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.client.clientConfig.defaultPostponingConfig.parameters.attempts),
      expression: "userProfileClient.client.clientConfig.defaultPostponingConfig.parameters.attempts"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "Параметр не указан",
      "type": "text"
    },
    domProps: {
      "value": (_vm.userProfileClient.client.clientConfig.defaultPostponingConfig.parameters.attempts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userProfileClient.client.clientConfig.defaultPostponingConfig.parameters, "attempts", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    staticClass: "input",
    attrs: {
      "value": "Время ожидания",
      "type": "text",
      "readonly": ""
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.client.clientConfig.defaultPostponingConfig.parameters.waitMinutes),
      expression: "userProfileClient.client.clientConfig.defaultPostponingConfig.parameters.waitMinutes"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "Параметр не указан",
      "type": "text"
    },
    domProps: {
      "value": (_vm.userProfileClient.client.clientConfig.defaultPostponingConfig.parameters.waitMinutes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userProfileClient.client.clientConfig.defaultPostponingConfig.parameters, "waitMinutes", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tariff billing"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Биллинг")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('input', {
    staticClass: "input",
    attrs: {
      "value": "Тариф",
      "type": "text",
      "readonly": ""
    }
  })]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "control tariff"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.client.tariff),
      expression: "userProfileClient.client.tariff"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.userProfileClient.client, "tariff", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.tariffs), function(tariff) {
    return _c('option', {
      domProps: {
        "value": tariff.id
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.generateTariffLabel(tariff)) + "\n                        ")])
  }), 0)])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    staticClass: "input",
    attrs: {
      "value": "Биллинг",
      "type": "text",
      "readonly": ""
    }
  })]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "control billing"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.client.billingEnable),
      expression: "userProfileClient.client.billingEnable"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.userProfileClient.client, "billingEnable", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("По умолчанию")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Включён")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("Выключён")])])])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": function($event) {
        return _vm.saveClientConfig()
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _vm._v(" "), _c('span', [_vm._v("Сохранить")])])])]) : _vm._e(), _vm._v(" "), (!!_vm.userProfileClient && _vm.userProfileClient.client && _vm.userProfileClient.client.id && _vm.canAccessAdditionalParameters(_vm.permissionKey)) ? _c('tab-pane', {
    attrs: {
      "label": "Лицевой счёт"
    }
  }, [_c('Balance', {
    attrs: {
      "client-id": _vm.userProfileClient.client.id,
      "reload-client": _vm.load,
      "client-balance": _vm.userProfileClient.clientBalance
    }
  })], 1) : _vm._e()], 1)], 1) : (_vm.id === 'new') ? _c('article', {
    staticClass: "tile is-child box createNew"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Логин")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.user.username),
      expression: "userProfileClient.user.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите логин",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userProfileClient.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userProfileClient.user, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Пароль")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.user.password),
      expression: "userProfileClient.user.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Введите пароль",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userProfileClient.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userProfileClient.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Тип")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.user.roleId),
      expression: "userProfileClient.user.roleId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.userProfileClient.user, "roleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.loggedRole <= 1) ? _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("СуперАдминистратор")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 2) ? _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Администратор")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 4) ? _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Партнер")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 8) ? _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Реферер")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 16) ? _c('option', {
    attrs: {
      "value": "16"
    }
  }, [_vm._v("Клиент")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 32) ? _c('option', {
    attrs: {
      "value": "32"
    }
  }, [_vm._v("Клиент Автоматизации")]) : _vm._e()])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Центр затрат")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfileClient.client.costCenterId),
      expression: "userProfileClient.client.costCenterId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.userProfileClient.client, "costCenterId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.costCenters), function(costCenter) {
    return _c('option', {
      domProps: {
        "value": costCenter.id
      }
    }, [_vm._v("\n              " + _vm._s(costCenter.name) + "\n            ")])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Создать")])])]) : _c('article', [_c('loader-rollers1')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
}]}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VisCommon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VisCommon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_VisCommon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Paging__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Paging___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Paging__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var USERS_API = '/api/userProfileClient';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Users',
  extends: __WEBPACK_IMPORTED_MODULE_0__components_VisCommon___default.a,
  components: {
    Paging: __WEBPACK_IMPORTED_MODULE_1__components_Paging___default.a
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['loggedUser', 'loggedId', 'loggedRole', 'clientId', 'authenticationToken'])),
  data: function data() {
    return {
      usersPage: { content: [] },
      perPage: 16,
      searchName: '',
      showModal: null,

      permissionKey: 'user'
    };
  },
  created: function created() {
    this.loadData();
  },

  methods: {
    loadData: function loadData(page) {
      var that = this;
      page = page ? page - 1 : 0;
      var url = USERS_API + '/filter' + '?page=' + page + '&pageSize=' + this.perPage;
      this.$http.get(url, { headers: this.prepareSecurityHeader() }).then(function (response) {
        that.usersPage = response.data;
      }).catch(function (error) {
        console.log(error);
        that.openNotificationWithType('danger', 'Ошибка загрузки списка пользователей. ');
      });
    },
    getBillingLabel: function getBillingLabel(billingEnable) {
      if (billingEnable === false) {
        return 'выключен';
      } else if (billingEnable === true) {
        return 'включён';
      } else {
        return '';
      }
    }
  }
});

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [(_vm.canCreate(_vm.permissionKey)) ? _c('a', {
    staticClass: "button is-success",
    attrs: {
      "href": "#/users/new"
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Создать пользователя")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "paging-top"
  }, [_c('Paging', {
    attrs: {
      "refresh": _vm.loadData,
      "per-page": _vm.perPage,
      "data": _vm.usersPage,
      "pagingClass": 'top'
    },
    on: {
      "update:data": function($event) {
        _vm.usersPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow usersTable"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.usersPage.content), function(user, index) {
    return _c('tr', [_c('td', {
      staticClass: "userNameCell"
    }, [(user.userId && (user.role !== 'СуперАдминистратор' || _vm.loggedRole === '1' || _vm.loggedRole === 1)) ? _c('a', {
      attrs: {
        "href": '#/users/' + user.id
      }
    }, [_vm._v(_vm._s(user.name))]) : _c('span', [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('td', {}, [_c('span', [_vm._v(_vm._s(user.role))])]), _vm._v(" "), _c('td', {}, [_c('span', [_vm._v(_vm._s(user.defaultGateway))])]), _vm._v(" "), _c('td', {
      staticClass: "billingEnable"
    }, [_c('span', {
      class: !!user.billingEnable ? 'enable' : ''
    }, [_vm._v(_vm._s(_vm.getBillingLabel(user.billingEnable)))])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "paging-bottom"
  }, [_c('Paging', {
    attrs: {
      "refresh": _vm.loadData,
      "per-page": _vm.perPage,
      "data": _vm.usersPage,
      "pagingClass": 'bottom'
    },
    on: {
      "update:data": function($event) {
        _vm.usersPage = $event
      }
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Имя")]), _vm._v(" "), _c('th', [_vm._v("Роль")]), _vm._v(" "), _c('th', [_vm._v("Шлюз по-умолчанию")]), _vm._v(" "), _c('th', [_vm._v("Биллинг")])])])
}]}

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_package__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_package___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_package__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_app__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_menu__ = __webpack_require__(160);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["default"]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["default"].Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_5__modules_app__["a" /* default */],
    menu: __WEBPACK_IMPORTED_MODULE_6__modules_menu__["a" /* default */]
  },
  mutations: {
    setLoadedScenario: function setLoadedScenario(state, payload) {
      state.loadedScenario = payload;
    },
    SET_AUTHENTICATION_TOKEN: function SET_AUTHENTICATION_TOKEN(state, token) {
      state.authenticationToken = token;
    },
    SET_LOGGED_ROLE: function SET_LOGGED_ROLE(state, role) {
      state.loggedRole = role;
    },
    SET_LOGGED_USER: function SET_LOGGED_USER(state, user) {
      state.loggedUser = user;
    },
    SET_LOGGED_USER_STATE: function SET_LOGGED_USER_STATE(state, userstate) {
      state.loggedUserState = userstate;
    },
    SET_LOGGED_STATUS: function SET_LOGGED_STATUS(state, status) {
      state.isLogged = status;
    },
    SET_LOGGED_ID: function SET_LOGGED_ID(state, id) {
      state.loggedId = id;
    },
    SET_PERMISSION_MAP: function SET_PERMISSION_MAP(state, map) {
      state.permissionMap = map;
    },
    SET_CLIENT_ID: function SET_CLIENT_ID(state, clientid) {
      state.clientId = clientid;
    }
  },
  state: {
    isLogged: localStorage.getItem('authenticationToken') !== null,
    authenticationToken: localStorage.getItem('authenticationToken'),
    loggedUser: localStorage.getItem('authenticationToken') !== null ? localStorage.getItem('loggedUser') : '',
    loggedUserState: localStorage.getItem('authenticationToken') !== null ? localStorage.getItem('loggedUserState') : '',
    loggedRole: localStorage.getItem('authenticationToken') !== null ? localStorage.getItem('loggedRole') : 16,
    loggedId: localStorage.getItem('authenticationToken') !== null ? localStorage.getItem('loggedId') : null,
    loadedScenario: {},
    permissionMap: localStorage.getItem('authenticationToken') !== null ? localStorage.getItem('permissionMap') : null,
    clientId: localStorage.getItem('authenticationToken') !== null ? localStorage.getItem('clientId') : null,
    pkg: __WEBPACK_IMPORTED_MODULE_2_package___default.a
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports = {"name":"vue-admin","version":"0.1.12","description":"Vue Admin Panel Framework","repository":"vue-bulma/vue-admin","homepage":"https://admin.vuebulma.com","license":"MIT","author":{"name":"Fangdun Cai","email":"cfddream@gmail.com","url":"fundon.me"},"keywords":["admin","bulma","dashboard","data","visualization","vue"],"engines":{"node":">=4","npm":">=3"},"scripts":{"build":"cross-env NODE_ENV=production node build/build.js","clean":"rm -rf dist","dev":"cross-env NODE_ENV=development node build/dev-server.js","electron":"cross-env NODE_ELECTRON=true npm run build && electron electronIndex.js","gh":"npm run build && gh-pages -d dist","lint":"eslint --ext .js .vue client/*","lint:fix":"eslint --fix --ext .js .vue electron.js client/* build/* config/*","test":"echo lol"},"dependencies":{"@fortawesome/fontawesome-free":"^5.9.0","@websanova/vue-auth":"^2.8.2-beta","animate.css":"3.5.2","animejs":"^2.0.1","axios":"^0.15.3","buefy":"^0.9.11","bulma":"^0.3.2","font-awesome":"4.7.0","jsplumb":"^2.11.1","mdi":"^1.8.36","plotly.js":"^1.24.2","sip.js":"^0.16.1","vue":"^2.6.10","vue-audio":"0.0.12","vue-axios":"^2.0.1","vue-bulma-brace":"^0.1.0","vue-bulma-breadcrumb":"^1.0.1","vue-bulma-card":"^1.0.2","vue-bulma-chartist":"^1.1.0","vue-bulma-chartjs":"^1.0.4","vue-bulma-collapse":"1.0.3","vue-bulma-datepicker":"^1.3.0","vue-bulma-emoji":"^0.0.2","vue-bulma-expanding":"^0.0.1","vue-bulma-jump":"^0.0.2","vue-bulma-message":"^1.1.1","vue-bulma-modal":"1.0.1","vue-bulma-notification":"^1.1.1","vue-bulma-progress-bar":"^1.0.2","vue-bulma-progress-tracker":"0.0.4","vue-bulma-quill":"0.0.1","vue-bulma-rating":"^1.0.1","vue-bulma-slider":"^1.0.2","vue-bulma-switch":"^2.0.0-alpha.6","vue-bulma-tabs":"^1.1.3","vue-bulma-tooltip":"^1.0.3","vue-cleave":"1.1.1","vue-codemirror":"^4.0.6","vue-howler":"^0.7.0","vue-i18n":"^8.17.6","vue-js-toggle-button":"^1.2.3","vue-lory":"0.0.4","vue-nprogress":"0.1.5","vue-peity":"0.5.0","vue-router":"^2.3.0","vue-slider-component":"^3.1.0","vue-suggestion":"^1.1.0","vue-tags":"^1.0.4","vuex":"^2.2.1","vuex-router-sync":"^4.1.2","wysiwyg.css":"0.0.2"},"devDependencies":{"autoprefixer":"^6.7.7","babel-core":"^6.21.0","babel-eslint":"^7.1.1","babel-loader":"^6.4.0","babel-plugin-transform-export-extensions":"^6.8.0","babel-preset-es2015":"^6.14.0","babel-preset-stage-2":"^6.17.0","connect-history-api-fallback":"^1.3.0","cross-env":"^3.1.3","css-loader":"^3.0.0","electron-devtools-installer":"^2.0.1","eslint":"^3.17.1","eslint-config-standard":"^7.0.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.6.1","eslint-plugin-html":"^2.0.1","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^2.1.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^3.0.2","file-loader":"^4.0.0","html-webpack-plugin":"^2.25.0","http-proxy-middleware":"^0.17.4","imports-loader":"^0.7.0","node-sass":"^4.1.1","opn":"^4.0.2","ora":"^1.1.0","postcss-loader":"^1.3.3","progress-bar-webpack-plugin":"^1.9.1","sass-loader":"^6.0.3","serve-favicon":"^2.4.1","style-loader":"^0.13.1","stylus":"^0.54.5","stylus-loader":"^3.0.1","url-loader":"^0.5.7","vue-html-loader":"^1.2.3","vue-loader":"^11.1.4","vue-template-compiler":"^2.6.10","webpack":"^3.12.0","webpack-dev-middleware":"^1.9.0","webpack-hot-middleware":"^2.14.0","webpack-merge":"^4.0.0"}}

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleSidebar", function() { return toggleSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleDevice", function() { return toggleDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expandMenu", function() { return expandMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "switchEffect", function() { return switchEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAuthenticationToken", function() { return setAuthenticationToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeToken", function() { return removeToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLoggedRole", function() { return setLoggedRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLoggedUser", function() { return setLoggedUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeLoggedUser", function() { return removeLoggedUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLoggedUserState", function() { return setLoggedUserState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeLoggedUserState", function() { return removeLoggedUserState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLoggedStatus", function() { return setLoggedStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeLoggedStatus", function() { return removeLoggedStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLoggedId", function() { return setLoggedId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeLoggedId", function() { return removeLoggedId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPermissionMap", function() { return setPermissionMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removePermissionMap", function() { return removePermissionMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setClientId", function() { return setClientId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeClientId", function() { return removeClientId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(62);


// Roles (binary)
//  000001 - SuperAdmin  (1)
//  000010 - Admin  (2)
//  000100 - Partner (4)
//  001000 - Referrer (8)
//  010000 - Client (16)
//  100000 - Anonymous (32)

var ROLE_MAPPER = {
  'SuperAdministrator': 1,
  'Administrator': 2,
  'Partner': 4,
  'Referrer': 8,
  'Client': 16,
  'ClientAutomation': 32,
  'Anonymous': 64
};

var toggleSidebar = function toggleSidebar(_ref, config) {
  var commit = _ref.commit;

  if (config instanceof Object) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* TOGGLE_SIDEBAR */], config);
  }
};

var toggleDevice = function toggleDevice(_ref2, device) {
  var commit = _ref2.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* TOGGLE_DEVICE */], device);
};

var expandMenu = function expandMenu(_ref3, menuItem) {
  var commit = _ref3.commit;

  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false;
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* EXPAND_MENU */], menuItem);
  }
};

var switchEffect = function switchEffect(_ref4, effectItem) {
  var commit = _ref4.commit;

  if (effectItem) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SWITCH_EFFECT */], effectItem);
  }
};

var setAuthenticationToken = function setAuthenticationToken(_ref5, token) {
  var commit = _ref5.commit;

  localStorage.setItem('authenticationToken', token);
  commit('SET_AUTHENTICATION_TOKEN', token);
};

var removeToken = function removeToken(_ref6) {
  var commit = _ref6.commit;

  localStorage.removeItem('authenticationToken');
  commit('SET_AUTHENTICATION_TOKEN');
};

var setLoggedRole = function setLoggedRole(_ref7, role) {
  var commit = _ref7.commit;

  localStorage.setItem('loggedRole', ROLE_MAPPER[role]);
  commit('SET_LOGGED_ROLE', ROLE_MAPPER[role]);
};

var setLoggedUser = function setLoggedUser(_ref8, user) {
  var commit = _ref8.commit;

  localStorage.setItem('loggedUser', user);
  commit('SET_LOGGED_USER', user);
};

var removeLoggedUser = function removeLoggedUser(_ref9) {
  var commit = _ref9.commit;

  localStorage.removeItem('loggedUser');
  commit('SET_LOGGED_USER');
};

var setLoggedUserState = function setLoggedUserState(_ref10, userstate) {
  var commit = _ref10.commit;

  localStorage.setItem('loggedUserState', userstate);
  commit('SET_LOGGED_USER_STATE', userstate);
};

var removeLoggedUserState = function removeLoggedUserState(_ref11) {
  var commit = _ref11.commit;

  localStorage.removeItem('loggedUserState');
  commit('SET_LOGGED_USER_STATE');
};

var setLoggedStatus = function setLoggedStatus(_ref12, status) {
  var commit = _ref12.commit;

  localStorage.setItem('loggedStatus', status);
  commit('SET_LOGGED_STATUS', status);
};

var removeLoggedStatus = function removeLoggedStatus(_ref13) {
  var commit = _ref13.commit;

  localStorage.removeItem('loggedStatus');
  commit('SET_LOGGED_STATUS');
};

var setLoggedId = function setLoggedId(_ref14, id) {
  var commit = _ref14.commit;

  localStorage.setItem('loggedId', id);
  commit('SET_LOGGED_ID', id);
};

var removeLoggedId = function removeLoggedId(_ref15) {
  var commit = _ref15.commit;

  localStorage.removeItem('loggedId');
  commit('SET_LOGGED_ID');
};

var setPermissionMap = function setPermissionMap(_ref16, map) {
  var commit = _ref16.commit;

  localStorage.setItem('permissionMap', map);
  commit('SET_PERMISSION_MAP', map);
};
var removePermissionMap = function removePermissionMap(_ref17) {
  var commit = _ref17.commit;

  localStorage.removeItem('permissionMap');
  commit('SET_PERMISSION_MAP');
};

var setClientId = function setClientId(_ref18, clientid) {
  var commit = _ref18.commit;

  localStorage.setItem('clientId', clientid);
  commit('SET_CLIENT_ID', clientid);
};

var removeClientId = function removeClientId(_ref19) {
  var commit = _ref19.commit;

  localStorage.removeItem('clientId');
  commit('SET_CLIENT_ID');
};

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pkg", function() { return pkg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "app", function() { return app; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "device", function() { return device; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sidebar", function() { return sidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "effect", function() { return effect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "menuitems", function() { return menuitems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componententry", function() { return componententry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadedScenario", function() { return loadedScenario; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "authenticationToken", function() { return authenticationToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loggedRole", function() { return loggedRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loggedUser", function() { return loggedUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loggedUserState", function() { return loggedUserState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLogged", function() { return isLogged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loggedId", function() { return loggedId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "permissionMap", function() { return permissionMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clientId", function() { return clientId; });
var pkg = function pkg(state) {
  return state.pkg;
};
var app = function app(state) {
  return state.app;
};
var device = function device(state) {
  return state.app.device;
};
var sidebar = function sidebar(state) {
  return state.app.sidebar;
};
var effect = function effect(state) {
  return state.app.effect;
};
var menuitems = function menuitems(state) {
  return state.menu.items;
};

var componententry = function componententry(state) {
  return state.menu.items.filter(function (c) {
    return c.meta && c.meta.label === 'Components';
  })[0];
};
var loadedScenario = function loadedScenario(state) {
  return state.loadedScenario;
};

var loggedRole = function loggedRole(state) {
  return state.loggedRole;
};

var loggedUser = function loggedUser(state) {
  return state.loggedUser;
};

var loggedUserState = function loggedUserState(state) {
  return state.loggedUserState;
};

var isLogged = function isLogged(state) {
  return state.isLogged;
};

var loggedId = function loggedId(state) {
  return state.loggedId;
};

var permissionMap = function permissionMap(state) {
  return state.permissionMap;
};

var clientId = function clientId(state) {
  return state.clientId;
};

var authenticationToken = function authenticationToken(state) {
  return state.authenticationToken;
};



/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(62);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var state = {
  device: {
    isMobile: false,
    isTablet: false
  },
  sidebar: {
    opened: false,
    hidden: false
  },
  effect: {
    translate3d: true
  }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* TOGGLE_DEVICE */], function (state, device) {
  state.device.isMobile = device === 'mobile';
  state.device.isTablet = device === 'tablet';
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* TOGGLE_SIDEBAR */], function (state, config) {
  if (state.device.isMobile && config.hasOwnProperty('opened')) {
    state.sidebar.opened = config.opened;
  } else {
    state.sidebar.opened = true;
  }

  if (config.hasOwnProperty('hidden')) {
    state.sidebar.hidden = config.hidden;
  }
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SWITCH_EFFECT */], function (state, effectItem) {
  for (var name in effectItem) {
    state.effect[name] = effectItem[name];
  }
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 672 */
/***/ (function(module, exports) {



/***/ })
],[255]);


// WEBPACK FOOTER //
// assets/js/app.63129d112b2e9bbae550.js